var _setPrototypeOf = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/setPrototypeOf");
var _slicedToArray = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/defineProperty");
var _assertThisInitialized = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _inherits = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _wrapNativeSuper = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _toConsumableArray = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/toConsumableArray");
var _createClass = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) { k++; } groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var fv = Object.defineProperty,
  dv = Object.defineProperties;
var hv = Object.getOwnPropertyDescriptors;
var bo = Object.getOwnPropertySymbols;
var gf = Object.prototype.hasOwnProperty,
  vf = Object.prototype.propertyIsEnumerable;
var mf = function mf(bt, gt, st) {
    return gt in bt ? fv(bt, gt, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: st
    }) : bt[gt] = st;
  },
  L = function L(bt, gt) {
    for (var st in gt || (gt = {})) {
      gf.call(gt, st) && mf(bt, st, gt[st]);
    }
    if (bo) {
      var _iterator = _createForOfIteratorHelper(bo(gt)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var st = _step.value;
          vf.call(gt, st) && mf(bt, st, gt[st]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return bt;
  },
  ue = function ue(bt, gt) {
    return dv(bt, hv(gt));
  };
var Bt = function Bt(bt, gt) {
  var st = {};
  for (var zt in bt) {
    gf.call(bt, zt) && gt.indexOf(zt) < 0 && (st[zt] = bt[zt]);
  }
  if (bt != null && bo) {
    var _iterator2 = _createForOfIteratorHelper(bo(bt)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var zt = _step2.value;
        gt.indexOf(zt) < 0 && vf.call(bt, zt) && (st[zt] = bt[zt]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return st;
};
var Un = function Un(bt, gt, st) {
  return new Promise(function (zt, pe) {
    var ja = function ja(O) {
        try {
          c(st.next(O));
        } catch (Z) {
          pe(Z);
        }
      },
      _ = function _(O) {
        try {
          c(st.throw(O));
        } catch (Z) {
          pe(Z);
        }
      },
      c = function c(O) {
        return O.done ? zt(O.value) : Promise.resolve(O.value).then(ja, _);
      };
    c((st = st.apply(bt, gt)).next());
  });
};
(function (gt, st) {
  typeof exports == "object" && typeof module == "object" ? module.exports = st(require("react"), require("react-dom")) : typeof define == "function" && define.amd ? define(["react", "react-dom"], st) : typeof exports == "object" ? exports.pyroscope = st(require("react"), require("react-dom")) : gt.pyroscope = st(gt.react, gt["react-dom"]);
})(this, function (bt, gt) {
  return function () {
    var st = {
        899: function _(_2, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "align-left",
            J = 448,
            M = 512,
            $ = [],
            A = "f036",
            N = "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.el = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        459: function _(_3, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "bars",
            J = 448,
            M = 512,
            $ = [],
            A = "f0c9",
            N = "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.xi = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        971: function _(_4, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "columns",
            J = 512,
            M = 512,
            $ = [],
            A = "f0db",
            N = "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.rW = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        42: function _(_5, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "compress-alt",
            J = 448,
            M = 512,
            $ = [],
            A = "f422",
            N = "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.V9 = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        682: function _(_6, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "copy",
            J = 448,
            M = 512,
            $ = [],
            A = "f0c5",
            N = "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.kZ = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        438: function _(_7, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "highlighter",
            J = 544,
            M = 512,
            $ = [],
            A = "f591",
            N = "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.Y6 = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        384: function _(_8, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "icicles",
            J = 512,
            M = 512,
            $ = [],
            A = "f7ad",
            N = "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.$P = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        687: function _(_9, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "link",
            J = 512,
            M = 512,
            $ = [],
            A = "f0c1",
            N = "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.nN = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        646: function _(_10, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "list-ul",
            J = 512,
            M = 512,
            $ = [],
            A = "f0ca",
            N = "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.gf = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        247: function _(_11, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "redo",
            J = 512,
            M = 512,
            $ = [],
            A = "f01e",
            N = "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.XS = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        769: function _(_12, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "table",
            J = 512,
            M = 512,
            $ = [],
            A = "f0ce",
            N = "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.B3 = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        692: function _(_13, c) {
          "use strict";

          var O;
          O = {
            value: !0
          };
          var Z = "fas",
            W = "undo",
            J = 512,
            M = 512,
            $ = [],
            A = "f0e2",
            N = "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z";
          c.DF = {
            prefix: Z,
            iconName: W,
            icon: [J, M, $, A, N]
          }, c.X7 = c.DF, O = Z, O = W, O = J, O = M, O = $, O = A, O = N;
        },
        779: function _(_14, c) {
          var O, Z; /*!
                    Copyright (c) 2018 Jed Watson.
                    Licensed under the MIT License (MIT), see
                    http://jedwatson.github.io/classnames
                    */
          (function () {
            "use strict";

            var W = {}.hasOwnProperty;
            function J() {
              for (var M = [], $ = 0; $ < arguments.length; $++) {
                var A = arguments[$];
                if (!!A) {
                  var N = typeof A;
                  if (N === "string" || N === "number") M.push(A);else if (Array.isArray(A)) {
                    if (A.length) {
                      var ee = J.apply(null, A);
                      ee && M.push(ee);
                    }
                  } else if (N === "object") if (A.toString === Object.prototype.toString) for (var p in A) {
                    W.call(A, p) && A[p] && M.push(p);
                  } else M.push(A.toString());
                }
              }
              return M.join(" ");
            }
            _14.exports ? (J.default = J, _14.exports = J) : (O = [], Z = function () {
              return J;
            }.apply(c, O), Z !== void 0 && (_14.exports = Z));
          })();
        },
        959: function _(_15, c, O) {
          var Z = O(351),
            W = {};
          for (var J in Z) {
            Z.hasOwnProperty(J) && (W[Z[J]] = J);
          }
          var M = _15.exports = {
            rgb: {
              channels: 3,
              labels: "rgb"
            },
            hsl: {
              channels: 3,
              labels: "hsl"
            },
            hsv: {
              channels: 3,
              labels: "hsv"
            },
            hwb: {
              channels: 3,
              labels: "hwb"
            },
            cmyk: {
              channels: 4,
              labels: "cmyk"
            },
            xyz: {
              channels: 3,
              labels: "xyz"
            },
            lab: {
              channels: 3,
              labels: "lab"
            },
            lch: {
              channels: 3,
              labels: "lch"
            },
            hex: {
              channels: 1,
              labels: ["hex"]
            },
            keyword: {
              channels: 1,
              labels: ["keyword"]
            },
            ansi16: {
              channels: 1,
              labels: ["ansi16"]
            },
            ansi256: {
              channels: 1,
              labels: ["ansi256"]
            },
            hcg: {
              channels: 3,
              labels: ["h", "c", "g"]
            },
            apple: {
              channels: 3,
              labels: ["r16", "g16", "b16"]
            },
            gray: {
              channels: 1,
              labels: ["gray"]
            }
          };
          for (var $ in M) {
            if (M.hasOwnProperty($)) {
              if (!("channels" in M[$])) throw new Error("missing channels property: " + $);
              if (!("labels" in M[$])) throw new Error("missing channel labels property: " + $);
              if (M[$].labels.length !== M[$].channels) throw new Error("channel and label counts mismatch: " + $);
              var A = M[$].channels,
                N = M[$].labels;
              delete M[$].channels, delete M[$].labels, Object.defineProperty(M[$], "channels", {
                value: A
              }), Object.defineProperty(M[$], "labels", {
                value: N
              });
            }
          }
          M.rgb.hsl = function (p) {
            var w = p[0] / 255,
              x = p[1] / 255,
              E = p[2] / 255,
              S = Math.min(w, x, E),
              m = Math.max(w, x, E),
              v = m - S,
              T,
              I,
              K;
            return m === S ? T = 0 : w === m ? T = (x - E) / v : x === m ? T = 2 + (E - w) / v : E === m && (T = 4 + (w - x) / v), T = Math.min(T * 60, 360), T < 0 && (T += 360), K = (S + m) / 2, m === S ? I = 0 : K <= .5 ? I = v / (m + S) : I = v / (2 - m - S), [T, I * 100, K * 100];
          }, M.rgb.hsv = function (p) {
            var w,
              x,
              E,
              S,
              m,
              v = p[0] / 255,
              T = p[1] / 255,
              I = p[2] / 255,
              K = Math.max(v, T, I),
              Ee = K - Math.min(v, T, I),
              Be = function Be(q) {
                return (K - q) / 6 / Ee + 1 / 2;
              };
            return Ee === 0 ? S = m = 0 : (m = Ee / K, w = Be(v), x = Be(T), E = Be(I), v === K ? S = E - x : T === K ? S = .3333333333333333 + w - E : I === K && (S = .6666666666666666 + x - w), S < 0 ? S += 1 : S > 1 && (S -= 1)), [S * 360, m * 100, K * 100];
          }, M.rgb.hwb = function (p) {
            var w = p[0],
              x = p[1],
              E = p[2],
              S = M.rgb.hsl(p)[0],
              m = 1 / 255 * Math.min(w, Math.min(x, E));
            return E = 1 - .00392156862745098 * Math.max(w, Math.max(x, E)), [S, m * 100, E * 100];
          }, M.rgb.cmyk = function (p) {
            var w = p[0] / 255,
              x = p[1] / 255,
              E = p[2] / 255,
              S,
              m,
              v,
              T;
            return T = Math.min(1 - w, 1 - x, 1 - E), S = (1 - w - T) / (1 - T) || 0, m = (1 - x - T) / (1 - T) || 0, v = (1 - E - T) / (1 - T) || 0, [S * 100, m * 100, v * 100, T * 100];
          };
          function ee(p, w) {
            return Math.pow(p[0] - w[0], 2) + Math.pow(p[1] - w[1], 2) + Math.pow(p[2] - w[2], 2);
          }
          M.rgb.keyword = function (p) {
            var w = W[p];
            if (w) return w;
            var x = 1 / 0,
              E;
            for (var S in Z) {
              if (Z.hasOwnProperty(S)) {
                var m = Z[S],
                  v = ee(p, m);
                v < x && (x = v, E = S);
              }
            }
            return E;
          }, M.keyword.rgb = function (p) {
            return Z[p];
          }, M.rgb.xyz = function (p) {
            var w = p[0] / 255,
              x = p[1] / 255,
              E = p[2] / 255;
            w = w > .04045 ? Math.pow((w + .055) / 1.055, 2.4) : w / 12.92, x = x > .04045 ? Math.pow((x + .055) / 1.055, 2.4) : x / 12.92, E = E > .04045 ? Math.pow((E + .055) / 1.055, 2.4) : E / 12.92;
            var S = w * .4124 + x * .3576 + E * .1805,
              m = w * .2126 + x * .7152 + E * .0722,
              v = w * .0193 + x * .1192 + E * .9505;
            return [S * 100, m * 100, v * 100];
          }, M.rgb.lab = function (p) {
            var w = M.rgb.xyz(p),
              x = w[0],
              E = w[1],
              S = w[2],
              m,
              v,
              T;
            return x /= 95.047, E /= 100, S /= 108.883, x = x > .008856 ? Math.pow(x, .3333333333333333) : 7.787 * x + .13793103448275862, E = E > .008856 ? Math.pow(E, .3333333333333333) : 7.787 * E + .13793103448275862, S = S > .008856 ? Math.pow(S, .3333333333333333) : 7.787 * S + .13793103448275862, m = 116 * E - 16, v = 500 * (x - E), T = 200 * (E - S), [m, v, T];
          }, M.hsl.rgb = function (p) {
            var w = p[0] / 360,
              x = p[1] / 100,
              E = p[2] / 100,
              S,
              m,
              v,
              T,
              I;
            if (x === 0) return I = E * 255, [I, I, I];
            E < .5 ? m = E * (1 + x) : m = E + x - E * x, S = 2 * E - m, T = [0, 0, 0];
            for (var K = 0; K < 3; K++) {
              v = w + .3333333333333333 * -(K - 1), v < 0 && v++, v > 1 && v--, 6 * v < 1 ? I = S + (m - S) * 6 * v : 2 * v < 1 ? I = m : 3 * v < 2 ? I = S + (m - S) * (.6666666666666666 - v) * 6 : I = S, T[K] = I * 255;
            }
            return T;
          }, M.hsl.hsv = function (p) {
            var w = p[0],
              x = p[1] / 100,
              E = p[2] / 100,
              S = x,
              m = Math.max(E, .01),
              v,
              T;
            return E *= 2, x *= E <= 1 ? E : 2 - E, S *= m <= 1 ? m : 2 - m, T = (E + x) / 2, v = E === 0 ? 2 * S / (m + S) : 2 * x / (E + x), [w, v * 100, T * 100];
          }, M.hsv.rgb = function (p) {
            var w = p[0] / 60,
              x = p[1] / 100,
              E = p[2] / 100,
              S = Math.floor(w) % 6,
              m = w - Math.floor(w),
              v = 255 * E * (1 - x),
              T = 255 * E * (1 - x * m),
              I = 255 * E * (1 - x * (1 - m));
            switch (E *= 255, S) {
              case 0:
                return [E, I, v];
              case 1:
                return [T, E, v];
              case 2:
                return [v, E, I];
              case 3:
                return [v, T, E];
              case 4:
                return [I, v, E];
              case 5:
                return [E, v, T];
            }
          }, M.hsv.hsl = function (p) {
            var w = p[0],
              x = p[1] / 100,
              E = p[2] / 100,
              S = Math.max(E, .01),
              m,
              v,
              T;
            return T = (2 - x) * E, m = (2 - x) * S, v = x * S, v /= m <= 1 ? m : 2 - m, v = v || 0, T /= 2, [w, v * 100, T * 100];
          }, M.hwb.rgb = function (p) {
            var w = p[0] / 360,
              x = p[1] / 100,
              E = p[2] / 100,
              S = x + E,
              m,
              v,
              T,
              I;
            S > 1 && (x /= S, E /= S), m = Math.floor(6 * w), v = 1 - E, T = 6 * w - m, (m & 1) !== 0 && (T = 1 - T), I = x + T * (v - x);
            var K, Ee, Be;
            switch (m) {
              default:
              case 6:
              case 0:
                K = v, Ee = I, Be = x;
                break;
              case 1:
                K = I, Ee = v, Be = x;
                break;
              case 2:
                K = x, Ee = v, Be = I;
                break;
              case 3:
                K = x, Ee = I, Be = v;
                break;
              case 4:
                K = I, Ee = x, Be = v;
                break;
              case 5:
                K = v, Ee = x, Be = I;
                break;
            }
            return [K * 255, Ee * 255, Be * 255];
          }, M.cmyk.rgb = function (p) {
            var w = p[0] / 100,
              x = p[1] / 100,
              E = p[2] / 100,
              S = p[3] / 100,
              m,
              v,
              T;
            return m = 1 - Math.min(1, w * (1 - S) + S), v = 1 - Math.min(1, x * (1 - S) + S), T = 1 - Math.min(1, E * (1 - S) + S), [m * 255, v * 255, T * 255];
          }, M.xyz.rgb = function (p) {
            var w = p[0] / 100,
              x = p[1] / 100,
              E = p[2] / 100,
              S,
              m,
              v;
            return S = w * 3.2406 + x * -1.5372 + E * -.4986, m = w * -.9689 + x * 1.8758 + E * .0415, v = w * .0557 + x * -.204 + E * 1.057, S = S > .0031308 ? 1.055 * Math.pow(S, .4166666666666667) - .055 : S * 12.92, m = m > .0031308 ? 1.055 * Math.pow(m, .4166666666666667) - .055 : m * 12.92, v = v > .0031308 ? 1.055 * Math.pow(v, .4166666666666667) - .055 : v * 12.92, S = Math.min(Math.max(0, S), 1), m = Math.min(Math.max(0, m), 1), v = Math.min(Math.max(0, v), 1), [S * 255, m * 255, v * 255];
          }, M.xyz.lab = function (p) {
            var w = p[0],
              x = p[1],
              E = p[2],
              S,
              m,
              v;
            return w /= 95.047, x /= 100, E /= 108.883, w = w > .008856 ? Math.pow(w, .3333333333333333) : 7.787 * w + .13793103448275862, x = x > .008856 ? Math.pow(x, .3333333333333333) : 7.787 * x + .13793103448275862, E = E > .008856 ? Math.pow(E, .3333333333333333) : 7.787 * E + .13793103448275862, S = 116 * x - 16, m = 500 * (w - x), v = 200 * (x - E), [S, m, v];
          }, M.lab.xyz = function (p) {
            var w = p[0],
              x = p[1],
              E = p[2],
              S,
              m,
              v;
            m = (w + 16) / 116, S = x / 500 + m, v = m - E / 200;
            var T = Math.pow(m, 3),
              I = Math.pow(S, 3),
              K = Math.pow(v, 3);
            return m = T > .008856 ? T : (m - .13793103448275862) / 7.787, S = I > .008856 ? I : (S - .13793103448275862) / 7.787, v = K > .008856 ? K : (v - .13793103448275862) / 7.787, S *= 95.047, m *= 100, v *= 108.883, [S, m, v];
          }, M.lab.lch = function (p) {
            var w = p[0],
              x = p[1],
              E = p[2],
              S,
              m,
              v;
            return S = Math.atan2(E, x), m = S * 360 / 2 / Math.PI, m < 0 && (m += 360), v = Math.sqrt(x * x + E * E), [w, v, m];
          }, M.lch.lab = function (p) {
            var w = p[0],
              x = p[1],
              E = p[2],
              S,
              m,
              v;
            return v = E / 360 * 2 * Math.PI, S = x * Math.cos(v), m = x * Math.sin(v), [w, S, m];
          }, M.rgb.ansi16 = function (p) {
            var w = p[0],
              x = p[1],
              E = p[2],
              S = 1 in arguments ? arguments[1] : M.rgb.hsv(p)[2];
            if (S = Math.round(S / 50), S === 0) return 30;
            var m = 30 + (Math.round(E / 255) << 2 | Math.round(x / 255) << 1 | Math.round(w / 255));
            return S === 2 && (m += 60), m;
          }, M.hsv.ansi16 = function (p) {
            return M.rgb.ansi16(M.hsv.rgb(p), p[2]);
          }, M.rgb.ansi256 = function (p) {
            var w = p[0],
              x = p[1],
              E = p[2];
            if (w === x && x === E) return w < 8 ? 16 : w > 248 ? 231 : Math.round((w - 8) / 247 * 24) + 232;
            var S = 16 + 36 * Math.round(w / 255 * 5) + 6 * Math.round(x / 255 * 5) + Math.round(E / 255 * 5);
            return S;
          }, M.ansi16.rgb = function (p) {
            var w = p % 10;
            if (w === 0 || w === 7) return p > 50 && (w += 3.5), w = w / 10.5 * 255, [w, w, w];
            var x = (~~(p > 50) + 1) * .5,
              E = (w & 1) * x * 255,
              S = (w >> 1 & 1) * x * 255,
              m = (w >> 2 & 1) * x * 255;
            return [E, S, m];
          }, M.ansi256.rgb = function (p) {
            if (p >= 232) {
              var w = (p - 232) * 10 + 8;
              return [w, w, w];
            }
            p -= 16;
            var x,
              E = Math.floor(p / 36) / 5 * 255,
              S = Math.floor((x = p % 36) / 6) / 5 * 255,
              m = x % 6 / 5 * 255;
            return [E, S, m];
          }, M.rgb.hex = function (p) {
            var w = ((Math.round(p[0]) & 255) << 16) + ((Math.round(p[1]) & 255) << 8) + (Math.round(p[2]) & 255),
              x = w.toString(16).toUpperCase();
            return "000000".substring(x.length) + x;
          }, M.hex.rgb = function (p) {
            var w = p.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!w) return [0, 0, 0];
            var x = w[0];
            w[0].length === 3 && (x = x.split("").map(function (T) {
              return T + T;
            }).join(""));
            var E = parseInt(x, 16),
              S = E >> 16 & 255,
              m = E >> 8 & 255,
              v = E & 255;
            return [S, m, v];
          }, M.rgb.hcg = function (p) {
            var w = p[0] / 255,
              x = p[1] / 255,
              E = p[2] / 255,
              S = Math.max(Math.max(w, x), E),
              m = Math.min(Math.min(w, x), E),
              v = S - m,
              T,
              I;
            return v < 1 ? T = m / (1 - v) : T = 0, v <= 0 ? I = 0 : S === w ? I = (x - E) / v % 6 : S === x ? I = 2 + (E - w) / v : I = 4 + (w - x) / v + 4, I /= 6, I %= 1, [I * 360, v * 100, T * 100];
          }, M.hsl.hcg = function (p) {
            var w = p[1] / 100,
              x = p[2] / 100,
              E = 1,
              S = 0;
            return x < .5 ? E = 2 * w * x : E = 2 * w * (1 - x), E < 1 && (S = (x - .5 * E) / (1 - E)), [p[0], E * 100, S * 100];
          }, M.hsv.hcg = function (p) {
            var w = p[1] / 100,
              x = p[2] / 100,
              E = w * x,
              S = 0;
            return E < 1 && (S = (x - E) / (1 - E)), [p[0], E * 100, S * 100];
          }, M.hcg.rgb = function (p) {
            var w = p[0] / 360,
              x = p[1] / 100,
              E = p[2] / 100;
            if (x === 0) return [E * 255, E * 255, E * 255];
            var S = [0, 0, 0],
              m = w % 1 * 6,
              v = m % 1,
              T = 1 - v,
              I = 0;
            switch (Math.floor(m)) {
              case 0:
                S[0] = 1, S[1] = v, S[2] = 0;
                break;
              case 1:
                S[0] = T, S[1] = 1, S[2] = 0;
                break;
              case 2:
                S[0] = 0, S[1] = 1, S[2] = v;
                break;
              case 3:
                S[0] = 0, S[1] = T, S[2] = 1;
                break;
              case 4:
                S[0] = v, S[1] = 0, S[2] = 1;
                break;
              default:
                S[0] = 1, S[1] = 0, S[2] = T;
            }
            return I = (1 - x) * E, [(x * S[0] + I) * 255, (x * S[1] + I) * 255, (x * S[2] + I) * 255];
          }, M.hcg.hsv = function (p) {
            var w = p[1] / 100,
              x = p[2] / 100,
              E = w + x * (1 - w),
              S = 0;
            return E > 0 && (S = w / E), [p[0], S * 100, E * 100];
          }, M.hcg.hsl = function (p) {
            var w = p[1] / 100,
              x = p[2] / 100,
              E = x * (1 - w) + .5 * w,
              S = 0;
            return E > 0 && E < .5 ? S = w / (2 * E) : E >= .5 && E < 1 && (S = w / (2 * (1 - E))), [p[0], S * 100, E * 100];
          }, M.hcg.hwb = function (p) {
            var w = p[1] / 100,
              x = p[2] / 100,
              E = w + x * (1 - w);
            return [p[0], (E - w) * 100, (1 - E) * 100];
          }, M.hwb.hcg = function (p) {
            var w = p[1] / 100,
              x = p[2] / 100,
              E = 1 - x,
              S = E - w,
              m = 0;
            return S < 1 && (m = (E - S) / (1 - S)), [p[0], S * 100, m * 100];
          }, M.apple.rgb = function (p) {
            return [p[0] / 65535 * 255, p[1] / 65535 * 255, p[2] / 65535 * 255];
          }, M.rgb.apple = function (p) {
            return [p[0] / 255 * 65535, p[1] / 255 * 65535, p[2] / 255 * 65535];
          }, M.gray.rgb = function (p) {
            return [p[0] / 100 * 255, p[0] / 100 * 255, p[0] / 100 * 255];
          }, M.gray.hsl = M.gray.hsv = function (p) {
            return [0, 0, p[0]];
          }, M.gray.hwb = function (p) {
            return [0, 100, p[0]];
          }, M.gray.cmyk = function (p) {
            return [0, 0, 0, p[0]];
          }, M.gray.lab = function (p) {
            return [p[0], 0, 0];
          }, M.gray.hex = function (p) {
            var w = Math.round(p[0] / 100 * 255) & 255,
              x = (w << 16) + (w << 8) + w,
              E = x.toString(16).toUpperCase();
            return "000000".substring(E.length) + E;
          }, M.rgb.gray = function (p) {
            var w = (p[0] + p[1] + p[2]) / 3;
            return [w / 255 * 100];
          };
        },
        841: function _(_16, c, O) {
          var Z = O(959),
            W = O(325),
            J = {},
            M = Object.keys(Z);
          function $(N) {
            var ee = function ee(p) {
              return p == null ? p : (arguments.length > 1 && (p = Array.prototype.slice.call(arguments)), N(p));
            };
            return "conversion" in N && (ee.conversion = N.conversion), ee;
          }
          function A(N) {
            var ee = function ee(p) {
              if (p == null) return p;
              arguments.length > 1 && (p = Array.prototype.slice.call(arguments));
              var w = N(p);
              if (typeof w == "object") for (var x = w.length, E = 0; E < x; E++) {
                w[E] = Math.round(w[E]);
              }
              return w;
            };
            return "conversion" in N && (ee.conversion = N.conversion), ee;
          }
          M.forEach(function (N) {
            J[N] = {}, Object.defineProperty(J[N], "channels", {
              value: Z[N].channels
            }), Object.defineProperty(J[N], "labels", {
              value: Z[N].labels
            });
            var ee = W(N),
              p = Object.keys(ee);
            p.forEach(function (w) {
              var x = ee[w];
              J[N][w] = A(x), J[N][w].raw = $(x);
            });
          }), _16.exports = J;
        },
        351: function _(_17) {
          "use strict";

          _17.exports = {
            aliceblue: [240, 248, 255],
            antiquewhite: [250, 235, 215],
            aqua: [0, 255, 255],
            aquamarine: [127, 255, 212],
            azure: [240, 255, 255],
            beige: [245, 245, 220],
            bisque: [255, 228, 196],
            black: [0, 0, 0],
            blanchedalmond: [255, 235, 205],
            blue: [0, 0, 255],
            blueviolet: [138, 43, 226],
            brown: [165, 42, 42],
            burlywood: [222, 184, 135],
            cadetblue: [95, 158, 160],
            chartreuse: [127, 255, 0],
            chocolate: [210, 105, 30],
            coral: [255, 127, 80],
            cornflowerblue: [100, 149, 237],
            cornsilk: [255, 248, 220],
            crimson: [220, 20, 60],
            cyan: [0, 255, 255],
            darkblue: [0, 0, 139],
            darkcyan: [0, 139, 139],
            darkgoldenrod: [184, 134, 11],
            darkgray: [169, 169, 169],
            darkgreen: [0, 100, 0],
            darkgrey: [169, 169, 169],
            darkkhaki: [189, 183, 107],
            darkmagenta: [139, 0, 139],
            darkolivegreen: [85, 107, 47],
            darkorange: [255, 140, 0],
            darkorchid: [153, 50, 204],
            darkred: [139, 0, 0],
            darksalmon: [233, 150, 122],
            darkseagreen: [143, 188, 143],
            darkslateblue: [72, 61, 139],
            darkslategray: [47, 79, 79],
            darkslategrey: [47, 79, 79],
            darkturquoise: [0, 206, 209],
            darkviolet: [148, 0, 211],
            deeppink: [255, 20, 147],
            deepskyblue: [0, 191, 255],
            dimgray: [105, 105, 105],
            dimgrey: [105, 105, 105],
            dodgerblue: [30, 144, 255],
            firebrick: [178, 34, 34],
            floralwhite: [255, 250, 240],
            forestgreen: [34, 139, 34],
            fuchsia: [255, 0, 255],
            gainsboro: [220, 220, 220],
            ghostwhite: [248, 248, 255],
            gold: [255, 215, 0],
            goldenrod: [218, 165, 32],
            gray: [128, 128, 128],
            green: [0, 128, 0],
            greenyellow: [173, 255, 47],
            grey: [128, 128, 128],
            honeydew: [240, 255, 240],
            hotpink: [255, 105, 180],
            indianred: [205, 92, 92],
            indigo: [75, 0, 130],
            ivory: [255, 255, 240],
            khaki: [240, 230, 140],
            lavender: [230, 230, 250],
            lavenderblush: [255, 240, 245],
            lawngreen: [124, 252, 0],
            lemonchiffon: [255, 250, 205],
            lightblue: [173, 216, 230],
            lightcoral: [240, 128, 128],
            lightcyan: [224, 255, 255],
            lightgoldenrodyellow: [250, 250, 210],
            lightgray: [211, 211, 211],
            lightgreen: [144, 238, 144],
            lightgrey: [211, 211, 211],
            lightpink: [255, 182, 193],
            lightsalmon: [255, 160, 122],
            lightseagreen: [32, 178, 170],
            lightskyblue: [135, 206, 250],
            lightslategray: [119, 136, 153],
            lightslategrey: [119, 136, 153],
            lightsteelblue: [176, 196, 222],
            lightyellow: [255, 255, 224],
            lime: [0, 255, 0],
            limegreen: [50, 205, 50],
            linen: [250, 240, 230],
            magenta: [255, 0, 255],
            maroon: [128, 0, 0],
            mediumaquamarine: [102, 205, 170],
            mediumblue: [0, 0, 205],
            mediumorchid: [186, 85, 211],
            mediumpurple: [147, 112, 219],
            mediumseagreen: [60, 179, 113],
            mediumslateblue: [123, 104, 238],
            mediumspringgreen: [0, 250, 154],
            mediumturquoise: [72, 209, 204],
            mediumvioletred: [199, 21, 133],
            midnightblue: [25, 25, 112],
            mintcream: [245, 255, 250],
            mistyrose: [255, 228, 225],
            moccasin: [255, 228, 181],
            navajowhite: [255, 222, 173],
            navy: [0, 0, 128],
            oldlace: [253, 245, 230],
            olive: [128, 128, 0],
            olivedrab: [107, 142, 35],
            orange: [255, 165, 0],
            orangered: [255, 69, 0],
            orchid: [218, 112, 214],
            palegoldenrod: [238, 232, 170],
            palegreen: [152, 251, 152],
            paleturquoise: [175, 238, 238],
            palevioletred: [219, 112, 147],
            papayawhip: [255, 239, 213],
            peachpuff: [255, 218, 185],
            peru: [205, 133, 63],
            pink: [255, 192, 203],
            plum: [221, 160, 221],
            powderblue: [176, 224, 230],
            purple: [128, 0, 128],
            rebeccapurple: [102, 51, 153],
            red: [255, 0, 0],
            rosybrown: [188, 143, 143],
            royalblue: [65, 105, 225],
            saddlebrown: [139, 69, 19],
            salmon: [250, 128, 114],
            sandybrown: [244, 164, 96],
            seagreen: [46, 139, 87],
            seashell: [255, 245, 238],
            sienna: [160, 82, 45],
            silver: [192, 192, 192],
            skyblue: [135, 206, 235],
            slateblue: [106, 90, 205],
            slategray: [112, 128, 144],
            slategrey: [112, 128, 144],
            snow: [255, 250, 250],
            springgreen: [0, 255, 127],
            steelblue: [70, 130, 180],
            tan: [210, 180, 140],
            teal: [0, 128, 128],
            thistle: [216, 191, 216],
            tomato: [255, 99, 71],
            turquoise: [64, 224, 208],
            violet: [238, 130, 238],
            wheat: [245, 222, 179],
            white: [255, 255, 255],
            whitesmoke: [245, 245, 245],
            yellow: [255, 255, 0],
            yellowgreen: [154, 205, 50]
          };
        },
        325: function _(_18, c, O) {
          var Z = O(959);
          function W() {
            for (var A = {}, N = Object.keys(Z), ee = N.length, p = 0; p < ee; p++) {
              A[N[p]] = {
                distance: -1,
                parent: null
              };
            }
            return A;
          }
          function J(A) {
            var N = W(),
              ee = [A];
            for (N[A].distance = 0; ee.length;) {
              for (var p = ee.pop(), w = Object.keys(Z[p]), x = w.length, E = 0; E < x; E++) {
                var S = w[E],
                  m = N[S];
                m.distance === -1 && (m.distance = N[p].distance + 1, m.parent = p, ee.unshift(S));
              }
            }
            return N;
          }
          function M(A, N) {
            return function (ee) {
              return N(A(ee));
            };
          }
          function $(A, N) {
            for (var ee = [N[A].parent, A], p = Z[N[A].parent][A], w = N[A].parent; N[w].parent;) {
              ee.unshift(N[w].parent), p = M(Z[N[w].parent][w], p), w = N[w].parent;
            }
            return p.conversion = ee, p;
          }
          _18.exports = function (A) {
            for (var N = J(A), ee = {}, p = Object.keys(N), w = p.length, x = 0; x < w; x++) {
              var E = p[x],
                S = N[E];
              S.parent !== null && (ee[E] = $(E, N));
            }
            return ee;
          };
        },
        103: function _(_19) {
          "use strict";

          _19.exports = {
            aliceblue: [240, 248, 255],
            antiquewhite: [250, 235, 215],
            aqua: [0, 255, 255],
            aquamarine: [127, 255, 212],
            azure: [240, 255, 255],
            beige: [245, 245, 220],
            bisque: [255, 228, 196],
            black: [0, 0, 0],
            blanchedalmond: [255, 235, 205],
            blue: [0, 0, 255],
            blueviolet: [138, 43, 226],
            brown: [165, 42, 42],
            burlywood: [222, 184, 135],
            cadetblue: [95, 158, 160],
            chartreuse: [127, 255, 0],
            chocolate: [210, 105, 30],
            coral: [255, 127, 80],
            cornflowerblue: [100, 149, 237],
            cornsilk: [255, 248, 220],
            crimson: [220, 20, 60],
            cyan: [0, 255, 255],
            darkblue: [0, 0, 139],
            darkcyan: [0, 139, 139],
            darkgoldenrod: [184, 134, 11],
            darkgray: [169, 169, 169],
            darkgreen: [0, 100, 0],
            darkgrey: [169, 169, 169],
            darkkhaki: [189, 183, 107],
            darkmagenta: [139, 0, 139],
            darkolivegreen: [85, 107, 47],
            darkorange: [255, 140, 0],
            darkorchid: [153, 50, 204],
            darkred: [139, 0, 0],
            darksalmon: [233, 150, 122],
            darkseagreen: [143, 188, 143],
            darkslateblue: [72, 61, 139],
            darkslategray: [47, 79, 79],
            darkslategrey: [47, 79, 79],
            darkturquoise: [0, 206, 209],
            darkviolet: [148, 0, 211],
            deeppink: [255, 20, 147],
            deepskyblue: [0, 191, 255],
            dimgray: [105, 105, 105],
            dimgrey: [105, 105, 105],
            dodgerblue: [30, 144, 255],
            firebrick: [178, 34, 34],
            floralwhite: [255, 250, 240],
            forestgreen: [34, 139, 34],
            fuchsia: [255, 0, 255],
            gainsboro: [220, 220, 220],
            ghostwhite: [248, 248, 255],
            gold: [255, 215, 0],
            goldenrod: [218, 165, 32],
            gray: [128, 128, 128],
            green: [0, 128, 0],
            greenyellow: [173, 255, 47],
            grey: [128, 128, 128],
            honeydew: [240, 255, 240],
            hotpink: [255, 105, 180],
            indianred: [205, 92, 92],
            indigo: [75, 0, 130],
            ivory: [255, 255, 240],
            khaki: [240, 230, 140],
            lavender: [230, 230, 250],
            lavenderblush: [255, 240, 245],
            lawngreen: [124, 252, 0],
            lemonchiffon: [255, 250, 205],
            lightblue: [173, 216, 230],
            lightcoral: [240, 128, 128],
            lightcyan: [224, 255, 255],
            lightgoldenrodyellow: [250, 250, 210],
            lightgray: [211, 211, 211],
            lightgreen: [144, 238, 144],
            lightgrey: [211, 211, 211],
            lightpink: [255, 182, 193],
            lightsalmon: [255, 160, 122],
            lightseagreen: [32, 178, 170],
            lightskyblue: [135, 206, 250],
            lightslategray: [119, 136, 153],
            lightslategrey: [119, 136, 153],
            lightsteelblue: [176, 196, 222],
            lightyellow: [255, 255, 224],
            lime: [0, 255, 0],
            limegreen: [50, 205, 50],
            linen: [250, 240, 230],
            magenta: [255, 0, 255],
            maroon: [128, 0, 0],
            mediumaquamarine: [102, 205, 170],
            mediumblue: [0, 0, 205],
            mediumorchid: [186, 85, 211],
            mediumpurple: [147, 112, 219],
            mediumseagreen: [60, 179, 113],
            mediumslateblue: [123, 104, 238],
            mediumspringgreen: [0, 250, 154],
            mediumturquoise: [72, 209, 204],
            mediumvioletred: [199, 21, 133],
            midnightblue: [25, 25, 112],
            mintcream: [245, 255, 250],
            mistyrose: [255, 228, 225],
            moccasin: [255, 228, 181],
            navajowhite: [255, 222, 173],
            navy: [0, 0, 128],
            oldlace: [253, 245, 230],
            olive: [128, 128, 0],
            olivedrab: [107, 142, 35],
            orange: [255, 165, 0],
            orangered: [255, 69, 0],
            orchid: [218, 112, 214],
            palegoldenrod: [238, 232, 170],
            palegreen: [152, 251, 152],
            paleturquoise: [175, 238, 238],
            palevioletred: [219, 112, 147],
            papayawhip: [255, 239, 213],
            peachpuff: [255, 218, 185],
            peru: [205, 133, 63],
            pink: [255, 192, 203],
            plum: [221, 160, 221],
            powderblue: [176, 224, 230],
            purple: [128, 0, 128],
            rebeccapurple: [102, 51, 153],
            red: [255, 0, 0],
            rosybrown: [188, 143, 143],
            royalblue: [65, 105, 225],
            saddlebrown: [139, 69, 19],
            salmon: [250, 128, 114],
            sandybrown: [244, 164, 96],
            seagreen: [46, 139, 87],
            seashell: [255, 245, 238],
            sienna: [160, 82, 45],
            silver: [192, 192, 192],
            skyblue: [135, 206, 235],
            slateblue: [106, 90, 205],
            slategray: [112, 128, 144],
            slategrey: [112, 128, 144],
            snow: [255, 250, 250],
            springgreen: [0, 255, 127],
            steelblue: [70, 130, 180],
            tan: [210, 180, 140],
            teal: [0, 128, 128],
            thistle: [216, 191, 216],
            tomato: [255, 99, 71],
            turquoise: [64, 224, 208],
            violet: [238, 130, 238],
            wheat: [245, 222, 179],
            white: [255, 255, 255],
            whitesmoke: [245, 245, 245],
            yellow: [255, 255, 0],
            yellowgreen: [154, 205, 50]
          };
        },
        804: function _(_20, c, O) {
          var Z = O(103),
            W = O(47),
            J = Object.hasOwnProperty,
            M = {};
          for (var $ in Z) {
            J.call(Z, $) && (M[Z[$]] = $);
          }
          var A = _20.exports = {
            to: {},
            get: {}
          };
          A.get = function (p) {
            var w = p.substring(0, 3).toLowerCase(),
              x,
              E;
            switch (w) {
              case "hsl":
                x = A.get.hsl(p), E = "hsl";
                break;
              case "hwb":
                x = A.get.hwb(p), E = "hwb";
                break;
              default:
                x = A.get.rgb(p), E = "rgb";
                break;
            }
            return x ? {
              model: E,
              value: x
            } : null;
          }, A.get.rgb = function (p) {
            if (!p) return null;
            var w = /^#([a-f0-9]{3,4})$/i,
              x = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i,
              E = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/,
              S = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/,
              m = /^(\w+)$/,
              v = [0, 0, 0, 1],
              T,
              I,
              K;
            if (T = p.match(x)) {
              for (K = T[2], T = T[1], I = 0; I < 3; I++) {
                var Ee = I * 2;
                v[I] = parseInt(T.slice(Ee, Ee + 2), 16);
              }
              K && (v[3] = parseInt(K, 16) / 255);
            } else if (T = p.match(w)) {
              for (T = T[1], K = T[3], I = 0; I < 3; I++) {
                v[I] = parseInt(T[I] + T[I], 16);
              }
              K && (v[3] = parseInt(K + K, 16) / 255);
            } else if (T = p.match(E)) {
              for (I = 0; I < 3; I++) {
                v[I] = parseInt(T[I + 1], 0);
              }
              T[4] && (T[5] ? v[3] = parseFloat(T[4]) * .01 : v[3] = parseFloat(T[4]));
            } else if (T = p.match(S)) {
              for (I = 0; I < 3; I++) {
                v[I] = Math.round(parseFloat(T[I + 1]) * 2.55);
              }
              T[4] && (T[5] ? v[3] = parseFloat(T[4]) * .01 : v[3] = parseFloat(T[4]));
            } else return (T = p.match(m)) ? T[1] === "transparent" ? [0, 0, 0, 0] : J.call(Z, T[1]) ? (v = Z[T[1]], v[3] = 1, v) : null : null;
            for (I = 0; I < 3; I++) {
              v[I] = N(v[I], 0, 255);
            }
            return v[3] = N(v[3], 0, 1), v;
          }, A.get.hsl = function (p) {
            if (!p) return null;
            var w = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/,
              x = p.match(w);
            if (x) {
              var E = parseFloat(x[4]),
                S = (parseFloat(x[1]) % 360 + 360) % 360,
                m = N(parseFloat(x[2]), 0, 100),
                v = N(parseFloat(x[3]), 0, 100),
                T = N(isNaN(E) ? 1 : E, 0, 1);
              return [S, m, v, T];
            }
            return null;
          }, A.get.hwb = function (p) {
            if (!p) return null;
            var w = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/,
              x = p.match(w);
            if (x) {
              var E = parseFloat(x[4]),
                S = (parseFloat(x[1]) % 360 + 360) % 360,
                m = N(parseFloat(x[2]), 0, 100),
                v = N(parseFloat(x[3]), 0, 100),
                T = N(isNaN(E) ? 1 : E, 0, 1);
              return [S, m, v, T];
            }
            return null;
          }, A.to.hex = function () {
            var p = W(arguments);
            return "#" + ee(p[0]) + ee(p[1]) + ee(p[2]) + (p[3] < 1 ? ee(Math.round(p[3] * 255)) : "");
          }, A.to.rgb = function () {
            var p = W(arguments);
            return p.length < 4 || p[3] === 1 ? "rgb(" + Math.round(p[0]) + ", " + Math.round(p[1]) + ", " + Math.round(p[2]) + ")" : "rgba(" + Math.round(p[0]) + ", " + Math.round(p[1]) + ", " + Math.round(p[2]) + ", " + p[3] + ")";
          }, A.to.rgb.percent = function () {
            var p = W(arguments),
              w = Math.round(p[0] / 255 * 100),
              x = Math.round(p[1] / 255 * 100),
              E = Math.round(p[2] / 255 * 100);
            return p.length < 4 || p[3] === 1 ? "rgb(" + w + "%, " + x + "%, " + E + "%)" : "rgba(" + w + "%, " + x + "%, " + E + "%, " + p[3] + ")";
          }, A.to.hsl = function () {
            var p = W(arguments);
            return p.length < 4 || p[3] === 1 ? "hsl(" + p[0] + ", " + p[1] + "%, " + p[2] + "%)" : "hsla(" + p[0] + ", " + p[1] + "%, " + p[2] + "%, " + p[3] + ")";
          }, A.to.hwb = function () {
            var p = W(arguments),
              w = "";
            return p.length >= 4 && p[3] !== 1 && (w = ", " + p[3]), "hwb(" + p[0] + ", " + p[1] + "%, " + p[2] + "%" + w + ")";
          }, A.to.keyword = function (p) {
            return M[p.slice(0, 3)];
          };
          function N(p, w, x) {
            return Math.min(Math.max(w, p), x);
          }
          function ee(p) {
            var w = Math.round(p).toString(16).toUpperCase();
            return w.length < 2 ? "0" + w : w;
          }
        },
        346: function _(_21, c, O) {
          "use strict";

          var Z = O(804),
            W = O(841),
            J = [].slice,
            M = ["keyword", "gray", "hex"],
            $ = {};
          Object.keys(W).forEach(function (m) {
            $[J.call(W[m].labels).sort().join("")] = m;
          });
          var A = {};
          function N(m, v) {
            if (!(this instanceof N)) return new N(m, v);
            if (v && v in M && (v = null), v && !(v in W)) throw new Error("Unknown model: " + v);
            var T, I;
            if (m == null) this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;else if (m instanceof N) this.model = m.model, this.color = m.color.slice(), this.valpha = m.valpha;else if (typeof m == "string") {
              var K = Z.get(m);
              if (K === null) throw new Error("Unable to parse color from string: " + m);
              this.model = K.model, I = W[this.model].channels, this.color = K.value.slice(0, I), this.valpha = typeof K.value[I] == "number" ? K.value[I] : 1;
            } else if (m.length) {
              this.model = v || "rgb", I = W[this.model].channels;
              var Ee = J.call(m, 0, I);
              this.color = S(Ee, I), this.valpha = typeof m[I] == "number" ? m[I] : 1;
            } else if (typeof m == "number") m &= 16777215, this.model = "rgb", this.color = [m >> 16 & 255, m >> 8 & 255, m & 255], this.valpha = 1;else {
              this.valpha = 1;
              var Be = Object.keys(m);
              "alpha" in m && (Be.splice(Be.indexOf("alpha"), 1), this.valpha = typeof m.alpha == "number" ? m.alpha : 0);
              var q = Be.sort().join("");
              if (!(q in $)) throw new Error("Unable to parse color from object: " + JSON.stringify(m));
              this.model = $[q];
              var V = W[this.model].labels,
                Q = [];
              for (T = 0; T < V.length; T++) {
                Q.push(m[V[T]]);
              }
              this.color = S(Q);
            }
            if (A[this.model]) for (I = W[this.model].channels, T = 0; T < I; T++) {
              var ae = A[this.model][T];
              ae && (this.color[T] = ae(this.color[T]));
            }
            this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
          }
          N.prototype = {
            toString: function toString() {
              return this.string();
            },
            toJSON: function toJSON() {
              return this[this.model]();
            },
            string: function string(m) {
              var v = this.model in Z.to ? this : this.rgb();
              v = v.round(typeof m == "number" ? m : 1);
              var T = v.valpha === 1 ? v.color : v.color.concat(this.valpha);
              return Z.to[v.model](T);
            },
            percentString: function percentString(m) {
              var v = this.rgb().round(typeof m == "number" ? m : 1),
                T = v.valpha === 1 ? v.color : v.color.concat(this.valpha);
              return Z.to.rgb.percent(T);
            },
            array: function array() {
              return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
            },
            object: function object() {
              for (var m = {}, v = W[this.model].channels, T = W[this.model].labels, I = 0; I < v; I++) {
                m[T[I]] = this.color[I];
              }
              return this.valpha !== 1 && (m.alpha = this.valpha), m;
            },
            unitArray: function unitArray() {
              var m = this.rgb().color;
              return m[0] /= 255, m[1] /= 255, m[2] /= 255, this.valpha !== 1 && m.push(this.valpha), m;
            },
            unitObject: function unitObject() {
              var m = this.rgb().object();
              return m.r /= 255, m.g /= 255, m.b /= 255, this.valpha !== 1 && (m.alpha = this.valpha), m;
            },
            round: function round(m) {
              return m = Math.max(m || 0, 0), new N(this.color.map(p(m)).concat(this.valpha), this.model);
            },
            alpha: function alpha(m) {
              return arguments.length ? new N(this.color.concat(Math.max(0, Math.min(1, m))), this.model) : this.valpha;
            },
            red: w("rgb", 0, x(255)),
            green: w("rgb", 1, x(255)),
            blue: w("rgb", 2, x(255)),
            hue: w(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function (m) {
              return (m % 360 + 360) % 360;
            }),
            saturationl: w("hsl", 1, x(100)),
            lightness: w("hsl", 2, x(100)),
            saturationv: w("hsv", 1, x(100)),
            value: w("hsv", 2, x(100)),
            chroma: w("hcg", 1, x(100)),
            gray: w("hcg", 2, x(100)),
            white: w("hwb", 1, x(100)),
            wblack: w("hwb", 2, x(100)),
            cyan: w("cmyk", 0, x(100)),
            magenta: w("cmyk", 1, x(100)),
            yellow: w("cmyk", 2, x(100)),
            black: w("cmyk", 3, x(100)),
            x: w("xyz", 0, x(100)),
            y: w("xyz", 1, x(100)),
            z: w("xyz", 2, x(100)),
            l: w("lab", 0, x(100)),
            a: w("lab", 1),
            b: w("lab", 2),
            keyword: function keyword(m) {
              return arguments.length ? new N(m) : W[this.model].keyword(this.color);
            },
            hex: function hex(m) {
              return arguments.length ? new N(m) : Z.to.hex(this.rgb().round().color);
            },
            rgbNumber: function rgbNumber() {
              var m = this.rgb().color;
              return (m[0] & 255) << 16 | (m[1] & 255) << 8 | m[2] & 255;
            },
            luminosity: function luminosity() {
              for (var m = this.rgb().color, v = [], T = 0; T < m.length; T++) {
                var I = m[T] / 255;
                v[T] = I <= .03928 ? I / 12.92 : Math.pow((I + .055) / 1.055, 2.4);
              }
              return .2126 * v[0] + .7152 * v[1] + .0722 * v[2];
            },
            contrast: function contrast(m) {
              var v = this.luminosity(),
                T = m.luminosity();
              return v > T ? (v + .05) / (T + .05) : (T + .05) / (v + .05);
            },
            level: function level(m) {
              var v = this.contrast(m);
              return v >= 7.1 ? "AAA" : v >= 4.5 ? "AA" : "";
            },
            isDark: function isDark() {
              var m = this.rgb().color,
                v = (m[0] * 299 + m[1] * 587 + m[2] * 114) / 1e3;
              return v < 128;
            },
            isLight: function isLight() {
              return !this.isDark();
            },
            negate: function negate() {
              for (var m = this.rgb(), v = 0; v < 3; v++) {
                m.color[v] = 255 - m.color[v];
              }
              return m;
            },
            lighten: function lighten(m) {
              var v = this.hsl();
              return v.color[2] += v.color[2] * m, v;
            },
            darken: function darken(m) {
              var v = this.hsl();
              return v.color[2] -= v.color[2] * m, v;
            },
            saturate: function saturate(m) {
              var v = this.hsl();
              return v.color[1] += v.color[1] * m, v;
            },
            desaturate: function desaturate(m) {
              var v = this.hsl();
              return v.color[1] -= v.color[1] * m, v;
            },
            whiten: function whiten(m) {
              var v = this.hwb();
              return v.color[1] += v.color[1] * m, v;
            },
            blacken: function blacken(m) {
              var v = this.hwb();
              return v.color[2] += v.color[2] * m, v;
            },
            grayscale: function grayscale() {
              var m = this.rgb().color,
                v = m[0] * .3 + m[1] * .59 + m[2] * .11;
              return N.rgb(v, v, v);
            },
            fade: function fade(m) {
              return this.alpha(this.valpha - this.valpha * m);
            },
            opaquer: function opaquer(m) {
              return this.alpha(this.valpha + this.valpha * m);
            },
            rotate: function rotate(m) {
              var v = this.hsl(),
                T = v.color[0];
              return T = (T + m) % 360, T = T < 0 ? 360 + T : T, v.color[0] = T, v;
            },
            mix: function mix(m, v) {
              if (!m || !m.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof m);
              var T = m.rgb(),
                I = this.rgb(),
                K = v === void 0 ? .5 : v,
                Ee = 2 * K - 1,
                Be = T.alpha() - I.alpha(),
                q = ((Ee * Be === -1 ? Ee : (Ee + Be) / (1 + Ee * Be)) + 1) / 2,
                V = 1 - q;
              return N.rgb(q * T.red() + V * I.red(), q * T.green() + V * I.green(), q * T.blue() + V * I.blue(), T.alpha() * K + I.alpha() * (1 - K));
            }
          }, Object.keys(W).forEach(function (m) {
            if (M.indexOf(m) === -1) {
              var v = W[m].channels;
              N.prototype[m] = function () {
                if (this.model === m) return new N(this);
                if (arguments.length) return new N(arguments, m);
                var T = typeof arguments[v] == "number" ? v : this.valpha;
                return new N(E(W[this.model][m].raw(this.color)).concat(T), m);
              }, N[m] = function (T) {
                return typeof T == "number" && (T = S(J.call(arguments), v)), new N(T, m);
              };
            }
          });
          function ee(m, v) {
            return Number(m.toFixed(v));
          }
          function p(m) {
            return function (v) {
              return ee(v, m);
            };
          }
          function w(m, v, T) {
            return m = Array.isArray(m) ? m : [m], m.forEach(function (I) {
              (A[I] || (A[I] = []))[v] = T;
            }), m = m[0], function (I) {
              var K;
              return arguments.length ? (T && (I = T(I)), K = this[m](), K.color[v] = I, K) : (K = this[m]().color[v], T && (K = T(K)), K);
            };
          }
          function x(m) {
            return function (v) {
              return Math.max(0, Math.min(m, v));
            };
          }
          function E(m) {
            return Array.isArray(m) ? m : [m];
          }
          function S(m, v) {
            for (var T = 0; T < v; T++) {
              typeof m[T] != "number" && (m[T] = 0);
            }
            return m;
          }
          _21.exports = N;
        },
        594: function _(_22, c, O) {
          var Z = "Expected a function",
            W = NaN,
            J = "[object Symbol]",
            M = /^\s+|\s+$/g,
            $ = /^[-+]0x[0-9a-f]+$/i,
            A = /^0b[01]+$/i,
            N = /^0o[0-7]+$/i,
            ee = parseInt,
            p = typeof O.g == "object" && O.g && O.g.Object === Object && O.g,
            w = typeof self == "object" && self && self.Object === Object && self,
            x = p || w || Function("return this")(),
            E = Object.prototype,
            S = E.toString,
            m = Math.max,
            v = Math.min,
            T = function T() {
              return x.Date.now();
            };
          function I(V, Q, ae) {
            var G,
              nt,
              Re,
              qe,
              et,
              yt,
              $t = 0,
              Rr = !1,
              Ht = !1,
              sr = !0;
            if (typeof V != "function") throw new TypeError(Z);
            Q = q(Q) || 0, K(ae) && (Rr = !!ae.leading, Ht = "maxWait" in ae, Re = Ht ? m(q(ae.maxWait) || 0, Q) : Re, sr = "trailing" in ae ? !!ae.trailing : sr);
            function lr(He) {
              var Lt = G,
                it = nt;
              return G = nt = void 0, $t = He, qe = V.apply(it, Lt), qe;
            }
            function Jr(He) {
              return $t = He, et = setTimeout(Ut, Q), Rr ? lr(He) : qe;
            }
            function pn(He) {
              var Lt = He - yt,
                it = He - $t,
                qr = Q - Lt;
              return Ht ? v(qr, Re - it) : qr;
            }
            function cr(He) {
              var Lt = He - yt,
                it = He - $t;
              return yt === void 0 || Lt >= Q || Lt < 0 || Ht && it >= Re;
            }
            function Ut() {
              var He = T();
              if (cr(He)) return Xr(He);
              et = setTimeout(Ut, pn(He));
            }
            function Xr(He) {
              return et = void 0, sr && G ? lr(He) : (G = nt = void 0, qe);
            }
            function Ir() {
              et !== void 0 && clearTimeout(et), $t = 0, G = yt = nt = et = void 0;
            }
            function vr() {
              return et === void 0 ? qe : Xr(T());
            }
            function se() {
              var He = T(),
                Lt = cr(He);
              if (G = arguments, nt = this, yt = He, Lt) {
                if (et === void 0) return Jr(yt);
                if (Ht) return et = setTimeout(Ut, Q), lr(yt);
              }
              return et === void 0 && (et = setTimeout(Ut, Q)), qe;
            }
            return se.cancel = Ir, se.flush = vr, se;
          }
          function K(V) {
            var Q = typeof V;
            return !!V && (Q == "object" || Q == "function");
          }
          function Ee(V) {
            return !!V && typeof V == "object";
          }
          function Be(V) {
            return typeof V == "symbol" || Ee(V) && S.call(V) == J;
          }
          function q(V) {
            if (typeof V == "number") return V;
            if (Be(V)) return W;
            if (K(V)) {
              var Q = typeof V.valueOf == "function" ? V.valueOf() : V;
              V = K(Q) ? Q + "" : Q;
            }
            if (typeof V != "string") return V === 0 ? V : +V;
            V = V.replace(M, "");
            var ae = A.test(V);
            return ae || N.test(V) ? ee(V.slice(2), ae ? 2 : 8) : $.test(V) ? W : +V;
          }
          _22.exports = I;
        },
        572: function _(_23, c, O) {
          _23 = O.nmd(_23);
          var Z = 200,
            W = "Expected a function",
            J = "__lodash_hash_undefined__",
            M = 1,
            $ = 2,
            A = 1 / 0,
            N = 9007199254740991,
            ee = "[object Arguments]",
            p = "[object Array]",
            w = "[object Boolean]",
            x = "[object Date]",
            E = "[object Error]",
            S = "[object Function]",
            m = "[object GeneratorFunction]",
            v = "[object Map]",
            T = "[object Number]",
            I = "[object Object]",
            K = "[object Promise]",
            Ee = "[object RegExp]",
            Be = "[object Set]",
            q = "[object String]",
            V = "[object Symbol]",
            Q = "[object WeakMap]",
            ae = "[object ArrayBuffer]",
            G = "[object DataView]",
            nt = "[object Float32Array]",
            Re = "[object Float64Array]",
            qe = "[object Int8Array]",
            et = "[object Int16Array]",
            yt = "[object Int32Array]",
            $t = "[object Uint8Array]",
            Rr = "[object Uint8ClampedArray]",
            Ht = "[object Uint16Array]",
            sr = "[object Uint32Array]",
            lr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Jr = /^\w*$/,
            pn = /^\./,
            cr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            Ut = /[\\^$.*+?()[\]{}|]/g,
            Xr = /\\(\\)?/g,
            Ir = /^\[object .+?Constructor\]$/,
            vr = /^(?:0|[1-9]\d*)$/,
            se = {};
          se[nt] = se[Re] = se[qe] = se[et] = se[yt] = se[$t] = se[Rr] = se[Ht] = se[sr] = !0, se[ee] = se[p] = se[ae] = se[w] = se[G] = se[x] = se[E] = se[S] = se[v] = se[T] = se[I] = se[Ee] = se[Be] = se[q] = se[Q] = !1;
          var He = typeof O.g == "object" && O.g && O.g.Object === Object && O.g,
            Lt = typeof self == "object" && self && self.Object === Object && self,
            it = He || Lt || Function("return this")(),
            qr = c && !c.nodeType && c,
            Zn = qr && !0 && _23 && !_23.nodeType && _23,
            Ba = Zn && Zn.exports === qr,
            mn = Ba && He.process,
            Vn = function () {
              try {
                return mn && mn.binding("util");
              } catch (s) {}
            }(),
            gn = Vn && Vn.isTypedArray;
          function za(s, f, b, P) {
            for (var k = -1, B = s ? s.length : 0; ++k < B;) {
              var te = s[k];
              f(P, te, b(te), s);
            }
            return P;
          }
          function $a(s, f) {
            for (var b = -1, P = s ? s.length : 0; ++b < P;) {
              if (f(s[b], b, s)) return !0;
            }
            return !1;
          }
          function Ha(s) {
            return function (f) {
              return f == null ? void 0 : f[s];
            };
          }
          function Ua(s, f) {
            for (var b = -1, P = Array(s); ++b < s;) {
              P[b] = f(b);
            }
            return P;
          }
          function Ri(s) {
            return function (f) {
              return s(f);
            };
          }
          function Za(s, f) {
            return s == null ? void 0 : s[f];
          }
          function Kr(s) {
            var f = !1;
            if (s != null && typeof s.toString != "function") try {
              f = !!(s + "");
            } catch (b) {}
            return f;
          }
          function Va(s) {
            var f = -1,
              b = Array(s.size);
            return s.forEach(function (P, k) {
              b[++f] = [k, P];
            }), b;
          }
          function Ga(s, f) {
            return function (b) {
              return s(f(b));
            };
          }
          function Wa(s) {
            var f = -1,
              b = Array(s.size);
            return s.forEach(function (P) {
              b[++f] = P;
            }), b;
          }
          var Ja = Array.prototype,
            Ii = Function.prototype,
            Ar = Object.prototype,
            vn = it["__core-js_shared__"],
            ca = function () {
              var s = /[^.]+$/.exec(vn && vn.keys && vn.keys.IE_PROTO || "");
              return s ? "Symbol(src)_1." + s : "";
            }(),
            ua = Ii.toString,
            wt = Ar.hasOwnProperty,
            Zt = Ar.toString,
            Ai = RegExp("^" + ua.call(wt).replace(Ut, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
            fa = it.Symbol,
            da = it.Uint8Array,
            Xa = Ar.propertyIsEnumerable,
            qa = Ja.splice,
            Di = Ga(Object.keys, Object),
            ot = Rt(it, "DataView"),
            Vt = Rt(it, "Map"),
            Ue = Rt(it, "Promise"),
            Y = Rt(it, "Set"),
            At = Rt(it, "WeakMap"),
            X = Rt(Object, "create"),
            Ka = _r(ot),
            Qt = _r(Vt),
            Yr = _r(Ue),
            Qr = _r(Y),
            Ya = _r(At),
            Gt = fa ? fa.prototype : void 0,
            en = Gt ? Gt.valueOf : void 0,
            le = Gt ? Gt.toString : void 0;
          function Ke(s) {
            var f = -1,
              b = s ? s.length : 0;
            for (this.clear(); ++f < b;) {
              var P = s[f];
              this.set(P[0], P[1]);
            }
          }
          function ke() {
            this.__data__ = X ? X(null) : {};
          }
          function Qa(s) {
            return this.has(s) && delete this.__data__[s];
          }
          function Ct(s) {
            var f = this.__data__;
            if (X) {
              var b = f[s];
              return b === J ? void 0 : b;
            }
            return wt.call(f, s) ? f[s] : void 0;
          }
          function Gn(s) {
            var f = this.__data__;
            return X ? f[s] !== void 0 : wt.call(f, s);
          }
          function Wn(s, f) {
            var b = this.__data__;
            return b[s] = X && f === void 0 ? J : f, this;
          }
          Ke.prototype.clear = ke, Ke.prototype.delete = Qa, Ke.prototype.get = Ct, Ke.prototype.has = Gn, Ke.prototype.set = Wn;
          function ft(s) {
            var f = -1,
              b = s ? s.length : 0;
            for (this.clear(); ++f < b;) {
              var P = s[f];
              this.set(P[0], P[1]);
            }
          }
          function Jn() {
            this.__data__ = [];
          }
          function Ge(s) {
            var f = this.__data__,
              b = Tt(f, s);
            if (b < 0) return !1;
            var P = f.length - 1;
            return b == P ? f.pop() : qa.call(f, b, 1), !0;
          }
          function Wt(s) {
            var f = this.__data__,
              b = Tt(f, s);
            return b < 0 ? void 0 : f[b][1];
          }
          function ha(s) {
            return Tt(this.__data__, s) > -1;
          }
          function Ae(s, f) {
            var b = this.__data__,
              P = Tt(b, s);
            return P < 0 ? b.push([s, f]) : b[P][1] = f, this;
          }
          ft.prototype.clear = Jn, ft.prototype.delete = Ge, ft.prototype.get = Wt, ft.prototype.has = ha, ft.prototype.set = Ae;
          function ce(s) {
            var f = -1,
              b = s ? s.length : 0;
            for (this.clear(); ++f < b;) {
              var P = s[f];
              this.set(P[0], P[1]);
            }
          }
          function ei() {
            this.__data__ = {
              hash: new Ke(),
              map: new (Vt || ft)(),
              string: new Ke()
            };
          }
          function ti(s) {
            return Rn(this, s).delete(s);
          }
          function ri(s) {
            return Rn(this, s).get(s);
          }
          function ur(s) {
            return Rn(this, s).has(s);
          }
          function ni(s, f) {
            return Rn(this, s).set(s, f), this;
          }
          ce.prototype.clear = ei, ce.prototype.delete = ti, ce.prototype.get = ri, ce.prototype.has = ur, ce.prototype.set = ni;
          function Pt(s) {
            var f = -1,
              b = s ? s.length : 0;
            for (this.__data__ = new ce(); ++f < b;) {
              this.add(s[f]);
            }
          }
          function bn(s) {
            return this.__data__.set(s, J), this;
          }
          function yn(s) {
            return this.__data__.has(s);
          }
          Pt.prototype.add = Pt.prototype.push = bn, Pt.prototype.has = yn;
          function dt(s) {
            this.__data__ = new ft(s);
          }
          function wn() {
            this.__data__ = new ft();
          }
          function _n(s) {
            return this.__data__.delete(s);
          }
          function Dr(s) {
            return this.__data__.get(s);
          }
          function fr(s) {
            return this.__data__.has(s);
          }
          function dr(s, f) {
            var b = this.__data__;
            if (b instanceof ft) {
              var P = b.__data__;
              if (!Vt || P.length < Z - 1) return P.push([s, f]), this;
              b = this.__data__ = new ce(P);
            }
            return b.set(s, f), this;
          }
          dt.prototype.clear = wn, dt.prototype.delete = _n, dt.prototype.get = Dr, dt.prototype.has = fr, dt.prototype.set = dr;
          function xn(s, f) {
            var b = Ft(s) || tr(s) ? Ua(s.length, String) : [],
              P = b.length,
              k = !!P;
            for (var B in s) {
              (f || wt.call(s, B)) && !(k && (B == "length" || an(B, P))) && b.push(B);
            }
            return b;
          }
          function Tt(s, f) {
            for (var b = s.length; b--;) {
              if (Yn(s[b][0], f)) return b;
            }
            return -1;
          }
          function En(s, f, b, P) {
            return pa(s, function (k, B, te) {
              f(P, k, b(k), te);
            }), P;
          }
          var pa = qt(tt),
            Lr = pr();
          function tt(s, f) {
            return s && Lr(s, f, on);
          }
          function Fr(s, f) {
            f = In(f, s) ? [f] : hr(f);
            for (var b = 0, P = f.length; s != null && b < P;) {
              s = s[Kt(f[b++])];
            }
            return b && b == P ? s : void 0;
          }
          function On(s) {
            return Zt.call(s);
          }
          function tn(s, f) {
            return s != null && f in Object(s);
          }
          function br(s, f, b, P, k) {
            return s === f ? !0 : s == null || f == null || !xr(s) && !Br(f) ? s !== s && f !== f : Jt(s, f, br, b, P, k);
          }
          function Jt(s, f, b, P, k, B) {
            var te = Ft(s),
              fe = Ft(f),
              Se = p,
              Le = p;
            te || (Se = er(s), Se = Se == ee ? I : Se), fe || (Le = er(f), Le = Le == ee ? I : Le);
            var We = Se == I && !Kr(s),
              ze = Le == I && !Kr(f),
              Ze = Se == Le;
            if (Ze && !We) return B || (B = new dt()), te || oi(s) ? Nn(s, f, b, P, k, B) : Pn(s, f, Se, b, P, k, B);
            if (!(k & $)) {
              var lt = We && wt.call(s, "__wrapped__"),
                ct = ze && wt.call(f, "__wrapped__");
              if (lt || ct) {
                var ht = lt ? s.value() : s,
                  vt = ct ? f.value() : f;
                return B || (B = new dt()), b(ht, vt, P, k, B);
              }
            }
            return Ze ? (B || (B = new dt()), nn(s, f, b, P, k, B)) : !1;
          }
          function rn(s, f, b, P) {
            var k = b.length,
              B = k,
              te = !P;
            if (s == null) return !B;
            for (s = Object(s); k--;) {
              var fe = b[k];
              if (te && fe[2] ? fe[1] !== s[fe[0]] : !(fe[0] in s)) return !1;
            }
            for (; ++k < B;) {
              fe = b[k];
              var Se = fe[0],
                Le = s[Se],
                We = fe[1];
              if (te && fe[2]) {
                if (Le === void 0 && !(Se in s)) return !1;
              } else {
                var ze = new dt();
                if (P) var Ze = P(Le, We, Se, s, f, ze);
                if (!(Ze === void 0 ? br(We, Le, P, M | $, ze) : Ze)) return !1;
              }
            }
            return !0;
          }
          function Tn(s) {
            if (!xr(s) || ii(s)) return !1;
            var f = Ln(s) || Kr(s) ? Ai : Ir;
            return f.test(_r(s));
          }
          function yr(s) {
            return Br(s) && jr(s.length) && !!se[Zt.call(s)];
          }
          function wr(s) {
            return typeof s == "function" ? s : s == null ? ci : typeof s == "object" ? Ft(s) ? ai(s[0], s[1]) : Sn(s) : d(s);
          }
          function kn(s) {
            if (!ga(s)) return Di(s);
            var f = [];
            for (var b in Object(s)) {
              wt.call(s, b) && b != "constructor" && f.push(b);
            }
            return f;
          }
          function Sn(s) {
            var f = me(s);
            return f.length == 1 && f[0][2] ? va(f[0][0], f[0][1]) : function (b) {
              return b === s || rn(b, s, f);
            };
          }
          function ai(s, f) {
            return In(s) && qn(f) ? va(Kt(s), f) : function (b) {
              var P = li(b, s);
              return P === void 0 && P === f ? Fn(b, s) : br(f, P, void 0, M | $);
            };
          }
          function Cn(s) {
            return function (f) {
              return Fr(f, s);
            };
          }
          function Mn(s) {
            if (typeof s == "string") return s;
            if (ea(s)) return le ? le.call(s) : "";
            var f = s + "";
            return f == "0" && 1 / s == -A ? "-0" : f;
          }
          function hr(s) {
            return Ft(s) ? s : An(s);
          }
          function Xt(s, f) {
            return function (b, P) {
              var k = Ft(b) ? za : En,
                B = f ? f() : {};
              return k(b, s, wr(P, 2), B);
            };
          }
          function qt(s, f) {
            return function (b, P) {
              if (b == null) return b;
              if (!Qn(b)) return s(b, P);
              for (var k = b.length, B = f ? k : -1, te = Object(b); (f ? B-- : ++B < k) && P(te[B], B, te) !== !1;) {
                ;
              }
              return b;
            };
          }
          function pr(s) {
            return function (f, b, P) {
              for (var k = -1, B = Object(f), te = P(f), fe = te.length; fe--;) {
                var Se = te[s ? fe : ++k];
                if (b(B[Se], Se, B) === !1) break;
              }
              return f;
            };
          }
          function Nn(s, f, b, P, k, B) {
            var te = k & $,
              fe = s.length,
              Se = f.length;
            if (fe != Se && !(te && Se > fe)) return !1;
            var Le = B.get(s);
            if (Le && B.get(f)) return Le == f;
            var We = -1,
              ze = !0,
              Ze = k & M ? new Pt() : void 0;
            for (B.set(s, f), B.set(f, s); ++We < fe;) {
              var lt = s[We],
                ct = f[We];
              if (P) var ht = te ? P(ct, lt, We, f, s, B) : P(lt, ct, We, s, f, B);
              if (ht !== void 0) {
                if (ht) continue;
                ze = !1;
                break;
              }
              if (Ze) {
                if (!$a(f, function (vt, mr) {
                  if (!Ze.has(mr) && (lt === vt || b(lt, vt, P, k, B))) return Ze.add(mr);
                })) {
                  ze = !1;
                  break;
                }
              } else if (!(lt === ct || b(lt, ct, P, k, B))) {
                ze = !1;
                break;
              }
            }
            return B.delete(s), B.delete(f), ze;
          }
          function Pn(s, f, b, P, k, B, te) {
            switch (b) {
              case G:
                if (s.byteLength != f.byteLength || s.byteOffset != f.byteOffset) return !1;
                s = s.buffer, f = f.buffer;
              case ae:
                return !(s.byteLength != f.byteLength || !P(new da(s), new da(f)));
              case w:
              case x:
              case T:
                return Yn(+s, +f);
              case E:
                return s.name == f.name && s.message == f.message;
              case Ee:
              case q:
                return s == f + "";
              case v:
                var fe = Va;
              case Be:
                var Se = B & $;
                if (fe || (fe = Wa), s.size != f.size && !Se) return !1;
                var Le = te.get(s);
                if (Le) return Le == f;
                B |= M, te.set(s, f);
                var We = Nn(fe(s), fe(f), P, k, B, te);
                return te.delete(s), We;
              case V:
                if (en) return en.call(s) == en.call(f);
            }
            return !1;
          }
          function nn(s, f, b, P, k, B) {
            var te = k & $,
              fe = on(s),
              Se = fe.length,
              Le = on(f),
              We = Le.length;
            if (Se != We && !te) return !1;
            for (var ze = Se; ze--;) {
              var Ze = fe[ze];
              if (!(te ? Ze in f : wt.call(f, Ze))) return !1;
            }
            var lt = B.get(s);
            if (lt && B.get(f)) return lt == f;
            var ct = !0;
            B.set(s, f), B.set(f, s);
            for (var ht = te; ++ze < Se;) {
              Ze = fe[ze];
              var vt = s[Ze],
                mr = f[Ze];
              if (P) var Er = te ? P(mr, vt, Ze, f, s, B) : P(vt, mr, Ze, s, f, B);
              if (!(Er === void 0 ? vt === mr || b(vt, mr, P, k, B) : Er)) {
                ct = !1;
                break;
              }
              ht || (ht = Ze == "constructor");
            }
            if (ct && !ht) {
              var Or = s.constructor,
                ya = f.constructor;
              Or != ya && "constructor" in s && "constructor" in f && !(typeof Or == "function" && Or instanceof Or && typeof ya == "function" && ya instanceof ya) && (ct = !1);
            }
            return B.delete(s), B.delete(f), ct;
          }
          function Rn(s, f) {
            var b = s.__data__;
            return ma(f) ? b[typeof f == "string" ? "string" : "hash"] : b.map;
          }
          function me(s) {
            for (var f = on(s), b = f.length; b--;) {
              var P = f[b],
                k = s[P];
              f[b] = [P, k, qn(k)];
            }
            return f;
          }
          function Rt(s, f) {
            var b = Za(s, f);
            return Tn(b) ? b : void 0;
          }
          var er = On;
          (ot && er(new ot(new ArrayBuffer(1))) != G || Vt && er(new Vt()) != v || Ue && er(Ue.resolve()) != K || Y && er(new Y()) != Be || At && er(new At()) != Q) && (er = function er(s) {
            var f = Zt.call(s),
              b = f == I ? s.constructor : void 0,
              P = b ? _r(b) : void 0;
            if (P) switch (P) {
              case Ka:
                return G;
              case Qt:
                return v;
              case Yr:
                return K;
              case Qr:
                return Be;
              case Ya:
                return Q;
            }
            return f;
          });
          function Xn(s, f, b) {
            f = In(f, s) ? [f] : hr(f);
            for (var P, k = -1, te = f.length; ++k < te;) {
              var B = Kt(f[k]);
              if (!(P = s != null && b(s, B))) break;
              s = s[B];
            }
            if (P) return P;
            var te = s ? s.length : 0;
            return !!te && jr(te) && an(B, te) && (Ft(s) || tr(s));
          }
          function an(s, f) {
            return f = f == null ? N : f, !!f && (typeof s == "number" || vr.test(s)) && s > -1 && s % 1 == 0 && s < f;
          }
          function In(s, f) {
            if (Ft(s)) return !1;
            var b = typeof s;
            return b == "number" || b == "symbol" || b == "boolean" || s == null || ea(s) ? !0 : Jr.test(s) || !lr.test(s) || f != null && s in Object(f);
          }
          function ma(s) {
            var f = typeof s;
            return f == "string" || f == "number" || f == "symbol" || f == "boolean" ? s !== "__proto__" : s === null;
          }
          function ii(s) {
            return !!ca && ca in s;
          }
          function ga(s) {
            var f = s && s.constructor,
              b = typeof f == "function" && f.prototype || Ar;
            return s === b;
          }
          function qn(s) {
            return s === s && !xr(s);
          }
          function va(s, f) {
            return function (b) {
              return b == null ? !1 : b[s] === f && (f !== void 0 || s in Object(b));
            };
          }
          var An = Dn(function (s) {
            s = si(s);
            var f = [];
            return pn.test(s) && f.push(""), s.replace(cr, function (b, P, k, B) {
              f.push(k ? B.replace(Xr, "$1") : P || b);
            }), f;
          });
          function Kt(s) {
            if (typeof s == "string" || ea(s)) return s;
            var f = s + "";
            return f == "0" && 1 / s == -A ? "-0" : f;
          }
          function _r(s) {
            if (s != null) {
              try {
                return ua.call(s);
              } catch (f) {}
              try {
                return s + "";
              } catch (f) {}
            }
            return "";
          }
          var Kn = Xt(function (s, f, b) {
            wt.call(s, b) ? s[b].push(f) : s[b] = [f];
          });
          function Dn(s, f) {
            if (typeof s != "function" || f && typeof f != "function") throw new TypeError(W);
            var b = function b() {
              var P = arguments,
                k = f ? f.apply(this, P) : P[0],
                B = b.cache;
              if (B.has(k)) return B.get(k);
              var te = s.apply(this, P);
              return b.cache = B.set(k, te), te;
            };
            return b.cache = new (Dn.Cache || ce)(), b;
          }
          Dn.Cache = ce;
          function Yn(s, f) {
            return s === f || s !== s && f !== f;
          }
          function tr(s) {
            return ba(s) && wt.call(s, "callee") && (!Xa.call(s, "callee") || Zt.call(s) == ee);
          }
          var Ft = Array.isArray;
          function Qn(s) {
            return s != null && jr(s.length) && !Ln(s);
          }
          function ba(s) {
            return Br(s) && Qn(s);
          }
          function Ln(s) {
            var f = xr(s) ? Zt.call(s) : "";
            return f == S || f == m;
          }
          function jr(s) {
            return typeof s == "number" && s > -1 && s % 1 == 0 && s <= N;
          }
          function xr(s) {
            var f = typeof s;
            return !!s && (f == "object" || f == "function");
          }
          function Br(s) {
            return !!s && typeof s == "object";
          }
          function ea(s) {
            return typeof s == "symbol" || Br(s) && Zt.call(s) == V;
          }
          var oi = gn ? Ri(gn) : yr;
          function si(s) {
            return s == null ? "" : Mn(s);
          }
          function li(s, f, b) {
            var P = s == null ? void 0 : Fr(s, f);
            return P === void 0 ? b : P;
          }
          function Fn(s, f) {
            return s != null && Xn(s, f, tn);
          }
          function on(s) {
            return Qn(s) ? xn(s) : kn(s);
          }
          function ci(s) {
            return s;
          }
          function d(s) {
            return In(s) ? Ha(Kt(s)) : Cn(s);
          }
          _23.exports = Kn;
        },
        343: function _(_24, c, O) {
          _24 = O.nmd(_24);
          var Z = 200,
            W = "Expected a function",
            J = "__lodash_hash_undefined__",
            M = 1,
            $ = 2,
            A = 1 / 0,
            N = 9007199254740991,
            ee = "[object Arguments]",
            p = "[object Array]",
            w = "[object Boolean]",
            x = "[object Date]",
            E = "[object Error]",
            S = "[object Function]",
            m = "[object GeneratorFunction]",
            v = "[object Map]",
            T = "[object Number]",
            I = "[object Object]",
            K = "[object Promise]",
            Ee = "[object RegExp]",
            Be = "[object Set]",
            q = "[object String]",
            V = "[object Symbol]",
            Q = "[object WeakMap]",
            ae = "[object ArrayBuffer]",
            G = "[object DataView]",
            nt = "[object Float32Array]",
            Re = "[object Float64Array]",
            qe = "[object Int8Array]",
            et = "[object Int16Array]",
            yt = "[object Int32Array]",
            $t = "[object Uint8Array]",
            Rr = "[object Uint8ClampedArray]",
            Ht = "[object Uint16Array]",
            sr = "[object Uint32Array]",
            lr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            Jr = /^\w*$/,
            pn = /^\./,
            cr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            Ut = /[\\^$.*+?()[\]{}|]/g,
            Xr = /\\(\\)?/g,
            Ir = /^\[object .+?Constructor\]$/,
            vr = /^(?:0|[1-9]\d*)$/,
            se = {};
          se[nt] = se[Re] = se[qe] = se[et] = se[yt] = se[$t] = se[Rr] = se[Ht] = se[sr] = !0, se[ee] = se[p] = se[ae] = se[w] = se[G] = se[x] = se[E] = se[S] = se[v] = se[T] = se[I] = se[Ee] = se[Be] = se[q] = se[Q] = !1;
          var He = typeof O.g == "object" && O.g && O.g.Object === Object && O.g,
            Lt = typeof self == "object" && self && self.Object === Object && self,
            it = He || Lt || Function("return this")(),
            qr = c && !c.nodeType && c,
            Zn = qr && !0 && _24 && !_24.nodeType && _24,
            Ba = Zn && Zn.exports === qr,
            mn = Ba && He.process,
            Vn = function () {
              try {
                return mn && mn.binding("util");
              } catch (d) {}
            }(),
            gn = Vn && Vn.isTypedArray;
          function za(d, s) {
            for (var f = -1, b = d ? d.length : 0, P = Array(b); ++f < b;) {
              P[f] = s(d[f], f, d);
            }
            return P;
          }
          function $a(d, s) {
            for (var f = -1, b = d ? d.length : 0; ++f < b;) {
              if (s(d[f], f, d)) return !0;
            }
            return !1;
          }
          function Ha(d) {
            return function (s) {
              return s == null ? void 0 : s[d];
            };
          }
          function Ua(d, s) {
            for (var f = -1, b = Array(d); ++f < d;) {
              b[f] = s(f);
            }
            return b;
          }
          function Ri(d) {
            return function (s) {
              return d(s);
            };
          }
          function Za(d, s) {
            return d == null ? void 0 : d[s];
          }
          function Kr(d) {
            var s = !1;
            if (d != null && typeof d.toString != "function") try {
              s = !!(d + "");
            } catch (f) {}
            return s;
          }
          function Va(d) {
            var s = -1,
              f = Array(d.size);
            return d.forEach(function (b, P) {
              f[++s] = [P, b];
            }), f;
          }
          function Ga(d, s) {
            return function (f) {
              return d(s(f));
            };
          }
          function Wa(d) {
            var s = -1,
              f = Array(d.size);
            return d.forEach(function (b) {
              f[++s] = b;
            }), f;
          }
          var Ja = Array.prototype,
            Ii = Function.prototype,
            Ar = Object.prototype,
            vn = it["__core-js_shared__"],
            ca = function () {
              var d = /[^.]+$/.exec(vn && vn.keys && vn.keys.IE_PROTO || "");
              return d ? "Symbol(src)_1." + d : "";
            }(),
            ua = Ii.toString,
            wt = Ar.hasOwnProperty,
            Zt = Ar.toString,
            Ai = RegExp("^" + ua.call(wt).replace(Ut, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
            fa = it.Symbol,
            da = it.Uint8Array,
            Xa = Ar.propertyIsEnumerable,
            qa = Ja.splice,
            Di = Ga(Object.keys, Object),
            ot = me(it, "DataView"),
            Vt = me(it, "Map"),
            Ue = me(it, "Promise"),
            Y = me(it, "Set"),
            At = me(it, "WeakMap"),
            X = me(Object, "create"),
            Ka = Kt(ot),
            Qt = Kt(Vt),
            Yr = Kt(Ue),
            Qr = Kt(Y),
            Ya = Kt(At),
            Gt = fa ? fa.prototype : void 0,
            en = Gt ? Gt.valueOf : void 0,
            le = Gt ? Gt.toString : void 0;
          function Ke(d) {
            var s = -1,
              f = d ? d.length : 0;
            for (this.clear(); ++s < f;) {
              var b = d[s];
              this.set(b[0], b[1]);
            }
          }
          function ke() {
            this.__data__ = X ? X(null) : {};
          }
          function Qa(d) {
            return this.has(d) && delete this.__data__[d];
          }
          function Ct(d) {
            var s = this.__data__;
            if (X) {
              var f = s[d];
              return f === J ? void 0 : f;
            }
            return wt.call(s, d) ? s[d] : void 0;
          }
          function Gn(d) {
            var s = this.__data__;
            return X ? s[d] !== void 0 : wt.call(s, d);
          }
          function Wn(d, s) {
            var f = this.__data__;
            return f[d] = X && s === void 0 ? J : s, this;
          }
          Ke.prototype.clear = ke, Ke.prototype.delete = Qa, Ke.prototype.get = Ct, Ke.prototype.has = Gn, Ke.prototype.set = Wn;
          function ft(d) {
            var s = -1,
              f = d ? d.length : 0;
            for (this.clear(); ++s < f;) {
              var b = d[s];
              this.set(b[0], b[1]);
            }
          }
          function Jn() {
            this.__data__ = [];
          }
          function Ge(d) {
            var s = this.__data__,
              f = Tt(s, d);
            if (f < 0) return !1;
            var b = s.length - 1;
            return f == b ? s.pop() : qa.call(s, f, 1), !0;
          }
          function Wt(d) {
            var s = this.__data__,
              f = Tt(s, d);
            return f < 0 ? void 0 : s[f][1];
          }
          function ha(d) {
            return Tt(this.__data__, d) > -1;
          }
          function Ae(d, s) {
            var f = this.__data__,
              b = Tt(f, d);
            return b < 0 ? f.push([d, s]) : f[b][1] = s, this;
          }
          ft.prototype.clear = Jn, ft.prototype.delete = Ge, ft.prototype.get = Wt, ft.prototype.has = ha, ft.prototype.set = Ae;
          function ce(d) {
            var s = -1,
              f = d ? d.length : 0;
            for (this.clear(); ++s < f;) {
              var b = d[s];
              this.set(b[0], b[1]);
            }
          }
          function ei() {
            this.__data__ = {
              hash: new Ke(),
              map: new (Vt || ft)(),
              string: new Ke()
            };
          }
          function ti(d) {
            return nn(this, d).delete(d);
          }
          function ri(d) {
            return nn(this, d).get(d);
          }
          function ur(d) {
            return nn(this, d).has(d);
          }
          function ni(d, s) {
            return nn(this, d).set(d, s), this;
          }
          ce.prototype.clear = ei, ce.prototype.delete = ti, ce.prototype.get = ri, ce.prototype.has = ur, ce.prototype.set = ni;
          function Pt(d) {
            var s = -1,
              f = d ? d.length : 0;
            for (this.__data__ = new ce(); ++s < f;) {
              this.add(d[s]);
            }
          }
          function bn(d) {
            return this.__data__.set(d, J), this;
          }
          function yn(d) {
            return this.__data__.has(d);
          }
          Pt.prototype.add = Pt.prototype.push = bn, Pt.prototype.has = yn;
          function dt(d) {
            this.__data__ = new ft(d);
          }
          function wn() {
            this.__data__ = new ft();
          }
          function _n(d) {
            return this.__data__.delete(d);
          }
          function Dr(d) {
            return this.__data__.get(d);
          }
          function fr(d) {
            return this.__data__.has(d);
          }
          function dr(d, s) {
            var f = this.__data__;
            if (f instanceof ft) {
              var b = f.__data__;
              if (!Vt || b.length < Z - 1) return b.push([d, s]), this;
              f = this.__data__ = new ce(b);
            }
            return f.set(d, s), this;
          }
          dt.prototype.clear = wn, dt.prototype.delete = _n, dt.prototype.get = Dr, dt.prototype.has = fr, dt.prototype.set = dr;
          function xn(d, s) {
            var f = tr(d) || Yn(d) ? Ua(d.length, String) : [],
              b = f.length,
              P = !!b;
            for (var k in d) {
              (s || wt.call(d, k)) && !(P && (k == "length" || Xn(k, b))) && f.push(k);
            }
            return f;
          }
          function Tt(d, s) {
            for (var f = d.length; f--;) {
              if (Dn(d[f][0], s)) return f;
            }
            return -1;
          }
          var En = Xt(Lr),
            pa = qt();
          function Lr(d, s) {
            return d && pa(d, s, Fn);
          }
          function tt(d, s) {
            s = an(s, d) ? [s] : hr(s);
            for (var f = 0, b = s.length; d != null && f < b;) {
              d = d[An(s[f++])];
            }
            return f && f == b ? d : void 0;
          }
          function Fr(d) {
            return Zt.call(d);
          }
          function On(d, s) {
            return d != null && s in Object(d);
          }
          function tn(d, s, f, b, P) {
            return d === s ? !0 : d == null || s == null || !jr(d) && !xr(s) ? d !== d && s !== s : br(d, s, tn, f, b, P);
          }
          function br(d, s, f, b, P, k) {
            var B = tr(d),
              te = tr(s),
              fe = p,
              Se = p;
            B || (fe = Rt(d), fe = fe == ee ? I : fe), te || (Se = Rt(s), Se = Se == ee ? I : Se);
            var Le = fe == I && !Kr(d),
              We = Se == I && !Kr(s),
              ze = fe == Se;
            if (ze && !Le) return k || (k = new dt()), B || ea(d) ? pr(d, s, f, b, P, k) : Nn(d, s, fe, f, b, P, k);
            if (!(P & $)) {
              var Ze = Le && wt.call(d, "__wrapped__"),
                lt = We && wt.call(s, "__wrapped__");
              if (Ze || lt) {
                var ct = Ze ? d.value() : d,
                  ht = lt ? s.value() : s;
                return k || (k = new dt()), f(ct, ht, b, P, k);
              }
            }
            return ze ? (k || (k = new dt()), Pn(d, s, f, b, P, k)) : !1;
          }
          function Jt(d, s, f, b) {
            var P = f.length,
              k = P,
              B = !b;
            if (d == null) return !k;
            for (d = Object(d); P--;) {
              var te = f[P];
              if (B && te[2] ? te[1] !== d[te[0]] : !(te[0] in d)) return !1;
            }
            for (; ++P < k;) {
              te = f[P];
              var fe = te[0],
                Se = d[fe],
                Le = te[1];
              if (B && te[2]) {
                if (Se === void 0 && !(fe in d)) return !1;
              } else {
                var We = new dt();
                if (b) var ze = b(Se, Le, fe, d, s, We);
                if (!(ze === void 0 ? tn(Le, Se, b, M | $, We) : ze)) return !1;
              }
            }
            return !0;
          }
          function rn(d) {
            if (!jr(d) || ma(d)) return !1;
            var s = ba(d) || Kr(d) ? Ai : Ir;
            return s.test(Kt(d));
          }
          function Tn(d) {
            return xr(d) && Ln(d.length) && !!se[Zt.call(d)];
          }
          function yr(d) {
            return typeof d == "function" ? d : d == null ? on : typeof d == "object" ? tr(d) ? ai(d[0], d[1]) : Sn(d) : ci(d);
          }
          function wr(d) {
            if (!ii(d)) return Di(d);
            var s = [];
            for (var f in Object(d)) {
              wt.call(d, f) && f != "constructor" && s.push(f);
            }
            return s;
          }
          function kn(d, s) {
            var f = -1,
              b = Ft(d) ? Array(d.length) : [];
            return En(d, function (P, k, B) {
              b[++f] = s(P, k, B);
            }), b;
          }
          function Sn(d) {
            var s = Rn(d);
            return s.length == 1 && s[0][2] ? qn(s[0][0], s[0][1]) : function (f) {
              return f === d || Jt(f, d, s);
            };
          }
          function ai(d, s) {
            return an(d) && ga(s) ? qn(An(d), s) : function (f) {
              var b = si(f, d);
              return b === void 0 && b === s ? li(f, d) : tn(s, b, void 0, M | $);
            };
          }
          function Cn(d) {
            return function (s) {
              return tt(s, d);
            };
          }
          function Mn(d) {
            if (typeof d == "string") return d;
            if (Br(d)) return le ? le.call(d) : "";
            var s = d + "";
            return s == "0" && 1 / d == -A ? "-0" : s;
          }
          function hr(d) {
            return tr(d) ? d : va(d);
          }
          function Xt(d, s) {
            return function (f, b) {
              if (f == null) return f;
              if (!Ft(f)) return d(f, b);
              for (var P = f.length, k = s ? P : -1, B = Object(f); (s ? k-- : ++k < P) && b(B[k], k, B) !== !1;) {
                ;
              }
              return f;
            };
          }
          function qt(d) {
            return function (s, f, b) {
              for (var P = -1, k = Object(s), B = b(s), te = B.length; te--;) {
                var fe = B[d ? te : ++P];
                if (f(k[fe], fe, k) === !1) break;
              }
              return s;
            };
          }
          function pr(d, s, f, b, P, k) {
            var B = P & $,
              te = d.length,
              fe = s.length;
            if (te != fe && !(B && fe > te)) return !1;
            var Se = k.get(d);
            if (Se && k.get(s)) return Se == s;
            var Le = -1,
              We = !0,
              ze = P & M ? new Pt() : void 0;
            for (k.set(d, s), k.set(s, d); ++Le < te;) {
              var Ze = d[Le],
                lt = s[Le];
              if (b) var ct = B ? b(lt, Ze, Le, s, d, k) : b(Ze, lt, Le, d, s, k);
              if (ct !== void 0) {
                if (ct) continue;
                We = !1;
                break;
              }
              if (ze) {
                if (!$a(s, function (ht, vt) {
                  if (!ze.has(vt) && (Ze === ht || f(Ze, ht, b, P, k))) return ze.add(vt);
                })) {
                  We = !1;
                  break;
                }
              } else if (!(Ze === lt || f(Ze, lt, b, P, k))) {
                We = !1;
                break;
              }
            }
            return k.delete(d), k.delete(s), We;
          }
          function Nn(d, s, f, b, P, k, B) {
            switch (f) {
              case G:
                if (d.byteLength != s.byteLength || d.byteOffset != s.byteOffset) return !1;
                d = d.buffer, s = s.buffer;
              case ae:
                return !(d.byteLength != s.byteLength || !b(new da(d), new da(s)));
              case w:
              case x:
              case T:
                return Dn(+d, +s);
              case E:
                return d.name == s.name && d.message == s.message;
              case Ee:
              case q:
                return d == s + "";
              case v:
                var te = Va;
              case Be:
                var fe = k & $;
                if (te || (te = Wa), d.size != s.size && !fe) return !1;
                var Se = B.get(d);
                if (Se) return Se == s;
                k |= M, B.set(d, s);
                var Le = pr(te(d), te(s), b, P, k, B);
                return B.delete(d), Le;
              case V:
                if (en) return en.call(d) == en.call(s);
            }
            return !1;
          }
          function Pn(d, s, f, b, P, k) {
            var B = P & $,
              te = Fn(d),
              fe = te.length,
              Se = Fn(s),
              Le = Se.length;
            if (fe != Le && !B) return !1;
            for (var We = fe; We--;) {
              var ze = te[We];
              if (!(B ? ze in s : wt.call(s, ze))) return !1;
            }
            var Ze = k.get(d);
            if (Ze && k.get(s)) return Ze == s;
            var lt = !0;
            k.set(d, s), k.set(s, d);
            for (var ct = B; ++We < fe;) {
              ze = te[We];
              var ht = d[ze],
                vt = s[ze];
              if (b) var mr = B ? b(vt, ht, ze, s, d, k) : b(ht, vt, ze, d, s, k);
              if (!(mr === void 0 ? ht === vt || f(ht, vt, b, P, k) : mr)) {
                lt = !1;
                break;
              }
              ct || (ct = ze == "constructor");
            }
            if (lt && !ct) {
              var Er = d.constructor,
                Or = s.constructor;
              Er != Or && "constructor" in d && "constructor" in s && !(typeof Er == "function" && Er instanceof Er && typeof Or == "function" && Or instanceof Or) && (lt = !1);
            }
            return k.delete(d), k.delete(s), lt;
          }
          function nn(d, s) {
            var f = d.__data__;
            return In(s) ? f[typeof s == "string" ? "string" : "hash"] : f.map;
          }
          function Rn(d) {
            for (var s = Fn(d), f = s.length; f--;) {
              var b = s[f],
                P = d[b];
              s[f] = [b, P, ga(P)];
            }
            return s;
          }
          function me(d, s) {
            var f = Za(d, s);
            return rn(f) ? f : void 0;
          }
          var Rt = Fr;
          (ot && Rt(new ot(new ArrayBuffer(1))) != G || Vt && Rt(new Vt()) != v || Ue && Rt(Ue.resolve()) != K || Y && Rt(new Y()) != Be || At && Rt(new At()) != Q) && (Rt = function Rt(d) {
            var s = Zt.call(d),
              f = s == I ? d.constructor : void 0,
              b = f ? Kt(f) : void 0;
            if (b) switch (b) {
              case Ka:
                return G;
              case Qt:
                return v;
              case Yr:
                return K;
              case Qr:
                return Be;
              case Ya:
                return Q;
            }
            return s;
          });
          function er(d, s, f) {
            s = an(s, d) ? [s] : hr(s);
            for (var b, P = -1, B = s.length; ++P < B;) {
              var k = An(s[P]);
              if (!(b = d != null && f(d, k))) break;
              d = d[k];
            }
            if (b) return b;
            var B = d ? d.length : 0;
            return !!B && Ln(B) && Xn(k, B) && (tr(d) || Yn(d));
          }
          function Xn(d, s) {
            return s = s == null ? N : s, !!s && (typeof d == "number" || vr.test(d)) && d > -1 && d % 1 == 0 && d < s;
          }
          function an(d, s) {
            if (tr(d)) return !1;
            var f = typeof d;
            return f == "number" || f == "symbol" || f == "boolean" || d == null || Br(d) ? !0 : Jr.test(d) || !lr.test(d) || s != null && d in Object(s);
          }
          function In(d) {
            var s = typeof d;
            return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? d !== "__proto__" : d === null;
          }
          function ma(d) {
            return !!ca && ca in d;
          }
          function ii(d) {
            var s = d && d.constructor,
              f = typeof s == "function" && s.prototype || Ar;
            return d === f;
          }
          function ga(d) {
            return d === d && !jr(d);
          }
          function qn(d, s) {
            return function (f) {
              return f == null ? !1 : f[d] === s && (s !== void 0 || d in Object(f));
            };
          }
          var va = Kn(function (d) {
            d = oi(d);
            var s = [];
            return pn.test(d) && s.push(""), d.replace(cr, function (f, b, P, k) {
              s.push(P ? k.replace(Xr, "$1") : b || f);
            }), s;
          });
          function An(d) {
            if (typeof d == "string" || Br(d)) return d;
            var s = d + "";
            return s == "0" && 1 / d == -A ? "-0" : s;
          }
          function Kt(d) {
            if (d != null) {
              try {
                return ua.call(d);
              } catch (s) {}
              try {
                return d + "";
              } catch (s) {}
            }
            return "";
          }
          function _r(d, s) {
            var f = tr(d) ? za : kn;
            return f(d, yr(s, 3));
          }
          function Kn(d, s) {
            if (typeof d != "function" || s && typeof s != "function") throw new TypeError(W);
            var f = function f() {
              var b = arguments,
                P = s ? s.apply(this, b) : b[0],
                k = f.cache;
              if (k.has(P)) return k.get(P);
              var B = d.apply(this, b);
              return f.cache = k.set(P, B), B;
            };
            return f.cache = new (Kn.Cache || ce)(), f;
          }
          Kn.Cache = ce;
          function Dn(d, s) {
            return d === s || d !== d && s !== s;
          }
          function Yn(d) {
            return Qn(d) && wt.call(d, "callee") && (!Xa.call(d, "callee") || Zt.call(d) == ee);
          }
          var tr = Array.isArray;
          function Ft(d) {
            return d != null && Ln(d.length) && !ba(d);
          }
          function Qn(d) {
            return xr(d) && Ft(d);
          }
          function ba(d) {
            var s = jr(d) ? Zt.call(d) : "";
            return s == S || s == m;
          }
          function Ln(d) {
            return typeof d == "number" && d > -1 && d % 1 == 0 && d <= N;
          }
          function jr(d) {
            var s = typeof d;
            return !!d && (s == "object" || s == "function");
          }
          function xr(d) {
            return !!d && typeof d == "object";
          }
          function Br(d) {
            return typeof d == "symbol" || xr(d) && Zt.call(d) == V;
          }
          var ea = gn ? Ri(gn) : Tn;
          function oi(d) {
            return d == null ? "" : Mn(d);
          }
          function si(d, s, f) {
            var b = d == null ? void 0 : tt(d, s);
            return b === void 0 ? f : b;
          }
          function li(d, s) {
            return d != null && er(d, s, On);
          }
          function Fn(d) {
            return Ft(d) ? xn(d) : wr(d);
          }
          function on(d) {
            return d;
          }
          function ci(d) {
            return an(d) ? Ha(An(d)) : Cn(d);
          }
          _24.exports = _r;
        },
        262: function _(_25, c, O) {
          "use strict";

          var Z = O(586);
          function W() {}
          function J() {}
          J.resetWarningCache = W, _25.exports = function () {
            function M(N, ee, p, w, x, E) {
              if (E !== Z) {
                var S = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw S.name = "Invariant Violation", S;
              }
            }
            M.isRequired = M;
            function $() {
              return M;
            }
            var A = {
              array: M,
              bigint: M,
              bool: M,
              func: M,
              number: M,
              object: M,
              string: M,
              symbol: M,
              any: M,
              arrayOf: $,
              element: M,
              elementType: M,
              instanceOf: $,
              node: M,
              objectOf: $,
              oneOf: $,
              oneOfType: $,
              shape: $,
              exact: $,
              checkPropTypes: J,
              resetWarningCache: W
            };
            return A.PropTypes = A, A;
          };
        },
        980: function _(_26, c, O) {
          if (!1) var Z, W;else _26.exports = O(262)();
        },
        586: function _(_27) {
          "use strict";

          var c = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
          _27.exports = c;
        },
        129: function _(_28, c, O) {
          "use strict";

          Object.defineProperty(c, "__esModule", {
            value: !0
          }), c.DebounceInput = void 0;
          var Z = J(O(156)),
            W = J(O(594));
          function J(q) {
            return q && q.__esModule ? q : {
              default: q
            };
          }
          function M(q) {
            return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? M = function M(Q) {
              return typeof Q;
            } : M = function M(Q) {
              return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
            }, M(q);
          }
          function $(q, V) {
            if (q == null) return {};
            var Q = A(q, V),
              ae,
              G;
            if (Object.getOwnPropertySymbols) {
              var nt = Object.getOwnPropertySymbols(q);
              for (G = 0; G < nt.length; G++) {
                ae = nt[G], !(V.indexOf(ae) >= 0) && (!Object.prototype.propertyIsEnumerable.call(q, ae) || (Q[ae] = q[ae]));
              }
            }
            return Q;
          }
          function A(q, V) {
            if (q == null) return {};
            var Q = {},
              ae = Object.keys(q),
              G,
              nt;
            for (nt = 0; nt < ae.length; nt++) {
              G = ae[nt], !(V.indexOf(G) >= 0) && (Q[G] = q[G]);
            }
            return Q;
          }
          function N(q, V) {
            var Q = Object.keys(q);
            if (Object.getOwnPropertySymbols) {
              var ae = Object.getOwnPropertySymbols(q);
              V && (ae = ae.filter(function (G) {
                return Object.getOwnPropertyDescriptor(q, G).enumerable;
              })), Q.push.apply(Q, ae);
            }
            return Q;
          }
          function ee(q) {
            for (var V = 1; V < arguments.length; V++) {
              var Q = arguments[V] != null ? arguments[V] : {};
              V % 2 ? N(Object(Q), !0).forEach(function (ae) {
                Ee(q, ae, Q[ae]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(Q)) : N(Object(Q)).forEach(function (ae) {
                Object.defineProperty(q, ae, Object.getOwnPropertyDescriptor(Q, ae));
              });
            }
            return q;
          }
          function p(q, V) {
            if (!(q instanceof V)) throw new TypeError("Cannot call a class as a function");
          }
          function w(q, V) {
            for (var Q = 0; Q < V.length; Q++) {
              var ae = V[Q];
              ae.enumerable = ae.enumerable || !1, ae.configurable = !0, "value" in ae && (ae.writable = !0), Object.defineProperty(q, ae.key, ae);
            }
          }
          function x(q, V, Q) {
            return V && w(q.prototype, V), Q && w(q, Q), q;
          }
          function E(q, V) {
            if (typeof V != "function" && V !== null) throw new TypeError("Super expression must either be null or a function");
            q.prototype = Object.create(V && V.prototype, {
              constructor: {
                value: q,
                writable: !0,
                configurable: !0
              }
            }), V && S(q, V);
          }
          function S(q, V) {
            return S = Object.setPrototypeOf || function (ae, G) {
              return ae.__proto__ = G, ae;
            }, S(q, V);
          }
          function m(q) {
            var V = I();
            return function () {
              var ae = K(q),
                G;
              if (V) {
                var nt = K(this).constructor;
                G = Reflect.construct(ae, arguments, nt);
              } else G = ae.apply(this, arguments);
              return v(this, G);
            };
          }
          function v(q, V) {
            return V && (M(V) === "object" || typeof V == "function") ? V : T(q);
          }
          function T(q) {
            if (q === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return q;
          }
          function I() {
            if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (q) {
              return !1;
            }
          }
          function K(q) {
            return K = Object.setPrototypeOf ? Object.getPrototypeOf : function (Q) {
              return Q.__proto__ || Object.getPrototypeOf(Q);
            }, K(q);
          }
          function Ee(q, V, Q) {
            return V in q ? Object.defineProperty(q, V, {
              value: Q,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : q[V] = Q, q;
          }
          var Be = function (q) {
            E(Q, q);
            var V = m(Q);
            function Q(ae) {
              var G;
              p(this, Q), G = V.call(this, ae), Ee(T(G), "onChange", function (Re) {
                Re.persist();
                var qe = G.state.value,
                  et = G.props.minLength;
                G.setState({
                  value: Re.target.value
                }, function () {
                  var yt = G.state.value;
                  if (yt.length >= et) {
                    G.notify(Re);
                    return;
                  }
                  qe.length > yt.length && G.notify(ee(ee({}, Re), {}, {
                    target: ee(ee({}, Re.target), {}, {
                      value: ""
                    })
                  }));
                });
              }), Ee(T(G), "onKeyDown", function (Re) {
                Re.key === "Enter" && G.forceNotify(Re);
                var qe = G.props.onKeyDown;
                qe && (Re.persist(), qe(Re));
              }), Ee(T(G), "onBlur", function (Re) {
                G.forceNotify(Re);
                var qe = G.props.onBlur;
                qe && (Re.persist(), qe(Re));
              }), Ee(T(G), "createNotifier", function (Re) {
                if (Re < 0) G.notify = function () {
                  return null;
                };else if (Re === 0) G.notify = G.doNotify;else {
                  var qe = (0, W.default)(function (et) {
                    G.isDebouncing = !1, G.doNotify(et);
                  }, Re);
                  G.notify = function (et) {
                    G.isDebouncing = !0, qe(et);
                  }, G.flush = function () {
                    return qe.flush();
                  }, G.cancel = function () {
                    G.isDebouncing = !1, qe.cancel();
                  };
                }
              }), Ee(T(G), "doNotify", function () {
                var Re = G.props.onChange;
                Re.apply(void 0, arguments);
              }), Ee(T(G), "forceNotify", function (Re) {
                var qe = G.props.debounceTimeout;
                if (!(!G.isDebouncing && qe > 0)) {
                  G.cancel && G.cancel();
                  var et = G.state.value,
                    yt = G.props.minLength;
                  et.length >= yt ? G.doNotify(Re) : G.doNotify(ee(ee({}, Re), {}, {
                    target: ee(ee({}, Re.target), {}, {
                      value: et
                    })
                  }));
                }
              }), G.isDebouncing = !1, G.state = {
                value: typeof ae.value == "undefined" || ae.value === null ? "" : ae.value
              };
              var nt = G.props.debounceTimeout;
              return G.createNotifier(nt), G;
            }
            return x(Q, [{
              key: "componentDidUpdate",
              value: function value(G) {
                if (!this.isDebouncing) {
                  var nt = this.props,
                    Re = nt.value,
                    qe = nt.debounceTimeout,
                    et = G.debounceTimeout,
                    yt = G.value,
                    $t = this.state.value;
                  typeof Re != "undefined" && yt !== Re && $t !== Re && this.setState({
                    value: Re
                  }), qe !== et && this.createNotifier(qe);
                }
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this.flush && this.flush();
              }
            }, {
              key: "render",
              value: function value() {
                var G = this.props,
                  nt = G.element,
                  Re = G.onChange,
                  qe = G.value,
                  et = G.minLength,
                  yt = G.debounceTimeout,
                  $t = G.forceNotifyByEnter,
                  Rr = G.forceNotifyOnBlur,
                  Ht = G.onKeyDown,
                  sr = G.onBlur,
                  lr = G.inputRef,
                  Jr = $(G, ["element", "onChange", "value", "minLength", "debounceTimeout", "forceNotifyByEnter", "forceNotifyOnBlur", "onKeyDown", "onBlur", "inputRef"]),
                  pn = this.state.value,
                  cr;
                $t ? cr = {
                  onKeyDown: this.onKeyDown
                } : Ht ? cr = {
                  onKeyDown: Ht
                } : cr = {};
                var Ut;
                Rr ? Ut = {
                  onBlur: this.onBlur
                } : sr ? Ut = {
                  onBlur: sr
                } : Ut = {};
                var Xr = lr ? {
                  ref: lr
                } : {};
                return Z.default.createElement(nt, ee(ee(ee(ee({}, Jr), {}, {
                  onChange: this.onChange,
                  value: pn
                }, cr), Ut), Xr));
              }
            }]), Q;
          }(Z.default.PureComponent);
          c.DebounceInput = Be, Ee(Be, "defaultProps", {
            element: "input",
            type: "text",
            onKeyDown: void 0,
            onBlur: void 0,
            value: void 0,
            minLength: 0,
            debounceTimeout: 100,
            forceNotifyByEnter: !0,
            forceNotifyOnBlur: !0,
            inputRef: void 0
          });
        },
        912: function _(_29, c, O) {
          "use strict";

          var Z = O(129),
            W = Z.DebounceInput;
          W.DebounceInput = W, _29.exports = W;
        },
        424: function _(_30, c, O) {
          function Z(A) {
            return A && typeof A == "object" && "default" in A ? A.default : A;
          }
          var W = Z(O(156)),
            J = Z(O(980));
          function M(A) {
            return A === "fast" ? 600 : A === "slow" ? 900 : 750;
          }
          var $ = function $(A) {
            var N = A.color,
              ee = A.speed,
              p = A.gap,
              w = A.thickness,
              x = A.size,
              E = function (S, m) {
                var v = {};
                for (var T in S) {
                  Object.prototype.hasOwnProperty.call(S, T) && m.indexOf(T) === -1 && (v[T] = S[T]);
                }
                return v;
              }(A, ["color", "speed", "gap", "thickness", "size"]);
            return W.createElement("svg", Object.assign({}, {
              height: x,
              width: x
            }, E, {
              style: {
                animationDuration: M(ee) + "ms"
              },
              className: "__react-svg-spinner_circle",
              role: "img",
              "aria-labelledby": "title desc",
              viewBox: "0 0 32 32"
            }), W.createElement("title", {
              id: "title"
            }, "Circle loading spinner"), W.createElement("desc", {
              id: "desc"
            }, 'Image of a partial circle indicating "loading."'), W.createElement("style", {
              dangerouslySetInnerHTML: {
                __html: "\n      .__react-svg-spinner_circle{\n          transition-property: transform;\n          animation-name: __react-svg-spinner_infinite-spin;\n          animation-iteration-count: infinite;\n          animation-timing-function: linear;\n      }\n      @keyframes __react-svg-spinner_infinite-spin {\n          from {transform: rotate(0deg)}\n          to {transform: rotate(360deg)}\n      }\n    "
              }
            }), W.createElement("circle", {
              role: "presentation",
              cx: 16,
              cy: 16,
              r: 14 - w / 2,
              stroke: N,
              fill: "none",
              strokeWidth: w,
              strokeDasharray: 2 * Math.PI * (11 - p),
              strokeLinecap: "round"
            }));
          };
          $.propTypes = {
            color: J.string,
            thickness: J.oneOf([1, 2, 3, 4, 5, 6, 7, 8]).isRequired,
            gap: J.oneOf([1, 2, 3, 4, 5]).isRequired,
            speed: J.oneOf(["fast", "slow"]),
            size: J.string.isRequired
          }, $.defaultProps = {
            color: "rgba(0,0,0,0.4)",
            gap: 4,
            thickness: 4,
            size: "1em"
          }, _30.exports = $;
        },
        47: function _(_31, c, O) {
          "use strict";

          var Z = O(905),
            W = Array.prototype.concat,
            J = Array.prototype.slice,
            M = _31.exports = function (A) {
              for (var N = [], ee = 0, p = A.length; ee < p; ee++) {
                var w = A[ee];
                Z(w) ? N = W.call(N, J.call(w)) : N.push(w);
              }
              return N;
            };
          M.wrap = function ($) {
            return function () {
              return $(M(arguments));
            };
          };
        },
        905: function _(_32) {
          _32.exports = function (O) {
            return !O || typeof O == "string" ? !1 : O instanceof Array || Array.isArray(O) || O.length >= 0 && (O.splice instanceof Function || Object.getOwnPropertyDescriptor(O, O.length - 1) && O.constructor.name !== "String");
          };
        },
        156: function _(_33) {
          "use strict";

          _33.exports = bt;
        },
        111: function _(_34) {
          "use strict";

          _34.exports = gt;
        }
      },
      zt = {};
    function pe(_) {
      var c = zt[_];
      if (c !== void 0) return c.exports;
      var O = zt[_] = {
        id: _,
        loaded: !1,
        exports: {}
      };
      return st[_](O, O.exports, pe), O.loaded = !0, O.exports;
    }
    pe.n = function (_) {
      var c = _ && _.__esModule ? function () {
        return _.default;
      } : function () {
        return _;
      };
      return pe.d(c, {
        a: c
      }), c;
    }, pe.d = function (_, c) {
      for (var O in c) {
        pe.o(c, O) && !pe.o(_, O) && Object.defineProperty(_, O, {
          enumerable: !0,
          get: c[O]
        });
      }
    }, pe.g = function () {
      if (typeof globalThis == "object") return globalThis;
      try {
        return this || new Function("return this")();
      } catch (_) {
        if (typeof window == "object") return window;
      }
    }(), pe.o = function (_, c) {
      return Object.prototype.hasOwnProperty.call(_, c);
    }, pe.r = function (_) {
      typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(_, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(_, "__esModule", {
        value: !0
      });
    }, pe.nmd = function (_) {
      return _.paths = [], _.children || (_.children = []), _;
    };
    var ja = {};
    return function () {
      "use strict";

      var _marked = /*#__PURE__*/_regeneratorRuntime().mark(gv);
      pe.r(ja), pe.d(ja, {
        Box: function Box() {
          return Z;
        },
        DefaultPalette: function DefaultPalette() {
          return Aa;
        },
        Flamegraph: function Flamegraph() {
          return Nl;
        },
        FlamegraphRenderer: function FlamegraphRenderer() {
          return Bg;
        },
        convertJaegerTraceToProfile: function convertJaegerTraceToProfile() {
          return Zg;
        },
        diffTwoProfiles: function diffTwoProfiles() {
          return Kg;
        }
      });
      var _ = pe(156),
        c = pe.n(_);
      var O = {
        box: "CymgObeW6VZutKnn+knV0w==",
        padding: "_27LlhV46s9ZMTAMouwXorw=="
      };
      function Z(e) {
        var t = e.children,
          r = e.noPadding,
          _e$className = e.className,
          n = _e$className === void 0 ? "" : _e$className,
          a = r ? "" : O.padding;
        return c().createElement("div", {
          className: "".concat(O.box, " ").concat(a, " ").concat(n)
        }, t);
      }
      var W = Symbol("BrandTag");
      var J = /*#__PURE__*/_createClass(function J(t) {
        _classCallCheck(this, J);
        this[W] = t;
      });
      var $ = new J("unit"),
        A = function A(e) {
          return typeof e == "undefined" || e === null;
        };
      function N(e, t) {
        return t !== void 0 ? e(t) : e;
      }
      function ee(e) {
        return e.match({
          Ok: function Ok(t) {
            return t.match({
              Just: function Just(r) {
                return Maybe.just(Result.ok(r));
              },
              Nothing: function Nothing() {
                return Maybe.nothing();
              }
            });
          },
          Err: function Err(t) {
            return Maybe.just(Result.err(t));
          }
        });
      }
      function p(e) {
        return e.isOk ? Vt.just(e.value) : Vt.nothing();
      }
      function w(e, t) {
        var r = function r(n) {
          return n.isJust ? Result.ok(n.value) : Result.err(e);
        };
        return curry1(r, t);
      }
      function x(e) {
        return e.match({
          Just: function Just(t) {
            return t.match({
              Ok: function Ok(r) {
                return Result.ok(Maybe.just(r));
              },
              Err: function Err(r) {
                return Result.err(r);
              }
            });
          },
          Nothing: function Nothing() {
            return Result.ok(Maybe.nothing());
          }
        });
      }
      function E(e, t) {
        var r = function r(n) {
          return n.isJust ? Ir.ok(n.value) : Ir.err(e);
        };
        return t !== void 0 ? r(t) : r;
      }
      function S(e, t) {
        return N(function (n) {
          return n.isJust ? Ir.ok(n.value) : Ir.err(e());
        }, t);
      }
      function m(e) {
        return e.isOk ? Maybe.just(e.value) : Maybe.nothing();
      }
      var v = {
        Ok: "Ok",
        Err: "Err"
      };
      var T = /*#__PURE__*/function () {
        function T(t) {
          _classCallCheck(this, T);
          this.repr = t;
        }
        _createClass(T, [{
          key: "variant",
          get: function get() {
            return this.repr[0];
          }
        }, {
          key: "value",
          get: function get() {
            if (this.repr[0] === v.Err) throw new Error("Cannot get the value of Err");
            return this.repr[1];
          }
        }, {
          key: "error",
          get: function get() {
            if (this.repr[0] === v.Ok) throw new Error("Cannot get the error of Ok");
            return this.repr[1];
          }
        }, {
          key: "isOk",
          get: function get() {
            return this.repr[0] === v.Ok;
          }
        }, {
          key: "isErr",
          get: function get() {
            return this.repr[0] === v.Err;
          }
        }, {
          key: "map",
          value: function map(t) {
            return q(t, this);
          }
        }, {
          key: "mapOr",
          value: function mapOr(t, r) {
            return V(t, r, this);
          }
        }, {
          key: "mapOrElse",
          value: function mapOrElse(t, r) {
            return Q(t, r, this);
          }
        }, {
          key: "match",
          value: function match(t) {
            return sr(t, this);
          }
        }, {
          key: "mapErr",
          value: function mapErr(t) {
            return ae(t, this);
          }
        }, {
          key: "or",
          value: function or(t) {
            return Re(t, this);
          }
        }, {
          key: "orElse",
          value: function orElse(t) {
            return qe(t, this);
          }
        }, {
          key: "and",
          value: function and(t) {
            return G(t, this);
          }
        }, {
          key: "andThen",
          value: function andThen(t) {
            return nt(t, this);
          }
        }, {
          key: "unwrapOr",
          value: function unwrapOr(t) {
            return et(t, this);
          }
        }, {
          key: "unwrapOrElse",
          value: function unwrapOrElse(t) {
            return yt(t, this);
          }
        }, {
          key: "toMaybe",
          value: function toMaybe() {
            return p(this);
          }
        }, {
          key: "toString",
          value: function toString() {
            return Rr(this);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return Ht(this);
          }
        }, {
          key: "equals",
          value: function equals(t) {
            return lr(t, this);
          }
        }, {
          key: "ap",
          value: function ap(t) {
            return Jr(this, t);
          }
        }], [{
          key: "ok",
          value: function ok(t) {
            return A(t) ? new T(["Ok", $]) : new T(["Ok", t]);
          }
        }, {
          key: "err",
          value: function err(t) {
            return A(t) ? new T(["Err", $]) : new T(["Err", t]);
          }
        }]);
        return T;
      }();
      function I(e, t) {
        var r = function r(n) {
          try {
            return K(n());
          } catch (a) {
            return Ee(e);
          }
        };
        return curry1(r, t);
      }
      var K = T.ok,
        Ee = T.err;
      function Be(e, t) {
        var r = function r(n) {
          try {
            return K(n());
          } catch (a) {
            return Ee(e(a));
          }
        };
        return curry1(r, t);
      }
      function q(e, t) {
        return N(function (n) {
          return n.isOk ? K(e(n.value)) : n;
        }, t);
      }
      function V(e, t, r) {
        function n(i, o) {
          return o.isOk ? i(o.value) : e;
        }
        function a(i, o) {
          return o !== void 0 ? n(i, o) : function (l) {
            return n(i, l);
          };
        }
        return t === void 0 ? a : r === void 0 ? a(t) : a(t, r);
      }
      function Q(e, t, r) {
        function n(i, o) {
          return o.isOk ? i(o.value) : e(o.error);
        }
        function a(i, o) {
          return o !== void 0 ? n(i, o) : function (l) {
            return n(i, l);
          };
        }
        return t === void 0 ? a : r === void 0 ? a(t) : a(t, r);
      }
      function ae(e, t) {
        return N(function (n) {
          return n.isOk ? n : Ee(e(n.error));
        }, t);
      }
      function G(e, t) {
        return N(function (n) {
          return n.isOk ? e : Ee(n.error);
        }, t);
      }
      function nt(e, t) {
        return N(function (n) {
          return n.isOk ? e(n.value) : Ee(n.error);
        }, t);
      }
      function Re(e, t) {
        return N(function (n) {
          return n.isOk ? K(n.value) : e;
        }, t);
      }
      function qe(e, t) {
        return N(function (n) {
          return n.isOk ? K(n.value) : e(n.error);
        }, t);
      }
      function et(e, t) {
        return N(function (n) {
          return n.isOk ? n.value : e;
        }, t);
      }
      function yt(e, t) {
        return N(function (n) {
          return n.isOk ? n.value : e(n.error);
        }, t);
      }
      function $t(e, t) {
        var r = function r(n) {
          return n.isJust ? K(n.value) : Ee(e);
        };
        return curry1(r, t);
      }
      var Rr = function Rr(e) {
          var t = (e.isOk ? e.value : e.error).toString();
          return "".concat(e.variant.toString(), "(").concat(t, ")");
        },
        Ht = function Ht(e) {
          return e.isOk ? {
            variant: e.variant,
            value: e.value
          } : {
            variant: e.variant,
            error: e.error
          };
        };
      function sr(e, t) {
        return N(function (n) {
          return Q(e.Err, e.Ok, n);
        }, t);
      }
      function lr(e, t) {
        return t !== void 0 ? t.match({
          Err: function Err() {
            return e.isErr;
          },
          Ok: function Ok(r) {
            return e.isOk && e.value === r;
          }
        }) : function (r) {
          return r.match({
            Err: function Err() {
              return e.isErr;
            },
            Ok: function Ok(n) {
              return e.isOk && e.value === n;
            }
          });
        };
      }
      function Jr(e, t) {
        return N(function (n) {
          return n.andThen(function (a) {
            return e.map(function (i) {
              return i(a);
            });
          });
        }, t);
      }
      function pn(e) {
        return e instanceof T;
      }
      function cr(e) {
        return Toolbelt.transposeMaybe(e);
      }
      function Ut(e) {
        return Toolbelt.toMaybe(e);
      }
      var Ir = T,
        vr = {
          Just: "Just",
          Nothing: "Nothing"
        };
      var se;
      var He = /*#__PURE__*/function () {
        function He(t) {
          _classCallCheck(this, He);
          if (A(t)) return this.repr = [vr.Nothing], se || (se = this), se;
          this.repr = [vr.Just, t];
        }
        _createClass(He, [{
          key: "variant",
          get: function get() {
            return this.repr[0];
          }
        }, {
          key: "value",
          get: function get() {
            if (this.repr[0] === vr.Nothing) throw new Error("Cannot get the value of `Nothing`");
            return this.repr[1];
          }
        }, {
          key: "isJust",
          get: function get() {
            return this.repr[0] === vr.Just;
          }
        }, {
          key: "isNothing",
          get: function get() {
            return this.repr[0] === vr.Nothing;
          }
        }, {
          key: "map",
          value: function map(t) {
            return Zn(t, this);
          }
        }, {
          key: "mapOr",
          value: function mapOr(t, r) {
            return Ba(t, r, this);
          }
        }, {
          key: "mapOrElse",
          value: function mapOrElse(t, r) {
            return mn(t, r, this);
          }
        }, {
          key: "match",
          value: function match(t) {
            return Va(t, this);
          }
        }, {
          key: "or",
          value: function or(t) {
            return za(t, this);
          }
        }, {
          key: "orElse",
          value: function orElse(t) {
            return $a(t, this);
          }
        }, {
          key: "and",
          value: function and(t) {
            return Vn(t, this);
          }
        }, {
          key: "andThen",
          value: function andThen(t) {
            return gn(t, this);
          }
        }, {
          key: "unwrapOr",
          value: function unwrapOr(t) {
            return Ha(t, this);
          }
        }, {
          key: "unwrapOrElse",
          value: function unwrapOrElse(t) {
            return Ua(t, this);
          }
        }, {
          key: "toOkOrErr",
          value: function toOkOrErr(t) {
            return E(t, this);
          }
        }, {
          key: "toOkOrElseErr",
          value: function toOkOrElseErr(t) {
            return S(t, this);
          }
        }, {
          key: "toString",
          value: function toString() {
            return Za(this);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return Kr(this);
          }
        }, {
          key: "equals",
          value: function equals(t) {
            return Ga(t, this);
          }
        }, {
          key: "ap",
          value: function ap(t) {
            return Wa(this, t);
          }
        }, {
          key: "get",
          value: function get(t) {
            return qa(t, this);
          }
        }], [{
          key: "of",
          value: function of(t) {
            return new He(t);
          }
        }, {
          key: "just",
          value: function just(t) {
            if (A(t)) throw new Error("attempted to call \"just\" with ".concat(t));
            return new He(t);
          }
        }, {
          key: "nothing",
          value: function nothing(t) {
            return new He();
          }
        }]);
        return He;
      }();
      var Lt = He.just,
        it = He.nothing,
        qr = He.of;
      function Zn(e, t) {
        return N(function (n) {
          return n.isJust ? Lt(e(n.value)) : it();
        }, t);
      }
      function Ba(e, t, r) {
        function n(i, o) {
          return o.isJust ? i(o.value) : e;
        }
        function a(i, o) {
          return o !== void 0 ? n(i, o) : function (l) {
            return n(i, l);
          };
        }
        return t === void 0 ? a : r === void 0 ? a(t) : a(t, r);
      }
      function mn(e, t, r) {
        function n(i, o) {
          return o.isJust ? i(o.value) : e();
        }
        function a(i, o) {
          return o !== void 0 ? n(i, o) : function (l) {
            return n(i, l);
          };
        }
        return t === void 0 ? a : r === void 0 ? a(t) : a(t, r);
      }
      function Vn(e, t) {
        return N(function (n) {
          return n.isJust ? e : it();
        }, t);
      }
      function gn(e, t) {
        var r = function r(n) {
          return n.isJust ? e(n.value) : it();
        };
        return t !== void 0 ? r(t) : r;
      }
      function za(e, t) {
        var r = function r(n) {
          return n.isJust ? n : e;
        };
        return t !== void 0 ? r(t) : r;
      }
      function $a(e, t) {
        return N(function (n) {
          return n.isJust ? n : e();
        }, t);
      }
      function Ha(e, t) {
        return N(function (n) {
          return n.isJust ? n.value : e;
        }, t);
      }
      function Ua(e, t) {
        return N(function (n) {
          return n.isJust ? n.value : e();
        }, t);
      }
      function Ri(e) {
        return Toolbelt.fromResult(e);
      }
      function Za(e) {
        var t = e.isJust ? "(".concat(e.value.toString(), ")") : "";
        return "".concat(e.variant).concat(t);
      }
      function Kr(e) {
        return e.isJust ? {
          variant: e.variant,
          value: Ja(e.value) ? e.value.toJSON() : e.value
        } : {
          variant: e.variant
        };
      }
      function Va(e, t) {
        return N(function (n) {
          return mn(e.Nothing, e.Just, n);
        }, t);
      }
      function Ga(e, t) {
        return N(function (n) {
          return n.match({
            Just: function Just(a) {
              return e.isJust && e.value === a;
            },
            Nothing: function Nothing() {
              return e.isNothing;
            }
          });
        }, t);
      }
      function Wa(e, t) {
        return N(function (n) {
          return n.andThen(function (a) {
            return e.map(function (i) {
              return i(a);
            });
          });
        }, t);
      }
      function Ja(e) {
        return e instanceof ot;
      }
      function Ii(e, t) {
        var r = function r(n) {
          return ot.of(n.find(e));
        };
        return curry1(r, t);
      }
      function Ar(e) {
        return ot.of(e[0]);
      }
      var vn = null;
      function ca(e) {
        return ot.of(e[e.length - 1]);
      }
      function ua(e) {
        return e.reduce(function (t, r) {
          return t.andThen(function (n) {
            return r.map(function (a) {
              return [].concat(_toConsumableArray(n), [a]);
            });
          });
        }, Lt([]));
      }
      var wt = null,
        Zt = null;
      function Ai(e) {
        return Toolbelt.transposeResult(e);
      }
      function fa(e, t) {
        var r = function r(n) {
          return n.isJust ? Result.ok(n.value) : Result.err(e);
        };
        return t !== void 0 ? r(t) : r;
      }
      function da(e, t) {
        var r = function r(n) {
          return n.isJust ? Result.ok(n.value) : Result.err(e());
        };
        return curry1(r, t);
      }
      function Xa(e, t) {
        return N(function (n) {
          return ot.of(n[e]);
        }, t);
      }
      function qa(e, t) {
        return N(gn(Xa(e)), t);
      }
      function Di(e) {
        return function () {
          return ot.of(e.apply(void 0, arguments));
        };
      }
      var ot = He,
        Vt = ot;
      var Ue;
      (function (e) {
        function t(n) {
          throw new Error();
        }
        e.assertNever = t, e.arrayToEnum = function (n) {
          var a = {};
          var _iterator3 = _createForOfIteratorHelper(n),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var i = _step3.value;
              a[i] = i;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          return a;
        }, e.getValidEnumValues = function (n) {
          var a = e.objectKeys(n).filter(function (o) {
              return typeof n[n[o]] != "number";
            }),
            i = {};
          var _iterator4 = _createForOfIteratorHelper(a),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var o = _step4.value;
              i[o] = n[o];
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return e.objectValues(i);
        }, e.objectValues = function (n) {
          return e.objectKeys(n).map(function (a) {
            return n[a];
          });
        }, e.objectKeys = typeof Object.keys == "function" ? function (n) {
          return Object.keys(n);
        } : function (n) {
          var a = [];
          for (var i in n) {
            Object.prototype.hasOwnProperty.call(n, i) && a.push(i);
          }
          return a;
        }, e.find = function (n, a) {
          var _iterator5 = _createForOfIteratorHelper(n),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var i = _step5.value;
              if (a(i)) return i;
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }, e.isInteger = typeof Number.isInteger == "function" ? function (n) {
          return Number.isInteger(n);
        } : function (n) {
          return typeof n == "number" && isFinite(n) && Math.floor(n) === n;
        };
        function r(n) {
          var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " | ";
          return n.map(function (i) {
            return typeof i == "string" ? "'".concat(i, "'") : i;
          }).join(a);
        }
        e.joinValues = r;
      })(Ue || (Ue = {}));
      var Y = Ue.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]),
        At = function At(e) {
          switch (typeof e) {
            case "undefined":
              return Y.undefined;
            case "string":
              return Y.string;
            case "number":
              return isNaN(e) ? Y.nan : Y.number;
            case "boolean":
              return Y.boolean;
            case "function":
              return Y.function;
            case "bigint":
              return Y.bigint;
            case "object":
              return Array.isArray(e) ? Y.array : e === null ? Y.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Y.promise : typeof Map != "undefined" && e instanceof Map ? Y.map : typeof Set != "undefined" && e instanceof Set ? Y.set : typeof Date != "undefined" && e instanceof Date ? Y.date : Y.object;
            default:
              return Y.unknown;
          }
        },
        X = Ue.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of"]),
        Ka = function Ka(e) {
          return JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
        };
      var Qt = /*#__PURE__*/function (_Error) {
        _inherits(Qt, _Error);
        var _super = _createSuper(Qt);
        function Qt(t) {
          var _this;
          _classCallCheck(this, Qt);
          _this = _super.call(this);
          _this.issues = [], _this.addIssue = function (n) {
            _this.issues = [].concat(_toConsumableArray(_this.issues), [n]);
          }, _this.addIssues = function () {
            var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            _this.issues = [].concat(_toConsumableArray(_this.issues), _toConsumableArray(n));
          };
          var r = (this instanceof Qt ? this.constructor : void 0).prototype;
          Object.setPrototypeOf ? Object.setPrototypeOf(_assertThisInitialized(_this), r) : _this.__proto__ = r, _this.name = "ZodError", _this.issues = t;
          return _this;
        }
        _createClass(Qt, [{
          key: "errors",
          get: function get() {
            return this.issues;
          }
        }, {
          key: "format",
          value: function format(t) {
            var r = t || function (i) {
                return i.message;
              },
              n = {
                _errors: []
              },
              a = function a(i) {
                var _iterator6 = _createForOfIteratorHelper(i.issues),
                  _step6;
                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    var o = _step6.value;
                    if (o.code === "invalid_union") o.unionErrors.map(a);else if (o.code === "invalid_return_type") a(o.returnTypeError);else if (o.code === "invalid_arguments") a(o.argumentsError);else if (o.path.length === 0) n._errors.push(r(o));else {
                      var l = n,
                        u = 0;
                      for (; u < o.path.length;) {
                        var h = o.path[u];
                        u === o.path.length - 1 ? (l[h] = l[h] || {
                          _errors: []
                        }, l[h]._errors.push(r(o))) : l[h] = l[h] || {
                          _errors: []
                        }, l = l[h], u++;
                      }
                    }
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
              };
            return a(this), n;
          }
        }, {
          key: "toString",
          value: function toString() {
            return this.message;
          }
        }, {
          key: "message",
          get: function get() {
            return JSON.stringify(this.issues, null, 2);
          }
        }, {
          key: "isEmpty",
          get: function get() {
            return this.issues.length === 0;
          }
        }, {
          key: "flatten",
          value: function flatten() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (r) {
              return r.message;
            };
            var r = {},
              n = [];
            var _iterator7 = _createForOfIteratorHelper(this.issues),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var a = _step7.value;
                a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            return {
              formErrors: n,
              fieldErrors: r
            };
          }
        }, {
          key: "formErrors",
          get: function get() {
            return this.flatten();
          }
        }]);
        return Qt;
      }( /*#__PURE__*/_wrapNativeSuper(Error));
      Qt.create = function (e) {
        return new Qt(e);
      };
      var Yr = function Yr(e, t) {
        var r;
        switch (e.code) {
          case X.invalid_type:
            e.received === Y.undefined ? r = "Required" : r = "Expected ".concat(e.expected, ", received ").concat(e.received);
            break;
          case X.invalid_literal:
            r = "Invalid literal value, expected ".concat(JSON.stringify(e.expected));
            break;
          case X.unrecognized_keys:
            r = "Unrecognized key(s) in object: ".concat(Ue.joinValues(e.keys, ", "));
            break;
          case X.invalid_union:
            r = "Invalid input";
            break;
          case X.invalid_union_discriminator:
            r = "Invalid discriminator value. Expected ".concat(Ue.joinValues(e.options));
            break;
          case X.invalid_enum_value:
            r = "Invalid enum value. Expected ".concat(Ue.joinValues(e.options), ", received '").concat(e.received, "'");
            break;
          case X.invalid_arguments:
            r = "Invalid function arguments";
            break;
          case X.invalid_return_type:
            r = "Invalid function return type";
            break;
          case X.invalid_date:
            r = "Invalid date";
            break;
          case X.invalid_string:
            e.validation !== "regex" ? r = "Invalid ".concat(e.validation) : r = "Invalid";
            break;
          case X.too_small:
            e.type === "array" ? r = "Array must contain ".concat(e.inclusive ? "at least" : "more than", " ").concat(e.minimum, " element(s)") : e.type === "string" ? r = "String must contain ".concat(e.inclusive ? "at least" : "over", " ").concat(e.minimum, " character(s)") : e.type === "number" ? r = "Number must be greater than ".concat(e.inclusive ? "or equal to " : "").concat(e.minimum) : r = "Invalid input";
            break;
          case X.too_big:
            e.type === "array" ? r = "Array must contain ".concat(e.inclusive ? "at most" : "less than", " ").concat(e.maximum, " element(s)") : e.type === "string" ? r = "String must contain ".concat(e.inclusive ? "at most" : "under", " ").concat(e.maximum, " character(s)") : e.type === "number" ? r = "Number must be less than ".concat(e.inclusive ? "or equal to " : "").concat(e.maximum) : r = "Invalid input";
            break;
          case X.custom:
            r = "Invalid input";
            break;
          case X.invalid_intersection_types:
            r = "Intersection results could not be merged";
            break;
          case X.not_multiple_of:
            r = "Number must be a multiple of ".concat(e.multipleOf);
            break;
          default:
            r = t.defaultError, Ue.assertNever(e);
        }
        return {
          message: r
        };
      };
      var Qr = Yr;
      var Ya = function Ya(e) {
          Qr = e;
        },
        Gt = function Gt(e) {
          var t = e.data,
            r = e.path,
            n = e.errorMaps,
            a = e.issueData,
            i = [].concat(_toConsumableArray(r), _toConsumableArray(a.path || [])),
            o = ue(L({}, a), {
              path: i
            });
          var l = "";
          var u = n.filter(function (h) {
            return !!h;
          }).slice().reverse();
          var _iterator8 = _createForOfIteratorHelper(u),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var h = _step8.value;
              l = h(o, {
                data: t,
                defaultError: l
              }).message;
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          return ue(L({}, a), {
            path: i,
            message: a.message || l
          });
        },
        en = [];
      function le(e, t) {
        var r = Gt({
          issueData: t,
          data: e.data,
          path: e.path,
          errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, Qr, Yr].filter(function (n) {
            return !!n;
          })
        });
        e.common.issues.push(r);
      }
      var Ke = /*#__PURE__*/function () {
        function Ke() {
          _classCallCheck(this, Ke);
          this.value = "valid";
        }
        _createClass(Ke, [{
          key: "dirty",
          value: function dirty() {
            this.value === "valid" && (this.value = "dirty");
          }
        }, {
          key: "abort",
          value: function abort() {
            this.value !== "aborted" && (this.value = "aborted");
          }
        }], [{
          key: "mergeArray",
          value: function mergeArray(t, r) {
            var n = [];
            var _iterator9 = _createForOfIteratorHelper(r),
              _step9;
            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var a = _step9.value;
                if (a.status === "aborted") return ke;
                a.status === "dirty" && t.dirty(), n.push(a.value);
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
            return {
              status: t.value,
              value: n
            };
          }
        }, {
          key: "mergeObjectAsync",
          value: function mergeObjectAsync(t, r) {
            return Un(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var n, _iterator10, _step10, a;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      n = [];
                      _iterator10 = _createForOfIteratorHelper(r);
                      _context.prev = 2;
                      _iterator10.s();
                    case 4:
                      if ((_step10 = _iterator10.n()).done) {
                        _context.next = 17;
                        break;
                      }
                      a = _step10.value;
                      _context.t0 = n;
                      _context.next = 9;
                      return a.key;
                    case 9:
                      _context.t1 = _context.sent;
                      _context.next = 12;
                      return a.value;
                    case 12:
                      _context.t2 = _context.sent;
                      _context.t3 = {
                        key: _context.t1,
                        value: _context.t2
                      };
                      _context.t0.push.call(_context.t0, _context.t3);
                    case 15:
                      _context.next = 4;
                      break;
                    case 17:
                      _context.next = 22;
                      break;
                    case 19:
                      _context.prev = 19;
                      _context.t4 = _context["catch"](2);
                      _iterator10.e(_context.t4);
                    case 22:
                      _context.prev = 22;
                      _iterator10.f();
                      return _context.finish(22);
                    case 25:
                      return _context.abrupt("return", Ke.mergeObjectSync(t, n));
                    case 26:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[2, 19, 22, 25]]);
            }));
          }
        }, {
          key: "mergeObjectSync",
          value: function mergeObjectSync(t, r) {
            var n = {};
            var _iterator11 = _createForOfIteratorHelper(r),
              _step11;
            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var a = _step11.value;
                var i = a.key,
                  o = a.value;
                if (i.status === "aborted" || o.status === "aborted") return ke;
                i.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), (typeof o.value != "undefined" || a.alwaysSet) && (n[i.value] = o.value);
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }
            return {
              status: t.value,
              value: n
            };
          }
        }]);
        return Ke;
      }();
      var ke = Object.freeze({
          status: "aborted"
        }),
        Qa = function Qa(e) {
          return {
            status: "dirty",
            value: e
          };
        },
        Ct = function Ct(e) {
          return {
            status: "valid",
            value: e
          };
        },
        Gn = function Gn(e) {
          return e.status === "aborted";
        },
        Wn = function Wn(e) {
          return e.status === "dirty";
        },
        ft = function ft(e) {
          return e.status === "valid";
        },
        Jn = function Jn(e) {
          return typeof Promise !== void 0 && e instanceof Promise;
        };
      var Ge;
      (function (e) {
        e.errToObj = function (t) {
          return typeof t == "string" ? {
            message: t
          } : t || {};
        }, e.toString = function (t) {
          return typeof t == "string" ? t : t == null ? void 0 : t.message;
        };
      })(Ge || (Ge = {}));
      var Wt = /*#__PURE__*/function () {
        function Wt(t, r, n, a) {
          _classCallCheck(this, Wt);
          this.parent = t, this.data = r, this._path = n, this._key = a;
        }
        _createClass(Wt, [{
          key: "path",
          get: function get() {
            return this._path.concat(this._key);
          }
        }]);
        return Wt;
      }();
      var ha = function ha(e, t) {
        if (ft(t)) return {
          success: !0,
          data: t.value
        };
        {
          if (!e.common.issues.length) throw new Error("Validation failed but no issues detected.");
          var r = new Qt(e.common.issues);
          return {
            success: !1,
            error: r
          };
        }
      };
      function Ae(e) {
        if (!e) return {};
        var t = e.errorMap,
          r = e.invalid_type_error,
          n = e.required_error,
          a = e.description;
        if (t && (r || n)) throw new Error("Can't use \"invalid\" or \"required\" in conjunction with custom error map.");
        return t ? {
          errorMap: t,
          description: a
        } : {
          errorMap: function errorMap(o, l) {
            return o.code !== "invalid_type" ? {
              message: l.defaultError
            } : typeof l.data == "undefined" && n ? {
              message: n
            } : e.invalid_type_error ? {
              message: e.invalid_type_error
            } : {
              message: l.defaultError
            };
          },
          description: a
        };
      }
      var ce = /*#__PURE__*/function () {
        function ce(t) {
          _classCallCheck(this, ce);
          this.spa = this.safeParseAsync, this.superRefine = this._refinement, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.default = this.default.bind(this), this.describe = this.describe.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
        }
        _createClass(ce, [{
          key: "description",
          get: function get() {
            return this._def.description;
          }
        }, {
          key: "_getType",
          value: function _getType(t) {
            return At(t.data);
          }
        }, {
          key: "_getOrReturnCtx",
          value: function _getOrReturnCtx(t, r) {
            return r || {
              common: t.parent.common,
              data: t.data,
              parsedType: At(t.data),
              schemaErrorMap: this._def.errorMap,
              path: t.path,
              parent: t.parent
            };
          }
        }, {
          key: "_processInputParams",
          value: function _processInputParams(t) {
            return {
              status: new Ke(),
              ctx: {
                common: t.parent.common,
                data: t.data,
                parsedType: At(t.data),
                schemaErrorMap: this._def.errorMap,
                path: t.path,
                parent: t.parent
              }
            };
          }
        }, {
          key: "_parseSync",
          value: function _parseSync(t) {
            var r = this._parse(t);
            if (Jn(r)) throw new Error("Synchronous parse encountered promise.");
            return r;
          }
        }, {
          key: "_parseAsync",
          value: function _parseAsync(t) {
            var r = this._parse(t);
            return Promise.resolve(r);
          }
        }, {
          key: "parse",
          value: function parse(t, r) {
            var n = this.safeParse(t, r);
            if (n.success) return n.data;
            throw n.error;
          }
        }, {
          key: "safeParse",
          value: function safeParse(t, r) {
            var n;
            var a = {
                common: {
                  issues: [],
                  async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
                  contextualErrorMap: r == null ? void 0 : r.errorMap
                },
                path: (r == null ? void 0 : r.path) || [],
                schemaErrorMap: this._def.errorMap,
                parent: null,
                data: t,
                parsedType: At(t)
              },
              i = this._parseSync({
                data: t,
                path: a.path,
                parent: a
              });
            return ha(a, i);
          }
        }, {
          key: "parseAsync",
          value: function parseAsync(t, r) {
            return Un(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
              var n;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return this.safeParseAsync(t, r);
                    case 2:
                      n = _context2.sent;
                      if (!n.success) {
                        _context2.next = 5;
                        break;
                      }
                      return _context2.abrupt("return", n.data);
                    case 5:
                      throw n.error;
                    case 6:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
          }
        }, {
          key: "safeParseAsync",
          value: function safeParseAsync(t, r) {
            return Un(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              var n, a, i;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      n = {
                        common: {
                          issues: [],
                          contextualErrorMap: r == null ? void 0 : r.errorMap,
                          async: !0
                        },
                        path: (r == null ? void 0 : r.path) || [],
                        schemaErrorMap: this._def.errorMap,
                        parent: null,
                        data: t,
                        parsedType: At(t)
                      };
                      a = this._parse({
                        data: t,
                        path: [],
                        parent: n
                      });
                      _context3.next = 4;
                      return Jn(a) ? a : Promise.resolve(a);
                    case 4:
                      i = _context3.sent;
                      return _context3.abrupt("return", ha(n, i));
                    case 6:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));
          }
        }, {
          key: "refine",
          value: function refine(t, r) {
            var n = function n(a) {
              return typeof r == "string" || typeof r == "undefined" ? {
                message: r
              } : typeof r == "function" ? r(a) : r;
            };
            return this._refinement(function (a, i) {
              var o = t(a),
                l = function l() {
                  return i.addIssue(L({
                    code: X.custom
                  }, n(a)));
                };
              return typeof Promise != "undefined" && o instanceof Promise ? o.then(function (u) {
                return u ? !0 : (l(), !1);
              }) : o ? !0 : (l(), !1);
            });
          }
        }, {
          key: "refinement",
          value: function refinement(t, r) {
            return this._refinement(function (n, a) {
              return t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1);
            });
          }
        }, {
          key: "_refinement",
          value: function _refinement(t) {
            return new Xt({
              schema: this,
              typeName: me.ZodEffects,
              effect: {
                type: "refinement",
                refinement: t
              }
            });
          }
        }, {
          key: "optional",
          value: function optional() {
            return qt.create(this);
          }
        }, {
          key: "nullable",
          value: function nullable() {
            return pr.create(this);
          }
        }, {
          key: "nullish",
          value: function nullish() {
            return this.optional().nullable();
          }
        }, {
          key: "array",
          value: function array() {
            return Tt.create(this);
          }
        }, {
          key: "promise",
          value: function promise() {
            return hr.create(this);
          }
        }, {
          key: "or",
          value: function or(t) {
            return Fr.create([this, t]);
          }
        }, {
          key: "and",
          value: function and(t) {
            return br.create(this, t);
          }
        }, {
          key: "transform",
          value: function transform(t) {
            return new Xt({
              schema: this,
              typeName: me.ZodEffects,
              effect: {
                type: "transform",
                transform: t
              }
            });
          }
        }, {
          key: "default",
          value: function _default(t) {
            var r = typeof t == "function" ? t : function () {
              return t;
            };
            return new Nn({
              innerType: this,
              defaultValue: r,
              typeName: me.ZodDefault
            });
          }
        }, {
          key: "describe",
          value: function describe(t) {
            var r = this.constructor;
            return new r(ue(L({}, this._def), {
              description: t
            }));
          }
        }, {
          key: "isOptional",
          value: function isOptional() {
            return this.safeParse(void 0).success;
          }
        }, {
          key: "isNullable",
          value: function isNullable() {
            return this.safeParse(null).success;
          }
        }]);
        return ce;
      }();
      var ei = /^c[^\s-]{8,}$/i,
        ti = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i,
        ri = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      var ur = /*#__PURE__*/function (_ce) {
        _inherits(ur, _ce);
        var _super2 = _createSuper(ur);
        function ur() {
          var _this2;
          _classCallCheck(this, ur);
          _this2 = _super2.apply(this, arguments);
          _this2._regex = function (t, r, n) {
            return _this2.refinement(function (a) {
              return t.test(a);
            }, L({
              validation: r,
              code: X.invalid_string
            }, Ge.errToObj(n)));
          }, _this2.nonempty = function (t) {
            return _this2.min(1, Ge.errToObj(t));
          }, _this2.trim = function () {
            return new ur(ue(L({}, _this2._def), {
              checks: [].concat(_toConsumableArray(_this2._def.checks), [{
                kind: "trim"
              }])
            }));
          };
          return _this2;
        }
        _createClass(ur, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.string) {
              var i = this._getOrReturnCtx(t);
              return le(i, {
                code: X.invalid_type,
                expected: Y.string,
                received: i.parsedType
              }), ke;
            }
            var n = new Ke();
            var a;
            var _iterator12 = _createForOfIteratorHelper(this._def.checks),
              _step12;
            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var _i2 = _step12.value;
                if (_i2.kind === "min") t.data.length < _i2.value && (a = this._getOrReturnCtx(t, a), le(a, {
                  code: X.too_small,
                  minimum: _i2.value,
                  type: "string",
                  inclusive: !0,
                  message: _i2.message
                }), n.dirty());else if (_i2.kind === "max") t.data.length > _i2.value && (a = this._getOrReturnCtx(t, a), le(a, {
                  code: X.too_big,
                  maximum: _i2.value,
                  type: "string",
                  inclusive: !0,
                  message: _i2.message
                }), n.dirty());else if (_i2.kind === "email") ri.test(t.data) || (a = this._getOrReturnCtx(t, a), le(a, {
                  validation: "email",
                  code: X.invalid_string,
                  message: _i2.message
                }), n.dirty());else if (_i2.kind === "uuid") ti.test(t.data) || (a = this._getOrReturnCtx(t, a), le(a, {
                  validation: "uuid",
                  code: X.invalid_string,
                  message: _i2.message
                }), n.dirty());else if (_i2.kind === "cuid") ei.test(t.data) || (a = this._getOrReturnCtx(t, a), le(a, {
                  validation: "cuid",
                  code: X.invalid_string,
                  message: _i2.message
                }), n.dirty());else if (_i2.kind === "url") try {
                  new URL(t.data);
                } catch (o) {
                  a = this._getOrReturnCtx(t, a), le(a, {
                    validation: "url",
                    code: X.invalid_string,
                    message: _i2.message
                  }), n.dirty();
                } else _i2.kind === "regex" ? (_i2.regex.lastIndex = 0, _i2.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), le(a, {
                  validation: "regex",
                  code: X.invalid_string,
                  message: _i2.message
                }), n.dirty())) : _i2.kind === "trim" ? t.data = t.data.trim() : Ue.assertNever(_i2);
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }
            return {
              status: n.value,
              value: t.data
            };
          }
        }, {
          key: "_addCheck",
          value: function _addCheck(t) {
            return new ur(ue(L({}, this._def), {
              checks: [].concat(_toConsumableArray(this._def.checks), [t])
            }));
          }
        }, {
          key: "email",
          value: function email(t) {
            return this._addCheck(L({
              kind: "email"
            }, Ge.errToObj(t)));
          }
        }, {
          key: "url",
          value: function url(t) {
            return this._addCheck(L({
              kind: "url"
            }, Ge.errToObj(t)));
          }
        }, {
          key: "uuid",
          value: function uuid(t) {
            return this._addCheck(L({
              kind: "uuid"
            }, Ge.errToObj(t)));
          }
        }, {
          key: "cuid",
          value: function cuid(t) {
            return this._addCheck(L({
              kind: "cuid"
            }, Ge.errToObj(t)));
          }
        }, {
          key: "regex",
          value: function regex(t, r) {
            return this._addCheck(L({
              kind: "regex",
              regex: t
            }, Ge.errToObj(r)));
          }
        }, {
          key: "min",
          value: function min(t, r) {
            return this._addCheck(L({
              kind: "min",
              value: t
            }, Ge.errToObj(r)));
          }
        }, {
          key: "max",
          value: function max(t, r) {
            return this._addCheck(L({
              kind: "max",
              value: t
            }, Ge.errToObj(r)));
          }
        }, {
          key: "length",
          value: function length(t, r) {
            return this.min(t, r).max(t, r);
          }
        }, {
          key: "isEmail",
          get: function get() {
            return !!this._def.checks.find(function (t) {
              return t.kind === "email";
            });
          }
        }, {
          key: "isURL",
          get: function get() {
            return !!this._def.checks.find(function (t) {
              return t.kind === "url";
            });
          }
        }, {
          key: "isUUID",
          get: function get() {
            return !!this._def.checks.find(function (t) {
              return t.kind === "uuid";
            });
          }
        }, {
          key: "isCUID",
          get: function get() {
            return !!this._def.checks.find(function (t) {
              return t.kind === "cuid";
            });
          }
        }, {
          key: "minLength",
          get: function get() {
            var t = -1 / 0;
            return this._def.checks.map(function (r) {
              r.kind === "min" && (t === null || r.value > t) && (t = r.value);
            }), t;
          }
        }, {
          key: "maxLength",
          get: function get() {
            var t = null;
            return this._def.checks.map(function (r) {
              r.kind === "max" && (t === null || r.value < t) && (t = r.value);
            }), t;
          }
        }]);
        return ur;
      }(ce);
      ur.create = function (e) {
        return new ur(L({
          checks: [],
          typeName: me.ZodString
        }, Ae(e)));
      };
      function ni(e, t) {
        var r = (e.toString().split(".")[1] || "").length,
          n = (t.toString().split(".")[1] || "").length,
          a = r > n ? r : n,
          i = parseInt(e.toFixed(a).replace(".", "")),
          o = parseInt(t.toFixed(a).replace(".", ""));
        return i % o / Math.pow(10, a);
      }
      var Pt = /*#__PURE__*/function (_ce2) {
        _inherits(Pt, _ce2);
        var _super3 = _createSuper(Pt);
        function Pt() {
          var _this3;
          _classCallCheck(this, Pt);
          _this3 = _super3.apply(this, arguments);
          _this3.min = _this3.gte, _this3.max = _this3.lte, _this3.step = _this3.multipleOf;
          return _this3;
        }
        _createClass(Pt, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.number) {
              var i = this._getOrReturnCtx(t);
              return le(i, {
                code: X.invalid_type,
                expected: Y.number,
                received: i.parsedType
              }), ke;
            }
            var n;
            var a = new Ke();
            var _iterator13 = _createForOfIteratorHelper(this._def.checks),
              _step13;
            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                var _i3 = _step13.value;
                _i3.kind === "int" ? Ue.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), le(n, {
                  code: X.invalid_type,
                  expected: "integer",
                  received: "float",
                  message: _i3.message
                }), a.dirty()) : _i3.kind === "min" ? (_i3.inclusive ? t.data < _i3.value : t.data <= _i3.value) && (n = this._getOrReturnCtx(t, n), le(n, {
                  code: X.too_small,
                  minimum: _i3.value,
                  type: "number",
                  inclusive: _i3.inclusive,
                  message: _i3.message
                }), a.dirty()) : _i3.kind === "max" ? (_i3.inclusive ? t.data > _i3.value : t.data >= _i3.value) && (n = this._getOrReturnCtx(t, n), le(n, {
                  code: X.too_big,
                  maximum: _i3.value,
                  type: "number",
                  inclusive: _i3.inclusive,
                  message: _i3.message
                }), a.dirty()) : _i3.kind === "multipleOf" ? ni(t.data, _i3.value) !== 0 && (n = this._getOrReturnCtx(t, n), le(n, {
                  code: X.not_multiple_of,
                  multipleOf: _i3.value,
                  message: _i3.message
                }), a.dirty()) : Ue.assertNever(_i3);
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }
            return {
              status: a.value,
              value: t.data
            };
          }
        }, {
          key: "gte",
          value: function gte(t, r) {
            return this.setLimit("min", t, !0, Ge.toString(r));
          }
        }, {
          key: "gt",
          value: function gt(t, r) {
            return this.setLimit("min", t, !1, Ge.toString(r));
          }
        }, {
          key: "lte",
          value: function lte(t, r) {
            return this.setLimit("max", t, !0, Ge.toString(r));
          }
        }, {
          key: "lt",
          value: function lt(t, r) {
            return this.setLimit("max", t, !1, Ge.toString(r));
          }
        }, {
          key: "setLimit",
          value: function setLimit(t, r, n, a) {
            return new Pt(ue(L({}, this._def), {
              checks: [].concat(_toConsumableArray(this._def.checks), [{
                kind: t,
                value: r,
                inclusive: n,
                message: Ge.toString(a)
              }])
            }));
          }
        }, {
          key: "_addCheck",
          value: function _addCheck(t) {
            return new Pt(ue(L({}, this._def), {
              checks: [].concat(_toConsumableArray(this._def.checks), [t])
            }));
          }
        }, {
          key: "int",
          value: function int(t) {
            return this._addCheck({
              kind: "int",
              message: Ge.toString(t)
            });
          }
        }, {
          key: "positive",
          value: function positive(t) {
            return this._addCheck({
              kind: "min",
              value: 0,
              inclusive: !1,
              message: Ge.toString(t)
            });
          }
        }, {
          key: "negative",
          value: function negative(t) {
            return this._addCheck({
              kind: "max",
              value: 0,
              inclusive: !1,
              message: Ge.toString(t)
            });
          }
        }, {
          key: "nonpositive",
          value: function nonpositive(t) {
            return this._addCheck({
              kind: "max",
              value: 0,
              inclusive: !0,
              message: Ge.toString(t)
            });
          }
        }, {
          key: "nonnegative",
          value: function nonnegative(t) {
            return this._addCheck({
              kind: "min",
              value: 0,
              inclusive: !0,
              message: Ge.toString(t)
            });
          }
        }, {
          key: "multipleOf",
          value: function multipleOf(t, r) {
            return this._addCheck({
              kind: "multipleOf",
              value: t,
              message: Ge.toString(r)
            });
          }
        }, {
          key: "minValue",
          get: function get() {
            var t = null;
            var _iterator14 = _createForOfIteratorHelper(this._def.checks),
              _step14;
            try {
              for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                var r = _step14.value;
                r.kind === "min" && (t === null || r.value > t) && (t = r.value);
              }
            } catch (err) {
              _iterator14.e(err);
            } finally {
              _iterator14.f();
            }
            return t;
          }
        }, {
          key: "maxValue",
          get: function get() {
            var t = null;
            var _iterator15 = _createForOfIteratorHelper(this._def.checks),
              _step15;
            try {
              for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                var r = _step15.value;
                r.kind === "max" && (t === null || r.value < t) && (t = r.value);
              }
            } catch (err) {
              _iterator15.e(err);
            } finally {
              _iterator15.f();
            }
            return t;
          }
        }, {
          key: "isInt",
          get: function get() {
            return !!this._def.checks.find(function (t) {
              return t.kind === "int";
            });
          }
        }]);
        return Pt;
      }(ce);
      Pt.create = function (e) {
        return new Pt(L({
          checks: [],
          typeName: me.ZodNumber
        }, Ae(e)));
      };
      var bn = /*#__PURE__*/function (_ce3) {
        _inherits(bn, _ce3);
        var _super4 = _createSuper(bn);
        function bn() {
          _classCallCheck(this, bn);
          return _super4.apply(this, arguments);
        }
        _createClass(bn, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.bigint) {
              var n = this._getOrReturnCtx(t);
              return le(n, {
                code: X.invalid_type,
                expected: Y.bigint,
                received: n.parsedType
              }), ke;
            }
            return Ct(t.data);
          }
        }]);
        return bn;
      }(ce);
      bn.create = function (e) {
        return new bn(L({
          typeName: me.ZodBigInt
        }, Ae(e)));
      };
      var yn = /*#__PURE__*/function (_ce4) {
        _inherits(yn, _ce4);
        var _super5 = _createSuper(yn);
        function yn() {
          _classCallCheck(this, yn);
          return _super5.apply(this, arguments);
        }
        _createClass(yn, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.boolean) {
              var n = this._getOrReturnCtx(t);
              return le(n, {
                code: X.invalid_type,
                expected: Y.boolean,
                received: n.parsedType
              }), ke;
            }
            return Ct(t.data);
          }
        }]);
        return yn;
      }(ce);
      yn.create = function (e) {
        return new yn(L({
          typeName: me.ZodBoolean
        }, Ae(e)));
      };
      var dt = /*#__PURE__*/function (_ce5) {
        _inherits(dt, _ce5);
        var _super6 = _createSuper(dt);
        function dt() {
          _classCallCheck(this, dt);
          return _super6.apply(this, arguments);
        }
        _createClass(dt, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.date) {
              var n = this._getOrReturnCtx(t);
              return le(n, {
                code: X.invalid_type,
                expected: Y.date,
                received: n.parsedType
              }), ke;
            }
            if (isNaN(t.data.getTime())) {
              var _n2 = this._getOrReturnCtx(t);
              return le(_n2, {
                code: X.invalid_date
              }), ke;
            }
            return {
              status: "valid",
              value: new Date(t.data.getTime())
            };
          }
        }]);
        return dt;
      }(ce);
      dt.create = function (e) {
        return new dt(L({
          typeName: me.ZodDate
        }, Ae(e)));
      };
      var wn = /*#__PURE__*/function (_ce6) {
        _inherits(wn, _ce6);
        var _super7 = _createSuper(wn);
        function wn() {
          _classCallCheck(this, wn);
          return _super7.apply(this, arguments);
        }
        _createClass(wn, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.undefined) {
              var n = this._getOrReturnCtx(t);
              return le(n, {
                code: X.invalid_type,
                expected: Y.undefined,
                received: n.parsedType
              }), ke;
            }
            return Ct(t.data);
          }
        }]);
        return wn;
      }(ce);
      wn.create = function (e) {
        return new wn(L({
          typeName: me.ZodUndefined
        }, Ae(e)));
      };
      var _n = /*#__PURE__*/function (_ce7) {
        _inherits(_n, _ce7);
        var _super8 = _createSuper(_n);
        function _n() {
          _classCallCheck(this, _n);
          return _super8.apply(this, arguments);
        }
        _createClass(_n, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.null) {
              var n = this._getOrReturnCtx(t);
              return le(n, {
                code: X.invalid_type,
                expected: Y.null,
                received: n.parsedType
              }), ke;
            }
            return Ct(t.data);
          }
        }]);
        return _n;
      }(ce);
      _n.create = function (e) {
        return new _n(L({
          typeName: me.ZodNull
        }, Ae(e)));
      };
      var Dr = /*#__PURE__*/function (_ce8) {
        _inherits(Dr, _ce8);
        var _super9 = _createSuper(Dr);
        function Dr() {
          var _this4;
          _classCallCheck(this, Dr);
          _this4 = _super9.apply(this, arguments);
          _this4._any = !0;
          return _this4;
        }
        _createClass(Dr, [{
          key: "_parse",
          value: function _parse(t) {
            return Ct(t.data);
          }
        }]);
        return Dr;
      }(ce);
      Dr.create = function (e) {
        return new Dr(L({
          typeName: me.ZodAny
        }, Ae(e)));
      };
      var fr = /*#__PURE__*/function (_ce9) {
        _inherits(fr, _ce9);
        var _super10 = _createSuper(fr);
        function fr() {
          var _this5;
          _classCallCheck(this, fr);
          _this5 = _super10.apply(this, arguments);
          _this5._unknown = !0;
          return _this5;
        }
        _createClass(fr, [{
          key: "_parse",
          value: function _parse(t) {
            return Ct(t.data);
          }
        }]);
        return fr;
      }(ce);
      fr.create = function (e) {
        return new fr(L({
          typeName: me.ZodUnknown
        }, Ae(e)));
      };
      var dr = /*#__PURE__*/function (_ce10) {
        _inherits(dr, _ce10);
        var _super11 = _createSuper(dr);
        function dr() {
          _classCallCheck(this, dr);
          return _super11.apply(this, arguments);
        }
        _createClass(dr, [{
          key: "_parse",
          value: function _parse(t) {
            var r = this._getOrReturnCtx(t);
            return le(r, {
              code: X.invalid_type,
              expected: Y.never,
              received: r.parsedType
            }), ke;
          }
        }]);
        return dr;
      }(ce);
      dr.create = function (e) {
        return new dr(L({
          typeName: me.ZodNever
        }, Ae(e)));
      };
      var xn = /*#__PURE__*/function (_ce11) {
        _inherits(xn, _ce11);
        var _super12 = _createSuper(xn);
        function xn() {
          _classCallCheck(this, xn);
          return _super12.apply(this, arguments);
        }
        _createClass(xn, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.undefined) {
              var n = this._getOrReturnCtx(t);
              return le(n, {
                code: X.invalid_type,
                expected: Y.void,
                received: n.parsedType
              }), ke;
            }
            return Ct(t.data);
          }
        }]);
        return xn;
      }(ce);
      xn.create = function (e) {
        return new xn(L({
          typeName: me.ZodVoid
        }, Ae(e)));
      };
      var Tt = /*#__PURE__*/function (_ce12) {
        _inherits(Tt, _ce12);
        var _super13 = _createSuper(Tt);
        function Tt() {
          _classCallCheck(this, Tt);
          return _super13.apply(this, arguments);
        }
        _createClass(Tt, [{
          key: "_parse",
          value: function _parse(t) {
            var _this$_processInputPa = this._processInputParams(t),
              r = _this$_processInputPa.ctx,
              n = _this$_processInputPa.status,
              a = this._def;
            if (r.parsedType !== Y.array) return le(r, {
              code: X.invalid_type,
              expected: Y.array,
              received: r.parsedType
            }), ke;
            if (a.minLength !== null && r.data.length < a.minLength.value && (le(r, {
              code: X.too_small,
              minimum: a.minLength.value,
              type: "array",
              inclusive: !0,
              message: a.minLength.message
            }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (le(r, {
              code: X.too_big,
              maximum: a.maxLength.value,
              type: "array",
              inclusive: !0,
              message: a.maxLength.message
            }), n.dirty()), r.common.async) return Promise.all(r.data.map(function (o, l) {
              return a.type._parseAsync(new Wt(r, o, r.path, l));
            })).then(function (o) {
              return Ke.mergeArray(n, o);
            });
            var i = r.data.map(function (o, l) {
              return a.type._parseSync(new Wt(r, o, r.path, l));
            });
            return Ke.mergeArray(n, i);
          }
        }, {
          key: "element",
          get: function get() {
            return this._def.type;
          }
        }, {
          key: "min",
          value: function min(t, r) {
            return new Tt(ue(L({}, this._def), {
              minLength: {
                value: t,
                message: Ge.toString(r)
              }
            }));
          }
        }, {
          key: "max",
          value: function max(t, r) {
            return new Tt(ue(L({}, this._def), {
              maxLength: {
                value: t,
                message: Ge.toString(r)
              }
            }));
          }
        }, {
          key: "length",
          value: function length(t, r) {
            return this.min(t, r).max(t, r);
          }
        }, {
          key: "nonempty",
          value: function nonempty(t) {
            return this.min(1, t);
          }
        }]);
        return Tt;
      }(ce);
      Tt.create = function (e, t) {
        return new Tt(L({
          type: e,
          minLength: null,
          maxLength: null,
          typeName: me.ZodArray
        }, Ae(t)));
      };
      var En;
      (function (e) {
        e.mergeShapes = function (t, r) {
          return L(L({}, t), r);
        };
      })(En || (En = {}));
      var pa = function pa(e) {
        return function (t) {
          return new tt(ue(L({}, e), {
            shape: function shape() {
              return L(L({}, e.shape()), t);
            }
          }));
        };
      };
      function Lr(e) {
        if (e instanceof tt) {
          var t = {};
          for (var r in e.shape) {
            var n = e.shape[r];
            t[r] = qt.create(Lr(n));
          }
          return new tt(ue(L({}, e._def), {
            shape: function shape() {
              return t;
            }
          }));
        } else return e instanceof Tt ? Tt.create(Lr(e.element)) : e instanceof qt ? qt.create(Lr(e.unwrap())) : e instanceof pr ? pr.create(Lr(e.unwrap())) : e instanceof Jt ? Jt.create(e.items.map(function (t) {
          return Lr(t);
        })) : e;
      }
      var tt = /*#__PURE__*/function (_ce13) {
        _inherits(tt, _ce13);
        var _super14 = _createSuper(tt);
        function tt() {
          var _this6;
          _classCallCheck(this, tt);
          _this6 = _super14.apply(this, arguments);
          _this6._cached = null, _this6.nonstrict = _this6.passthrough, _this6.augment = pa(_this6._def), _this6.extend = pa(_this6._def);
          return _this6;
        }
        _createClass(tt, [{
          key: "_getCached",
          value: function _getCached() {
            if (this._cached !== null) return this._cached;
            var t = this._def.shape(),
              r = Ue.objectKeys(t);
            return this._cached = {
              shape: t,
              keys: r
            };
          }
        }, {
          key: "_parse",
          value: function _parse(t) {
            var _this7 = this;
            if (this._getType(t) !== Y.object) {
              var h = this._getOrReturnCtx(t);
              return le(h, {
                code: X.invalid_type,
                expected: Y.object,
                received: h.parsedType
              }), ke;
            }
            var _this$_processInputPa2 = this._processInputParams(t),
              n = _this$_processInputPa2.status,
              a = _this$_processInputPa2.ctx,
              _this$_getCached = this._getCached(),
              i = _this$_getCached.shape,
              o = _this$_getCached.keys,
              l = [];
            for (var h in a.data) {
              o.includes(h) || l.push(h);
            }
            var u = [];
            var _iterator16 = _createForOfIteratorHelper(o),
              _step16;
            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _h4 = _step16.value;
                var _g4 = i[_h4],
                  _y2 = a.data[_h4];
                u.push({
                  key: {
                    status: "valid",
                    value: _h4
                  },
                  value: _g4._parse(new Wt(a, _y2, a.path, _h4)),
                  alwaysSet: _h4 in a.data
                });
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }
            if (this._def.catchall instanceof dr) {
              var _h2 = this._def.unknownKeys;
              if (_h2 === "passthrough") {
                var _iterator17 = _createForOfIteratorHelper(l),
                  _step17;
                try {
                  for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                    var g = _step17.value;
                    u.push({
                      key: {
                        status: "valid",
                        value: g
                      },
                      value: {
                        status: "valid",
                        value: a.data[g]
                      }
                    });
                  }
                } catch (err) {
                  _iterator17.e(err);
                } finally {
                  _iterator17.f();
                }
              } else if (_h2 === "strict") l.length > 0 && (le(a, {
                code: X.unrecognized_keys,
                keys: l
              }), n.dirty());else if (_h2 !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
            } else {
              var _h3 = this._def.catchall;
              var _iterator18 = _createForOfIteratorHelper(l),
                _step18;
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var _g2 = _step18.value;
                  var y = a.data[_g2];
                  u.push({
                    key: {
                      status: "valid",
                      value: _g2
                    },
                    value: _h3._parse(new Wt(a, y, a.path, _g2)),
                    alwaysSet: _g2 in a.data
                  });
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
            }
            return a.common.async ? Promise.resolve().then(function () {
              return Un(_this7, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                var h, _iterator19, _step19, _g3, _y;
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        h = [];
                        _iterator19 = _createForOfIteratorHelper(u);
                        _context4.prev = 2;
                        _iterator19.s();
                      case 4:
                        if ((_step19 = _iterator19.n()).done) {
                          _context4.next = 19;
                          break;
                        }
                        _g3 = _step19.value;
                        _context4.next = 8;
                        return _g3.key;
                      case 8:
                        _y = _context4.sent;
                        _context4.t0 = h;
                        _context4.t1 = _y;
                        _context4.next = 13;
                        return _g3.value;
                      case 13:
                        _context4.t2 = _context4.sent;
                        _context4.t3 = _g3.alwaysSet;
                        _context4.t4 = {
                          key: _context4.t1,
                          value: _context4.t2,
                          alwaysSet: _context4.t3
                        };
                        _context4.t0.push.call(_context4.t0, _context4.t4);
                      case 17:
                        _context4.next = 4;
                        break;
                      case 19:
                        _context4.next = 24;
                        break;
                      case 21:
                        _context4.prev = 21;
                        _context4.t5 = _context4["catch"](2);
                        _iterator19.e(_context4.t5);
                      case 24:
                        _context4.prev = 24;
                        _iterator19.f();
                        return _context4.finish(24);
                      case 27:
                        return _context4.abrupt("return", h);
                      case 28:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[2, 21, 24, 27]]);
              }));
            }).then(function (h) {
              return Ke.mergeObjectSync(n, h);
            }) : Ke.mergeObjectSync(n, u);
          }
        }, {
          key: "shape",
          get: function get() {
            return this._def.shape();
          }
        }, {
          key: "strict",
          value: function strict(t) {
            var _this8 = this;
            return Ge.errToObj, new tt(L(ue(L({}, this._def), {
              unknownKeys: "strict"
            }), t !== void 0 ? {
              errorMap: function errorMap(r, n) {
                var a, i, o, l;
                var u = (o = (i = (a = _this8._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
                return r.code === "unrecognized_keys" ? {
                  message: (l = Ge.errToObj(t).message) !== null && l !== void 0 ? l : u
                } : {
                  message: u
                };
              }
            } : {}));
          }
        }, {
          key: "strip",
          value: function strip() {
            return new tt(ue(L({}, this._def), {
              unknownKeys: "strip"
            }));
          }
        }, {
          key: "passthrough",
          value: function passthrough() {
            return new tt(ue(L({}, this._def), {
              unknownKeys: "passthrough"
            }));
          }
        }, {
          key: "setKey",
          value: function setKey(t, r) {
            return this.augment(_defineProperty({}, t, r));
          }
        }, {
          key: "merge",
          value: function merge(t) {
            var _this9 = this;
            return new tt({
              unknownKeys: t._def.unknownKeys,
              catchall: t._def.catchall,
              shape: function shape() {
                return En.mergeShapes(_this9._def.shape(), t._def.shape());
              },
              typeName: me.ZodObject
            });
          }
        }, {
          key: "catchall",
          value: function catchall(t) {
            return new tt(ue(L({}, this._def), {
              catchall: t
            }));
          }
        }, {
          key: "pick",
          value: function pick(t) {
            var _this10 = this;
            var r = {};
            return Ue.objectKeys(t).map(function (n) {
              _this10.shape[n] && (r[n] = _this10.shape[n]);
            }), new tt(ue(L({}, this._def), {
              shape: function shape() {
                return r;
              }
            }));
          }
        }, {
          key: "omit",
          value: function omit(t) {
            var _this11 = this;
            var r = {};
            return Ue.objectKeys(this.shape).map(function (n) {
              Ue.objectKeys(t).indexOf(n) === -1 && (r[n] = _this11.shape[n]);
            }), new tt(ue(L({}, this._def), {
              shape: function shape() {
                return r;
              }
            }));
          }
        }, {
          key: "deepPartial",
          value: function deepPartial() {
            return Lr(this);
          }
        }, {
          key: "partial",
          value: function partial(t) {
            var _this12 = this;
            var r = {};
            if (t) return Ue.objectKeys(this.shape).map(function (n) {
              Ue.objectKeys(t).indexOf(n) === -1 ? r[n] = _this12.shape[n] : r[n] = _this12.shape[n].optional();
            }), new tt(ue(L({}, this._def), {
              shape: function shape() {
                return r;
              }
            }));
            for (var n in this.shape) {
              var a = this.shape[n];
              r[n] = a.optional();
            }
            return new tt(ue(L({}, this._def), {
              shape: function shape() {
                return r;
              }
            }));
          }
        }, {
          key: "required",
          value: function required() {
            var t = {};
            for (var r in this.shape) {
              var a = this.shape[r];
              for (; a instanceof qt;) {
                a = a._def.innerType;
              }
              t[r] = a;
            }
            return new tt(ue(L({}, this._def), {
              shape: function shape() {
                return t;
              }
            }));
          }
        }]);
        return tt;
      }(ce);
      tt.create = function (e, t) {
        return new tt(L({
          shape: function shape() {
            return e;
          },
          unknownKeys: "strip",
          catchall: dr.create(),
          typeName: me.ZodObject
        }, Ae(t)));
      }, tt.strictCreate = function (e, t) {
        return new tt(L({
          shape: function shape() {
            return e;
          },
          unknownKeys: "strict",
          catchall: dr.create(),
          typeName: me.ZodObject
        }, Ae(t)));
      }, tt.lazycreate = function (e, t) {
        return new tt(L({
          shape: e,
          unknownKeys: "strip",
          catchall: dr.create(),
          typeName: me.ZodObject
        }, Ae(t)));
      };
      var Fr = /*#__PURE__*/function (_ce14) {
        _inherits(Fr, _ce14);
        var _super15 = _createSuper(Fr);
        function Fr() {
          _classCallCheck(this, Fr);
          return _super15.apply(this, arguments);
        }
        _createClass(Fr, [{
          key: "_parse",
          value: function _parse(t) {
            var _this13 = this;
            var _this$_processInputPa3 = this._processInputParams(t),
              r = _this$_processInputPa3.ctx,
              n = this._def.options;
            function a(i) {
              var _iterator20 = _createForOfIteratorHelper(i),
                _step20;
              try {
                for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                  var l = _step20.value;
                  if (l.result.status === "valid") return l.result;
                }
              } catch (err) {
                _iterator20.e(err);
              } finally {
                _iterator20.f();
              }
              var _iterator21 = _createForOfIteratorHelper(i),
                _step21;
              try {
                for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                  var _r$common$issues;
                  var _l2 = _step21.value;
                  if (_l2.result.status === "dirty") return (_r$common$issues = r.common.issues).push.apply(_r$common$issues, _toConsumableArray(_l2.ctx.common.issues)), _l2.result;
                }
              } catch (err) {
                _iterator21.e(err);
              } finally {
                _iterator21.f();
              }
              var o = i.map(function (l) {
                return new Qt(l.ctx.common.issues);
              });
              return le(r, {
                code: X.invalid_union,
                unionErrors: o
              }), ke;
            }
            if (r.common.async) return Promise.all(n.map(function (i) {
              return Un(_this13, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                var o;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        o = ue(L({}, r), {
                          common: ue(L({}, r.common), {
                            issues: []
                          }),
                          parent: null
                        });
                        _context5.next = 3;
                        return i._parseAsync({
                          data: r.data,
                          path: r.path,
                          parent: o
                        });
                      case 3:
                        _context5.t0 = _context5.sent;
                        _context5.t1 = o;
                        return _context5.abrupt("return", {
                          result: _context5.t0,
                          ctx: _context5.t1
                        });
                      case 6:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));
            })).then(a);
            {
              var _r$common$issues2;
              var i;
              var o = [];
              var _iterator22 = _createForOfIteratorHelper(n),
                _step22;
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  var u = _step22.value;
                  var h = ue(L({}, r), {
                      common: ue(L({}, r.common), {
                        issues: []
                      }),
                      parent: null
                    }),
                    g = u._parseSync({
                      data: r.data,
                      path: r.path,
                      parent: h
                    });
                  if (g.status === "valid") return g;
                  g.status === "dirty" && !i && (i = {
                    result: g,
                    ctx: h
                  }), h.common.issues.length && o.push(h.common.issues);
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              if (i) return (_r$common$issues2 = r.common.issues).push.apply(_r$common$issues2, _toConsumableArray(i.ctx.common.issues)), i.result;
              var l = o.map(function (u) {
                return new Qt(u);
              });
              return le(r, {
                code: X.invalid_union,
                unionErrors: l
              }), ke;
            }
          }
        }, {
          key: "options",
          get: function get() {
            return this._def.options;
          }
        }]);
        return Fr;
      }(ce);
      Fr.create = function (e, t) {
        return new Fr(L({
          options: e,
          typeName: me.ZodUnion
        }, Ae(t)));
      };
      var On = /*#__PURE__*/function (_ce15) {
        _inherits(On, _ce15);
        var _super16 = _createSuper(On);
        function On() {
          _classCallCheck(this, On);
          return _super16.apply(this, arguments);
        }
        _createClass(On, [{
          key: "_parse",
          value: function _parse(t) {
            var _this$_processInputPa4 = this._processInputParams(t),
              r = _this$_processInputPa4.ctx;
            if (r.parsedType !== Y.object) return le(r, {
              code: X.invalid_type,
              expected: Y.object,
              received: r.parsedType
            }), ke;
            var n = this.discriminator,
              a = r.data[n],
              i = this.options.get(a);
            return i ? r.common.async ? i._parseAsync({
              data: r.data,
              path: r.path,
              parent: r
            }) : i._parseSync({
              data: r.data,
              path: r.path,
              parent: r
            }) : (le(r, {
              code: X.invalid_union_discriminator,
              options: this.validDiscriminatorValues,
              path: [n]
            }), ke);
          }
        }, {
          key: "discriminator",
          get: function get() {
            return this._def.discriminator;
          }
        }, {
          key: "validDiscriminatorValues",
          get: function get() {
            return Array.from(this.options.keys());
          }
        }, {
          key: "options",
          get: function get() {
            return this._def.options;
          }
        }], [{
          key: "create",
          value: function create(t, r, n) {
            var a = new Map();
            try {
              r.forEach(function (i) {
                var o = i.shape[t].value;
                a.set(o, i);
              });
            } catch (i) {
              throw new Error("The discriminator value could not be extracted from all the provided schemas");
            }
            if (a.size !== r.length) throw new Error("Some of the discriminator values are not unique");
            return new On(L({
              typeName: me.ZodDiscriminatedUnion,
              discriminator: t,
              options: a
            }, Ae(n)));
          }
        }]);
        return On;
      }(ce);
      function tn(e, t) {
        var r = At(e),
          n = At(t);
        if (e === t) return {
          valid: !0,
          data: e
        };
        if (r === Y.object && n === Y.object) {
          var a = Ue.objectKeys(t),
            i = Ue.objectKeys(e).filter(function (l) {
              return a.indexOf(l) !== -1;
            }),
            o = L(L({}, e), t);
          var _iterator23 = _createForOfIteratorHelper(i),
            _step23;
          try {
            for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
              var l = _step23.value;
              var u = tn(e[l], t[l]);
              if (!u.valid) return {
                valid: !1
              };
              o[l] = u.data;
            }
          } catch (err) {
            _iterator23.e(err);
          } finally {
            _iterator23.f();
          }
          return {
            valid: !0,
            data: o
          };
        } else if (r === Y.array && n === Y.array) {
          if (e.length !== t.length) return {
            valid: !1
          };
          var _a2 = [];
          for (var _i4 = 0; _i4 < e.length; _i4++) {
            var _o2 = e[_i4],
              _l3 = t[_i4],
              _u2 = tn(_o2, _l3);
            if (!_u2.valid) return {
              valid: !1
            };
            _a2.push(_u2.data);
          }
          return {
            valid: !0,
            data: _a2
          };
        } else return r === Y.date && n === Y.date && +e == +t ? {
          valid: !0,
          data: e
        } : {
          valid: !1
        };
      }
      var br = /*#__PURE__*/function (_ce16) {
        _inherits(br, _ce16);
        var _super17 = _createSuper(br);
        function br() {
          _classCallCheck(this, br);
          return _super17.apply(this, arguments);
        }
        _createClass(br, [{
          key: "_parse",
          value: function _parse(t) {
            var _this$_processInputPa5 = this._processInputParams(t),
              r = _this$_processInputPa5.status,
              n = _this$_processInputPa5.ctx,
              a = function a(i, o) {
                if (Gn(i) || Gn(o)) return ke;
                var l = tn(i.value, o.value);
                return l.valid ? ((Wn(i) || Wn(o)) && r.dirty(), {
                  status: r.value,
                  value: l.data
                }) : (le(n, {
                  code: X.invalid_intersection_types
                }), ke);
              };
            return n.common.async ? Promise.all([this._def.left._parseAsync({
              data: n.data,
              path: n.path,
              parent: n
            }), this._def.right._parseAsync({
              data: n.data,
              path: n.path,
              parent: n
            })]).then(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                i = _ref2[0],
                o = _ref2[1];
              return a(i, o);
            }) : a(this._def.left._parseSync({
              data: n.data,
              path: n.path,
              parent: n
            }), this._def.right._parseSync({
              data: n.data,
              path: n.path,
              parent: n
            }));
          }
        }]);
        return br;
      }(ce);
      br.create = function (e, t, r) {
        return new br(L({
          left: e,
          right: t,
          typeName: me.ZodIntersection
        }, Ae(r)));
      };
      var Jt = /*#__PURE__*/function (_ce17) {
        _inherits(Jt, _ce17);
        var _super18 = _createSuper(Jt);
        function Jt() {
          _classCallCheck(this, Jt);
          return _super18.apply(this, arguments);
        }
        _createClass(Jt, [{
          key: "_parse",
          value: function _parse(t) {
            var _this14 = this;
            var _this$_processInputPa6 = this._processInputParams(t),
              r = _this$_processInputPa6.status,
              n = _this$_processInputPa6.ctx;
            if (n.parsedType !== Y.array) return le(n, {
              code: X.invalid_type,
              expected: Y.array,
              received: n.parsedType
            }), ke;
            if (n.data.length < this._def.items.length) return le(n, {
              code: X.too_small,
              minimum: this._def.items.length,
              inclusive: !0,
              type: "array"
            }), ke;
            !this._def.rest && n.data.length > this._def.items.length && (le(n, {
              code: X.too_big,
              maximum: this._def.items.length,
              inclusive: !0,
              type: "array"
            }), r.dirty());
            var i = n.data.map(function (o, l) {
              var u = _this14._def.items[l] || _this14._def.rest;
              return u ? u._parse(new Wt(n, o, n.path, l)) : null;
            }).filter(function (o) {
              return !!o;
            });
            return n.common.async ? Promise.all(i).then(function (o) {
              return Ke.mergeArray(r, o);
            }) : Ke.mergeArray(r, i);
          }
        }, {
          key: "items",
          get: function get() {
            return this._def.items;
          }
        }, {
          key: "rest",
          value: function rest(t) {
            return new Jt(ue(L({}, this._def), {
              rest: t
            }));
          }
        }]);
        return Jt;
      }(ce);
      Jt.create = function (e, t) {
        return new Jt(L({
          items: e,
          typeName: me.ZodTuple,
          rest: null
        }, Ae(t)));
      };
      var rn = /*#__PURE__*/function (_ce18) {
        _inherits(rn, _ce18);
        var _super19 = _createSuper(rn);
        function rn() {
          _classCallCheck(this, rn);
          return _super19.apply(this, arguments);
        }
        _createClass(rn, [{
          key: "keySchema",
          get: function get() {
            return this._def.keyType;
          }
        }, {
          key: "valueSchema",
          get: function get() {
            return this._def.valueType;
          }
        }, {
          key: "_parse",
          value: function _parse(t) {
            var _this$_processInputPa7 = this._processInputParams(t),
              r = _this$_processInputPa7.status,
              n = _this$_processInputPa7.ctx;
            if (n.parsedType !== Y.object) return le(n, {
              code: X.invalid_type,
              expected: Y.object,
              received: n.parsedType
            }), ke;
            var a = [],
              i = this._def.keyType,
              o = this._def.valueType;
            for (var l in n.data) {
              a.push({
                key: i._parse(new Wt(n, l, n.path, l)),
                value: o._parse(new Wt(n, n.data[l], n.path, l))
              });
            }
            return n.common.async ? Ke.mergeObjectAsync(r, a) : Ke.mergeObjectSync(r, a);
          }
        }, {
          key: "element",
          get: function get() {
            return this._def.valueType;
          }
        }], [{
          key: "create",
          value: function create(t, r, n) {
            return r instanceof ce ? new rn(L({
              keyType: t,
              valueType: r,
              typeName: me.ZodRecord
            }, Ae(n))) : new rn(L({
              keyType: ur.create(),
              valueType: t,
              typeName: me.ZodRecord
            }, Ae(r)));
          }
        }]);
        return rn;
      }(ce);
      var Tn = /*#__PURE__*/function (_ce19) {
        _inherits(Tn, _ce19);
        var _super20 = _createSuper(Tn);
        function Tn() {
          _classCallCheck(this, Tn);
          return _super20.apply(this, arguments);
        }
        _createClass(Tn, [{
          key: "_parse",
          value: function _parse(t) {
            var _this15 = this;
            var _this$_processInputPa8 = this._processInputParams(t),
              r = _this$_processInputPa8.status,
              n = _this$_processInputPa8.ctx;
            if (n.parsedType !== Y.map) return le(n, {
              code: X.invalid_type,
              expected: Y.map,
              received: n.parsedType
            }), ke;
            var a = this._def.keyType,
              i = this._def.valueType,
              o = _toConsumableArray(n.data.entries()).map(function (_ref3, h) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  l = _ref4[0],
                  u = _ref4[1];
                return {
                  key: a._parse(new Wt(n, l, n.path, [h, "key"])),
                  value: i._parse(new Wt(n, u, n.path, [h, "value"]))
                };
              });
            if (n.common.async) {
              var l = new Map();
              return Promise.resolve().then(function () {
                return Un(_this15, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                  var _iterator24, _step24, u, h, g;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _iterator24 = _createForOfIteratorHelper(o);
                          _context6.prev = 1;
                          _iterator24.s();
                        case 3:
                          if ((_step24 = _iterator24.n()).done) {
                            _context6.next = 16;
                            break;
                          }
                          u = _step24.value;
                          _context6.next = 7;
                          return u.key;
                        case 7:
                          h = _context6.sent;
                          _context6.next = 10;
                          return u.value;
                        case 10:
                          g = _context6.sent;
                          if (!(h.status === "aborted" || g.status === "aborted")) {
                            _context6.next = 13;
                            break;
                          }
                          return _context6.abrupt("return", ke);
                        case 13:
                          (h.status === "dirty" || g.status === "dirty") && r.dirty(), l.set(h.value, g.value);
                        case 14:
                          _context6.next = 3;
                          break;
                        case 16:
                          _context6.next = 21;
                          break;
                        case 18:
                          _context6.prev = 18;
                          _context6.t0 = _context6["catch"](1);
                          _iterator24.e(_context6.t0);
                        case 21:
                          _context6.prev = 21;
                          _iterator24.f();
                          return _context6.finish(21);
                        case 24:
                          return _context6.abrupt("return", {
                            status: r.value,
                            value: l
                          });
                        case 25:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6, null, [[1, 18, 21, 24]]);
                }));
              });
            } else {
              var _l4 = new Map();
              var _iterator25 = _createForOfIteratorHelper(o),
                _step25;
              try {
                for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                  var u = _step25.value;
                  var h = u.key,
                    g = u.value;
                  if (h.status === "aborted" || g.status === "aborted") return ke;
                  (h.status === "dirty" || g.status === "dirty") && r.dirty(), _l4.set(h.value, g.value);
                }
              } catch (err) {
                _iterator25.e(err);
              } finally {
                _iterator25.f();
              }
              return {
                status: r.value,
                value: _l4
              };
            }
          }
        }]);
        return Tn;
      }(ce);
      Tn.create = function (e, t, r) {
        return new Tn(L({
          valueType: t,
          keyType: e,
          typeName: me.ZodMap
        }, Ae(r)));
      };
      var yr = /*#__PURE__*/function (_ce20) {
        _inherits(yr, _ce20);
        var _super21 = _createSuper(yr);
        function yr() {
          _classCallCheck(this, yr);
          return _super21.apply(this, arguments);
        }
        _createClass(yr, [{
          key: "_parse",
          value: function _parse(t) {
            var _this$_processInputPa9 = this._processInputParams(t),
              r = _this$_processInputPa9.status,
              n = _this$_processInputPa9.ctx;
            if (n.parsedType !== Y.set) return le(n, {
              code: X.invalid_type,
              expected: Y.set,
              received: n.parsedType
            }), ke;
            var a = this._def;
            a.minSize !== null && n.data.size < a.minSize.value && (le(n, {
              code: X.too_small,
              minimum: a.minSize.value,
              type: "set",
              inclusive: !0,
              message: a.minSize.message
            }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (le(n, {
              code: X.too_big,
              maximum: a.maxSize.value,
              type: "set",
              inclusive: !0,
              message: a.maxSize.message
            }), r.dirty());
            var i = this._def.valueType;
            function o(u) {
              var h = new Set();
              var _iterator26 = _createForOfIteratorHelper(u),
                _step26;
              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  var g = _step26.value;
                  if (g.status === "aborted") return ke;
                  g.status === "dirty" && r.dirty(), h.add(g.value);
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }
              return {
                status: r.value,
                value: h
              };
            }
            var l = _toConsumableArray(n.data.values()).map(function (u, h) {
              return i._parse(new Wt(n, u, n.path, h));
            });
            return n.common.async ? Promise.all(l).then(function (u) {
              return o(u);
            }) : o(l);
          }
        }, {
          key: "min",
          value: function min(t, r) {
            return new yr(ue(L({}, this._def), {
              minSize: {
                value: t,
                message: Ge.toString(r)
              }
            }));
          }
        }, {
          key: "max",
          value: function max(t, r) {
            return new yr(ue(L({}, this._def), {
              maxSize: {
                value: t,
                message: Ge.toString(r)
              }
            }));
          }
        }, {
          key: "size",
          value: function size(t, r) {
            return this.min(t, r).max(t, r);
          }
        }, {
          key: "nonempty",
          value: function nonempty(t) {
            return this.min(1, t);
          }
        }]);
        return yr;
      }(ce);
      yr.create = function (e, t) {
        return new yr(L({
          valueType: e,
          minSize: null,
          maxSize: null,
          typeName: me.ZodSet
        }, Ae(t)));
      };
      var wr = /*#__PURE__*/function (_ce21) {
        _inherits(wr, _ce21);
        var _super22 = _createSuper(wr);
        function wr() {
          var _this16;
          _classCallCheck(this, wr);
          _this16 = _super22.apply(this, arguments);
          _this16.validate = _this16.implement;
          return _this16;
        }
        _createClass(wr, [{
          key: "_parse",
          value: function _parse(t) {
            var _this17 = this;
            var _this$_processInputPa10 = this._processInputParams(t),
              r = _this$_processInputPa10.ctx;
            if (r.parsedType !== Y.function) return le(r, {
              code: X.invalid_type,
              expected: Y.function,
              received: r.parsedType
            }), ke;
            function n(l, u) {
              return Gt({
                data: l,
                path: r.path,
                errorMaps: [r.common.contextualErrorMap, r.schemaErrorMap, Qr, Yr].filter(function (h) {
                  return !!h;
                }),
                issueData: {
                  code: X.invalid_arguments,
                  argumentsError: u
                }
              });
            }
            function a(l, u) {
              return Gt({
                data: l,
                path: r.path,
                errorMaps: [r.common.contextualErrorMap, r.schemaErrorMap, Qr, Yr].filter(function (h) {
                  return !!h;
                }),
                issueData: {
                  code: X.invalid_return_type,
                  returnTypeError: u
                }
              });
            }
            var i = {
                errorMap: r.common.contextualErrorMap
              },
              o = r.data;
            return this._def.returns instanceof hr ? Ct(function () {
              for (var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++) {
                l[_key] = arguments[_key];
              }
              return Un(_this17, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                var u, h, g;
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        u = new Qt([]);
                        _context7.next = 3;
                        return this._def.args.parseAsync(l, i).catch(function (C) {
                          throw u.addIssue(n(l, C)), u;
                        });
                      case 3:
                        h = _context7.sent;
                        _context7.next = 6;
                        return o.apply(void 0, _toConsumableArray(h));
                      case 6:
                        g = _context7.sent;
                        _context7.next = 9;
                        return this._def.returns._def.type.parseAsync(g, i).catch(function (C) {
                          throw u.addIssue(a(g, C)), u;
                        });
                      case 9:
                        return _context7.abrupt("return", _context7.sent);
                      case 10:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, this);
              }));
            }) : Ct(function () {
              for (var _len2 = arguments.length, l = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                l[_key2] = arguments[_key2];
              }
              var u = _this17._def.args.safeParse(l, i);
              if (!u.success) throw new Qt([n(l, u.error)]);
              var h = o.apply(void 0, _toConsumableArray(u.data)),
                g = _this17._def.returns.safeParse(h, i);
              if (!g.success) throw new Qt([a(h, g.error)]);
              return g.data;
            });
          }
        }, {
          key: "parameters",
          value: function parameters() {
            return this._def.args;
          }
        }, {
          key: "returnType",
          value: function returnType() {
            return this._def.returns;
          }
        }, {
          key: "args",
          value: function args() {
            for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              t[_key3] = arguments[_key3];
            }
            return new wr(ue(L({}, this._def), {
              args: Jt.create(t).rest(fr.create())
            }));
          }
        }, {
          key: "returns",
          value: function returns(t) {
            return new wr(ue(L({}, this._def), {
              returns: t
            }));
          }
        }, {
          key: "implement",
          value: function implement(t) {
            return this.parse(t);
          }
        }, {
          key: "strictImplement",
          value: function strictImplement(t) {
            return this.parse(t);
          }
        }]);
        return wr;
      }(ce);
      wr.create = function (e, t, r) {
        return new wr(L({
          args: e ? e.rest(fr.create()) : Jt.create([]).rest(fr.create()),
          returns: t || fr.create(),
          typeName: me.ZodFunction
        }, Ae(r)));
      };
      var kn = /*#__PURE__*/function (_ce22) {
        _inherits(kn, _ce22);
        var _super23 = _createSuper(kn);
        function kn() {
          _classCallCheck(this, kn);
          return _super23.apply(this, arguments);
        }
        _createClass(kn, [{
          key: "schema",
          get: function get() {
            return this._def.getter();
          }
        }, {
          key: "_parse",
          value: function _parse(t) {
            var _this$_processInputPa11 = this._processInputParams(t),
              r = _this$_processInputPa11.ctx;
            return this._def.getter()._parse({
              data: r.data,
              path: r.path,
              parent: r
            });
          }
        }]);
        return kn;
      }(ce);
      kn.create = function (e, t) {
        return new kn(L({
          getter: e,
          typeName: me.ZodLazy
        }, Ae(t)));
      };
      var Sn = /*#__PURE__*/function (_ce23) {
        _inherits(Sn, _ce23);
        var _super24 = _createSuper(Sn);
        function Sn() {
          _classCallCheck(this, Sn);
          return _super24.apply(this, arguments);
        }
        _createClass(Sn, [{
          key: "_parse",
          value: function _parse(t) {
            if (t.data !== this._def.value) {
              var r = this._getOrReturnCtx(t);
              return le(r, {
                code: X.invalid_literal,
                expected: this._def.value
              }), ke;
            }
            return {
              status: "valid",
              value: t.data
            };
          }
        }, {
          key: "value",
          get: function get() {
            return this._def.value;
          }
        }]);
        return Sn;
      }(ce);
      Sn.create = function (e, t) {
        return new Sn(L({
          value: e,
          typeName: me.ZodLiteral
        }, Ae(t)));
      };
      function ai(e, t) {
        return new Cn(L({
          values: e,
          typeName: me.ZodEnum
        }, Ae(t)));
      }
      var Cn = /*#__PURE__*/function (_ce24) {
        _inherits(Cn, _ce24);
        var _super25 = _createSuper(Cn);
        function Cn() {
          _classCallCheck(this, Cn);
          return _super25.apply(this, arguments);
        }
        _createClass(Cn, [{
          key: "_parse",
          value: function _parse(t) {
            if (typeof t.data != "string") {
              var r = this._getOrReturnCtx(t),
                n = this._def.values;
              return le(r, {
                expected: Ue.joinValues(n),
                received: r.parsedType,
                code: X.invalid_type
              }), ke;
            }
            if (this._def.values.indexOf(t.data) === -1) {
              var _r2 = this._getOrReturnCtx(t),
                _n3 = this._def.values;
              return le(_r2, {
                received: _r2.data,
                code: X.invalid_enum_value,
                options: _n3
              }), ke;
            }
            return Ct(t.data);
          }
        }, {
          key: "options",
          get: function get() {
            return this._def.values;
          }
        }, {
          key: "enum",
          get: function get() {
            var t = {};
            var _iterator27 = _createForOfIteratorHelper(this._def.values),
              _step27;
            try {
              for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                var r = _step27.value;
                t[r] = r;
              }
            } catch (err) {
              _iterator27.e(err);
            } finally {
              _iterator27.f();
            }
            return t;
          }
        }, {
          key: "Values",
          get: function get() {
            var t = {};
            var _iterator28 = _createForOfIteratorHelper(this._def.values),
              _step28;
            try {
              for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                var r = _step28.value;
                t[r] = r;
              }
            } catch (err) {
              _iterator28.e(err);
            } finally {
              _iterator28.f();
            }
            return t;
          }
        }, {
          key: "Enum",
          get: function get() {
            var t = {};
            var _iterator29 = _createForOfIteratorHelper(this._def.values),
              _step29;
            try {
              for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                var r = _step29.value;
                t[r] = r;
              }
            } catch (err) {
              _iterator29.e(err);
            } finally {
              _iterator29.f();
            }
            return t;
          }
        }]);
        return Cn;
      }(ce);
      Cn.create = ai;
      var Mn = /*#__PURE__*/function (_ce25) {
        _inherits(Mn, _ce25);
        var _super26 = _createSuper(Mn);
        function Mn() {
          _classCallCheck(this, Mn);
          return _super26.apply(this, arguments);
        }
        _createClass(Mn, [{
          key: "_parse",
          value: function _parse(t) {
            var r = Ue.getValidEnumValues(this._def.values),
              n = this._getOrReturnCtx(t);
            if (n.parsedType !== Y.string && n.parsedType !== Y.number) {
              var a = Ue.objectValues(r);
              return le(n, {
                expected: Ue.joinValues(a),
                received: n.parsedType,
                code: X.invalid_type
              }), ke;
            }
            if (r.indexOf(t.data) === -1) {
              var _a3 = Ue.objectValues(r);
              return le(n, {
                received: n.data,
                code: X.invalid_enum_value,
                options: _a3
              }), ke;
            }
            return Ct(t.data);
          }
        }, {
          key: "enum",
          get: function get() {
            return this._def.values;
          }
        }]);
        return Mn;
      }(ce);
      Mn.create = function (e, t) {
        return new Mn(L({
          values: e,
          typeName: me.ZodNativeEnum
        }, Ae(t)));
      };
      var hr = /*#__PURE__*/function (_ce26) {
        _inherits(hr, _ce26);
        var _super27 = _createSuper(hr);
        function hr() {
          _classCallCheck(this, hr);
          return _super27.apply(this, arguments);
        }
        _createClass(hr, [{
          key: "_parse",
          value: function _parse(t) {
            var _this18 = this;
            var _this$_processInputPa12 = this._processInputParams(t),
              r = _this$_processInputPa12.ctx;
            if (r.parsedType !== Y.promise && r.common.async === !1) return le(r, {
              code: X.invalid_type,
              expected: Y.promise,
              received: r.parsedType
            }), ke;
            var n = r.parsedType === Y.promise ? r.data : Promise.resolve(r.data);
            return Ct(n.then(function (a) {
              return _this18._def.type.parseAsync(a, {
                path: r.path,
                errorMap: r.common.contextualErrorMap
              });
            }));
          }
        }]);
        return hr;
      }(ce);
      hr.create = function (e, t) {
        return new hr(L({
          type: e,
          typeName: me.ZodPromise
        }, Ae(t)));
      };
      var Xt = /*#__PURE__*/function (_ce27) {
        _inherits(Xt, _ce27);
        var _super28 = _createSuper(Xt);
        function Xt() {
          _classCallCheck(this, Xt);
          return _super28.apply(this, arguments);
        }
        _createClass(Xt, [{
          key: "innerType",
          value: function innerType() {
            return this._def.schema;
          }
        }, {
          key: "_parse",
          value: function _parse(t) {
            var _this19 = this;
            var _this$_processInputPa13 = this._processInputParams(t),
              r = _this$_processInputPa13.status,
              n = _this$_processInputPa13.ctx,
              a = this._def.effect || null;
            if (a.type === "preprocess") {
              var o = a.transform(n.data);
              return n.common.async ? Promise.resolve(o).then(function (l) {
                return _this19._def.schema._parseAsync({
                  data: l,
                  path: n.path,
                  parent: n
                });
              }) : this._def.schema._parseSync({
                data: o,
                path: n.path,
                parent: n
              });
            }
            var i = {
              addIssue: function addIssue(o) {
                le(n, o), o.fatal ? r.abort() : r.dirty();
              },
              get path() {
                return n.path;
              }
            };
            if (i.addIssue = i.addIssue.bind(i), a.type === "refinement") {
              var _o3 = function _o3(l) {
                var u = a.refinement(l, i);
                if (n.common.async) return Promise.resolve(u);
                if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return l;
              };
              if (n.common.async === !1) {
                var l = this._def.schema._parseSync({
                  data: n.data,
                  path: n.path,
                  parent: n
                });
                return l.status === "aborted" ? ke : (l.status === "dirty" && r.dirty(), _o3(l.value), {
                  status: r.value,
                  value: l.value
                });
              } else return this._def.schema._parseAsync({
                data: n.data,
                path: n.path,
                parent: n
              }).then(function (l) {
                return l.status === "aborted" ? ke : (l.status === "dirty" && r.dirty(), _o3(l.value).then(function () {
                  return {
                    status: r.value,
                    value: l.value
                  };
                }));
              });
            }
            if (a.type === "transform") if (n.common.async === !1) {
              var _o4 = this._def.schema._parseSync({
                data: n.data,
                path: n.path,
                parent: n
              });
              if (!ft(_o4)) return _o4;
              var _l5 = a.transform(_o4.value, i);
              if (_l5 instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
              return {
                status: r.value,
                value: _l5
              };
            } else return this._def.schema._parseAsync({
              data: n.data,
              path: n.path,
              parent: n
            }).then(function (o) {
              return ft(o) ? Promise.resolve(a.transform(o.value, i)).then(function (l) {
                return {
                  status: r.value,
                  value: l
                };
              }) : o;
            });
            Ue.assertNever(a);
          }
        }]);
        return Xt;
      }(ce);
      Xt.create = function (e, t, r) {
        return new Xt(L({
          schema: e,
          typeName: me.ZodEffects,
          effect: t
        }, Ae(r)));
      }, Xt.createWithPreprocess = function (e, t, r) {
        return new Xt(L({
          schema: t,
          effect: {
            type: "preprocess",
            transform: e
          },
          typeName: me.ZodEffects
        }, Ae(r)));
      };
      var qt = /*#__PURE__*/function (_ce28) {
        _inherits(qt, _ce28);
        var _super29 = _createSuper(qt);
        function qt() {
          _classCallCheck(this, qt);
          return _super29.apply(this, arguments);
        }
        _createClass(qt, [{
          key: "_parse",
          value: function _parse(t) {
            return this._getType(t) === Y.undefined ? Ct(void 0) : this._def.innerType._parse(t);
          }
        }, {
          key: "unwrap",
          value: function unwrap() {
            return this._def.innerType;
          }
        }]);
        return qt;
      }(ce);
      qt.create = function (e, t) {
        return new qt(L({
          innerType: e,
          typeName: me.ZodOptional
        }, Ae(t)));
      };
      var pr = /*#__PURE__*/function (_ce29) {
        _inherits(pr, _ce29);
        var _super30 = _createSuper(pr);
        function pr() {
          _classCallCheck(this, pr);
          return _super30.apply(this, arguments);
        }
        _createClass(pr, [{
          key: "_parse",
          value: function _parse(t) {
            return this._getType(t) === Y.null ? Ct(null) : this._def.innerType._parse(t);
          }
        }, {
          key: "unwrap",
          value: function unwrap() {
            return this._def.innerType;
          }
        }]);
        return pr;
      }(ce);
      pr.create = function (e, t) {
        return new pr(L({
          innerType: e,
          typeName: me.ZodNullable
        }, Ae(t)));
      };
      var Nn = /*#__PURE__*/function (_ce30) {
        _inherits(Nn, _ce30);
        var _super31 = _createSuper(Nn);
        function Nn() {
          _classCallCheck(this, Nn);
          return _super31.apply(this, arguments);
        }
        _createClass(Nn, [{
          key: "_parse",
          value: function _parse(t) {
            var _this$_processInputPa14 = this._processInputParams(t),
              r = _this$_processInputPa14.ctx;
            var n = r.data;
            return r.parsedType === Y.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
              data: n,
              path: r.path,
              parent: r
            });
          }
        }, {
          key: "removeDefault",
          value: function removeDefault() {
            return this._def.innerType;
          }
        }]);
        return Nn;
      }(ce);
      Nn.create = function (e, t) {
        return new qt(L({
          innerType: e,
          typeName: me.ZodOptional
        }, Ae(t)));
      };
      var Pn = /*#__PURE__*/function (_ce31) {
        _inherits(Pn, _ce31);
        var _super32 = _createSuper(Pn);
        function Pn() {
          _classCallCheck(this, Pn);
          return _super32.apply(this, arguments);
        }
        _createClass(Pn, [{
          key: "_parse",
          value: function _parse(t) {
            if (this._getType(t) !== Y.nan) {
              var n = this._getOrReturnCtx(t);
              return le(n, {
                code: X.invalid_type,
                expected: Y.nan,
                received: n.parsedType
              }), ke;
            }
            return {
              status: "valid",
              value: t.data
            };
          }
        }]);
        return Pn;
      }(ce);
      Pn.create = function (e) {
        return new Pn(L({
          typeName: me.ZodNaN
        }, Ae(e)));
      };
      var nn = function nn(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var r = arguments.length > 2 ? arguments[2] : undefined;
          return e ? Dr.create().superRefine(function (n, a) {
            if (!e(n)) {
              var i = typeof t == "function" ? t(n) : t,
                o = typeof i == "string" ? {
                  message: i
                } : i;
              a.addIssue(ue(L({
                code: "custom"
              }, o), {
                fatal: r
              }));
            }
          }) : Dr.create();
        },
        Rn = {
          object: tt.lazycreate
        };
      var me;
      (function (e) {
        e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodPromise = "ZodPromise";
      })(me || (me = {}));
      var Rt = function Rt(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            message: "Input not instance of ".concat(e.name)
          };
          return nn(function (r) {
            return r instanceof e;
          }, t, !0);
        },
        er = ur.create,
        Xn = Pt.create,
        an = Pn.create,
        In = bn.create,
        ma = yn.create,
        ii = dt.create,
        ga = wn.create,
        qn = _n.create,
        va = Dr.create,
        An = fr.create,
        Kt = dr.create,
        _r = xn.create,
        Kn = Tt.create,
        Dn = tt.create,
        Yn = tt.strictCreate,
        tr = Fr.create,
        Ft = On.create,
        Qn = br.create,
        ba = Jt.create,
        Ln = rn.create,
        jr = Tn.create,
        xr = yr.create,
        Br = wr.create,
        ea = kn.create,
        oi = Sn.create,
        si = Cn.create,
        li = Mn.create,
        Fn = hr.create,
        on = Xt.create,
        ci = qt.create,
        d = pr.create,
        s = Xt.createWithPreprocess;
      var k = Object.freeze({
        __proto__: null,
        getParsedType: At,
        ZodParsedType: Y,
        makeIssue: Gt,
        EMPTY_PATH: en,
        addIssueToContext: le,
        ParseStatus: Ke,
        INVALID: ke,
        DIRTY: Qa,
        OK: Ct,
        isAborted: Gn,
        isDirty: Wn,
        isValid: ft,
        isAsync: Jn,
        ZodType: ce,
        ZodString: ur,
        ZodNumber: Pt,
        ZodBigInt: bn,
        ZodBoolean: yn,
        ZodDate: dt,
        ZodUndefined: wn,
        ZodNull: _n,
        ZodAny: Dr,
        ZodUnknown: fr,
        ZodNever: dr,
        ZodVoid: xn,
        ZodArray: Tt,
        get objectUtil() {
          return En;
        },
        ZodObject: tt,
        ZodUnion: Fr,
        ZodDiscriminatedUnion: On,
        ZodIntersection: br,
        ZodTuple: Jt,
        ZodRecord: rn,
        ZodMap: Tn,
        ZodSet: yr,
        ZodFunction: wr,
        ZodLazy: kn,
        ZodLiteral: Sn,
        ZodEnum: Cn,
        ZodNativeEnum: Mn,
        ZodPromise: hr,
        ZodEffects: Xt,
        ZodTransformer: Xt,
        ZodOptional: qt,
        ZodNullable: pr,
        ZodDefault: Nn,
        ZodNaN: Pn,
        custom: nn,
        Schema: ce,
        ZodSchema: ce,
        late: Rn,
        get ZodFirstPartyTypeKind() {
          return me;
        },
        any: va,
        array: Kn,
        bigint: In,
        boolean: ma,
        date: ii,
        discriminatedUnion: Ft,
        effect: on,
        enum: si,
        function: Br,
        instanceof: Rt,
        intersection: Qn,
        lazy: ea,
        literal: oi,
        map: jr,
        nan: an,
        nativeEnum: li,
        never: Kt,
        null: qn,
        nullable: d,
        number: Xn,
        object: Dn,
        oboolean: function oboolean() {
          return ma().optional();
        },
        onumber: function onumber() {
          return Xn().optional();
        },
        optional: ci,
        ostring: function ostring() {
          return er().optional();
        },
        preprocess: s,
        promise: Fn,
        record: Ln,
        set: xr,
        strictObject: Yn,
        string: er,
        transformer: on,
        tuple: ba,
        undefined: ga,
        union: tr,
        unknown: An,
        void: _r,
        ZodIssueCode: X,
        quotelessJson: Ka,
        ZodError: Qt,
        defaultErrorMap: Yr,
        get overrideErrorMap() {
          return Qr;
        },
        setErrorMap: Ya
      });
      var B = ["dotnetspy", "ebpfspy", "gospy", "phpspy", "pyspy", "rbspy", "nodespy", "javaspy", "pyroscope-rs"],
        te = ["scrape", "tracing", "unknown"],
        fe = [].concat(B, te),
        Se = k.preprocess(function (e) {
          return !e || !fe.includes(e) ? "unknown" : e;
        }, k.enum(fe).default("unknown")),
        Le = k.object({
          names: k.array(k.preprocess(function (e) {
            return e || "unknown";
          }, k.string().min(1))),
          levels: k.array(k.array(k.number())),
          numTicks: k.number(),
          maxSelf: k.number()
        }),
        We = ["samples", "objects", "goroutines", "bytes", "lock_samples", "lock_nanoseconds", "trace_samples"],
        ze = k.preprocess(function (e) {
          return typeof e == "string" && We.includes(e) ? e : "";
        }, k.enum(["samples", "objects", "goroutines", "bytes", "lock_samples", "lock_nanoseconds", "trace_samples", ""])),
        Ze = k.object({
          appName: k.string().optional(),
          name: k.string().optional(),
          startTime: k.number().optional(),
          endTime: k.number().optional(),
          query: k.string().optional(),
          maxNodes: k.number().optional(),
          format: k.enum(["single", "double"]),
          sampleRate: k.number(),
          spyName: Se,
          units: ze
        }),
        lt = k.object({
          version: k.number().min(1).max(1).default(1),
          flamebearer: Le,
          metadata: Ze,
          leftTicks: k.number().optional(),
          rightTicks: k.number().optional()
        }),
        ct = {
          format: "single",
          jStep: 4,
          jName: 3,
          getBarOffset: function getBarOffset(e, t) {
            return e[t];
          },
          getBarTotal: function getBarTotal(e, t) {
            return e[t + 1];
          },
          getBarTotalDiff: function getBarTotalDiff(e, t) {
            return 0;
          },
          getBarSelf: function getBarSelf(e, t) {
            return e[t + 2];
          },
          getBarSelfDiff: function getBarSelfDiff(e, t) {
            return 0;
          },
          getBarName: function getBarName(e, t) {
            return e[t + 3];
          }
        },
        ht = {
          format: "double",
          jStep: 7,
          jName: 6,
          getBarOffset: function getBarOffset(e, t) {
            return e[t] + e[t + 3];
          },
          getBarTotal: function getBarTotal(e, t) {
            return e[t + 4] + e[t + 1];
          },
          getBarTotalLeft: function getBarTotalLeft(e, t) {
            return e[t + 1];
          },
          getBarTotalRght: function getBarTotalRght(e, t) {
            return e[t + 4];
          },
          getBarTotalDiff: function getBarTotalDiff(e, t) {
            return e[t + 4] - e[t + 1];
          },
          getBarSelf: function getBarSelf(e, t) {
            return e[t + 5] + e[t + 2];
          },
          getBarSelfLeft: function getBarSelfLeft(e, t) {
            return e[t + 2];
          },
          getBarSelfRght: function getBarSelfRght(e, t) {
            return e[t + 5];
          },
          getBarSelfDiff: function getBarSelfDiff(e, t) {
            return e[t + 5] - e[t + 2];
          },
          getBarName: function getBarName(e, t) {
            return e[t + 6];
          }
        };
      function vt(e) {
        switch (e) {
          case "single":
            return ct;
          case "double":
            return ht;
          default:
            throw new Error("Unsupported type: '".concat(e, "'"));
        }
      }
      var mr = k.object({
          refType: k.string(),
          traceID: k.string(),
          spanID: k.string()
        }),
        Er = k.object({
          key: k.string(),
          type: k.string(),
          value: k.union([k.boolean(), k.number(), k.string()])
        }),
        Or = k.object({
          traceID: k.string(),
          spanID: k.string(),
          flags: k.string(),
          operationName: k.string(),
          references: k.array(mr),
          startTime: k.number(),
          duration: k.number(),
          tags: k.array(Er),
          logs: k.object({
            timestamp: k.number(),
            fields: k.array(Er)
          }),
          processID: k.string(),
          warnings: k.any()
        }),
        ya = k.object({
          serviceName: k.string(),
          tags: k.array(Er)
        }),
        pv = k.object({
          traceID: k.string(),
          spans: k.array(Or),
          processes: k.record(ya),
          warnings: k.any()
        }),
        bf = k.object({
          watermark: k.object({}).optional(),
          startTime: k.number(),
          samples: k.array(k.number()),
          durationDelta: k.number()
        }),
        mv = k.record(k.string(), bf),
        ta = 22,
        yo = 5,
        yf = 20,
        Bs = .5,
        ra = ta - Bs;
      function wo(e) {
        return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      function zs(e) {
        return "".concat(ui(e), "%");
      }
      function ui(e) {
        return Math.round(1e4 * e) / 100;
      }
      function Li(e, t, r) {
        switch (r) {
          case "samples":
            return new _o(e / t);
          case "objects":
            return new xo(e);
          case "goroutines":
            return new xo(e);
          case "bytes":
            return new _f(e);
          case "lock_nanoseconds":
            return new wf(e);
          case "lock_samples":
            return new xo(e);
          case "trace_samples":
            return new _o(e / t, "", !0);
          default:
            return console.warn("Unsupported unit: '".concat(r, "'. Defaulting to ''")), new _o(e / t, " ");
        }
      }
      var _o = /*#__PURE__*/function () {
        function _o(t, r, n) {
          _classCallCheck(this, _o);
          this.divider = 1, this.enableSubsecondPrecision = !1, this.suffix = "second", this.durations = [[60, "minute"], [60, "hour"], [24, "day"], [30, "month"], [12, "year"]], this.units = "", n && (this.enableSubsecondPrecision = n, this.durations = [[1e3, "ms"], [1e3, "second"]].concat(_toConsumableArray(this.durations)), this.suffix = "\u03BCs", t *= 1e6), this.units = r || "";
          for (var a = 0; a < this.durations.length; a++) {
            var i = this.durations[a];
            if (!i) {
              console.warn("Could not calculate level");
              break;
            }
            if (t >= i[0]) this.divider *= i[0], t /= i[0], this.suffix = i[1];else break;
          }
        }
        _createClass(_o, [{
          key: "format",
          value: function format(t, r) {
            this.enableSubsecondPrecision && (r /= 1e6);
            var n = t / r / this.divider;
            var a = n.toFixed(2);
            return n === 0 ? a = "0.00" : (n >= 0 && n < .01 || n <= 0 && n > -.01) && (a = "< 0.01"), "".concat(a, " ").concat(this.units || "".concat(this.suffix).concat(n === 1 || this.suffix.length === 2 ? "" : "s"));
          }
        }]);
        return _o;
      }();
      var wf = /*#__PURE__*/function () {
        function wf(t) {
          _classCallCheck(this, wf);
          this.divider = 1, this.multiplier = 1, this.suffix = "second", this.durations = [[60, "minute"], [60, "hour"], [24, "day"], [30, "month"], [12, "year"]], t /= 1e9;
          for (var r = 0; r < this.durations.length; r++) {
            var n = this.durations[r];
            if (!n) {
              console.warn("Could not calculate level");
              break;
            }
            if (t >= n[0]) this.divider *= n[0], t /= n[0], this.suffix = n[1];else break;
          }
        }
        _createClass(wf, [{
          key: "format",
          value: function format(t) {
            var r = t / 1e9 / this.divider;
            var n = r.toFixed(2);
            return (r >= 0 && r < .01 || r <= 0 && r > -.01) && (n = "< 0.01"), "".concat(n, " ").concat(this.suffix).concat(r === 1 ? "" : "s");
          }
        }]);
        return wf;
      }();
      var xo = /*#__PURE__*/function () {
        function xo(t) {
          _classCallCheck(this, xo);
          this.divider = 1, this.suffix = "", this.objects = [[1e3, "K"], [1e3, "M"], [1e3, "G"], [1e3, "T"], [1e3, "P"]];
          for (var r = 0; r < this.objects.length; r++) {
            var n = this.objects[r];
            if (!n) {
              console.warn("Could not calculate level");
              break;
            }
            if (t >= n[0]) this.divider *= n[0], t /= n[0], this.suffix = n[1];else break;
          }
        }
        _createClass(xo, [{
          key: "format",
          value: function format(t) {
            var r = t / this.divider;
            var n = r.toFixed(2);
            return (r >= 0 && r < .01 || r <= 0 && r > -.01) && (n = "< 0.01"), "".concat(n, " ").concat(this.suffix);
          }
        }]);
        return xo;
      }();
      var _f = /*#__PURE__*/function () {
        function _f(t) {
          _classCallCheck(this, _f);
          this.divider = 1, this.suffix = "bytes", this.bytes = [[1024, "KB"], [1024, "MB"], [1024, "GB"], [1024, "TB"], [1024, "PB"]];
          for (var r = 0; r < this.bytes.length; r++) {
            var n = this.bytes[r];
            if (!n) {
              console.warn("Could not calculate level");
              break;
            }
            if (t >= n[0]) {
              this.divider *= n[0], t /= n[0];
              var a = n[1];
              a ? this.suffix = a : (console.warn("Could not calculate suffix"), this.suffix = "");
            } else break;
          }
        }
        _createClass(_f, [{
          key: "format",
          value: function format(t) {
            var r = t / this.divider;
            var n = r.toFixed(2);
            return (r >= 0 && r < .01 || r <= 0 && r > -.01) && (n = "< 0.01"), "".concat(n, " ").concat(this.suffix);
          }
        }]);
        return _f;
      }();
      var wa = "TAIL",
        _a = "HEAD",
        Fi = 3;
      function $s(_ref5) {
        var e = _ref5.mode,
          t = _ref5.charSize,
          r = _ref5.rectWidth,
          n = _ref5.fullText,
          a = _ref5.shortText;
        switch (e) {
          case wa:
            if (t * n.length <= r) return {
              mode: e,
              text: n,
              marginLeft: Fi
            };
            var i = t * a.length;
            return i <= r ? {
              mode: e,
              text: a,
              marginLeft: Fi
            } : {
              mode: e,
              text: a,
              marginLeft: -(i - r + Fi)
            };
          case _a:
          default:
            return {
              mode: e,
              text: n,
              marginLeft: Fi
            };
        }
      }
      function xf(e) {
        switch (e) {
          case wa:
            return {
              direction: "rtl",
              overflow: "hidden",
              textOverflow: "ellipsis"
            };
          case _a:
          default:
            return {
              overflow: "hidden",
              textOverflow: "ellipsis"
            };
        }
      }
      function Ef(e, t, r, n) {
        var a = ht;
        if (!r || !n) return console.error("Properties 'rightTicks' and 'leftTicks' are required. Can't calculate ratio."), {
          leftRatio: 0,
          rightRatio: 0
        };
        var i = a.getBarTotalLeft(e, t) / r,
          o = a.getBarTotalRght(e, t) / n;
        return {
          leftRatio: i,
          rightRatio: o
        };
      }
      var Of = pe(346),
        Fe = pe.n(Of),
        Eo = Math.sqrt(50),
        Oo = Math.sqrt(10),
        To = Math.sqrt(2);
      function Tf(e, t, r) {
        var n,
          a = -1,
          i,
          o,
          l;
        if (t = +t, e = +e, r = +r, e === t && r > 0) return [e];
        if ((n = t < e) && (i = e, e = t, t = i), (l = Hs(e, t, r)) === 0 || !isFinite(l)) return [];
        if (l > 0) {
          var u = Math.round(e / l),
            h = Math.round(t / l);
          for (u * l < e && ++u, h * l > t && --h, o = new Array(i = h - u + 1); ++a < i;) {
            o[a] = (u + a) * l;
          }
        } else {
          l = -l;
          var _u3 = Math.round(e * l),
            _h5 = Math.round(t * l);
          for (_u3 / l < e && ++_u3, _h5 / l > t && --_h5, o = new Array(i = _h5 - _u3 + 1); ++a < i;) {
            o[a] = (_u3 + a) / l;
          }
        }
        return n && o.reverse(), o;
      }
      function Hs(e, t, r) {
        var n = (t - e) / Math.max(0, r),
          a = Math.floor(Math.log(n) / Math.LN10),
          i = n / Math.pow(10, a);
        return a >= 0 ? (i >= Eo ? 10 : i >= Oo ? 5 : i >= To ? 2 : 1) * Math.pow(10, a) : -Math.pow(10, -a) / (i >= Eo ? 10 : i >= Oo ? 5 : i >= To ? 2 : 1);
      }
      function kf(e, t, r) {
        var n = Math.abs(t - e) / Math.max(0, r),
          a = Math.pow(10, Math.floor(Math.log(n) / Math.LN10)),
          i = n / a;
        return i >= Eo ? a *= 10 : i >= Oo ? a *= 5 : i >= To && (a *= 2), t < e ? -a : a;
      }
      function ko(e, t) {
        return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
      }
      function Us(e) {
        var t = e,
          r = e,
          n = e;
        e.length !== 2 && (t = function t(l, u) {
          return e(l) - u;
        }, r = ko, n = function n(l, u) {
          return ko(e(l), u);
        });
        function a(l, u) {
          var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : l.length;
          if (h < g) {
            if (r(u, u) !== 0) return g;
            do {
              var y = h + g >>> 1;
              n(l[y], u) < 0 ? h = y + 1 : g = y;
            } while (h < g);
          }
          return h;
        }
        function i(l, u) {
          var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : l.length;
          if (h < g) {
            if (r(u, u) !== 0) return g;
            do {
              var y = h + g >>> 1;
              n(l[y], u) <= 0 ? h = y + 1 : g = y;
            } while (h < g);
          }
          return h;
        }
        function o(l, u) {
          var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          var g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : l.length;
          var y = a(l, u, h, g - 1);
          return y > h && t(l[y - 1], u) > -t(l[y], u) ? y - 1 : y;
        }
        return {
          left: a,
          center: o,
          right: i
        };
      }
      function Sf(e) {
        return e === null ? NaN : +e;
      }
      function gv(e, t) {
        var _iterator30, _step30, r, _r3, _iterator31, _step31, n;
        return _regeneratorRuntime().wrap(function gv$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(t === void 0)) {
                  _context8.next = 22;
                  break;
                }
                _iterator30 = _createForOfIteratorHelper(e);
                _context8.prev = 2;
                _iterator30.s();
              case 4:
                if ((_step30 = _iterator30.n()).done) {
                  _context8.next = 12;
                  break;
                }
                r = _step30.value;
                _context8.t0 = r != null && (r = +r) >= r;
                if (!_context8.t0) {
                  _context8.next = 10;
                  break;
                }
                _context8.next = 10;
                return r;
              case 10:
                _context8.next = 4;
                break;
              case 12:
                _context8.next = 17;
                break;
              case 14:
                _context8.prev = 14;
                _context8.t1 = _context8["catch"](2);
                _iterator30.e(_context8.t1);
              case 17:
                _context8.prev = 17;
                _iterator30.f();
                return _context8.finish(17);
              case 20:
                _context8.next = 42;
                break;
              case 22:
                _r3 = -1;
                _iterator31 = _createForOfIteratorHelper(e);
                _context8.prev = 24;
                _iterator31.s();
              case 26:
                if ((_step31 = _iterator31.n()).done) {
                  _context8.next = 34;
                  break;
                }
                n = _step31.value;
                _context8.t2 = (n = t(n, ++_r3, e)) != null && (n = +n) >= n;
                if (!_context8.t2) {
                  _context8.next = 32;
                  break;
                }
                _context8.next = 32;
                return n;
              case 32:
                _context8.next = 26;
                break;
              case 34:
                _context8.next = 39;
                break;
              case 36:
                _context8.prev = 36;
                _context8.t3 = _context8["catch"](24);
                _iterator31.e(_context8.t3);
              case 39:
                _context8.prev = 39;
                _iterator31.f();
                return _context8.finish(39);
              case 42:
              case "end":
                return _context8.stop();
            }
          }
        }, _marked, null, [[2, 14, 17, 20], [24, 36, 39, 42]]);
      }
      var Zs = Us(ko),
        Cf = Zs.right,
        vv = Zs.left,
        bv = Us(Sf).center,
        Mf = Cf;
      function So(e, t, r) {
        e.prototype = t.prototype = r, r.constructor = e;
      }
      function Vs(e, t) {
        var r = Object.create(e.prototype);
        for (var n in t) {
          r[n] = t[n];
        }
        return r;
      }
      function fi() {}
      var di = .7,
        ji = 1 / di,
        xa = "\\s*([+-]?\\d+)\\s*",
        hi = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
        zr = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
        Nf = /^#([0-9a-f]{3,8})$/,
        Pf = new RegExp("^rgb\\(" + [xa, xa, xa] + "\\)$"),
        Rf = new RegExp("^rgb\\(" + [zr, zr, zr] + "\\)$"),
        If = new RegExp("^rgba\\(" + [xa, xa, xa, hi] + "\\)$"),
        Af = new RegExp("^rgba\\(" + [zr, zr, zr, hi] + "\\)$"),
        Df = new RegExp("^hsl\\(" + [hi, zr, zr] + "\\)$"),
        Lf = new RegExp("^hsla\\(" + [hi, zr, zr, hi] + "\\)$"),
        Gs = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074
        };
      So(fi, pi, {
        copy: function copy(e) {
          return Object.assign(new this.constructor(), this, e);
        },
        displayable: function displayable() {
          return this.rgb().displayable();
        },
        hex: Ws,
        formatHex: Ws,
        formatHsl: Ff,
        formatRgb: Js,
        toString: Js
      });
      function Ws() {
        return this.rgb().formatHex();
      }
      function Ff() {
        return Qs(this).formatHsl();
      }
      function Js() {
        return this.rgb().formatRgb();
      }
      function pi(e) {
        var t, r;
        return e = (e + "").trim().toLowerCase(), (t = Nf.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? Xs(t) : r === 3 ? new rr(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Bi(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Bi(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Pf.exec(e)) ? new rr(t[1], t[2], t[3], 1) : (t = Rf.exec(e)) ? new rr(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = If.exec(e)) ? Bi(t[1], t[2], t[3], t[4]) : (t = Af.exec(e)) ? Bi(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Df.exec(e)) ? Ys(t[1], t[2] / 100, t[3] / 100, 1) : (t = Lf.exec(e)) ? Ys(t[1], t[2] / 100, t[3] / 100, t[4]) : Gs.hasOwnProperty(e) ? Xs(Gs[e]) : e === "transparent" ? new rr(NaN, NaN, NaN, 0) : null;
      }
      function Xs(e) {
        return new rr(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
      }
      function Bi(e, t, r, n) {
        return n <= 0 && (e = t = r = NaN), new rr(e, t, r, n);
      }
      function jf(e) {
        return e instanceof fi || (e = pi(e)), e ? (e = e.rgb(), new rr(e.r, e.g, e.b, e.opacity)) : new rr();
      }
      function zi(e, t, r, n) {
        return arguments.length === 1 ? jf(e) : new rr(e, t, r, n == null ? 1 : n);
      }
      function rr(e, t, r, n) {
        this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
      }
      So(rr, zi, Vs(fi, {
        brighter: function brighter(e) {
          return e = e == null ? ji : Math.pow(ji, e), new rr(this.r * e, this.g * e, this.b * e, this.opacity);
        },
        darker: function darker(e) {
          return e = e == null ? di : Math.pow(di, e), new rr(this.r * e, this.g * e, this.b * e, this.opacity);
        },
        rgb: function rgb() {
          return this;
        },
        displayable: function displayable() {
          return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
        },
        hex: qs,
        formatHex: qs,
        formatRgb: Ks,
        toString: Ks
      }));
      function qs() {
        return "#" + Co(this.r) + Co(this.g) + Co(this.b);
      }
      function Ks() {
        var e = this.opacity;
        return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
      }
      function Co(e) {
        return e = Math.max(0, Math.min(255, Math.round(e) || 0)), (e < 16 ? "0" : "") + e.toString(16);
      }
      function Ys(e, t, r, n) {
        return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new $r(e, t, r, n);
      }
      function Qs(e) {
        if (e instanceof $r) return new $r(e.h, e.s, e.l, e.opacity);
        if (e instanceof fi || (e = pi(e)), !e) return new $r();
        if (e instanceof $r) return e;
        e = e.rgb();
        var t = e.r / 255,
          r = e.g / 255,
          n = e.b / 255,
          a = Math.min(t, r, n),
          i = Math.max(t, r, n),
          o = NaN,
          l = i - a,
          u = (i + a) / 2;
        return l ? (t === i ? o = (r - n) / l + (r < n) * 6 : r === i ? o = (n - t) / l + 2 : o = (t - r) / l + 4, l /= u < .5 ? i + a : 2 - i - a, o *= 60) : l = u > 0 && u < 1 ? 0 : o, new $r(o, l, u, e.opacity);
      }
      function Bf(e, t, r, n) {
        return arguments.length === 1 ? Qs(e) : new $r(e, t, r, n == null ? 1 : n);
      }
      function $r(e, t, r, n) {
        this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
      }
      So($r, Bf, Vs(fi, {
        brighter: function brighter(e) {
          return e = e == null ? ji : Math.pow(ji, e), new $r(this.h, this.s, this.l * e, this.opacity);
        },
        darker: function darker(e) {
          return e = e == null ? di : Math.pow(di, e), new $r(this.h, this.s, this.l * e, this.opacity);
        },
        rgb: function rgb() {
          var e = this.h % 360 + (this.h < 0) * 360,
            t = isNaN(e) || isNaN(this.s) ? 0 : this.s,
            r = this.l,
            n = r + (r < .5 ? r : 1 - r) * t,
            a = 2 * r - n;
          return new rr(Mo(e >= 240 ? e - 240 : e + 120, a, n), Mo(e, a, n), Mo(e < 120 ? e + 240 : e - 120, a, n), this.opacity);
        },
        displayable: function displayable() {
          return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
        },
        formatHsl: function formatHsl() {
          var e = this.opacity;
          return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (e === 1 ? ")" : ", " + e + ")");
        }
      }));
      function Mo(e, t, r) {
        return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
      }
      function el(e, t, r, n, a) {
        var i = e * e,
          o = i * e;
        return ((1 - 3 * e + 3 * i - o) * t + (4 - 6 * i + 3 * o) * r + (1 + 3 * e + 3 * i - 3 * o) * n + o * a) / 6;
      }
      function zf(e) {
        var t = e.length - 1;
        return function (r) {
          var n = r <= 0 ? r = 0 : r >= 1 ? (r = 1, t - 1) : Math.floor(r * t),
            a = e[n],
            i = e[n + 1],
            o = n > 0 ? e[n - 1] : 2 * a - i,
            l = n < t - 1 ? e[n + 2] : 2 * i - a;
          return el((r - n / t) * t, o, a, i, l);
        };
      }
      function $f(e) {
        var t = e.length;
        return function (r) {
          var n = Math.floor(((r %= 1) < 0 ? ++r : r) * t),
            a = e[(n + t - 1) % t],
            i = e[n % t],
            o = e[(n + 1) % t],
            l = e[(n + 2) % t];
          return el((r - n / t) * t, a, i, o, l);
        };
      }
      var No = function No(e) {
        return function () {
          return e;
        };
      };
      function tl(e, t) {
        return function (r) {
          return e + r * t;
        };
      }
      function Hf(e, t, r) {
        return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function (n) {
          return Math.pow(e + n * t, r);
        };
      }
      function yv(e, t) {
        var r = t - e;
        return r ? tl(e, r > 180 || r < -180 ? r - 360 * Math.round(r / 360) : r) : constant(isNaN(e) ? t : e);
      }
      function Uf(e) {
        return (e = +e) == 1 ? rl : function (t, r) {
          return r - t ? Hf(t, r, e) : No(isNaN(t) ? r : t);
        };
      }
      function rl(e, t) {
        var r = t - e;
        return r ? tl(e, r) : No(isNaN(e) ? t : e);
      }
      var nl = function e(t) {
        var r = Uf(t);
        function n(a, i) {
          var o = r((a = zi(a)).r, (i = zi(i)).r),
            l = r(a.g, i.g),
            u = r(a.b, i.b),
            h = rl(a.opacity, i.opacity);
          return function (g) {
            return a.r = o(g), a.g = l(g), a.b = u(g), a.opacity = h(g), a + "";
          };
        }
        return n.gamma = e, n;
      }(1);
      function al(e) {
        return function (t) {
          var r = t.length,
            n = new Array(r),
            a = new Array(r),
            i = new Array(r),
            o,
            l;
          for (o = 0; o < r; ++o) {
            l = zi(t[o]), n[o] = l.r || 0, a[o] = l.g || 0, i[o] = l.b || 0;
          }
          return n = e(n), a = e(a), i = e(i), l.opacity = 1, function (u) {
            return l.r = n(u), l.g = a(u), l.b = i(u), l + "";
          };
        };
      }
      var wv = al(zf),
        _v = al($f);
      function xv(e, t) {
        return (isNumberArray(t) ? numberArray : il)(e, t);
      }
      function il(e, t) {
        var r = t ? t.length : 0,
          n = e ? Math.min(r, e.length) : 0,
          a = new Array(n),
          i = new Array(r),
          o;
        for (o = 0; o < n; ++o) {
          a[o] = Io(e[o], t[o]);
        }
        for (; o < r; ++o) {
          i[o] = t[o];
        }
        return function (l) {
          for (o = 0; o < n; ++o) {
            i[o] = a[o](l);
          }
          return i;
        };
      }
      function Zf(e, t) {
        var r = new Date();
        return e = +e, t = +t, function (n) {
          return r.setTime(e * (1 - n) + t * n), r;
        };
      }
      function $i(e, t) {
        return e = +e, t = +t, function (r) {
          return e * (1 - r) + t * r;
        };
      }
      function Vf(e, t) {
        var r = {},
          n = {},
          a;
        (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
        for (a in t) {
          a in e ? r[a] = Io(e[a], t[a]) : n[a] = t[a];
        }
        return function (i) {
          for (a in r) {
            n[a] = r[a](i);
          }
          return n;
        };
      }
      var Po = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
        Ro = new RegExp(Po.source, "g");
      function Gf(e) {
        return function () {
          return e;
        };
      }
      function Wf(e) {
        return function (t) {
          return e(t) + "";
        };
      }
      function Jf(e, t) {
        var r = Po.lastIndex = Ro.lastIndex = 0,
          n,
          a,
          i,
          o = -1,
          l = [],
          u = [];
        for (e = e + "", t = t + ""; (n = Po.exec(e)) && (a = Ro.exec(t));) {
          (i = a.index) > r && (i = t.slice(r, i), l[o] ? l[o] += i : l[++o] = i), (n = n[0]) === (a = a[0]) ? l[o] ? l[o] += a : l[++o] = a : (l[++o] = null, u.push({
            i: o,
            x: $i(n, a)
          })), r = Ro.lastIndex;
        }
        return r < t.length && (i = t.slice(r), l[o] ? l[o] += i : l[++o] = i), l.length < 2 ? u[0] ? Wf(u[0].x) : Gf(t) : (t = u.length, function (h) {
          for (var g = 0, y; g < t; ++g) {
            l[(y = u[g]).i] = y.x(h);
          }
          return l.join("");
        });
      }
      function Xf(e, t) {
        t || (t = []);
        var r = e ? Math.min(t.length, e.length) : 0,
          n = t.slice(),
          a;
        return function (i) {
          for (a = 0; a < r; ++a) {
            n[a] = e[a] * (1 - i) + t[a] * i;
          }
          return n;
        };
      }
      function qf(e) {
        return ArrayBuffer.isView(e) && !(e instanceof DataView);
      }
      function Io(e, t) {
        var r = typeof t,
          n;
        return t == null || r === "boolean" ? No(t) : (r === "number" ? $i : r === "string" ? (n = pi(t)) ? (t = n, nl) : Jf : t instanceof pi ? nl : t instanceof Date ? Zf : qf(t) ? Xf : Array.isArray(t) ? il : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Vf : $i)(e, t);
      }
      function Kf(e, t) {
        return e = +e, t = +t, function (r) {
          return Math.round(e * (1 - r) + t * r);
        };
      }
      function Yf(e) {
        return function () {
          return e;
        };
      }
      function Qf(e) {
        return +e;
      }
      var ol = [0, 1];
      function Ea(e) {
        return e;
      }
      function Ao(e, t) {
        return (t -= e = +e) ? function (r) {
          return (r - e) / t;
        } : Yf(isNaN(t) ? NaN : .5);
      }
      function ed(e, t) {
        var r;
        return e > t && (r = e, e = t, t = r), function (n) {
          return Math.max(e, Math.min(t, n));
        };
      }
      function td(e, t, r) {
        var n = e[0],
          a = e[1],
          i = t[0],
          o = t[1];
        return a < n ? (n = Ao(a, n), i = r(o, i)) : (n = Ao(n, a), i = r(i, o)), function (l) {
          return i(n(l));
        };
      }
      function rd(e, t, r) {
        var n = Math.min(e.length, t.length) - 1,
          a = new Array(n),
          i = new Array(n),
          o = -1;
        for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n;) {
          a[o] = Ao(e[o], e[o + 1]), i[o] = r(t[o], t[o + 1]);
        }
        return function (l) {
          var u = Mf(e, l, 1, n) - 1;
          return i[u](a[u](l));
        };
      }
      function nd(e, t) {
        return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
      }
      function ad() {
        var e = ol,
          t = ol,
          r = Io,
          n,
          a,
          i,
          o = Ea,
          l,
          u,
          h;
        function g() {
          var C = Math.min(e.length, t.length);
          return o !== Ea && (o = ed(e[0], e[C - 1])), l = C > 2 ? rd : td, u = h = null, y;
        }
        function y(C) {
          return C == null || isNaN(C = +C) ? i : (u || (u = l(e.map(n), t, r)))(n(o(C)));
        }
        return y.invert = function (C) {
          return o(a((h || (h = l(t, e.map(n), $i)))(C)));
        }, y.domain = function (C) {
          return arguments.length ? (e = Array.from(C, Qf), g()) : e.slice();
        }, y.range = function (C) {
          return arguments.length ? (t = Array.from(C), g()) : t.slice();
        }, y.rangeRound = function (C) {
          return t = Array.from(C), r = Kf, g();
        }, y.clamp = function (C) {
          return arguments.length ? (o = C ? !0 : Ea, g()) : o !== Ea;
        }, y.interpolate = function (C) {
          return arguments.length ? (r = C, g()) : r;
        }, y.unknown = function (C) {
          return arguments.length ? (i = C, y) : i;
        }, function (C, H) {
          return n = C, a = H, g();
        };
      }
      function id() {
        return ad()(Ea, Ea);
      }
      function od(e, t) {
        switch (arguments.length) {
          case 0:
            break;
          case 1:
            this.range(e);
            break;
          default:
            this.range(t).domain(e);
            break;
        }
        return this;
      }
      function Ev(e, t) {
        switch (arguments.length) {
          case 0:
            break;
          case 1:
            {
              typeof e == "function" ? this.interpolator(e) : this.range(e);
              break;
            }
          default:
            {
              this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
              break;
            }
        }
        return this;
      }
      var sd = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
      function Hi(e) {
        if (!(t = sd.exec(e))) throw new Error("invalid format: " + e);
        var t;
        return new Do({
          fill: t[1],
          align: t[2],
          sign: t[3],
          symbol: t[4],
          zero: t[5],
          width: t[6],
          comma: t[7],
          precision: t[8] && t[8].slice(1),
          trim: t[9],
          type: t[10]
        });
      }
      Hi.prototype = Do.prototype;
      function Do(e) {
        this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
      }
      Do.prototype.toString = function () {
        return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
      };
      function ld(e) {
        return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
      }
      function Ui(e, t) {
        if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
        var r,
          n = e.slice(0, r);
        return [n.length > 1 ? n[0] + n.slice(2) : n, +e.slice(r + 1)];
      }
      function Oa(e) {
        return e = Ui(Math.abs(e)), e ? e[1] : NaN;
      }
      function cd(e, t) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Oa(t) / 3))) * 3 - Oa(Math.abs(e)));
      }
      function ud(e, t) {
        return function (r, n) {
          for (var a = r.length, i = [], o = 0, l = e[0], u = 0; a > 0 && l > 0 && (u + l + 1 > n && (l = Math.max(1, n - u)), i.push(r.substring(a -= l, a + l)), !((u += l + 1) > n));) {
            l = e[o = (o + 1) % e.length];
          }
          return i.reverse().join(t);
        };
      }
      function fd(e) {
        return function (t) {
          return t.replace(/[0-9]/g, function (r) {
            return e[+r];
          });
        };
      }
      function dd(e) {
        e: for (var t = e.length, r = 1, n = -1, a; r < t; ++r) {
          switch (e[r]) {
            case ".":
              n = a = r;
              break;
            case "0":
              n === 0 && (n = r), a = r;
              break;
            default:
              if (!+e[r]) break e;
              n > 0 && (n = 0);
              break;
          }
        }
        return n > 0 ? e.slice(0, n) + e.slice(a + 1) : e;
      }
      var sl;
      function hd(e, t) {
        var r = Ui(e, t);
        if (!r) return e + "";
        var n = r[0],
          a = r[1],
          i = a - (sl = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1,
          o = n.length;
        return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + Ui(e, Math.max(0, t + i - 1))[0];
      }
      function ll(e, t) {
        var r = Ui(e, t);
        if (!r) return e + "";
        var n = r[0],
          a = r[1];
        return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
      }
      var cl = {
        "%": function _(e, t) {
          return (e * 100).toFixed(t);
        },
        b: function b(e) {
          return Math.round(e).toString(2);
        },
        c: function c(e) {
          return e + "";
        },
        d: ld,
        e: function e(_e2, t) {
          return _e2.toExponential(t);
        },
        f: function f(e, t) {
          return e.toFixed(t);
        },
        g: function g(e, t) {
          return e.toPrecision(t);
        },
        o: function o(e) {
          return Math.round(e).toString(8);
        },
        p: function p(e, t) {
          return ll(e * 100, t);
        },
        r: ll,
        s: hd,
        X: function X(e) {
          return Math.round(e).toString(16).toUpperCase();
        },
        x: function x(e) {
          return Math.round(e).toString(16);
        }
      };
      function ul(e) {
        return e;
      }
      var fl = Array.prototype.map,
        dl = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
      function pd(e) {
        var t = e.grouping === void 0 || e.thousands === void 0 ? ul : ud(fl.call(e.grouping, Number), e.thousands + ""),
          r = e.currency === void 0 ? "" : e.currency[0] + "",
          n = e.currency === void 0 ? "" : e.currency[1] + "",
          a = e.decimal === void 0 ? "." : e.decimal + "",
          i = e.numerals === void 0 ? ul : fd(fl.call(e.numerals, String)),
          o = e.percent === void 0 ? "%" : e.percent + "",
          l = e.minus === void 0 ? "\u2212" : e.minus + "",
          u = e.nan === void 0 ? "NaN" : e.nan + "";
        function h(y) {
          y = Hi(y);
          var C = y.fill,
            H = y.align,
            z = y.sign,
            F = y.symbol,
            R = y.zero,
            D = y.width,
            re = y.comma,
            oe = y.precision,
            we = y.trim,
            ve = y.type;
          ve === "n" ? (re = !0, ve = "g") : cl[ve] || (oe === void 0 && (oe = 12), we = !0, ve = "g"), (R || C === "0" && H === "=") && (R = !0, C = "0", H = "=");
          var Pe = F === "$" ? r : F === "#" && /[boxX]/.test(ve) ? "0" + ve.toLowerCase() : "",
            U = F === "$" ? n : /[%p]/.test(ve) ? o : "",
            ie = cl[ve],
            de = /[defgprs%]/.test(ve);
          oe = oe === void 0 ? 6 : /[gprs]/.test(ve) ? Math.max(1, Math.min(21, oe)) : Math.max(0, Math.min(20, oe));
          function ye(ne) {
            var Ne = Pe,
              ge = U,
              Je,
              pt,
              Ye;
            if (ve === "c") ge = ie(ne) + ge, ne = "";else {
              ne = +ne;
              var rt = ne < 0 || 1 / ne < 0;
              if (ne = isNaN(ne) ? u : ie(Math.abs(ne), oe), we && (ne = dd(ne)), rt && +ne == 0 && z !== "+" && (rt = !1), Ne = (rt ? z === "(" ? z : l : z === "-" || z === "(" ? "" : z) + Ne, ge = (ve === "s" ? dl[8 + sl / 3] : "") + ge + (rt && z === "(" ? ")" : ""), de) {
                for (Je = -1, pt = ne.length; ++Je < pt;) {
                  if (Ye = ne.charCodeAt(Je), 48 > Ye || Ye > 57) {
                    ge = (Ye === 46 ? a + ne.slice(Je + 1) : ne.slice(Je)) + ge, ne = ne.slice(0, Je);
                    break;
                  }
                }
              }
            }
            re && !R && (ne = t(ne, 1 / 0));
            var Ie = Ne.length + ne.length + ge.length,
              Oe = Ie < D ? new Array(D - Ie + 1).join(C) : "";
            switch (re && R && (ne = t(Oe + ne, Oe.length ? D - ge.length : 1 / 0), Oe = ""), H) {
              case "<":
                ne = Ne + ne + ge + Oe;
                break;
              case "=":
                ne = Ne + Oe + ne + ge;
                break;
              case "^":
                ne = Oe.slice(0, Ie = Oe.length >> 1) + Ne + ne + ge + Oe.slice(Ie);
                break;
              default:
                ne = Oe + Ne + ne + ge;
                break;
            }
            return i(ne);
          }
          return ye.toString = function () {
            return y + "";
          }, ye;
        }
        function g(y, C) {
          var H = h((y = Hi(y), y.type = "f", y)),
            z = Math.max(-8, Math.min(8, Math.floor(Oa(C) / 3))) * 3,
            F = Math.pow(10, -z),
            R = dl[8 + z / 3];
          return function (D) {
            return H(F * D) + R;
          };
        }
        return {
          format: h,
          formatPrefix: g
        };
      }
      var Zi, hl, pl;
      md({
        thousands: ",",
        grouping: [3],
        currency: ["$", ""]
      });
      function md(e) {
        return Zi = pd(e), hl = Zi.format, pl = Zi.formatPrefix, Zi;
      }
      function gd(e, t) {
        return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Oa(t) - Oa(e)) + 1;
      }
      function vd(e) {
        return Math.max(0, -Oa(Math.abs(e)));
      }
      function bd(e, t, r, n) {
        var a = kf(e, t, r),
          i;
        switch (n = Hi(n == null ? ",f" : n), n.type) {
          case "s":
            {
              var o = Math.max(Math.abs(e), Math.abs(t));
              return n.precision == null && !isNaN(i = cd(a, o)) && (n.precision = i), pl(n, o);
            }
          case "":
          case "e":
          case "g":
          case "p":
          case "r":
            {
              n.precision == null && !isNaN(i = gd(a, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = i - (n.type === "e"));
              break;
            }
          case "f":
          case "%":
            {
              n.precision == null && !isNaN(i = vd(a)) && (n.precision = i - (n.type === "%") * 2);
              break;
            }
        }
        return hl(n);
      }
      function yd(e) {
        var t = e.domain;
        return e.ticks = function (r) {
          var n = t();
          return Tf(n[0], n[n.length - 1], r == null ? 10 : r);
        }, e.tickFormat = function (r, n) {
          var a = t();
          return bd(a[0], a[a.length - 1], r == null ? 10 : r, n);
        }, e.nice = function (r) {
          r == null && (r = 10);
          var n = t(),
            a = 0,
            i = n.length - 1,
            o = n[a],
            l = n[i],
            u,
            h,
            g = 10;
          for (l < o && (h = o, o = l, l = h, h = a, a = i, i = h); g-- > 0;) {
            if (h = Hs(o, l, r), h === u) return n[a] = o, n[i] = l, t(n);
            if (h > 0) o = Math.floor(o / h) * h, l = Math.ceil(l / h) * h;else if (h < 0) o = Math.ceil(o * h) / h, l = Math.floor(l * h) / h;else break;
            u = h;
          }
          return e;
        }, e;
      }
      function ml() {
        var e = id();
        return e.copy = function () {
          return nd(e, ml());
        }, od.apply(e, arguments), yd(e);
      }
      function wd(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var r, n, a, i, o, l, u, h;
        for (r = e.length & 3, n = e.length - r, a = t, o = 3432918353, l = 461845907, h = 0; h < n;) {
          u = e.charCodeAt(h) & 255 | (e.charCodeAt(++h) & 255) << 8 | (e.charCodeAt(++h) & 255) << 16 | (e.charCodeAt(++h) & 255) << 24, ++h, u = (u & 65535) * o + (((u >>> 16) * o & 65535) << 16) & 4294967295, u = u << 15 | u >>> 17, u = (u & 65535) * l + (((u >>> 16) * l & 65535) << 16) & 4294967295, a ^= u, a = a << 13 | a >>> 19, i = (a & 65535) * 5 + (((a >>> 16) * 5 & 65535) << 16) & 4294967295, a = (i & 65535) + 27492 + (((i >>> 16) + 58964 & 65535) << 16);
        }
        switch (u = 0, r) {
          case 3:
            u ^= (e.charCodeAt(h + 2) & 255) << 16;
          case 2:
            u ^= (e.charCodeAt(h + 1) & 255) << 8;
          case 1:
            u ^= e.charCodeAt(h) & 255;
          default:
            u = (u & 65535) * o + (((u >>> 16) * o & 65535) << 16) & 4294967295, u = u << 15 | u >>> 17, u = (u & 65535) * l + (((u >>> 16) * l & 65535) << 16) & 4294967295, a ^= u;
        }
        return a ^= e.length, a ^= a >>> 16, a = (a & 65535) * 2246822507 + (((a >>> 16) * 2246822507 & 65535) << 16) & 4294967295, a ^= a >>> 13, a = (a & 65535) * 3266489909 + (((a >>> 16) * 3266489909 & 65535) << 16) & 4294967295, a ^= a >>> 16, a >>> 0;
      }
      var gl = Fe().rgb(148, 142, 142),
        Ov = Fe().rgb(200, 0, 0),
        Tv = Fe().rgb(0, 170, 0),
        kv = Fe()("#48CE73");
      function _d(e, t, r) {
        var n = xd(t, r);
        return yl(e)(n);
      }
      function xd(e, t) {
        if (e === t) return 0;
        if (e === 0) return 100;
        var r = (t - e) / e * 100;
        return r > 100 ? 100 : r < -100 ? -100 : r;
      }
      function Sv(e, t) {
        var r = 180 - 1.8 * Math.abs(e);
        return r > 200 && (r = 200), e > 0 ? Color.rgb(200, r, r).alpha(t) : e < 0 ? Color.rgb(r, 200, r).alpha(t) : Color.rgb(200, 200, 200).alpha(t);
      }
      function Lo(e, t) {
        return Fe().rgb(e, e, e).alpha(t);
      }
      function Ed(e) {
        switch (e) {
          case "dotnetspy":
            return /*#__PURE__*/_wrapRegExp(/^(.+)\.(.+)\.(.+)\(.*\)$/, {
              packageName: 1
            });
          case "ebpfspy":
            return /*#__PURE__*/_wrapRegExp(/^(.+)$/, {
              packageName: 1
            });
          case "gospy":
            return /*#__PURE__*/_wrapRegExp(/^(.*?\/.*?\.|.*?\.|.+)(.*)$/, {
              packageName: 1,
              functionName: 2
            });
          case "scrape":
            return /*#__PURE__*/_wrapRegExp(/^(.*?\/.*?\.|.*?\.|.+)(.*)$/, {
              packageName: 1,
              functionName: 2
            });
          case "phpspy":
            return /*#__PURE__*/_wrapRegExp(/^((.*\/)*)(.*\.php+)(.*)$/, {
              packageName: 1,
              filename: 3,
              line_info: 4
            });
          case "pyspy":
            return /*#__PURE__*/_wrapRegExp(/^((.*\/)*)(.*\.py+)(.*)$/, {
              packageName: 1,
              filename: 3,
              line_info: 4
            });
          case "rbspy":
            return /*#__PURE__*/_wrapRegExp(/^((.*\/)*)(.*\.rb+)(.*)$/, {
              packageName: 1,
              filename: 3,
              line_info: 4
            });
          case "nodespy":
            return /*#__PURE__*/_wrapRegExp(/^(\.\/node_modules\/)?([^/]*)(.*\.?(jsx?|tsx?)?):(.*):(.*)$/, {
              packageName: 2,
              filename: 3,
              functionName: 5,
              line_info: 6
            });
          case "tracing":
            return /*#__PURE__*/_wrapRegExp(/^(.+?):.*$/, {
              packageName: 1
            });
          case "javaspy":
            return /*#__PURE__*/_wrapRegExp(/^(.+\/)(.+\.)(.+)$/, {
              packageName: 1,
              filename: 2,
              functionName: 3
            });
          case "pyroscope-rs":
            return /*#__PURE__*/_wrapRegExp(/^([^::]+)/, {
              packageName: 1
            });
          case "unknown":
            return /*#__PURE__*/_wrapRegExp(/^(.+)$/, {
              packageName: 1
            });
        }
        return /*#__PURE__*/_wrapRegExp(/^(.+)$/, {
          packageName: 1
        });
      }
      function vl(e, t) {
        if (t.length === 0) return t;
        var r = Ed(e),
          n = t.match(r);
        return n && n.groups ? n.groups.packageName || "" : t;
      }
      function bl(e, t) {
        var n = wd(t, 0) % e.colors.length,
          a = e.colors[n];
        return a || (console.warn("Could not calculate color. Defaulting to the first one"), e.colors[0]);
      }
      function yl(e) {
        var t = e.goodColor,
          r = e.neutralColor,
          n = e.badColor,
          a = ml().domain([-100, 0, 100]).range([t.rgb().toString(), r.rgb().toString(), n.rgb().toString()]);
        return function (i) {
          return Fe()(a(i).toString());
        };
      }
      function wl(e, t) {
        return t.toLowerCase().includes(e.toLowerCase());
      }
      var Od = Object.defineProperty,
        Td = Object.defineProperties,
        kd = Object.getOwnPropertyDescriptors,
        _l = Object.getOwnPropertySymbols,
        Sd = Object.prototype.hasOwnProperty,
        Cd = Object.prototype.propertyIsEnumerable,
        xl = function xl(e, t, r) {
          return t in e ? Od(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        El = function El(e, t) {
          for (var r in t || (t = {})) {
            Sd.call(t, r) && xl(e, r, t[r]);
          }
          if (_l) {
            var _iterator32 = _createForOfIteratorHelper(_l(t)),
              _step32;
            try {
              for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
                var r = _step32.value;
                Cd.call(t, r) && xl(e, r, t[r]);
              }
            } catch (err) {
              _iterator32.e(err);
            } finally {
              _iterator32.f();
            }
          }
          return e;
        },
        Md = function Md(e, t) {
          return Td(e, kd(t));
        };
      function Ol(e) {
        var t = e.canvas,
          r = e.fitMode,
          n = e.units,
          a = e.tickToX,
          i = e.levels,
          o = e.palette,
          l = e.numTicks,
          u = e.sampleRate,
          h = e.pxPerTick,
          g = e.rangeMin,
          y = e.rangeMax,
          C = e.focusedNode,
          H = e.zoom,
          z = Ad(t);
        if (t.width = z, g >= y) throw new Error("'rangeMin' should be strictly smaller than 'rangeMax'");
        var F = e.format,
          R = vt(F),
          D = t.getContext("2d");
        if (!D) throw new Error("Could not get ctx");
        var re = H.mapOrElse(function () {
            return 0;
          }, function (ie) {
            return ie.i;
          }),
          oe = Li(l, u, n),
          we = C.isJust,
          ve = C.mapOrElse(function () {
            return 0;
          }, function (ie) {
            return ie.i;
          }),
          Pe = ta * (i.length - ve) + (we ? ra : 0);
        t.height = Pe, devicePixelRatio > 1 && (t.width *= 2, t.height *= 2, D.scale(2, 2));
        var U = e.names;
        if (we) {
          var ie = l * h;
          D.beginPath(), D.rect(0, 0, l * h, ra), D.fillStyle = Lo(200, 1).rgb().string(), D.fill();
          var de = C.mapOrElse(function () {
            return "total";
          }, function (Ye) {
            return "total (".concat(Ye.i - 1, " level(s) collapsed)");
          });
          D.textBaseline = "middle", D.font = "400 11.5px SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace";
          var ye = D.measureText("a").width,
            ne = $s({
              mode: r,
              charSize: ye,
              rectWidth: ie,
              fullText: de,
              shortText: de
            }),
            Ne = 0,
            ge = 0,
            Je = ra;
          D.save(), D.clip(), D.fillStyle = "black";
          var pt = Math.round(Math.max(Ne, 0));
          D.fillText(ne.text, pt + ne.marginLeft, ge + Je / 2 + 1), D.restore();
        }
        var _loop = function _loop(_ie) {
          var de = i[ve + _ie];
          if (!de) throw new Error("Could not find level: ".concat(ve + _ie));
          var _loop2 = function _loop2(_ye2) {
            var ne = R.getBarOffset(de, _ye2),
              Ne = a(ne),
              ge = _ie * ta + (we ? ra : 0),
              Je = ra,
              pt = !!e.highlightQuery && e.highlightQuery.length > 0,
              Ye = kl(_ye2 + R.jName, de, U, e.highlightQuery);
            var rt = R.getBarTotal(de, _ye2);
            var Ie = rt * h <= yo;
            if (Ie) for (; _ye2 < de.length - R.jStep && ne + rt === R.getBarOffset(de, _ye2 + R.jStep) && R.getBarTotal(de, _ye2 + R.jStep) * h <= yo && Ye === (e.highlightQuery && kl(_ye2 + R.jStep + R.jName, de, U, e.highlightQuery) || !1);) {
              _ye2 += R.jStep, rt += R.getBarTotal(de, _ye2);
            }
            var Oe = rt * h - (Ie ? 0 : Bs),
              at = e.spyName,
              ir = function () {
                var Ot = {
                  level: de,
                  j: _ye2,
                  i: _ie + C.mapOrElse(function () {
                    return 0;
                  }, function (jt) {
                    return jt.i;
                  }),
                  names: U,
                  collapsed: Ie,
                  selectedLevel: re,
                  highlightModeOn: pt,
                  isHighlighted: Ye,
                  spyName: at,
                  palette: o
                };
                switch (F) {
                  case "single":
                    _ye = _ye2;
                    return Rd(El({}, Ot));
                  case "double":
                    _ye = _ye2;
                    return Id(Md(El({}, Ot), {
                      leftTicks: e.leftTicks,
                      rightTicks: e.rightTicks
                    }));
                  default:
                    throw new Error("Unsupported format: ".concat(F));
                }
              }();
            if (D.beginPath(), D.rect(Ne, ge, Oe, Je), D.fillStyle = ir.string(), D.fill(), Ie || Oe < yf) {
              _ye = _ye2;
              return "continue";
            }
            var St = Nd(U, _ye2, F, de),
              or = Pd(St, rt, l, u, oe);
            D.textBaseline = "middle", D.font = "400 11.5px SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace";
            var Et = D.measureText("a").width,
              Nt = $s({
                mode: r,
                charSize: Et,
                rectWidth: Oe,
                fullText: or,
                shortText: St
              });
            D.save(), D.clip(), D.fillStyle = "black";
            var Pr = Math.round(Math.max(Ne, 0));
            D.fillText(Nt.text, Pr + Nt.marginLeft, ge + Je / 2 + 1), D.restore();
            _ye = _ye2;
          };
          for (var _ye = 0; _ye < de.length; _ye += R.jStep) {
            var _ret = _loop2(_ye);
            if (_ret === "continue") continue;
          }
        };
        for (var _ie = 0; _ie < i.length - ve; _ie += 1) {
          _loop(_ie);
        }
      }
      function Nd(e, t, r, n) {
        var a = vt(r);
        var i = n[t + a.jName];
        i === void 0 && (i = -1);
        var o = e[i];
        return o || (console.warn("Could not find function name for", {
          j: t,
          format: r,
          level: n,
          names: e
        }), "");
      }
      function Pd(e, t, r, n, a) {
        var i = t / r,
          o = zs(i);
        return "".concat(e, " (").concat(o, ", ").concat(a.format(t, n), ")");
      }
      function Tl(_ref6) {
        var e = _ref6.collapsed,
          t = _ref6.highlightModeOn,
          r = _ref6.isHighlighted;
        return e || t && !r ? Lo(200, .66) : null;
      }
      function Rd(e) {
        var t = Tl(e);
        if (t) return t;
        var r = vt("single"),
          n = e.selectedLevel > e.i ? .33 : 1;
        var a = e.level[e.j + r.jName];
        a === void 0 && (console.warn("Could nto find level", {
          l: e.j,
          jName: r.jName,
          level: e.level
        }), a = -1);
        var i = e.names[a] || "",
          o = vl(e.spyName, i) || "";
        return bl(e.palette, o).alpha(n);
      }
      function Id(e) {
        var t = Tl(e);
        if (t) return t;
        var r = e.selectedLevel > e.i ? .33 : 1,
          _Ef = Ef(e.level, e.j, e.leftTicks, e.rightTicks),
          n = _Ef.leftRatio,
          a = _Ef.rightRatio,
          i = ui(n),
          o = ui(a);
        return _d(e.palette, i, o).alpha(r);
      }
      function kl(e, t, r, n) {
        var a = t[e];
        if (!a) return !1;
        var i = r[a];
        return i ? wl(n, i) : !1;
      }
      function Ad(e) {
        return e.clientWidth || e.width;
      }
      var Dd = Object.defineProperty,
        Ld = Object.defineProperties,
        Fd = Object.getOwnPropertyDescriptors,
        Sl = Object.getOwnPropertySymbols,
        jd = Object.prototype.hasOwnProperty,
        Bd = Object.prototype.propertyIsEnumerable,
        Cl = function Cl(e, t, r) {
          return t in e ? Dd(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        Vi = function Vi(e, t) {
          for (var r in t || (t = {})) {
            jd.call(t, r) && Cl(e, r, t[r]);
          }
          if (Sl) {
            var _iterator33 = _createForOfIteratorHelper(Sl(t)),
              _step33;
            try {
              for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                var r = _step33.value;
                Bd.call(t, r) && Cl(e, r, t[r]);
              }
            } catch (err) {
              _iterator33.e(err);
            } finally {
              _iterator33.f();
            }
          }
          return e;
        },
        Ml = function Ml(e, t) {
          return Ld(e, Fd(t));
        };
      var Nl = /*#__PURE__*/function () {
        function Nl(t, r, n, a, i, o, l) {
          var _this20 = this;
          _classCallCheck(this, Nl);
          if (this.flamebearer = t, this.canvas = r, this.focusedNode = n, this.fitMode = a, this.highlightQuery = i, this.zoom = o, this.palette = l, this.tickToX = function (u) {
            var _this20$getRange = _this20.getRange(),
              h = _this20$getRange.rangeMin;
            return (u - _this20.flamebearer.numTicks * h) * _this20.pxPerTick();
          }, this.xyToBarPosition = function (u) {
            var h = _this20.ff,
              _this20$xyToBarIndex = _this20.xyToBarIndex(u.x, u.y),
              g = _this20$xyToBarIndex.i,
              y = _this20$xyToBarIndex.j,
              C = _this20.focusedNode.mapOrElse(function () {
                return 0;
              }, function (D) {
                return D.i < 0 ? 0 : D.i - 1;
              }),
              H = _this20.flamebearer.levels[g];
            if (!H) throw new Error("Could not find level: '".concat(g, "'"));
            var z = Math.max(_this20.tickToX(h.getBarOffset(H, y)), 0),
              F = Math.max((g - C) * ta, 0),
              R = Math.min(_this20.tickToX(h.getBarOffset(H, y) + h.getBarTotal(H, y)) - z, _this20.getCanvasWidth());
            return {
              x: z,
              y: F,
              width: R
            };
          }, this.xyToBarData = function (u) {
            var _this20$xyToBarIndex2 = _this20.xyToBarIndex(u.x, u.y),
              h = _this20$xyToBarIndex2.i,
              g = _this20$xyToBarIndex2.j,
              y = _this20.flamebearer.levels[h];
            if (!y) throw new Error("Could not find level: '".concat(h, "'"));
            switch (_this20.flamebearer.format) {
              case "single":
                {
                  var C = ct;
                  return {
                    format: "single",
                    name: _this20.flamebearer.names[C.getBarName(y, g)],
                    self: C.getBarSelf(y, g),
                    offset: C.getBarOffset(y, g),
                    total: C.getBarTotal(y, g)
                  };
                }
              case "double":
                {
                  var _C = ht;
                  return {
                    format: "double",
                    barTotal: _C.getBarTotal(y, g),
                    totalLeft: _C.getBarTotalLeft(y, g),
                    totalRight: _C.getBarTotalRght(y, g),
                    totalDiff: _C.getBarTotalDiff(y, g),
                    name: _this20.flamebearer.names[_C.getBarName(y, g)]
                  };
                }
              default:
                throw new Error("Unsupported type");
            }
          }, this.isWithinBounds = function (u, h) {
            if (u < 0 || u > _this20.getCanvasWidth()) return !1;
            try {
              var _this20$xyToBarIndex3 = _this20.xyToBarIndex(u, h),
                g = _this20$xyToBarIndex3.i,
                y = _this20$xyToBarIndex3.j;
              if (y === -1 || g === -1) return !1;
            } catch (g) {
              return !1;
            }
            return !0;
          }, this.zoom = o, this.focusedNode = n, this.flamebearer = t, this.canvas = r, this.highlightQuery = i, this.ff = vt(t.format), this.palette = l, n.isJust && o.isJust && o.value.i < n.value.i) throw new Error("Zoom i level should be bigger than Focus");
        }
        _createClass(Nl, [{
          key: "render",
          value: function render() {
            var _this$getRange = this.getRange(),
              t = _this$getRange.rangeMin,
              r = _this$getRange.rangeMax,
              n = {
                canvas: this.canvas,
                format: this.flamebearer.format,
                numTicks: this.flamebearer.numTicks,
                sampleRate: this.flamebearer.sampleRate,
                names: this.flamebearer.names,
                levels: this.flamebearer.levels,
                spyName: this.flamebearer.spyName,
                units: this.flamebearer.units,
                maxSelf: this.flamebearer.maxSelf,
                rangeMin: t,
                rangeMax: r,
                fitMode: this.fitMode,
                highlightQuery: this.highlightQuery,
                zoom: this.zoom,
                focusedNode: this.focusedNode,
                pxPerTick: this.pxPerTick(),
                tickToX: this.tickToX,
                palette: this.palette
              },
              a = this.flamebearer.format;
            switch (a) {
              case "single":
                {
                  Ol(Ml(Vi({}, n), {
                    format: "single"
                  }));
                  break;
                }
              case "double":
                {
                  Ol(Ml(Vi({}, n), {
                    leftTicks: this.flamebearer.leftTicks,
                    rightTicks: this.flamebearer.rightTicks
                  }));
                  break;
                }
              default:
                throw new Error("Invalid format: '".concat(a, "'"));
            }
          }
        }, {
          key: "pxPerTick",
          value: function pxPerTick() {
            var _this$getRange2 = this.getRange(),
              t = _this$getRange2.rangeMin,
              r = _this$getRange2.rangeMax;
            return this.getCanvasWidth() / this.flamebearer.numTicks / (r - t);
          }
        }, {
          key: "getRange",
          value: function getRange() {
            var _this21 = this;
            var t = this.ff,
              r = function r(o) {
                var l = _this21.flamebearer.levels[o.i];
                if (!l) throw new Error("Could not find level: '".concat(o.i, "'"));
                var u = t.getBarOffset(l, o.j) / _this21.flamebearer.numTicks,
                  h = (t.getBarOffset(l, o.j) + t.getBarTotal(l, o.j)) / _this21.flamebearer.numTicks;
                return {
                  rangeMin: u,
                  rangeMax: h
                };
              },
              n = function n(o) {
                var l = _this21.flamebearer.levels[o.i];
                if (!l) throw new Error("Could not find level: '".concat(o.i, "'"));
                var u = t.getBarOffset(l, o.j) / _this21.flamebearer.numTicks,
                  h = (t.getBarOffset(l, o.j) + t.getBarTotal(l, o.j)) / _this21.flamebearer.numTicks;
                return {
                  rangeMin: u,
                  rangeMax: h
                };
              },
              a = this.zoom,
              i = this.focusedNode;
            return a.match({
              Just: function Just(o) {
                return i.match({
                  Just: function Just(l) {
                    var u = n(l),
                      h = r(o);
                    return u.rangeMax - u.rangeMin < h.rangeMax - h.rangeMin ? (console.warn("Focus is smaller than range, this shouldnt happen. Verify that the zoom is always bigger than the focus."), n(l)) : r(o);
                  },
                  Nothing: function Nothing() {
                    return r(o);
                  }
                });
              },
              Nothing: function Nothing() {
                return i.match({
                  Just: function Just(o) {
                    return n(o);
                  },
                  Nothing: function Nothing() {
                    return {
                      rangeMin: 0,
                      rangeMax: 1
                    };
                  }
                });
              }
            });
          }
        }, {
          key: "getCanvasWidth",
          value: function getCanvasWidth() {
            return this.canvas.clientWidth || this.canvas.width;
          }
        }, {
          key: "isFocused",
          value: function isFocused() {
            return this.focusedNode.isJust;
          }
        }, {
          key: "binarySearchLevel",
          value: function binarySearchLevel(t, r) {
            var n = this.ff;
            var a = 0,
              i = r.length - n.jStep;
            for (; a <= i;) {
              var o = n.jStep * (a / n.jStep + i / n.jStep >> 1),
                l = this.tickToX(n.getBarOffset(r, o)),
                u = this.tickToX(n.getBarOffset(r, o) + n.getBarTotal(r, o));
              if (l <= t && u >= t) return u - l > yo ? o : -1;
              l > t ? i = o - n.jStep : a = o + n.jStep;
            }
            return -1;
          }
        }, {
          key: "xyToBarIndex",
          value: function xyToBarIndex(t, r) {
            var _this22 = this;
            if (t < 0 || r < 0) throw new Error("x and y must be bigger than 0. x = ".concat(t, ", y = ").concat(r));
            if (this.isFocused() && r <= ra) return {
              i: 0,
              j: 0
            };
            var n = this.isFocused() ? r - ra : r,
              a = this.focusedNode.mapOrElse(function () {
                return 0;
              }, function (l) {
                return l.i <= 0 ? 0 : l.i;
              }),
              i = this.zoom.match({
                Just: function Just() {
                  return _this22.focusedNode.match({
                    Just: function Just() {
                      return a;
                    },
                    Nothing: function Nothing() {
                      return 0;
                    }
                  });
                },
                Nothing: function Nothing() {
                  return _this22.focusedNode.match({
                    Just: function Just() {
                      return a;
                    },
                    Nothing: function Nothing() {
                      return 0;
                    }
                  });
                }
              }),
              o = Math.floor(n / ta) + i;
            if (o >= 0 && o < this.flamebearer.levels.length) {
              var l = this.flamebearer.levels[o];
              if (!l) throw new Error("Could not find level: '".concat(o, "'"));
              var u = this.binarySearchLevel(t, l);
              return {
                i: o,
                j: u
              };
            }
            return {
              i: 0,
              j: 0
            };
          }
        }, {
          key: "parseXY",
          value: function parseXY(t, r) {
            var n = this.isWithinBounds(t, r),
              a = {
                x: t,
                y: r
              };
            return n ? ot.of(a) : ot.nothing();
          }
        }, {
          key: "xyToBar",
          value: function xyToBar(t, r) {
            var _this23 = this;
            return this.parseXY(t, r).map(function (n) {
              var _this23$xyToBarIndex = _this23.xyToBarIndex(t, r),
                a = _this23$xyToBarIndex.i,
                i = _this23$xyToBarIndex.j,
                o = _this23.xyToBarPosition(n),
                l = _this23.xyToBarData(n);
              return Vi(Vi({
                i: a,
                j: i
              }, o), l);
            });
          }
        }]);
        return Nl;
      }();
      function Pl(e) {
        var t,
          r,
          n = "";
        if (typeof e == "string" || typeof e == "number") n += e;else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
          e[t] && (r = Pl(e[t])) && (n && (n += " "), n += r);
        } else for (t in e) {
          e[t] && (n && (n += " "), n += t);
        }
        return n;
      }
      function sn() {
        for (var e = 0, t, r, n = ""; e < arguments.length;) {
          (t = arguments[e++]) && (r = Pl(t)) && (n && (n += " "), n += r);
        }
        return n;
      } /*!
        * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
        * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
        */
      function mi(e) {
        return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mi = function mi(t) {
          return typeof t;
        } : mi = function mi(t) {
          return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, mi(e);
      }
      function zd(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function Rl(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      function $d(e, t, r) {
        return t && Rl(e.prototype, t), r && Rl(e, r), e;
      }
      function Hd(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }
      function je(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t] != null ? arguments[t] : {},
            n = Object.keys(r);
          typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (a) {
            return Object.getOwnPropertyDescriptor(r, a).enumerable;
          }))), n.forEach(function (a) {
            Hd(e, a, r[a]);
          });
        }
        return e;
      }
      function Fo(e, t) {
        return Zd(e) || Gd(e, t) || Jd();
      }
      function jo(e) {
        return Ud(e) || Vd(e) || Wd();
      }
      function Ud(e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }
          return r;
        }
      }
      function Zd(e) {
        if (Array.isArray(e)) return e;
      }
      function Vd(e) {
        if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]") return Array.from(e);
      }
      function Gd(e, t) {
        var r = [],
          n = !0,
          a = !1,
          i = void 0;
        try {
          for (var o = e[Symbol.iterator](), l; !(n = (l = o.next()).done) && (r.push(l.value), !(t && r.length === t)); n = !0) {
            ;
          }
        } catch (u) {
          a = !0, i = u;
        } finally {
          try {
            !n && o.return != null && o.return();
          } finally {
            if (a) throw i;
          }
        }
        return r;
      }
      function Wd() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }
      function Jd() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
      var Il = function Il() {},
        Bo = {},
        Al = {},
        Dl = null,
        Ll = {
          mark: Il,
          measure: Il
        };
      try {
        typeof window != "undefined" && (Bo = window), typeof document != "undefined" && (Al = document), typeof MutationObserver != "undefined" && (Dl = MutationObserver), typeof performance != "undefined" && (Ll = performance);
      } catch (e) {}
      var Xd = Bo.navigator || {},
        Fl = Xd.userAgent,
        jl = Fl === void 0 ? "" : Fl,
        Ta = Bo,
        kt = Al,
        Bl = Dl,
        Gi = Ll,
        Cv = !!Ta.document,
        ln = !!kt.documentElement && !!kt.head && typeof kt.addEventListener == "function" && typeof kt.createElement == "function",
        zl = ~jl.indexOf("MSIE") || ~jl.indexOf("Trident/"),
        cn = "___FONT_AWESOME___",
        zo = 16,
        $l = "fa",
        Hl = "svg-inline--fa",
        ka = "data-fa-i2svg",
        $o = "data-fa-pseudo-element",
        qd = "data-fa-pseudo-element-pending",
        Kd = "data-prefix",
        Yd = "data-icon",
        Ul = "fontawesome-i2svg",
        Qd = "async",
        eh = ["HTML", "HEAD", "STYLE", "SCRIPT"],
        th = function () {
          try {
            return !0;
          } catch (e) {
            return !1;
          }
        }(),
        Zl = {
          fas: "solid",
          far: "regular",
          fal: "light",
          fad: "duotone",
          fab: "brands",
          fak: "kit",
          fa: "solid"
        },
        rh = {
          solid: "fas",
          regular: "far",
          light: "fal",
          duotone: "fad",
          brands: "fab",
          kit: "fak"
        },
        Vl = "fa-layers-text",
        nh = /Font Awesome ([5 ]*)(Solid|Regular|Light|Duotone|Brands|Free|Pro|Kit).*/i,
        ah = {
          "900": "fas",
          "400": "far",
          normal: "far",
          "300": "fal"
        },
        Gl = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        ih = Gl.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
        oh = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"],
        na = {
          GROUP: "group",
          SWAP_OPACITY: "swap-opacity",
          PRIMARY: "primary",
          SECONDARY: "secondary"
        },
        sh = ["xs", "sm", "lg", "fw", "ul", "li", "border", "pull-left", "pull-right", "spin", "pulse", "rotate-90", "rotate-180", "rotate-270", "flip-horizontal", "flip-vertical", "flip-both", "stack", "stack-1x", "stack-2x", "inverse", "layers", "layers-text", "layers-counter", na.GROUP, na.SWAP_OPACITY, na.PRIMARY, na.SECONDARY].concat(Gl.map(function (e) {
          return "".concat(e, "x");
        })).concat(ih.map(function (e) {
          return "w-".concat(e);
        })),
        Wl = Ta.FontAwesomeConfig || {};
      function lh(e) {
        var t = kt.querySelector("script[" + e + "]");
        if (t) return t.getAttribute(e);
      }
      function ch(e) {
        return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
      }
      if (kt && typeof kt.querySelector == "function") {
        var uh = [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
        uh.forEach(function (e) {
          var t = Fo(e, 2),
            r = t[0],
            n = t[1],
            a = ch(lh(r));
          a != null && (Wl[n] = a);
        });
      }
      var fh = {
          familyPrefix: $l,
          replacementClass: Hl,
          autoReplaceSvg: !0,
          autoAddCss: !0,
          autoA11y: !0,
          searchPseudoElements: !1,
          observeMutations: !0,
          mutateApproach: "async",
          keepOriginalSource: !0,
          measurePerformance: !1,
          showMissingIcons: !0
        },
        Ho = je({}, fh, Wl);
      Ho.autoReplaceSvg || (Ho.observeMutations = !1);
      var Me = je({}, Ho);
      Ta.FontAwesomeConfig = Me;
      var un = Ta || {};
      un[cn] || (un[cn] = {}), un[cn].styles || (un[cn].styles = {}), un[cn].hooks || (un[cn].hooks = {}), un[cn].shims || (un[cn].shims = []);
      var Tr = un[cn],
        Jl = [],
        dh = function e() {
          kt.removeEventListener("DOMContentLoaded", e), Wi = 1, Jl.map(function (t) {
            return t();
          });
        },
        Wi = !1;
      ln && (Wi = (kt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(kt.readyState), Wi || kt.addEventListener("DOMContentLoaded", dh));
      function hh(e) {
        !ln || (Wi ? setTimeout(e, 0) : Jl.push(e));
      }
      var Uo = "pending",
        Xl = "settled",
        Ji = "fulfilled",
        Xi = "rejected",
        ph = function ph() {},
        ql = typeof pe.g != "undefined" && typeof pe.g.process != "undefined" && typeof pe.g.process.emit == "function",
        mh = typeof setImmediate == "undefined" ? setTimeout : setImmediate,
        gi = [],
        Zo;
      function gh() {
        for (var e = 0; e < gi.length; e++) {
          gi[e][0](gi[e][1]);
        }
        gi = [], Zo = !1;
      }
      function qi(e, t) {
        gi.push([e, t]), Zo || (Zo = !0, mh(gh, 0));
      }
      function vh(e, t) {
        function r(a) {
          Vo(t, a);
        }
        function n(a) {
          vi(t, a);
        }
        try {
          e(r, n);
        } catch (a) {
          n(a);
        }
      }
      function Kl(e) {
        var t = e.owner,
          r = t._state,
          n = t._data,
          a = e[r],
          i = e.then;
        if (typeof a == "function") {
          r = Ji;
          try {
            n = a(n);
          } catch (o) {
            vi(i, o);
          }
        }
        Yl(i, n) || (r === Ji && Vo(i, n), r === Xi && vi(i, n));
      }
      function Yl(e, t) {
        var r;
        try {
          if (e === t) throw new TypeError("A promises callback cannot return that same promise.");
          if (t && (typeof t == "function" || mi(t) === "object")) {
            var n = t.then;
            if (typeof n == "function") return n.call(t, function (a) {
              r || (r = !0, t === a ? Ql(e, a) : Vo(e, a));
            }, function (a) {
              r || (r = !0, vi(e, a));
            }), !0;
          }
        } catch (a) {
          return r || vi(e, a), !0;
        }
        return !1;
      }
      function Vo(e, t) {
        (e === t || !Yl(e, t)) && Ql(e, t);
      }
      function Ql(e, t) {
        e._state === Uo && (e._state = Xl, e._data = t, qi(bh, e));
      }
      function vi(e, t) {
        e._state === Uo && (e._state = Xl, e._data = t, qi(yh, e));
      }
      function ec(e) {
        e._then = e._then.forEach(Kl);
      }
      function bh(e) {
        e._state = Ji, ec(e);
      }
      function yh(e) {
        e._state = Xi, ec(e), !e._handled && ql && pe.g.process.emit("unhandledRejection", e._data, e);
      }
      function wh(e) {
        pe.g.process.emit("rejectionHandled", e);
      }
      function nr(e) {
        if (typeof e != "function") throw new TypeError("Promise resolver " + e + " is not a function");
        if (!(this instanceof nr)) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        this._then = [], vh(e, this);
      }
      nr.prototype = {
        constructor: nr,
        _state: Uo,
        _then: null,
        _data: void 0,
        _handled: !1,
        then: function then(t, r) {
          var n = {
            owner: this,
            then: new this.constructor(ph),
            fulfilled: t,
            rejected: r
          };
          return (r || t) && !this._handled && (this._handled = !0, this._state === Xi && ql && qi(wh, this)), this._state === Ji || this._state === Xi ? qi(Kl, n) : this._then.push(n), n.then;
        },
        catch: function _catch(t) {
          return this.then(null, t);
        }
      }, nr.all = function (e) {
        if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.all().");
        return new nr(function (t, r) {
          var n = [],
            a = 0;
          function i(u) {
            return a++, function (h) {
              n[u] = h, --a || t(n);
            };
          }
          for (var o = 0, l; o < e.length; o++) {
            l = e[o], l && typeof l.then == "function" ? l.then(i(o), r) : n[o] = l;
          }
          a || t(n);
        });
      }, nr.race = function (e) {
        if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.race().");
        return new nr(function (t, r) {
          for (var n = 0, a; n < e.length; n++) {
            a = e[n], a && typeof a.then == "function" ? a.then(t, r) : t(a);
          }
        });
      }, nr.resolve = function (e) {
        return e && mi(e) === "object" && e.constructor === nr ? e : new nr(function (t) {
          t(e);
        });
      }, nr.reject = function (e) {
        return new nr(function (t, r) {
          r(e);
        });
      };
      var kr = typeof Promise == "function" ? Promise : nr,
        jn = zo,
        fn = {
          size: 16,
          x: 0,
          y: 0,
          rotate: 0,
          flipX: !1,
          flipY: !1
        };
      function _h(e) {
        return ~sh.indexOf(e);
      }
      function tc(e) {
        if (!(!e || !ln)) {
          var t = kt.createElement("style");
          t.setAttribute("type", "text/css"), t.innerHTML = e;
          for (var r = kt.head.childNodes, n = null, a = r.length - 1; a > -1; a--) {
            var i = r[a],
              o = (i.tagName || "").toUpperCase();
            ["STYLE", "LINK"].indexOf(o) > -1 && (n = i);
          }
          return kt.head.insertBefore(t, n), e;
        }
      }
      var xh = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      function bi() {
        for (var e = 12, t = ""; e-- > 0;) {
          t += xh[Math.random() * 62 | 0];
        }
        return t;
      }
      function Sa(e) {
        for (var t = [], r = (e || []).length >>> 0; r--;) {
          t[r] = e[r];
        }
        return t;
      }
      function Go(e) {
        return e.classList ? Sa(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function (t) {
          return t;
        });
      }
      function Eh(e, t) {
        var r = t.split("-"),
          n = r[0],
          a = r.slice(1).join("-");
        return n === e && a !== "" && !_h(a) ? a : null;
      }
      function rc(e) {
        return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      }
      function Oh(e) {
        return Object.keys(e || {}).reduce(function (t, r) {
          return t + "".concat(r, '="').concat(rc(e[r]), '" ');
        }, "").trim();
      }
      function Ki(e) {
        return Object.keys(e || {}).reduce(function (t, r) {
          return t + "".concat(r, ": ").concat(e[r], ";");
        }, "");
      }
      function Wo(e) {
        return e.size !== fn.size || e.x !== fn.x || e.y !== fn.y || e.rotate !== fn.rotate || e.flipX || e.flipY;
      }
      function nc(e) {
        var t = e.transform,
          r = e.containerWidth,
          n = e.iconWidth,
          a = {
            transform: "translate(".concat(r / 2, " 256)")
          },
          i = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "),
          o = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
          l = "rotate(".concat(t.rotate, " 0 0)"),
          u = {
            transform: "".concat(i, " ").concat(o, " ").concat(l)
          },
          h = {
            transform: "translate(".concat(n / 2 * -1, " -256)")
          };
        return {
          outer: a,
          inner: u,
          path: h
        };
      }
      function Th(e) {
        var t = e.transform,
          r = e.width,
          n = r === void 0 ? zo : r,
          a = e.height,
          i = a === void 0 ? zo : a,
          o = e.startCentered,
          l = o === void 0 ? !1 : o,
          u = "";
        return l && zl ? u += "translate(".concat(t.x / jn - n / 2, "em, ").concat(t.y / jn - i / 2, "em) ") : l ? u += "translate(calc(-50% + ".concat(t.x / jn, "em), calc(-50% + ").concat(t.y / jn, "em)) ") : u += "translate(".concat(t.x / jn, "em, ").concat(t.y / jn, "em) "), u += "scale(".concat(t.size / jn * (t.flipX ? -1 : 1), ", ").concat(t.size / jn * (t.flipY ? -1 : 1), ") "), u += "rotate(".concat(t.rotate, "deg) "), u;
      }
      var Jo = {
        x: 0,
        y: 0,
        width: "100%",
        height: "100%"
      };
      function ac(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
        return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
      }
      function kh(e) {
        return e.tag === "g" ? e.children : [e];
      }
      function Sh(e) {
        var t = e.children,
          r = e.attributes,
          n = e.main,
          a = e.mask,
          i = e.maskId,
          o = e.transform,
          l = n.width,
          u = n.icon,
          h = a.width,
          g = a.icon,
          y = nc({
            transform: o,
            containerWidth: h,
            iconWidth: l
          }),
          C = {
            tag: "rect",
            attributes: je({}, Jo, {
              fill: "white"
            })
          },
          H = u.children ? {
            children: u.children.map(ac)
          } : {},
          z = {
            tag: "g",
            attributes: je({}, y.inner),
            children: [ac(je({
              tag: u.tag,
              attributes: je({}, u.attributes, y.path)
            }, H))]
          },
          F = {
            tag: "g",
            attributes: je({}, y.outer),
            children: [z]
          },
          R = "mask-".concat(i || bi()),
          D = "clip-".concat(i || bi()),
          re = {
            tag: "mask",
            attributes: je({}, Jo, {
              id: R,
              maskUnits: "userSpaceOnUse",
              maskContentUnits: "userSpaceOnUse"
            }),
            children: [C, F]
          },
          oe = {
            tag: "defs",
            children: [{
              tag: "clipPath",
              attributes: {
                id: D
              },
              children: kh(g)
            }, re]
          };
        return t.push(oe, {
          tag: "rect",
          attributes: je({
            fill: "currentColor",
            "clip-path": "url(#".concat(D, ")"),
            mask: "url(#".concat(R, ")")
          }, Jo)
        }), {
          children: t,
          attributes: r
        };
      }
      function Ch(e) {
        var t = e.children,
          r = e.attributes,
          n = e.main,
          a = e.transform,
          i = e.styles,
          o = Ki(i);
        if (o.length > 0 && (r.style = o), Wo(a)) {
          var l = nc({
            transform: a,
            containerWidth: n.width,
            iconWidth: n.width
          });
          t.push({
            tag: "g",
            attributes: je({}, l.outer),
            children: [{
              tag: "g",
              attributes: je({}, l.inner),
              children: [{
                tag: n.icon.tag,
                children: n.icon.children,
                attributes: je({}, n.icon.attributes, l.path)
              }]
            }]
          });
        } else t.push(n.icon);
        return {
          children: t,
          attributes: r
        };
      }
      function Mh(e) {
        var t = e.children,
          r = e.main,
          n = e.mask,
          a = e.attributes,
          i = e.styles,
          o = e.transform;
        if (Wo(o) && r.found && !n.found) {
          var l = r.width,
            u = r.height,
            h = {
              x: l / u / 2,
              y: .5
            };
          a.style = Ki(je({}, i, {
            "transform-origin": "".concat(h.x + o.x / 16, "em ").concat(h.y + o.y / 16, "em")
          }));
        }
        return [{
          tag: "svg",
          attributes: a,
          children: t
        }];
      }
      function Nh(e) {
        var t = e.prefix,
          r = e.iconName,
          n = e.children,
          a = e.attributes,
          i = e.symbol,
          o = i === !0 ? "".concat(t, "-").concat(Me.familyPrefix, "-").concat(r) : i;
        return [{
          tag: "svg",
          attributes: {
            style: "display: none;"
          },
          children: [{
            tag: "symbol",
            attributes: je({}, a, {
              id: o
            }),
            children: n
          }]
        }];
      }
      function Xo(e) {
        var t = e.icons,
          r = t.main,
          n = t.mask,
          a = e.prefix,
          i = e.iconName,
          o = e.transform,
          l = e.symbol,
          u = e.title,
          h = e.maskId,
          g = e.titleId,
          y = e.extra,
          C = e.watchable,
          H = C === void 0 ? !1 : C,
          z = n.found ? n : r,
          F = z.width,
          R = z.height,
          D = a === "fak",
          re = D ? "" : "fa-w-".concat(Math.ceil(F / R * 16)),
          oe = [Me.replacementClass, i ? "".concat(Me.familyPrefix, "-").concat(i) : "", re].filter(function (ye) {
            return y.classes.indexOf(ye) === -1;
          }).filter(function (ye) {
            return ye !== "" || !!ye;
          }).concat(y.classes).join(" "),
          we = {
            children: [],
            attributes: je({}, y.attributes, {
              "data-prefix": a,
              "data-icon": i,
              class: oe,
              role: y.attributes.role || "img",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 ".concat(F, " ").concat(R)
            })
          },
          ve = D && !~y.classes.indexOf("fa-fw") ? {
            width: "".concat(F / R * 16 * .0625, "em")
          } : {};
        H && (we.attributes[ka] = ""), u && we.children.push({
          tag: "title",
          attributes: {
            id: we.attributes["aria-labelledby"] || "title-".concat(g || bi())
          },
          children: [u]
        });
        var Pe = je({}, we, {
            prefix: a,
            iconName: i,
            main: r,
            mask: n,
            maskId: h,
            transform: o,
            symbol: l,
            styles: je({}, ve, y.styles)
          }),
          U = n.found && r.found ? Sh(Pe) : Ch(Pe),
          ie = U.children,
          de = U.attributes;
        return Pe.children = ie, Pe.attributes = de, l ? Nh(Pe) : Mh(Pe);
      }
      function ic(e) {
        var t = e.content,
          r = e.width,
          n = e.height,
          a = e.transform,
          i = e.title,
          o = e.extra,
          l = e.watchable,
          u = l === void 0 ? !1 : l,
          h = je({}, o.attributes, i ? {
            title: i
          } : {}, {
            class: o.classes.join(" ")
          });
        u && (h[ka] = "");
        var g = je({}, o.styles);
        Wo(a) && (g.transform = Th({
          transform: a,
          startCentered: !0,
          width: r,
          height: n
        }), g["-webkit-transform"] = g.transform);
        var y = Ki(g);
        y.length > 0 && (h.style = y);
        var C = [];
        return C.push({
          tag: "span",
          attributes: h,
          children: [t]
        }), i && C.push({
          tag: "span",
          attributes: {
            class: "sr-only"
          },
          children: [i]
        }), C;
      }
      function Ph(e) {
        var t = e.content,
          r = e.title,
          n = e.extra,
          a = je({}, n.attributes, r ? {
            title: r
          } : {}, {
            class: n.classes.join(" ")
          }),
          i = Ki(n.styles);
        i.length > 0 && (a.style = i);
        var o = [];
        return o.push({
          tag: "span",
          attributes: a,
          children: [t]
        }), r && o.push({
          tag: "span",
          attributes: {
            class: "sr-only"
          },
          children: [r]
        }), o;
      }
      var oc = function oc() {},
        qo = Me.measurePerformance && Gi && Gi.mark && Gi.measure ? Gi : {
          mark: oc,
          measure: oc
        },
        yi = 'FA "5.15.4"',
        Rh = function Rh(t) {
          return qo.mark("".concat(yi, " ").concat(t, " begins")), function () {
            return sc(t);
          };
        },
        sc = function sc(t) {
          qo.mark("".concat(yi, " ").concat(t, " ends")), qo.measure("".concat(yi, " ").concat(t), "".concat(yi, " ").concat(t, " begins"), "".concat(yi, " ").concat(t, " ends"));
        },
        Ko = {
          begin: Rh,
          end: sc
        },
        Ih = function Ih(t, r) {
          return function (n, a, i, o) {
            return t.call(r, n, a, i, o);
          };
        },
        Yo = function Yo(t, r, n, a) {
          var i = Object.keys(t),
            o = i.length,
            l = a !== void 0 ? Ih(r, a) : r,
            u,
            h,
            g;
          for (n === void 0 ? (u = 1, g = t[i[0]]) : (u = 0, g = n); u < o; u++) {
            h = i[u], g = l(g, t[h], h, t);
          }
          return g;
        };
      function lc(e) {
        for (var t = "", r = 0; r < e.length; r++) {
          var n = e.charCodeAt(r).toString(16);
          t += ("000" + n).slice(-4);
        }
        return t;
      }
      function cc(e, t) {
        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
          n = r.skipHooks,
          a = n === void 0 ? !1 : n,
          i = Object.keys(t).reduce(function (o, l) {
            var u = t[l],
              h = !!u.icon;
            return h ? o[u.iconName] = u.icon : o[l] = u, o;
          }, {});
        typeof Tr.hooks.addPack == "function" && !a ? Tr.hooks.addPack(e, i) : Tr.styles[e] = je({}, Tr.styles[e] || {}, i), e === "fas" && cc("fa", t);
      }
      var uc = Tr.styles,
        Ah = Tr.shims,
        fc = {},
        dc = {},
        hc = {},
        pc = function pc() {
          var t = function t(a) {
            return Yo(uc, function (i, o, l) {
              return i[l] = Yo(o, a, {}), i;
            }, {});
          };
          fc = t(function (n, a, i) {
            return a[3] && (n[a[3]] = i), n;
          }), dc = t(function (n, a, i) {
            var o = a[2];
            return n[i] = i, o.forEach(function (l) {
              n[l] = i;
            }), n;
          });
          var r = ("far" in uc);
          hc = Yo(Ah, function (n, a) {
            var i = a[0],
              o = a[1],
              l = a[2];
            return o === "far" && !r && (o = "fas"), n[i] = {
              prefix: o,
              iconName: l
            }, n;
          }, {});
        };
      pc();
      function mc(e, t) {
        return (fc[e] || {})[t];
      }
      function Dh(e, t) {
        return (dc[e] || {})[t];
      }
      function Lh(e) {
        return hc[e] || {
          prefix: null,
          iconName: null
        };
      }
      var Fh = Tr.styles,
        Qo = function Qo() {
          return {
            prefix: null,
            iconName: null,
            rest: []
          };
        };
      function es(e) {
        return e.reduce(function (t, r) {
          var n = Eh(Me.familyPrefix, r);
          if (Fh[r]) t.prefix = r;else if (Me.autoFetchSvg && Object.keys(Zl).indexOf(r) > -1) t.prefix = r;else if (n) {
            var a = t.prefix === "fa" ? Lh(n) : {};
            t.iconName = a.iconName || n, t.prefix = a.prefix || t.prefix;
          } else r !== Me.replacementClass && r.indexOf("fa-w-") !== 0 && t.rest.push(r);
          return t;
        }, Qo());
      }
      function gc(e, t, r) {
        if (e && e[t] && e[t][r]) return {
          prefix: t,
          iconName: r,
          icon: e[t][r]
        };
      }
      function Ca(e) {
        var t = e.tag,
          r = e.attributes,
          n = r === void 0 ? {} : r,
          a = e.children,
          i = a === void 0 ? [] : a;
        return typeof e == "string" ? rc(e) : "<".concat(t, " ").concat(Oh(n), ">").concat(i.map(Ca).join(""), "</").concat(t, ">");
      }
      var jh = function jh() {};
      function vc(e) {
        var t = e.getAttribute ? e.getAttribute(ka) : null;
        return typeof t == "string";
      }
      function Bh() {
        if (Me.autoReplaceSvg === !0) return Yi.replace;
        var e = Yi[Me.autoReplaceSvg];
        return e || Yi.replace;
      }
      var Yi = {
        replace: function replace(t) {
          var r = t[0],
            n = t[1],
            a = n.map(function (o) {
              return Ca(o);
            }).join("\n");
          if (r.parentNode && r.outerHTML) r.outerHTML = a + (Me.keepOriginalSource && r.tagName.toLowerCase() !== "svg" ? "<!-- ".concat(r.outerHTML, " Font Awesome fontawesome.com -->") : "");else if (r.parentNode) {
            var i = document.createElement("span");
            r.parentNode.replaceChild(i, r), i.outerHTML = a;
          }
        },
        nest: function nest(t) {
          var r = t[0],
            n = t[1];
          if (~Go(r).indexOf(Me.replacementClass)) return Yi.replace(t);
          var a = new RegExp("".concat(Me.familyPrefix, "-.*"));
          delete n[0].attributes.style, delete n[0].attributes.id;
          var i = n[0].attributes.class.split(" ").reduce(function (l, u) {
            return u === Me.replacementClass || u.match(a) ? l.toSvg.push(u) : l.toNode.push(u), l;
          }, {
            toNode: [],
            toSvg: []
          });
          n[0].attributes.class = i.toSvg.join(" ");
          var o = n.map(function (l) {
            return Ca(l);
          }).join("\n");
          r.setAttribute("class", i.toNode.join(" ")), r.setAttribute(ka, ""), r.innerHTML = o;
        }
      };
      function bc(e) {
        e();
      }
      function yc(e, t) {
        var r = typeof t == "function" ? t : jh;
        if (e.length === 0) r();else {
          var n = bc;
          Me.mutateApproach === Qd && (n = Ta.requestAnimationFrame || bc), n(function () {
            var a = Bh(),
              i = Ko.begin("mutate");
            e.map(a), i(), r();
          });
        }
      }
      var ts = !1;
      function zh() {
        ts = !0;
      }
      function wc() {
        ts = !1;
      }
      var Qi = null;
      function $h(e) {
        if (!!Bl && !!Me.observeMutations) {
          var t = e.treeCallback,
            r = e.nodeCallback,
            n = e.pseudoElementsCallback,
            a = e.observeMutationsRoot,
            i = a === void 0 ? kt : a;
          Qi = new Bl(function (o) {
            ts || Sa(o).forEach(function (l) {
              if (l.type === "childList" && l.addedNodes.length > 0 && !vc(l.addedNodes[0]) && (Me.searchPseudoElements && n(l.target), t(l.target)), l.type === "attributes" && l.target.parentNode && Me.searchPseudoElements && n(l.target.parentNode), l.type === "attributes" && vc(l.target) && ~oh.indexOf(l.attributeName)) if (l.attributeName === "class") {
                var u = es(Go(l.target)),
                  h = u.prefix,
                  g = u.iconName;
                h && l.target.setAttribute("data-prefix", h), g && l.target.setAttribute("data-icon", g);
              } else r(l.target);
            });
          }), !!ln && Qi.observe(i, {
            childList: !0,
            attributes: !0,
            characterData: !0,
            subtree: !0
          });
        }
      }
      function Hh() {
        !Qi || Qi.disconnect();
      }
      function Uh(e) {
        var t = e.getAttribute("style"),
          r = [];
        return t && (r = t.split(";").reduce(function (n, a) {
          var i = a.split(":"),
            o = i[0],
            l = i.slice(1);
          return o && l.length > 0 && (n[o] = l.join(":").trim()), n;
        }, {})), r;
      }
      function Zh(e) {
        var t = e.getAttribute("data-prefix"),
          r = e.getAttribute("data-icon"),
          n = e.innerText !== void 0 ? e.innerText.trim() : "",
          a = es(Go(e));
        return t && r && (a.prefix = t, a.iconName = r), a.prefix && n.length > 1 ? a.iconName = Dh(a.prefix, e.innerText) : a.prefix && n.length === 1 && (a.iconName = mc(a.prefix, lc(e.innerText))), a;
      }
      var _c = function _c(t) {
        var r = {
          size: 16,
          x: 0,
          y: 0,
          flipX: !1,
          flipY: !1,
          rotate: 0
        };
        return t ? t.toLowerCase().split(" ").reduce(function (n, a) {
          var i = a.toLowerCase().split("-"),
            o = i[0],
            l = i.slice(1).join("-");
          if (o && l === "h") return n.flipX = !0, n;
          if (o && l === "v") return n.flipY = !0, n;
          if (l = parseFloat(l), isNaN(l)) return n;
          switch (o) {
            case "grow":
              n.size = n.size + l;
              break;
            case "shrink":
              n.size = n.size - l;
              break;
            case "left":
              n.x = n.x - l;
              break;
            case "right":
              n.x = n.x + l;
              break;
            case "up":
              n.y = n.y - l;
              break;
            case "down":
              n.y = n.y + l;
              break;
            case "rotate":
              n.rotate = n.rotate + l;
              break;
          }
          return n;
        }, r) : r;
      };
      function Vh(e) {
        return _c(e.getAttribute("data-fa-transform"));
      }
      function Gh(e) {
        var t = e.getAttribute("data-fa-symbol");
        return t === null ? !1 : t === "" ? !0 : t;
      }
      function Wh(e) {
        var t = Sa(e.attributes).reduce(function (a, i) {
            return a.name !== "class" && a.name !== "style" && (a[i.name] = i.value), a;
          }, {}),
          r = e.getAttribute("title"),
          n = e.getAttribute("data-fa-title-id");
        return Me.autoA11y && (r ? t["aria-labelledby"] = "".concat(Me.replacementClass, "-title-").concat(n || bi()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
      }
      function Jh(e) {
        var t = e.getAttribute("data-fa-mask");
        return t ? es(t.split(" ").map(function (r) {
          return r.trim();
        })) : Qo();
      }
      function Xh() {
        return {
          iconName: null,
          title: null,
          titleId: null,
          prefix: null,
          transform: fn,
          symbol: !1,
          mask: null,
          maskId: null,
          extra: {
            classes: [],
            styles: {},
            attributes: {}
          }
        };
      }
      function qh(e) {
        var t = Zh(e),
          r = t.iconName,
          n = t.prefix,
          a = t.rest,
          i = Uh(e),
          o = Vh(e),
          l = Gh(e),
          u = Wh(e),
          h = Jh(e);
        return {
          iconName: r,
          title: e.getAttribute("title"),
          titleId: e.getAttribute("data-fa-title-id"),
          prefix: n,
          transform: o,
          symbol: l,
          mask: h,
          maskId: e.getAttribute("data-fa-mask-id"),
          extra: {
            classes: a,
            styles: i,
            attributes: u
          }
        };
      }
      function wi(e) {
        this.name = "MissingIcon", this.message = e || "Icon unavailable", this.stack = new Error().stack;
      }
      wi.prototype = Object.create(Error.prototype), wi.prototype.constructor = wi;
      var eo = {
          fill: "currentColor"
        },
        xc = {
          attributeType: "XML",
          repeatCount: "indefinite",
          dur: "2s"
        },
        Kh = {
          tag: "path",
          attributes: je({}, eo, {
            d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
          })
        },
        rs = je({}, xc, {
          attributeName: "opacity"
        }),
        Yh = {
          tag: "circle",
          attributes: je({}, eo, {
            cx: "256",
            cy: "364",
            r: "28"
          }),
          children: [{
            tag: "animate",
            attributes: je({}, xc, {
              attributeName: "r",
              values: "28;14;28;28;14;28;"
            })
          }, {
            tag: "animate",
            attributes: je({}, rs, {
              values: "1;0;1;1;0;1;"
            })
          }]
        },
        Qh = {
          tag: "path",
          attributes: je({}, eo, {
            opacity: "1",
            d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
          }),
          children: [{
            tag: "animate",
            attributes: je({}, rs, {
              values: "1;0;0;0;0;1;"
            })
          }]
        },
        ep = {
          tag: "path",
          attributes: je({}, eo, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: je({}, rs, {
              values: "0;0;1;1;0;0;"
            })
          }]
        },
        tp = {
          tag: "g",
          children: [Kh, Yh, Qh, ep]
        },
        ns = Tr.styles;
      function as(e) {
        var t = e[0],
          r = e[1],
          n = e.slice(4),
          a = Fo(n, 1),
          i = a[0],
          o = null;
        return Array.isArray(i) ? o = {
          tag: "g",
          attributes: {
            class: "".concat(Me.familyPrefix, "-").concat(na.GROUP)
          },
          children: [{
            tag: "path",
            attributes: {
              class: "".concat(Me.familyPrefix, "-").concat(na.SECONDARY),
              fill: "currentColor",
              d: i[0]
            }
          }, {
            tag: "path",
            attributes: {
              class: "".concat(Me.familyPrefix, "-").concat(na.PRIMARY),
              fill: "currentColor",
              d: i[1]
            }
          }]
        } : o = {
          tag: "path",
          attributes: {
            fill: "currentColor",
            d: i
          }
        }, {
          found: !0,
          width: t,
          height: r,
          icon: o
        };
      }
      function is(e, t) {
        return new kr(function (r, n) {
          var a = {
            found: !1,
            width: 512,
            height: 512,
            icon: tp
          };
          if (e && t && ns[t] && ns[t][e]) {
            var i = ns[t][e];
            return r(as(i));
          }
          e && t && !Me.showMissingIcons ? n(new wi("Icon is missing for prefix ".concat(t, " with icon name ").concat(e))) : r(a);
        });
      }
      var rp = Tr.styles;
      function np(e, t) {
        var r = t.iconName,
          n = t.title,
          a = t.titleId,
          i = t.prefix,
          o = t.transform,
          l = t.symbol,
          u = t.mask,
          h = t.maskId,
          g = t.extra;
        return new kr(function (y, C) {
          kr.all([is(r, i), is(u.iconName, u.prefix)]).then(function (H) {
            var z = Fo(H, 2),
              F = z[0],
              R = z[1];
            y([e, Xo({
              icons: {
                main: F,
                mask: R
              },
              prefix: i,
              iconName: r,
              transform: o,
              symbol: l,
              mask: R,
              maskId: h,
              title: n,
              titleId: a,
              extra: g,
              watchable: !0
            })]);
          });
        });
      }
      function ap(e, t) {
        var r = t.title,
          n = t.transform,
          a = t.extra,
          i = null,
          o = null;
        if (zl) {
          var l = parseInt(getComputedStyle(e).fontSize, 10),
            u = e.getBoundingClientRect();
          i = u.width / l, o = u.height / l;
        }
        return Me.autoA11y && !r && (a.attributes["aria-hidden"] = "true"), kr.resolve([e, ic({
          content: e.innerHTML,
          width: i,
          height: o,
          transform: n,
          title: r,
          extra: a,
          watchable: !0
        })]);
      }
      function Ec(e) {
        var t = qh(e);
        return ~t.extra.classes.indexOf(Vl) ? ap(e, t) : np(e, t);
      }
      function Oc(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!!ln) {
          var r = kt.documentElement.classList,
            n = function n(y) {
              return r.add("".concat(Ul, "-").concat(y));
            },
            a = function a(y) {
              return r.remove("".concat(Ul, "-").concat(y));
            },
            i = Me.autoFetchSvg ? Object.keys(Zl) : Object.keys(rp),
            o = [".".concat(Vl, ":not([").concat(ka, "])")].concat(i.map(function (g) {
              return ".".concat(g, ":not([").concat(ka, "])");
            })).join(", ");
          if (o.length !== 0) {
            var l = [];
            try {
              l = Sa(e.querySelectorAll(o));
            } catch (g) {}
            if (l.length > 0) n("pending"), a("complete");else return;
            var u = Ko.begin("onTree"),
              h = l.reduce(function (g, y) {
                try {
                  var C = Ec(y);
                  C && g.push(C);
                } catch (H) {
                  th || H instanceof wi && console.error(H);
                }
                return g;
              }, []);
            return new kr(function (g, y) {
              kr.all(h).then(function (C) {
                yc(C, function () {
                  n("active"), n("complete"), a("pending"), typeof t == "function" && t(), u(), g();
                });
              }).catch(function () {
                u(), y();
              });
            });
          }
        }
      }
      function ip(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        Ec(e).then(function (r) {
          r && yc([r], t);
        });
      }
      function Tc(e, t) {
        var r = "".concat(qd).concat(t.replace(":", "-"));
        return new kr(function (n, a) {
          if (e.getAttribute(r) !== null) return n();
          var i = Sa(e.children),
            o = i.filter(function (re) {
              return re.getAttribute($o) === t;
            })[0],
            l = Ta.getComputedStyle(e, t),
            u = l.getPropertyValue("font-family").match(nh),
            h = l.getPropertyValue("font-weight"),
            g = l.getPropertyValue("content");
          if (o && !u) return e.removeChild(o), n();
          if (u && g !== "none" && g !== "") {
            var y = l.getPropertyValue("content"),
              C = ~["Solid", "Regular", "Light", "Duotone", "Brands", "Kit"].indexOf(u[2]) ? rh[u[2].toLowerCase()] : ah[h],
              H = lc(y.length === 3 ? y.substr(1, 1) : y),
              z = mc(C, H),
              F = z;
            if (z && (!o || o.getAttribute(Kd) !== C || o.getAttribute(Yd) !== F)) {
              e.setAttribute(r, F), o && e.removeChild(o);
              var R = Xh(),
                D = R.extra;
              D.attributes[$o] = t, is(z, C).then(function (re) {
                var oe = Xo(je({}, R, {
                    icons: {
                      main: re,
                      mask: Qo()
                    },
                    prefix: C,
                    iconName: F,
                    extra: D,
                    watchable: !0
                  })),
                  we = kt.createElement("svg");
                t === ":before" ? e.insertBefore(we, e.firstChild) : e.appendChild(we), we.outerHTML = oe.map(function (ve) {
                  return Ca(ve);
                }).join("\n"), e.removeAttribute(r), n();
              }).catch(a);
            } else n();
          } else n();
        });
      }
      function op(e) {
        return kr.all([Tc(e, ":before"), Tc(e, ":after")]);
      }
      function sp(e) {
        return e.parentNode !== document.head && !~eh.indexOf(e.tagName.toUpperCase()) && !e.getAttribute($o) && (!e.parentNode || e.parentNode.tagName !== "svg");
      }
      function kc(e) {
        if (!!ln) return new kr(function (t, r) {
          var n = Sa(e.querySelectorAll("*")).filter(sp).map(op),
            a = Ko.begin("searchPseudoElements");
          zh(), kr.all(n).then(function () {
            a(), wc(), t();
          }).catch(function () {
            a(), wc(), r();
          });
        });
      }
      var lp = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";
      function os() {
        var e = $l,
          t = Hl,
          r = Me.familyPrefix,
          n = Me.replacementClass,
          a = lp;
        if (r !== e || n !== t) {
          var i = new RegExp("\\.".concat(e, "\\-"), "g"),
            o = new RegExp("\\--".concat(e, "\\-"), "g"),
            l = new RegExp("\\.".concat(t), "g");
          a = a.replace(i, ".".concat(r, "-")).replace(o, "--".concat(r, "-")).replace(l, ".".concat(n));
        }
        return a;
      }
      var cp = function () {
        function e() {
          zd(this, e), this.definitions = {};
        }
        return $d(e, [{
          key: "add",
          value: function value() {
            for (var r = this, n = arguments.length, a = new Array(n), i = 0; i < n; i++) {
              a[i] = arguments[i];
            }
            var o = a.reduce(this._pullDefinitions, {});
            Object.keys(o).forEach(function (l) {
              r.definitions[l] = je({}, r.definitions[l] || {}, o[l]), cc(l, o[l]), pc();
            });
          }
        }, {
          key: "reset",
          value: function value() {
            this.definitions = {};
          }
        }, {
          key: "_pullDefinitions",
          value: function value(r, n) {
            var a = n.prefix && n.iconName && n.icon ? {
              0: n
            } : n;
            return Object.keys(a).map(function (i) {
              var o = a[i],
                l = o.prefix,
                u = o.iconName,
                h = o.icon;
              r[l] || (r[l] = {}), r[l][u] = h;
            }), r;
          }
        }]), e;
      }();
      function _i() {
        Me.autoAddCss && !ro && (tc(os()), ro = !0);
      }
      function to(e, t) {
        return Object.defineProperty(e, "abstract", {
          get: t
        }), Object.defineProperty(e, "html", {
          get: function get() {
            return e.abstract.map(function (n) {
              return Ca(n);
            });
          }
        }), Object.defineProperty(e, "node", {
          get: function get() {
            if (!!ln) {
              var n = kt.createElement("div");
              return n.innerHTML = e.html, n.children;
            }
          }
        }), e;
      }
      function ss(e) {
        var t = e.prefix,
          r = t === void 0 ? "fa" : t,
          n = e.iconName;
        if (!!n) return gc(Sc.definitions, r, n) || gc(Tr.styles, r, n);
      }
      function up(e) {
        return function (t) {
          var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            n = (t || {}).icon ? t : ss(t || {}),
            a = r.mask;
          return a && (a = (a || {}).icon ? a : ss(a || {})), e(n, je({}, r, {
            mask: a
          }));
        };
      }
      var Sc = new cp(),
        fp = function fp() {
          Me.autoReplaceSvg = !1, Me.observeMutations = !1, Hh();
        },
        ro = !1,
        dp = {
          i2svg: function i2svg() {
            var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            if (ln) {
              _i();
              var r = t.node,
                n = r === void 0 ? kt : r,
                a = t.callback,
                i = a === void 0 ? function () {} : a;
              return Me.searchPseudoElements && kc(n), Oc(n, i);
            } else return kr.reject("Operation requires a DOM of some kind.");
          },
          css: os,
          insertCss: function insertCss() {
            ro || (tc(os()), ro = !0);
          },
          watch: function watch() {
            var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              r = t.autoReplaceSvgRoot,
              n = t.observeMutationsRoot;
            Me.autoReplaceSvg === !1 && (Me.autoReplaceSvg = !0), Me.observeMutations = !0, hh(function () {
              vp({
                autoReplaceSvgRoot: r
              }), $h({
                treeCallback: Oc,
                nodeCallback: ip,
                pseudoElementsCallback: kc,
                observeMutationsRoot: n
              });
            });
          }
        },
        no = {
          transform: function transform(t) {
            return _c(t);
          }
        },
        Cc = up(function (e) {
          var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            r = t.transform,
            n = r === void 0 ? fn : r,
            a = t.symbol,
            i = a === void 0 ? !1 : a,
            o = t.mask,
            l = o === void 0 ? null : o,
            u = t.maskId,
            h = u === void 0 ? null : u,
            g = t.title,
            y = g === void 0 ? null : g,
            C = t.titleId,
            H = C === void 0 ? null : C,
            z = t.classes,
            F = z === void 0 ? [] : z,
            R = t.attributes,
            D = R === void 0 ? {} : R,
            re = t.styles,
            oe = re === void 0 ? {} : re;
          if (!!e) {
            var we = e.prefix,
              ve = e.iconName,
              Pe = e.icon;
            return to(je({
              type: "icon"
            }, e), function () {
              return _i(), Me.autoA11y && (y ? D["aria-labelledby"] = "".concat(Me.replacementClass, "-title-").concat(H || bi()) : (D["aria-hidden"] = "true", D.focusable = "false")), Xo({
                icons: {
                  main: as(Pe),
                  mask: l ? as(l.icon) : {
                    found: !1,
                    width: null,
                    height: null,
                    icon: {}
                  }
                },
                prefix: we,
                iconName: ve,
                transform: je({}, fn, n),
                symbol: i,
                title: y,
                maskId: h,
                titleId: H,
                extra: {
                  attributes: D,
                  styles: oe,
                  classes: F
                }
              });
            });
          }
        }),
        hp = function hp(t) {
          var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            n = r.transform,
            a = n === void 0 ? fn : n,
            i = r.title,
            o = i === void 0 ? null : i,
            l = r.classes,
            u = l === void 0 ? [] : l,
            h = r.attributes,
            g = h === void 0 ? {} : h,
            y = r.styles,
            C = y === void 0 ? {} : y;
          return to({
            type: "text",
            content: t
          }, function () {
            return _i(), ic({
              content: t,
              transform: je({}, fn, a),
              title: o,
              extra: {
                attributes: g,
                styles: C,
                classes: ["".concat(Me.familyPrefix, "-layers-text")].concat(jo(u))
              }
            });
          });
        },
        pp = function pp(t) {
          var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            n = r.title,
            a = n === void 0 ? null : n,
            i = r.classes,
            o = i === void 0 ? [] : i,
            l = r.attributes,
            u = l === void 0 ? {} : l,
            h = r.styles,
            g = h === void 0 ? {} : h;
          return to({
            type: "counter",
            content: t
          }, function () {
            return _i(), Ph({
              content: t.toString(),
              title: a,
              extra: {
                attributes: u,
                styles: g,
                classes: ["".concat(Me.familyPrefix, "-layers-counter")].concat(jo(o))
              }
            });
          });
        },
        mp = function mp(t) {
          var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
            n = r.classes,
            a = n === void 0 ? [] : n;
          return to({
            type: "layer"
          }, function () {
            _i();
            var i = [];
            return t(function (o) {
              Array.isArray(o) ? o.map(function (l) {
                i = i.concat(l.abstract);
              }) : i = i.concat(o.abstract);
            }), [{
              tag: "span",
              attributes: {
                class: ["".concat(Me.familyPrefix, "-layers")].concat(jo(a)).join(" ")
              },
              children: i
            }];
          });
        },
        gp = {
          noAuto: fp,
          config: Me,
          dom: dp,
          library: Sc,
          parse: no,
          findIconDefinition: ss,
          icon: Cc,
          text: hp,
          counter: pp,
          layer: mp,
          toHtml: Ca
        },
        vp = function vp() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
            r = t.autoReplaceSvgRoot,
            n = r === void 0 ? kt : r;
          (Object.keys(Tr.styles).length > 0 || Me.autoFetchSvg) && ln && Me.autoReplaceSvg && gp.dom.i2svg({
            node: n
          });
        },
        bp = pe(980),
        j = pe.n(bp);
      function Mc(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (a) {
            return Object.getOwnPropertyDescriptor(e, a).enumerable;
          })), r.push.apply(r, n);
        }
        return r;
      }
      function Bn(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t] != null ? arguments[t] : {};
          t % 2 ? Mc(Object(r), !0).forEach(function (n) {
            Ma(e, n, r[n]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mc(Object(r)).forEach(function (n) {
            Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
          });
        }
        return e;
      }
      function ao(e) {
        return ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
          return typeof t;
        } : function (t) {
          return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, ao(e);
      }
      function Ma(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r, e;
      }
      function yp(e, t) {
        if (e == null) return {};
        var r = {},
          n = Object.keys(e),
          a,
          i;
        for (i = 0; i < n.length; i++) {
          a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
        }
        return r;
      }
      function Nc(e, t) {
        if (e == null) return {};
        var r = yp(e, t),
          n,
          a;
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          for (a = 0; a < i.length; a++) {
            n = i[a], !(t.indexOf(n) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, n) || (r[n] = e[n]));
          }
        }
        return r;
      }
      function ls(e) {
        return wp(e) || _p(e) || xp(e) || Ep();
      }
      function wp(e) {
        if (Array.isArray(e)) return cs(e);
      }
      function _p(e) {
        if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
      }
      function xp(e, t) {
        if (!!e) {
          if (typeof e == "string") return cs(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
          if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cs(e, t);
        }
      }
      function cs(e, t) {
        (t == null || t > e.length) && (t = e.length);
        for (var r = 0, n = new Array(t); r < t; r++) {
          n[r] = e[r];
        }
        return n;
      }
      function Ep() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function Op(e) {
        var t,
          r = e.beat,
          n = e.fade,
          a = e.flash,
          i = e.spin,
          o = e.spinPulse,
          l = e.spinReverse,
          u = e.pulse,
          h = e.fixedWidth,
          g = e.inverse,
          y = e.border,
          C = e.listItem,
          H = e.flip,
          z = e.size,
          F = e.rotation,
          R = e.pull,
          D = (t = {
            "fa-beat": r,
            "fa-fade": n,
            "fa-flash": a,
            "fa-spin": i,
            "fa-spin-reverse": l,
            "fa-spin-pulse": o,
            "fa-pulse": u,
            "fa-fw": h,
            "fa-inverse": g,
            "fa-border": y,
            "fa-li": C,
            "fa-flip-horizontal": H === "horizontal" || H === "both",
            "fa-flip-vertical": H === "vertical" || H === "both"
          }, Ma(t, "fa-".concat(z), typeof z != "undefined" && z !== null), Ma(t, "fa-rotate-".concat(F), typeof F != "undefined" && F !== null && F !== 0), Ma(t, "fa-pull-".concat(R), typeof R != "undefined" && R !== null), Ma(t, "fa-swap-opacity", e.swapOpacity), t);
        return Object.keys(D).map(function (re) {
          return D[re] ? re : null;
        }).filter(function (re) {
          return re;
        });
      }
      function Tp(e) {
        return e = e - 0, e === e;
      }
      function Pc(e) {
        return Tp(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (t, r) {
          return r ? r.toUpperCase() : "";
        }), e.substr(0, 1).toLowerCase() + e.substr(1));
      }
      var kp = ["style"];
      function Sp(e) {
        return e.charAt(0).toUpperCase() + e.slice(1);
      }
      function Cp(e) {
        return e.split(";").map(function (t) {
          return t.trim();
        }).filter(function (t) {
          return t;
        }).reduce(function (t, r) {
          var n = r.indexOf(":"),
            a = Pc(r.slice(0, n)),
            i = r.slice(n + 1).trim();
          return a.startsWith("webkit") ? t[Sp(a)] = i : t[a] = i, t;
        }, {});
      }
      function Rc(e, t) {
        var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (typeof t == "string") return t;
        var n = (t.children || []).map(function (u) {
            return Rc(e, u);
          }),
          a = Object.keys(t.attributes || {}).reduce(function (u, h) {
            var g = t.attributes[h];
            switch (h) {
              case "class":
                u.attrs.className = g, delete t.attributes.class;
                break;
              case "style":
                u.attrs.style = Cp(g);
                break;
              default:
                h.indexOf("aria-") === 0 || h.indexOf("data-") === 0 ? u.attrs[h.toLowerCase()] = g : u.attrs[Pc(h)] = g;
            }
            return u;
          }, {
            attrs: {}
          }),
          i = r.style,
          o = i === void 0 ? {} : i,
          l = Nc(r, kp);
        return a.attrs.style = Bn(Bn({}, a.attrs.style), o), e.apply(void 0, [t.tag, Bn(Bn({}, a.attrs), l)].concat(ls(n)));
      }
      var Ic = !1;
      try {
        Ic = !0;
      } catch (e) {}
      function Mp() {
        if (!Ic && console && typeof console.error == "function") {
          var e;
          (e = console).error.apply(e, arguments);
        }
      }
      function Ac(e) {
        if (e && ao(e) === "object" && e.prefix && e.iconName && e.icon) return e;
        if (no.icon) return no.icon(e);
        if (e === null) return null;
        if (e && ao(e) === "object" && e.prefix && e.iconName) return e;
        if (Array.isArray(e) && e.length === 2) return {
          prefix: e[0],
          iconName: e[1]
        };
        if (typeof e == "string") return {
          prefix: "fas",
          iconName: e
        };
      }
      function us(e, t) {
        return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? Ma({}, e, t) : {};
      }
      var Np = ["forwardedRef"];
      function Hr(e) {
        var t = e.forwardedRef,
          r = Nc(e, Np),
          n = r.icon,
          a = r.mask,
          i = r.symbol,
          o = r.className,
          l = r.title,
          u = r.titleId,
          h = Ac(n),
          g = us("classes", [].concat(ls(Op(r)), ls(o.split(" ")))),
          y = us("transform", typeof r.transform == "string" ? no.transform(r.transform) : r.transform),
          C = us("mask", Ac(a)),
          H = Cc(h, Bn(Bn(Bn(Bn({}, g), y), C), {}, {
            symbol: i,
            title: l,
            titleId: u
          }));
        if (!H) return Mp("Could not find icon", h), null;
        var z = H.abstract,
          F = {
            ref: t
          };
        return Object.keys(r).forEach(function (R) {
          Hr.defaultProps.hasOwnProperty(R) || (F[R] = r[R]);
        }), Pp(z[0], F);
      }
      Hr.displayName = "FontAwesomeIcon", Hr.propTypes = {
        beat: j().bool,
        border: j().bool,
        className: j().string,
        fade: j().bool,
        flash: j().bool,
        mask: j().oneOfType([j().object, j().array, j().string]),
        fixedWidth: j().bool,
        inverse: j().bool,
        flip: j().oneOf(["horizontal", "vertical", "both"]),
        icon: j().oneOfType([j().object, j().array, j().string]),
        listItem: j().bool,
        pull: j().oneOf(["right", "left"]),
        pulse: j().bool,
        rotation: j().oneOf([0, 90, 180, 270]),
        size: j().oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
        spin: j().bool,
        spinPulse: j().bool,
        spinReverse: j().bool,
        symbol: j().oneOfType([j().bool, j().string]),
        title: j().string,
        transform: j().oneOfType([j().string, j().object]),
        swapOpacity: j().bool
      }, Hr.defaultProps = {
        border: !1,
        className: "",
        mask: null,
        fixedWidth: !1,
        inverse: !1,
        flip: null,
        icon: null,
        listItem: !1,
        pull: null,
        pulse: !1,
        rotation: null,
        size: null,
        spin: !1,
        symbol: !1,
        title: "",
        transform: null,
        swapOpacity: !1
      };
      var Pp = Rc.bind(null, c().createElement),
        Rp = pe(247),
        Ip = pe(682),
        Ap = pe(438),
        Dc = pe(42),
        Lc = pe(111),
        Dp = pe.n(Lc);
      var Lp = "rc-menu-container",
        Sr = "rc-menu",
        Fp = "rc-menu-button",
        jp = "arrow",
        fs = "item",
        Bp = "divider",
        zp = "header",
        $p = "group",
        Hp = "submenu",
        Up = "radio-group",
        xi = -1,
        ds = c().createContext({}),
        hs = c().createContext({}),
        ps = c().createContext({}),
        Fc = c().createContext({}),
        jc = c().createContext({}),
        ms = c().createContext({}),
        Mt = Object.freeze({
          ENTER: "Enter",
          ESC: "Escape",
          SPACE: " ",
          HOME: "Home",
          END: "End",
          LEFT: "ArrowLeft",
          RIGHT: "ArrowRight",
          UP: "ArrowUp",
          DOWN: "ArrowDown"
        }),
        _t = Object.freeze({
          RESET: "HOVER_INDEX_RESET",
          SET: "HOVER_INDEX_SET",
          UNSET: "HOVER_INDEX_UNSET",
          INCREASE: "HOVER_INDEX_INCREASE",
          DECREASE: "HOVER_INDEX_DECREASE",
          FIRST: "HOVER_INDEX_FIRST",
          LAST: "HOVER_INDEX_LAST"
        }),
        io = Object.freeze({
          OPEN: "SUBMENU_OPEN",
          CLOSE: "SUBMENU_CLOSE"
        }),
        Ei = Object.freeze({
          CLICK: "click",
          CANCEL: "cancel",
          BLUR: "blur",
          SCROLL: "scroll"
        }),
        Bc = Lc.unstable_batchedUpdates || function (e) {
          return e();
        },
        Cr = function Cr(e, t) {
          return t ? Object.defineProperty(e, "_reactMenu", {
            value: t,
            writable: !1
          }) : e;
        },
        Oi = function Oi(e) {
          return e && e._reactMenu;
        },
        Mv = function Mv(e) {
          return function () {
            return Cr(e.apply(void 0, arguments), Oi(arguments.length <= 0 ? undefined : arguments[0]));
          };
        },
        Nv = function Nv(e) {
          return function (t) {
            return Cr(t, Oi(e));
          };
        },
        ar = function ar(e) {
          for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            t[_key4 - 1] = arguments[_key4];
          }
          return typeof e == "function" ? e.apply(void 0, t) : e;
        },
        oo = function oo(e, t) {
          var r = {};
          var _loop3 = function _loop3() {
            var n = _Object$keys[_i5];
            var a = e[n],
              i = t[n];
            var o = void 0;
            typeof i == "function" ? o = function o(l) {
              i(l), a(l);
            } : o = a, r[n] = o;
          };
          for (var _i5 = 0, _Object$keys = Object.keys(e); _i5 < _Object$keys.length; _i5++) {
            _loop3();
          }
          return r;
        },
        Zp = function Zp(e) {
          if (typeof e != "string") return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          };
          var t = e.trim().split(/\s+/, 4).map(parseFloat),
            r = isNaN(t[0]) ? 0 : t[0],
            n = isNaN(t[1]) ? r : t[1];
          return {
            top: r,
            right: n,
            bottom: isNaN(t[2]) ? r : t[2],
            left: isNaN(t[3]) ? n : t[3]
          };
        },
        gr = function gr(_ref7) {
          var e = _ref7.block,
            t = _ref7.element,
            r = _ref7.modifiers,
            n = _ref7.className,
            a = _ref7.externalModifiers;
          return (0, _.useMemo)(function () {
            var i = t ? "".concat(e, "__").concat(t) : e;
            var o = i;
            for (var _i6 = 0, _Object$keys2 = Object.keys(r || {}); _i6 < _Object$keys2.length; _i6++) {
              var u = _Object$keys2[_i6];
              var h = r[u];
              h && (o += " ".concat(i, "--"), o += h === !0 ? u : "".concat(u, "-").concat(h));
            }
            var l = typeof n == "function" ? n(a || r) : n;
            return typeof l == "string" && (l = l.trim(), l && (o += " ".concat(l))), o;
          }, [e, t, r, n, a]);
        },
        gs = function gs(e) {
          return e && typeof e == "object";
        },
        zc = function zc(e) {
          return e.charAt(0) === "$" ? e.slice(1) : e;
        },
        Ur = function Ur(e, t) {
          return (0, _.useMemo)(function () {
            if (typeof e == "function") return e(t);
            if (!gs(e)) return;
            if (!t) return e;
            var r = {};
            for (var _i7 = 0, _Object$keys3 = Object.keys(e); _i7 < _Object$keys3.length; _i7++) {
              var n = _Object$keys3[_i7];
              var a = e[n];
              if (gs(a)) {
                var i = t[zc(n)];
                if (typeof i == "string") for (var _i8 = 0, _Object$keys4 = Object.keys(a); _i8 < _Object$keys4.length; _i8++) {
                  var o = _Object$keys4[_i8];
                  var l = a[o];
                  gs(l) ? zc(o) === i && Object.assign(r, l) : r[o] = l;
                } else i && Object.assign(r, a);
              } else r[n] = a;
            }
            return r;
          }, [e, t]);
        },
        $c = function $c(e) {
          for (; e && e !== document.body;) {
            var _getComputedStyle = getComputedStyle(e),
              t = _getComputedStyle.overflow,
              r = _getComputedStyle.overflowX,
              n = _getComputedStyle.overflowY;
            if (/auto|scroll|overlay|hidden/.test(t + n + r)) return e;
            e = e.parentNode;
          }
          return window;
        },
        Na = function Na(e, t) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e-4;
          return Math.abs(e - t) < r;
        },
        vs = !0,
        Hc = function Hc(e, t, r) {
          return t ? r.includes(Oi(t.type)) ? !0 : (!vs && console.warn("[react-menu] ".concat(t.type || t, " is ignored.\n"), "The permitted children inside a ".concat(e, " are ").concat(r.join(", "), "."), "If you create HOC of these components, you can use the applyHOC or applyStatics helper, see more at: https://szhsin.github.io/react-menu/docs#utils-apply-hoc"), !1) : !1;
        },
        Uc = function Uc(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var r = t,
            n = !1;
          var a = ["MenuDivider", "MenuGroup", "MenuHeader", "MenuItem", "FocusableItem", "MenuRadioGroup", "SubMenu"];
          return {
            items: c().Children.map(e, function (o) {
              if (!Hc("Menu or SubMenu", o, a)) return null;
              switch (Oi(o.type)) {
                case "MenuDivider":
                case "MenuHeader":
                  return o;
                case "MenuRadioGroup":
                  {
                    var l = ["MenuItem"],
                      u = {
                        type: "radio"
                      },
                      h = c().Children.map(o.props.children, function (g) {
                        return Hc("MenuRadioGroup", g, l) ? g.props.disabled ? c().cloneElement(g, u) : c().cloneElement(g, ue(L({}, u), {
                          index: r++
                        })) : null;
                      });
                    return c().cloneElement(o, {
                      children: h
                    });
                  }
                case "MenuGroup":
                  {
                    var _Uc = Uc(o.props.children, r),
                      _l6 = _Uc.items,
                      _u4 = _Uc.endIndex,
                      _h6 = _Uc.descendOverflow;
                    r = _u4;
                    var g = Boolean(o.props.takeOverflow);
                    if (!vs && (n === _h6 ? _h6 : g)) throw new Error("[react-menu] Only one MenuGroup in a menu is allowed to have takeOverflow prop.");
                    return n = n || _h6 || g, c().cloneElement(o, {
                      children: _l6
                    });
                  }
                default:
                  return o.props.disabled ? o : c().cloneElement(o, {
                    index: r++
                  });
              }
            }),
            endIndex: r,
            descendOverflow: n
          };
        },
        Zr = function Zr(e) {
          var _ref8;
          return _ref8 = {}, _defineProperty(_ref8, e ? "".concat(e, "ClassName") : "className", j().oneOfType([j().string, j().func])), _defineProperty(_ref8, e ? "".concat(e, "Styles") : "styles", j().oneOfType([j().object, j().func])), _ref8;
        },
        Zc = ue(L(L({}, Zr()), Zr("arrow")), {
          "aria-label": j().string,
          arrow: j().bool,
          offsetX: j().number,
          offsetY: j().number,
          align: j().oneOf(["start", "center", "end"]),
          direction: j().oneOf(["left", "right", "top", "bottom"]),
          position: j().oneOf(["auto", "anchor", "initial"]),
          overflow: j().oneOf(["auto", "visible", "hidden"]),
          children: j().node.isRequired
        }),
        Vc = ue(L({}, Zc), {
          id: j().oneOfType([j().string, j().number]),
          animation: j().bool,
          debugging: j().bool,
          boundingBoxRef: j().object,
          boundingBoxPadding: j().string,
          reposition: j().oneOf(["auto", "initial"]),
          repositionFlag: j().oneOfType([j().string, j().number]),
          viewScroll: j().oneOf(["auto", "close", "initial"]),
          submenuOpenDelay: j().number,
          submenuCloseDelay: j().number,
          portal: j().bool,
          theming: j().string,
          onItemClick: j().func,
          onClick: j().func
        }),
        Gc = {
          offsetX: 0,
          offsetY: 0,
          align: "start",
          direction: "bottom",
          position: "auto",
          overflow: "visible"
        },
        Wc = ue(L({}, Gc), {
          animation: !0,
          reposition: "auto",
          viewScroll: "initial",
          submenuOpenDelay: 300,
          submenuCloseDelay: 150
        }),
        Jc = function Jc(e, t, r) {
          var _ref9 = (0, _.useState)(!1),
            _ref10 = _slicedToArray(_ref9, 2),
            n = _ref10[0],
            a = _ref10[1],
            i = (0, _.useMemo)(function () {
              return [Mt.SPACE, Mt.ENTER].concat(_toConsumableArray(r ? [r] : []));
            }, [r]),
            o = (0, _.useCallback)(function () {
              return a(!1);
            }, []);
          return {
            isActive: n,
            onPointerDown: (0, _.useCallback)(function () {
              t || a(!0);
            }, [t]),
            onPointerUp: o,
            onPointerLeave: o,
            onKeyDown: (0, _.useCallback)(function (l) {
              e && !t && i.includes(l.key) && a(!0);
            }, [e, t, i]),
            onKeyUp: (0, _.useCallback)(function (l) {
              i.includes(l.key) && a(!1);
            }, [i]),
            onBlur: (0, _.useCallback)(function (l) {
              l.currentTarget.contains(l.relatedTarget) || a(!1);
            }, [])
          };
        },
        Xc = function Xc(e, t) {
          var r = (0, _.useRef)(null),
            _ref11 = (0, _.useContext)(ms),
            n = _ref11.submenuCloseDelay,
            _ref12 = (0, _.useContext)(ds),
            a = _ref12.isParentOpen,
            i = _ref12.hoverIndex,
            o = _ref12.isSubmenuOpen,
            l = _ref12.dispatch,
            u = i === t,
            h = (0, _.useRef)(),
            g = (0, _.useCallback)(function () {
              e || l({
                type: _t.SET,
                index: t
              });
            }, [e, l, t]),
            y = (0, _.useCallback)(function (z) {
              z.currentTarget.contains(z.relatedTarget) || l({
                type: _t.UNSET,
                index: t
              });
            }, [l, t]),
            C = (0, _.useCallback)(function () {
              o ? h.current = setTimeout(g, n) : g();
            }, [o, n, g]),
            H = (0, _.useCallback)(function (z, F) {
              h.current && clearTimeout(h.current), F || l({
                type: _t.UNSET,
                index: t
              });
            }, [l, t]);
          return (0, _.useEffect)(function () {
            return function () {
              return clearTimeout(h.current);
            };
          }, []), (0, _.useEffect)(function () {
            u && a && r.current && r.current.focus();
          }, [u, a]), {
            ref: r,
            isHovering: u,
            setHover: g,
            onBlur: y,
            onMouseEnter: C,
            onMouseLeave: H
          };
        },
        qc = function qc(e, t) {
          var r = (0, _.useRef)(t);
          (0, _.useEffect)(function () {
            r.current !== t && ar(e, {
              open: t
            }), r.current = t;
          }, [e, t]);
        },
        Mr = Object.freeze({
          INITIAL: "initial",
          FIRST: "first",
          LAST: "last"
        }),
        Nr = Object.freeze({
          UNMOUNTED: 0,
          CLOSED: 1,
          OPEN: 2
        }),
        Pa = Object.freeze({
          OPEN: 0,
          CLOSE: 1,
          TOGGLE: 2
        }),
        bs = function bs() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
          var _ref13 = (0, _.useState)({
              position: Mr.INITIAL
            }),
            _ref14 = _slicedToArray(_ref13, 2),
            t = _ref14[0],
            r = _ref14[1],
            _ref15 = (0, _.useReducer)(i, Nr.UNMOUNTED),
            _ref16 = _slicedToArray(_ref15, 2),
            n = _ref16[0],
            a = _ref16[1];
          function i(o, _ref17) {
            var l = _ref17.type;
            switch (l) {
              case Pa.OPEN:
                return Nr.OPEN;
              case Pa.CLOSE:
                return o === Nr.OPEN ? e ? Nr.CLOSED : Nr.UNMOUNTED : o;
              case Pa.TOGGLE:
                return o === Nr.OPEN ? e ? Nr.CLOSED : Nr.UNMOUNTED : Nr.OPEN;
              default:
                throw new Error("menuStateReducer: unknown action type");
            }
          }
          return {
            isMounted: n !== Nr.UNMOUNTED,
            isOpen: n === Nr.OPEN,
            menuItemFocus: t,
            openMenu: (0, _.useCallback)(function () {
              var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Mr.INITIAL;
              r({
                position: o
              }), a({
                type: Pa.OPEN
              });
            }, []),
            closeMenu: (0, _.useCallback)(function () {
              return a({
                type: Pa.CLOSE
              });
            }, []),
            toggleMenu: (0, _.useCallback)(function () {
              var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Mr.INITIAL;
              r({
                position: o
              }), a({
                type: Pa.TOGGLE
              });
            }, [])
          };
        },
        Ti = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? _.useLayoutEffect : _.useEffect,
        Kc = Cr(c().memo(c().forwardRef(function (u, l) {
          var h = u,
            t = h.className,
            r = h.styles,
            n = h.isOpen,
            a = h.disabled,
            i = h.children,
            o = Bt(h, ["className", "styles", "isOpen", "disabled", "children"]);
          var g = (0, _.useMemo)(function () {
            return Object.freeze({
              open: n
            });
          }, [n]);
          return c().createElement("button", Object.assign({
            "aria-haspopup": "true",
            "aria-expanded": n,
            "aria-disabled": a || void 0,
            disabled: a
          }, o, {
            ref: l,
            className: gr({
              block: Fp,
              modifiers: g,
              className: t
            }),
            style: Ur(r, g)
          }), i);
        })), "MenuButton");
      Kc.propTypes = ue(L({}, Zr()), {
        isOpen: j().bool,
        disabled: j().bool,
        children: j().node.isRequired,
        onClick: j().func,
        onKeyDown: j().func
      });
      var Yc = Cr(c().memo(function (ie) {
        var de = ie,
          t = de.ariaLabel,
          r = de.className,
          n = de.styles,
          a = de.arrowClassName,
          i = de.arrowStyles,
          o = de.anchorPoint,
          l = de.anchorRef,
          u = de.containerRef,
          h = de.arrow,
          g = de.align,
          y = de.direction,
          C = de.position,
          H = de.overflow,
          z = de.repositionFlag,
          _de$captureFocus = de.captureFocus,
          F = _de$captureFocus === void 0 ? !0 : _de$captureFocus,
          R = de.isOpen,
          D = de.isDisabled,
          re = de.menuItemFocus,
          oe = de.offsetX,
          we = de.offsetY,
          ve = de.children,
          Pe = de.onClose,
          U = Bt(de, ["ariaLabel", "className", "styles", "arrowClassName", "arrowStyles", "anchorPoint", "anchorRef", "containerRef", "arrow", "align", "direction", "position", "overflow", "repositionFlag", "captureFocus", "isOpen", "isDisabled", "menuItemFocus", "offsetX", "offsetY", "children", "onClose"]);
        var _ref18 = (0, _.useState)({
            x: 0,
            y: 0
          }),
          _ref19 = _slicedToArray(_ref18, 2),
          ye = _ref19[0],
          ne = _ref19[1],
          _ref20 = (0, _.useState)({}),
          _ref21 = _slicedToArray(_ref20, 2),
          Ne = _ref21[0],
          ge = _ref21[1],
          _ref22 = (0, _.useState)(),
          _ref23 = _slicedToArray(_ref22, 2),
          Je = _ref23[0],
          pt = _ref23[1],
          _ref24 = (0, _.useState)(!1),
          _ref25 = _slicedToArray(_ref24, 2),
          Ye = _ref25[0],
          rt = _ref25[1],
          _ref26 = (0, _.useState)(y),
          _ref27 = _slicedToArray(_ref26, 2),
          Ie = _ref27[0],
          Oe = _ref27[1],
          _ref28 = (0, _.useContext)(jc),
          at = _ref28.animation,
          xt = _ref28.boundingBoxRef,
          ir = _ref28.boundingBoxPadding,
          St = _ref28.rootMenuRef,
          or = _ref28.rootAnchorRef,
          Et = _ref28.scrollingRef,
          Nt = _ref28.anchorScrollingRef,
          Pr = _ref28.reposition,
          Ot = _ref28.viewScroll,
          jt = (0, _.useRef)(null),
          Ni = (0, _.useRef)(null),
          Fa = (0, _.useRef)(0),
          As = (0, _.useRef)(R),
          vo = (0, _.useRef)({
            width: 0,
            height: 0
          }),
          ef = (0, _.useRef)(function () {}),
          Ds = (0, _.useRef)(!1),
          Yg = (0, _.useContext)(hs).reposSubmenu || z,
          _ref29 = (0, _.useReducer)(function (he) {
            return he + 1;
          }, 1),
          _ref30 = _slicedToArray(_ref29, 2),
          tf = _ref30[0],
          rf = _ref30[1],
          _ref31 = (0, _.useReducer)(ev, {
            hoverIndex: xi,
            openSubmenuCount: 0
          }),
          _ref32 = _slicedToArray(_ref31, 2),
          _ref32$ = _ref32[0],
          nf = _ref32$.hoverIndex,
          Qg = _ref32$.openSubmenuCount,
          $n = _ref32[1];
        function ev(_ref33, Ce) {
          var he = _ref33.hoverIndex,
            _e = _ref33.openSubmenuCount;
          return {
            hoverIndex: tv(he, Ce),
            openSubmenuCount: Vp(_e, Ce)
          };
        }
        function tv(he, _ref34) {
          var _e = _ref34.type,
            Ce = _ref34.index;
          switch (_e) {
            case _t.RESET:
              return xi;
            case _t.SET:
              return Ce;
            case _t.UNSET:
              return he === Ce ? xi : he;
            case _t.DECREASE:
              {
                var be = he;
                return be--, be < 0 && (be = Fa.current - 1), be;
              }
            case _t.INCREASE:
              {
                var _be = he;
                return _be++, _be >= Fa.current && (_be = 0), _be;
              }
            case _t.FIRST:
              return Fa.current > 0 ? 0 : xi;
            case _t.LAST:
              return Fa.current > 0 ? Fa.current - 1 : xi;
            default:
              return he;
          }
        }
        var rv = (0, _.useMemo)(function () {
            var _Uc2 = Uc(ve),
              he = _Uc2.items,
              _e = _Uc2.endIndex,
              Ce = _Uc2.descendOverflow;
            return Fa.current = _e, Ds.current = Ce, he;
          }, [ve]),
          nv = function nv(he) {
            var _e = !1;
            switch (he.key) {
              case Mt.HOME:
                $n({
                  type: _t.FIRST
                }), _e = !0;
                break;
              case Mt.END:
                $n({
                  type: _t.LAST
                }), _e = !0;
                break;
              case Mt.UP:
                $n({
                  type: _t.DECREASE
                }), _e = !0;
                break;
              case Mt.DOWN:
                $n({
                  type: _t.INCREASE
                }), _e = !0;
                break;
              case Mt.SPACE:
                he.target && he.target.className.includes(Sr) && he.preventDefault();
                break;
            }
            _e && (he.preventDefault(), he.stopPropagation());
          },
          av = function av() {
            Ye && (rt(!1), pt());
          },
          af = (0, _.useCallback)(function () {
            var he = jt.current.getBoundingClientRect(),
              _e = u.current.getBoundingClientRect(),
              Ce = Et.current === window ? {
                left: 0,
                top: 0,
                right: document.documentElement.clientWidth,
                bottom: window.innerHeight
              } : Et.current.getBoundingClientRect(),
              be = Zp(ir),
              $e = function $e(Te) {
                return Te + _e.left - Ce.left - be.left;
              },
              Ve = function Ve(Te) {
                return Te + _e.left + he.width - Ce.right + be.right;
              },
              Qe = function Qe(Te) {
                return Te + _e.top - Ce.top - be.top;
              },
              Xe = function Xe(Te) {
                return Te + _e.top + he.height - Ce.bottom + be.bottom;
              };
            return {
              menuRect: he,
              containerRect: _e,
              getLeftOverflow: $e,
              getRightOverflow: Ve,
              getTopOverflow: Qe,
              getBottomOverflow: Xe,
              confineHorizontally: function confineHorizontally(Te) {
                var xe = $e(Te);
                if (xe < 0) Te -= xe;else {
                  var De = Ve(Te);
                  De > 0 && (Te -= De, xe = $e(Te), xe < 0 && (Te -= xe));
                }
                return Te;
              },
              confineVertically: function confineVertically(Te) {
                var xe = Qe(Te);
                if (xe < 0) Te -= xe;else {
                  var De = Xe(Te);
                  De > 0 && (Te -= De, xe = Qe(Te), xe < 0 && (Te -= xe));
                }
                return Te;
              }
            };
          }, [u, Et, ir]),
          of = (0, _.useCallback)(function (he, _e, Ce, be) {
            var $e = _e.left - Ce.left - he + _e.width / 2;
            var Ve = Ni.current.offsetWidth * 1.25;
            return $e = Math.max(Ve, $e), $e = Math.min($e, be.width - Ve), $e;
          }, []),
          sf = (0, _.useCallback)(function (he, _e, Ce, be) {
            var $e = _e.top - Ce.top - he + _e.height / 2;
            var Ve = Ni.current.offsetHeight * 1.25;
            return $e = Math.max(Ve, $e), $e = Math.min($e, be.height - Ve), $e;
          }, []),
          lf = (0, _.useCallback)(function (_ref35, _ref36, _ref37) {
            var he = _ref35.anchorRect,
              _e = _ref35.containerRect,
              Ce = _ref35.menuRect;
            var be = _ref36.placeLeftorRightY,
              $e = _ref36.placeLeftX,
              Ve = _ref36.placeRightX;
            var Qe = _ref37.getLeftOverflow,
              Xe = _ref37.getRightOverflow,
              It = _ref37.confineHorizontally,
              Wr = _ref37.confineVertically;
            var Te = y,
              xe = be;
            C !== "initial" && (xe = Wr(xe), C === "anchor" && (xe = Math.min(xe, he.bottom - _e.top), xe = Math.max(xe, he.top - _e.top - Ce.height)));
            var De, ut, mt;
            return Te === "left" ? (De = $e, C !== "initial" && (ut = Qe(De), ut < 0 && (mt = Xe(Ve), (mt <= 0 || -ut > mt) && (De = Ve, Te = "right")))) : (De = Ve, C !== "initial" && (mt = Xe(De), mt > 0 && (ut = Qe($e), (ut >= 0 || -ut < mt) && (De = $e, Te = "left")))), C === "auto" && (De = It(De)), {
              arrowY: h ? sf(xe, he, _e, Ce) : void 0,
              x: De,
              y: xe,
              computedDirection: Te
            };
          }, [sf, h, y, C]),
          cf = (0, _.useCallback)(function (_ref38, _ref39, _ref40) {
            var he = _ref38.anchorRect,
              _e = _ref38.containerRect,
              Ce = _ref38.menuRect;
            var be = _ref39.placeToporBottomX,
              $e = _ref39.placeTopY,
              Ve = _ref39.placeBottomY;
            var Qe = _ref40.getTopOverflow,
              Xe = _ref40.getBottomOverflow,
              It = _ref40.confineHorizontally,
              Wr = _ref40.confineVertically;
            var Te = y === "top" ? "top" : "bottom",
              xe = be;
            C !== "initial" && (xe = It(xe), C === "anchor" && (xe = Math.min(xe, he.right - _e.left), xe = Math.max(xe, he.left - _e.left - Ce.width)));
            var De, ut, mt;
            return Te === "top" ? (De = $e, C !== "initial" && (ut = Qe(De), ut < 0 && (mt = Xe(Ve), (mt <= 0 || -ut > mt) && (De = Ve, Te = "bottom")))) : (De = Ve, C !== "initial" && (mt = Xe(De), mt > 0 && (ut = Qe($e), (ut >= 0 || -ut < mt) && (De = $e, Te = "top")))), C === "auto" && (De = Wr(De)), {
              arrowX: h ? of(xe, he, _e, Ce) : void 0,
              x: xe,
              y: De,
              computedDirection: Te
            };
          }, [of, h, y, C]),
          uf = (0, _.useCallback)(function (he, _e) {
            var Hn = he,
              Ce = Hn.menuRect,
              be = Hn.containerRect,
              $e = Bt(Hn, ["menuRect", "containerRect"]);
            var Ve = oe,
              Qe = we;
            h && (y === "left" || y === "right" ? Ve += Ni.current.offsetWidth : Qe += Ni.current.offsetHeight);
            var Xe = _e.current.getBoundingClientRect(),
              It = Xe.left - be.left - Ce.width - Ve,
              Wr = Xe.right - be.left + Ve,
              Te = Xe.top - be.top - Ce.height - Qe,
              xe = Xe.bottom - be.top + Qe;
            var De, ut;
            g === "end" ? (De = Xe.right - be.left - Ce.width, ut = Xe.bottom - be.top - Ce.height) : g === "center" ? (De = Xe.left - be.left - (Ce.width - Xe.width) / 2, ut = Xe.top - be.top - (Ce.height - Xe.height) / 2) : (De = Xe.left - be.left, ut = Xe.top - be.top), De += Ve, ut += Qe;
            var mt = {
                anchorRect: Xe,
                containerRect: be,
                menuRect: Ce
              },
              Dt = {
                placeLeftX: It,
                placeRightX: Wr,
                placeLeftorRightY: ut,
                placeTopY: Te,
                placeBottomY: xe,
                placeToporBottomX: De
              };
            switch (y) {
              case "left":
              case "right":
                return lf(mt, Dt, $e);
              case "top":
              case "bottom":
              default:
                return cf(mt, Dt, $e);
            }
          }, [h, g, y, oe, we, lf, cf]),
          ff = (0, _.useCallback)(function (he, _e) {
            var Ce = he.menuRect,
              be = he.containerRect,
              $e = he.getLeftOverflow,
              Ve = he.getRightOverflow,
              Qe = he.getTopOverflow,
              Xe = he.getBottomOverflow,
              It = he.confineHorizontally,
              Wr = he.confineVertically;
            var Te, xe;
            Te = _e.x - be.left, xe = _e.y - be.top;
            var De = Ve(Te);
            if (De > 0) {
              var Dt = Te - Ce.width,
                Hn = $e(Dt);
              (Hn >= 0 || -Hn < De) && (Te = Dt), Te = It(Te);
            }
            var ut = "bottom";
            var mt = Xe(xe);
            if (mt > 0) {
              var _Dt = xe - Ce.height,
                _Hn = Qe(_Dt);
              (_Hn >= 0 || -_Hn < mt) && (xe = _Dt, ut = "top"), xe = Wr(xe);
            }
            return {
              x: Te,
              y: xe,
              computedDirection: ut
            };
          }, []),
          Pi = (0, _.useCallback)(function () {
            if (!u.current) {
              if (!vs) throw new Error("[react-menu] Menu cannot be positioned properly as container ref is null. If you initialise isOpen prop to true for ControlledMenu, please see this link for a solution: https://github.com/szhsin/react-menu/issues/2#issuecomment-719166062");
              return;
            }
            Et.current || (Et.current = xt ? xt.current : $c(St.current));
            var he = af(),
              _e = he.menuRect;
            var Ce = {
              computedDirection: "bottom"
            };
            o ? Ce = ff(he, o) : l && (Ce = uf(he, l));
            var _Ce = Ce,
              be = _Ce.arrowX,
              $e = _Ce.arrowY,
              Ve = _Ce.x,
              Qe = _Ce.y,
              Xe = _Ce.computedDirection,
              It = _e.height;
            if (H !== "visible") {
              var Wr = he.getTopOverflow,
                Te = he.getBottomOverflow;
              var xe, De;
              var ut = vo.current.height,
                mt = Te(Qe);
              if (mt > 0 || Na(mt, 0) && Na(It, ut)) xe = It - mt, De = mt;else {
                var Dt = Wr(Qe);
                (Dt < 0 || Na(Dt, 0) && Na(It, ut)) && (xe = It + Dt, De = 0 - Dt, xe >= 0 && (Qe -= Dt));
              }
              xe >= 0 ? (It = xe, pt({
                height: xe,
                overflowAmt: De
              })) : pt();
            }
            h && ge({
              x: be,
              y: $e
            }), ne({
              x: Ve,
              y: Qe
            }), Oe(Xe), vo.current = {
              width: _e.width,
              height: It
            };
          }, [h, o, l, u, xt, St, Et, H, af, uf, ff]);
        Ti(function () {
          R && (Pi(), As.current && rf()), ef.current = Pi;
        }, [R, Pi, Yg]), Ti(function () {
          Je && !Ds.current && (jt.current.scrollTop = 0);
        }, [Je]), Ti(function () {
          at && (R ? rt(!1) : R !== As.current && rt(!0)), As.current = R;
        }, [at, R]), (0, _.useEffect)(function () {
          if (!R) return;
          !Nt.current && or && or.current.tagName && (Nt.current = $c(or.current));
          var he = Et.current,
            _e = he && he.addEventListener ? he : window,
            Ce = Nt.current || _e;
          var be = Ot;
          if (Ce !== _e && be === "initial" && (be = "auto"), be === "initial") return;
          be === "auto" && H !== "visible" && (be = "close");
          var $e = function $e() {
              be === "auto" ? Bc(Pi) : ar(Pe, {
                reason: Ei.SCROLL
              });
            },
            Ve = Ce !== _e && Ot !== "initial" ? [Ce, _e] : [Ce];
          return Ve.forEach(function (Qe) {
            return Qe.addEventListener("scroll", $e);
          }), function () {
            return Ve.forEach(function (Qe) {
              return Qe.removeEventListener("scroll", $e);
            });
          };
        }, [or, Nt, Et, R, H, Pe, Ot, Pi]), (0, _.useEffect)(function () {
          if (typeof ResizeObserver != "function" || Pr === "initial") return;
          var he = new ResizeObserver(function (_ref41) {
              var _ref42 = _slicedToArray(_ref41, 1),
                Ce = _ref42[0];
              var be = Ce.borderBoxSize,
                $e = Ce.target;
              var Ve, Qe;
              if (be) {
                var _ref43 = be[0] || be,
                  Xe = _ref43.inlineSize,
                  It = _ref43.blockSize;
                Ve = Xe, Qe = It;
              } else {
                var _Xe = $e.getBoundingClientRect();
                Ve = _Xe.width, Qe = _Xe.height;
              }
              Ve === 0 || Qe === 0 || Na(Ve, vo.current.width, 1) && Na(Qe, vo.current.height, 1) || Bc(function () {
                ef.current(), rf();
              });
            }),
            _e = jt.current;
          return he.observe(_e, {
            box: "border-box"
          }), function () {
            return he.unobserve(_e);
          };
        }, [Pr]), (0, _.useEffect)(function () {
          R || ($n({
            type: _t.RESET
          }), at || pt());
          var he = setTimeout(function () {
            !R || !jt.current || jt.current.contains(document.activeElement) || (F && jt.current.focus(), re.position === Mr.FIRST ? $n({
              type: _t.FIRST
            }) : re.position === Mr.LAST && $n({
              type: _t.LAST
            }));
          }, at ? 170 : 100);
          return function () {
            return clearTimeout(he);
          };
        }, [at, F, R, re]);
        var df = Qg > 0,
          iv = (0, _.useMemo)(function () {
            return {
              isParentOpen: R,
              hoverIndex: nf,
              isSubmenuOpen: df,
              dispatch: $n
            };
          }, [R, nf, df]);
        var Ls, Fs;
        Je && (Ds.current ? Fs = Je.overflowAmt : Ls = Je.height);
        var ov = (0, _.useMemo)(function () {
            return {
              reposSubmenu: tf,
              overflow: H,
              overflowAmt: Fs
            };
          }, [tf, H, Fs]),
          sv = Ls >= 0 ? {
            maxHeight: Ls,
            overflow: H
          } : void 0,
          js = (0, _.useMemo)(function () {
            return {
              open: R,
              closing: Ye,
              animation: at,
              dir: at && Ie
            };
          }, [R, Ye, at, Ie]),
          hf = (0, _.useMemo)(function () {
            return Object.freeze(ue(L({}, js), {
              dir: Ie
            }));
          }, [js, Ie]),
          pf = (0, _.useMemo)(function () {
            return Object.freeze({
              dir: Ie
            });
          }, [Ie]),
          lv = gr({
            block: Sr,
            element: jp,
            modifiers: pf,
            className: a
          }),
          cv = Ur(i, pf),
          uv = oo({
            onKeyDown: nv,
            onAnimationEnd: av
          }, U);
        return c().createElement("ul", Object.assign({
          role: "menu",
          tabIndex: "-1",
          "aria-disabled": D || void 0,
          "aria-label": t
        }, U, uv, {
          ref: jt,
          className: gr({
            block: Sr,
            modifiers: js,
            className: r,
            externalModifiers: hf
          }),
          style: ue(L(L({}, Ur(n, hf)), sv), {
            left: "".concat(ye.x, "px"),
            top: "".concat(ye.y, "px")
          })
        }), h && c().createElement("div", {
          className: lv,
          style: ue(L({}, cv), {
            left: Ne.x && "".concat(Ne.x, "px"),
            top: Ne.y && "".concat(Ne.y, "px")
          }),
          ref: Ni
        }), c().createElement(hs.Provider, {
          value: ov
        }, c().createElement(ds.Provider, {
          value: iv
        }, rv)));
      }), "MenuList");
      function Vp(e, _ref44) {
        var t = _ref44.type;
        switch (t) {
          case io.OPEN:
            return e + 1;
          case io.CLOSE:
            return Math.max(e - 1, 0);
          default:
            return e;
        }
      }
      var Qc = function Qc(e, _ref45) {
          var t = _ref45.id,
            r = _ref45.animation,
            n = _ref45.boundingBoxRef,
            a = _ref45.boundingBoxPadding,
            i = _ref45.debugging,
            o = _ref45.reposition,
            l = _ref45.submenuOpenDelay,
            u = _ref45.submenuCloseDelay,
            h = _ref45.viewScroll,
            g = _ref45.portal,
            y = _ref45.theming,
            C = _ref45.isMounted,
            H = _ref45.onItemClick,
            z = _ref45.onClick,
            F = _ref45.onClose,
            R = _ref45.skipClick;
          var D = (0, _.useRef)(null),
            re = (0, _.useRef)(null),
            oe = (0, _.useRef)(null),
            we = e.anchorRef,
            ve = e.isOpen,
            Pe = (0, _.useMemo)(function () {
              return {
                animation: r,
                boundingBoxRef: n,
                boundingBoxPadding: a,
                rootMenuRef: D,
                rootAnchorRef: we,
                scrollingRef: re,
                anchorScrollingRef: oe,
                reposition: o,
                viewScroll: h
              };
            }, [r, we, n, a, o, h]),
            U = (0, _.useMemo)(function () {
              return {
                debugging: i,
                submenuOpenDelay: l,
                submenuCloseDelay: u
              };
            }, [i, l, u]),
            ie = (0, _.useMemo)(function () {
              return {
                handleClick: function handleClick(ge, Je, pt) {
                  Je || ar(H || z, ge);
                  var Ye = ge.keepOpen;
                  Ye === void 0 && (Ye = pt && ge.key === Mt.SPACE), Ye || ar(F, {
                    value: ge.value,
                    key: ge.key,
                    reason: Ei.CLICK
                  });
                },
                handleClose: function handleClose(ge) {
                  ar(F, {
                    key: ge,
                    reason: Ei.CLICK
                  });
                }
              };
            }, [H, z, F]),
            de = function de(_ref46) {
              var ge = _ref46.key;
              switch (ge) {
                case Mt.ESC:
                  ar(F, {
                    key: ge,
                    reason: Ei.CANCEL
                  });
                  break;
              }
            },
            ye = function ye(ge) {
              ve && !ge.currentTarget.contains(ge.relatedTarget || document.activeElement) && !i && (ar(F, {
                reason: Ei.BLUR
              }), R && (R.current = !0, setTimeout(function () {
                return R.current = !1;
              }, 300)));
            },
            ne = (0, _.useMemo)(function () {
              return {
                theme: y
              };
            }, [y]),
            Ne = c().createElement("div", {
              id: t,
              className: gr({
                block: Lp,
                modifiers: ne
              }),
              ref: D,
              onKeyDown: de,
              onBlur: ye
            }, C && c().createElement(jc.Provider, {
              value: Pe
            }, c().createElement(ms.Provider, {
              value: U
            }, c().createElement(ps.Provider, {
              value: ie
            }, c().createElement(Yc, Object.assign({}, e, {
              containerRef: D,
              onClose: F
            }))))));
          return g ? Dp().createPortal(Ne, document.body) : Ne;
        },
        ys = c().memo(function (we) {
          var ve = we,
            t = ve["aria-label"],
            r = ve.id,
            n = ve.animation,
            a = ve.boundingBoxRef,
            i = ve.boundingBoxPadding,
            o = ve.captureFocus,
            l = ve.debugging,
            u = ve.reposition,
            h = ve.viewScroll,
            g = ve.keepMounted,
            y = ve.menuButton,
            C = ve.portal,
            H = ve.submenuOpenDelay,
            z = ve.submenuCloseDelay,
            F = ve.theming,
            R = ve.onItemClick,
            D = ve.onClick,
            re = ve.onChange,
            oe = Bt(ve, ["aria-label", "id", "animation", "boundingBoxRef", "boundingBoxPadding", "captureFocus", "debugging", "reposition", "viewScroll", "keepMounted", "menuButton", "portal", "submenuOpenDelay", "submenuCloseDelay", "theming", "onItemClick", "onClick", "onChange"]);
          var _bs = bs(g),
            Pe = _bs.isMounted,
            U = _bs.isOpen,
            ie = _bs.menuItemFocus,
            de = _bs.openMenu,
            ye = _bs.closeMenu,
            ne = (0, _.useRef)(!1),
            Ne = (0, _.useRef)(null),
            ge = (0, _.useMemo)(function () {
              return ar(y, {
                open: U
              });
            }, [y, U]);
          if (!ge) throw new Error("Menu requires a menuButton prop.");
          var Je = (0, _.useCallback)(function (Oe) {
              ye(), Oe.key && Ne.current.focus();
            }, [ye]),
            pt = (0, _.useCallback)(function (Oe) {
              ne.current || de(Oe.detail === 0 ? Mr.FIRST : Mr.INITIAL);
            }, [de]),
            Ye = (0, _.useCallback)(function (Oe) {
              var at = !1;
              switch (Oe.key) {
                case Mt.UP:
                  de(Mr.LAST), at = !0;
                  break;
                case Mt.DOWN:
                  de(Mr.FIRST), at = !0;
                  break;
              }
              at && Oe.preventDefault();
            }, [de]),
            rt = (0, _.useMemo)(function () {
              var Oe = L({
                ref: Ne
              }, oo({
                onClick: pt,
                onKeyDown: Ye
              }, ge.props));
              return Oi(ge.type) === "MenuButton" && (Oe.isOpen = U), c().cloneElement(ge, Oe);
            }, [ge, U, pt, Ye]),
            Ie = Qc(ue(L({}, oe), {
              ariaLabel: t || (typeof ge.props.children == "string" ? ge.props.children : "Menu"),
              anchorRef: Ne,
              isOpen: U,
              menuItemFocus: ie
            }), {
              id: r,
              animation: n,
              boundingBoxRef: a,
              boundingBoxPadding: i,
              debugging: l,
              reposition: u,
              submenuOpenDelay: H,
              submenuCloseDelay: z,
              viewScroll: h,
              portal: C,
              theming: F,
              isMounted: Pe,
              onItemClick: R,
              onClick: D,
              onClose: Je,
              skipClick: ne
            });
          return qc(re, U), c().createElement(c().Fragment, null, rt, Ie);
        });
      ys.propTypes = ue(L({}, Vc), {
        keepMounted: j().bool,
        menuButton: j().oneOfType([j().element, j().func]).isRequired,
        onChange: j().func
      }), ys.defaultProps = ue(L({}, Wc), {
        keepMounted: !0
      });
      var ws = c().memo(function (re) {
        var oe = re,
          t = oe["aria-label"],
          r = oe.id,
          n = oe.animation,
          a = oe.boundingBoxRef,
          i = oe.boundingBoxPadding,
          o = oe.debugging,
          l = oe.reposition,
          u = oe.submenuOpenDelay,
          h = oe.submenuCloseDelay,
          g = oe.viewScroll,
          y = oe.portal,
          C = oe.theming,
          H = oe.isMounted,
          z = oe.onItemClick,
          F = oe.onClick,
          R = oe.onClose,
          D = Bt(oe, ["aria-label", "id", "animation", "boundingBoxRef", "boundingBoxPadding", "debugging", "reposition", "submenuOpenDelay", "submenuCloseDelay", "viewScroll", "portal", "theming", "isMounted", "onItemClick", "onClick", "onClose"]);
        return Qc(ue(L({}, D), {
          ariaLabel: t || "Menu"
        }), {
          id: r,
          animation: n,
          boundingBoxRef: a,
          boundingBoxPadding: i,
          debugging: o,
          reposition: l,
          submenuOpenDelay: u,
          submenuCloseDelay: h,
          viewScroll: g,
          portal: y,
          theming: C,
          isMounted: H,
          onItemClick: z,
          onClick: F,
          onClose: R
        });
      });
      ws.propTypes = ue(L({}, Vc), {
        anchorPoint: j().exact({
          x: j().number,
          y: j().number
        }),
        anchorRef: j().object,
        captureFocus: j().bool,
        isOpen: j().bool,
        isMounted: j().bool,
        menuItemFocus: j().exact({
          position: j().string
        }),
        onClose: j().func
      }), ws.defaultProps = ue(L({}, Wc), {
        captureFocus: !0,
        isOpen: !1,
        isMounted: !0,
        menuItemFocus: {
          position: Mr.INITIAL
        }
      });
      var eu = Cr(c().memo(function (C) {
        var H = C,
          t = H["aria-label"],
          r = H.itemClassName,
          n = H.itemStyles,
          a = H.disabled,
          i = H.keepMounted,
          o = H.label,
          l = H.index,
          u = H.onChange,
          h = H.captureFocus,
          g = H.repositionFlag,
          y = Bt(H, ["aria-label", "itemClassName", "itemStyles", "disabled", "keepMounted", "label", "index", "onChange", "captureFocus", "repositionFlag"]);
        var _bs2 = bs(i),
          z = _bs2.isMounted,
          F = _bs2.isOpen,
          R = _bs2.menuItemFocus,
          D = _bs2.openMenu,
          re = _bs2.closeMenu,
          _ref47 = (0, _.useContext)(ds),
          oe = _ref47.isParentOpen,
          we = _ref47.hoverIndex,
          ve = _ref47.isSubmenuOpen,
          Pe = _ref47.dispatch,
          _ref48 = (0, _.useContext)(ms),
          U = _ref48.debugging,
          ie = _ref48.submenuOpenDelay,
          de = _ref48.submenuCloseDelay,
          ye = we === l,
          ne = Boolean(a),
          Pr = Jc(ye, ne, Mt.RIGHT),
          Ne = Pr.isActive,
          ge = Pr.onKeyUp,
          Je = Bt(Pr, ["isActive", "onKeyUp"]),
          pt = (0, _.useRef)(null),
          Ye = (0, _.useRef)(null),
          rt = (0, _.useRef)(),
          Ie = (0, _.useCallback)(function () {
            re(), Ye.current.focus();
          }, [re]),
          Oe = function Oe(Ot) {
            Pe({
              type: _t.SET,
              index: l
            }), rt.current = setTimeout(D, Math.max(Ot, 0));
          },
          at = function at() {
            ne || F || (ve ? rt.current = setTimeout(function () {
              return Oe(ie - de);
            }, de) : Oe(ie));
          },
          xt = function xt() {
            clearTimeout(rt.current), F || Pe({
              type: _t.UNSET,
              index: l
            });
          },
          ir = function ir() {
            ne || (clearTimeout(rt.current), D());
          },
          St = function St(Ot) {
            var jt = !1;
            switch (Ot.key) {
              case Mt.LEFT:
                F && (Ie(), jt = !0);
                break;
              case Mt.RIGHT:
                F || (jt = !0);
                break;
            }
            jt && (Ot.preventDefault(), Ot.stopPropagation());
          },
          or = function or(Ot) {
            if (!!Ne) switch (ge(Ot), Ot.key) {
              case Mt.SPACE:
              case Mt.ENTER:
              case Mt.RIGHT:
                D(Mr.FIRST);
                break;
            }
          },
          Et = function Et(Ot) {
            if (U) return;
            var jt = Ot.relatedTarget || document.activeElement;
            Ot.currentTarget.contains(jt) || (re(), Pe({
              type: _t.UNSET,
              index: l
            }));
          };
        (0, _.useEffect)(function () {
          return function () {
            return clearTimeout(rt.current);
          };
        }, []), (0, _.useEffect)(function () {
          ye && oe ? Ye.current.focus() : re();
        }, [ye, oe, re]), (0, _.useEffect)(function () {
          Pe({
            type: F ? io.OPEN : io.CLOSE
          });
        }, [Pe, F]), qc(u, F);
        var Nt = (0, _.useMemo)(function () {
          return Object.freeze({
            open: F,
            hover: ye,
            active: Ne,
            disabled: ne
          });
        }, [F, ye, Ne, ne]);
        return c().createElement("li", {
          className: gr({
            block: Sr,
            element: Hp
          }),
          role: "presentation",
          ref: pt,
          onKeyDown: St,
          onBlur: Et
        }, c().createElement("div", Object.assign({
          className: gr({
            block: Sr,
            element: fs,
            modifiers: Nt,
            className: r
          }),
          style: Ur(n, Nt),
          role: "menuitem",
          "aria-haspopup": "true",
          "aria-expanded": F,
          "aria-disabled": ne || void 0,
          tabIndex: ye && !F ? 0 : -1,
          ref: Ye,
          onMouseEnter: at,
          onMouseLeave: xt,
          onMouseDown: function onMouseDown() {
            return !ye && Pe({
              type: _t.SET,
              index: l
            });
          },
          onClick: ir,
          onKeyUp: or
        }, Je), (0, _.useMemo)(function () {
          return ar(o, Nt);
        }, [o, Nt])), z && c().createElement(Yc, Object.assign({}, y, {
          ariaLabel: t || (typeof o == "string" ? o : "Submenu"),
          anchorRef: Ye,
          containerRef: pt,
          isOpen: F,
          isDisabled: ne,
          menuItemFocus: R
        })));
      }), "SubMenu");
      eu.propTypes = ue(L(L({}, Zc), Zr("item")), {
        disabled: j().bool,
        keepMounted: j().bool,
        label: j().oneOfType([j().node, j().func]).isRequired,
        onChange: j().func
      }), eu.defaultProps = ue(L({}, Gc), {
        direction: "right",
        keepMounted: !0
      });
      var Ra = Cr(c().memo(function (C) {
        var H = C,
          t = H.className,
          r = H.styles,
          n = H.value,
          a = H.href,
          i = H.type,
          o = H.checked,
          l = H.disabled,
          u = H.index,
          h = H.children,
          g = H.onClick,
          y = Bt(H, ["className", "styles", "value", "href", "type", "checked", "disabled", "index", "children", "onClick"]);
        var z = Boolean(l),
          _Xc = Xc(z, u),
          F = _Xc.ref,
          R = _Xc.isHovering,
          D = _Xc.setHover,
          re = _Xc.onBlur,
          oe = _Xc.onMouseEnter,
          we = _Xc.onMouseLeave,
          ve = (0, _.useContext)(ps),
          Pe = (0, _.useContext)(Fc),
          ir = Jc(R, z),
          U = ir.isActive,
          ie = ir.onKeyUp,
          de = ir.onBlur,
          ye = Bt(ir, ["isActive", "onKeyUp", "onBlur"]),
          ne = i === "radio",
          Ne = i === "checkbox",
          ge = Boolean(a) && !z && !ne && !Ne,
          Je = ne ? Pe.value === n : Ne ? Boolean(o) : !1,
          pt = function pt(St) {
            if (z) return;
            var or = !1;
            var Et = {
              value: n,
              syntheticEvent: St
            };
            St.key !== void 0 && (Et.key = St.key), ne && (Et.name = Pe.name, ar(Pe.onChange, Et)), Et.checked = Ne ? !Je : !1, or = ar(g, Et) === !1, ve.handleClick(Et, or, Ne || ne);
          },
          Ye = function Ye(St) {
            if (!!U) switch (ie(St), St.key) {
              case Mt.SPACE:
              case Mt.ENTER:
                ge ? F.current.click() : pt(St);
                break;
            }
          },
          rt = function rt(St) {
            de(St), re(St);
          },
          Ie = (0, _.useMemo)(function () {
            return Object.freeze({
              type: i,
              disabled: z,
              hover: R,
              active: U,
              checked: Je,
              anchor: ge
            });
          }, [i, z, R, U, Je, ge]),
          Oe = oo(ue(L({}, ye), {
            onMouseEnter: oe,
            onMouseLeave: we,
            onMouseDown: D,
            onKeyUp: Ye,
            onBlur: rt,
            onClick: pt
          }), y),
          at = ue(L(L({
            role: ne ? "menuitemradio" : Ne ? "menuitemcheckbox" : "menuitem",
            "aria-checked": ne || Ne ? Je : void 0,
            "aria-disabled": z || void 0,
            tabIndex: R ? 0 : -1
          }, y), Oe), {
            ref: F,
            className: gr({
              block: Sr,
              element: fs,
              modifiers: Ie,
              className: t
            }),
            style: Ur(r, Ie)
          }),
          xt = (0, _.useMemo)(function () {
            return ar(h, Ie);
          }, [h, Ie]);
        return ge ? c().createElement("li", {
          role: "presentation"
        }, c().createElement("a", Object.assign({}, at, {
          href: a
        }), xt)) : c().createElement("li", at, xt);
      }), "MenuItem");
      Ra.propTypes = ue(L({}, Zr()), {
        value: j().any,
        href: j().string,
        type: j().oneOf(["checkbox", "radio"]),
        checked: j().bool,
        disabled: j().bool,
        children: j().oneOfType([j().node, j().func]).isRequired,
        onClick: j().func
      });
      var Gp = Cr(c().memo(function (l) {
        var u = l,
          t = u.className,
          r = u.styles,
          n = u.disabled,
          a = u.index,
          i = u.children,
          o = Bt(u, ["className", "styles", "disabled", "index", "children"]);
        var h = Boolean(n),
          _Xc2 = Xc(h, a),
          g = _Xc2.ref,
          y = _Xc2.isHovering,
          C = _Xc2.setHover,
          H = _Xc2.onBlur,
          z = _Xc2.onMouseEnter,
          F = _Xc2.onMouseLeave,
          _ref49 = (0, _.useContext)(ps),
          R = _ref49.handleClose,
          D = (0, _.useMemo)(function () {
            return Object.freeze({
              disabled: h,
              hover: y,
              focusable: !0
            });
          }, [h, y]),
          re = (0, _.useMemo)(function () {
            return ar(i, ue(L({}, D), {
              ref: g,
              closeMenu: R
            }));
          }, [g, i, D, R]),
          oe = oo({
            onMouseEnter: z,
            onMouseLeave: function onMouseLeave(we) {
              return F(we, !0);
            },
            onFocus: C,
            onBlur: H
          }, o);
        return c().createElement("li", Object.assign({
          "aria-disabled": h || void 0,
          role: "menuitem",
          tabIndex: "-1"
        }, o, oe, {
          className: gr({
            block: Sr,
            element: fs,
            modifiers: D,
            className: t
          }),
          style: Ur(r, D)
        }), re);
      }), "FocusableItem");
      Gp.propTypes = ue(L({}, Zr()), {
        disabled: j().bool,
        children: j().func.isRequired
      });
      var Wp = Cr(c().memo(function (a) {
        var i = a,
          t = i.className,
          r = i.styles,
          n = Bt(i, ["className", "styles"]);
        return c().createElement("li", Object.assign({
          role: "separator"
        }, n, {
          className: gr({
            block: Sr,
            element: Bp,
            className: t
          }),
          style: Ur(r)
        }));
      }), "MenuDivider");
      Wp.propTypes = L({}, Zr());
      var tu = Cr(c().memo(function (a) {
        var i = a,
          t = i.className,
          r = i.styles,
          n = Bt(i, ["className", "styles"]);
        return c().createElement("li", Object.assign({
          role: "presentation"
        }, n, {
          className: gr({
            block: Sr,
            element: zp,
            className: t
          }),
          style: Ur(r)
        }));
      }), "MenuHeader");
      tu.propTypes = L({}, Zr());
      var Jp = Cr(c().memo(function (i) {
        var o = i,
          t = o.className,
          r = o.styles,
          n = o.takeOverflow,
          a = Bt(o, ["className", "styles", "takeOverflow"]);
        var l = (0, _.useRef)(null),
          _ref50 = (0, _.useState)(),
          _ref51 = _slicedToArray(_ref50, 2),
          u = _ref51[0],
          h = _ref51[1],
          _ref52 = (0, _.useContext)(hs),
          g = _ref52.overflow,
          y = _ref52.overflowAmt;
        return Ti(function () {
          var C;
          n && y >= 0 && (C = l.current.getBoundingClientRect().height - y, C < 0 && (C = 0)), h(C >= 0 ? {
            maxHeight: C,
            overflow: g
          } : void 0);
        }, [n, g, y]), Ti(function () {
          u && (l.current.scrollTop = 0);
        }, [u]), c().createElement("div", Object.assign({
          ref: l
        }, a, {
          className: gr({
            block: Sr,
            element: $p,
            className: t
          }),
          style: L(L({}, Ur(r)), u)
        }));
      }), "MenuGroup");
      Jp.propTypes = ue(L({}, Zr()), {
        takeOverflow: j().bool
      });
      var Xp = Cr(c().memo(function (h) {
        var g = h,
          t = g["aria-label"],
          r = g.className,
          n = g.styles,
          a = g.name,
          i = g.value,
          o = g.children,
          l = g.onChange,
          u = Bt(g, ["aria-label", "className", "styles", "name", "value", "children", "onChange"]);
        var y = (0, _.useMemo)(function () {
          return {
            name: a,
            value: i,
            onChange: l
          };
        }, [a, i, l]);
        return c().createElement("li", {
          role: "presentation"
        }, c().createElement("ul", Object.assign({
          role: "group",
          "aria-label": t || a || "Radio group"
        }, u, {
          className: gr({
            block: Sr,
            element: Up,
            className: r
          }),
          style: Ur(n)
        }), c().createElement(Fc.Provider, {
          value: y
        }, o)));
      }), "MenuRadioGroup");
      Xp.propTypes = ue(L({}, Zr()), {
        "aria-label": j().string,
        name: j().string,
        value: j().any,
        children: j().node.isRequired,
        onChange: j().func
      });
      var aa = [],
        qp = function qp() {
          return aa.some(function (e) {
            return e.activeTargets.length > 0;
          });
        },
        Kp = function Kp() {
          return aa.some(function (e) {
            return e.skippedTargets.length > 0;
          });
        },
        ru = "ResizeObserver loop completed with undelivered notifications.",
        Yp = function Yp() {
          var e;
          typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
            message: ru
          }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = ru), window.dispatchEvent(e);
        },
        ki;
      (function (e) {
        e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
      })(ki || (ki = {}));
      var ia = function ia(e) {
          return Object.freeze(e);
        },
        Qp = function () {
          function e(t, r) {
            this.inlineSize = t, this.blockSize = r, ia(this);
          }
          return e;
        }(),
        nu = function () {
          function e(t, r, n, a) {
            return this.x = t, this.y = r, this.width = n, this.height = a, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, ia(this);
          }
          return e.prototype.toJSON = function () {
            var t = this,
              r = t.x,
              n = t.y,
              a = t.top,
              i = t.right,
              o = t.bottom,
              l = t.left,
              u = t.width,
              h = t.height;
            return {
              x: r,
              y: n,
              top: a,
              right: i,
              bottom: o,
              left: l,
              width: u,
              height: h
            };
          }, e.fromRect = function (t) {
            return new e(t.x, t.y, t.width, t.height);
          }, e;
        }(),
        _s = function _s(e) {
          return e instanceof SVGElement && "getBBox" in e;
        },
        au = function au(e) {
          if (_s(e)) {
            var t = e.getBBox(),
              r = t.width,
              n = t.height;
            return !r && !n;
          }
          var a = e,
            i = a.offsetWidth,
            o = a.offsetHeight;
          return !(i || o || e.getClientRects().length);
        },
        iu = function iu(e) {
          var t, r;
          if (e instanceof Element) return !0;
          var n = (r = (t = e) === null || t === void 0 ? void 0 : t.ownerDocument) === null || r === void 0 ? void 0 : r.defaultView;
          return !!(n && e instanceof n.Element);
        },
        em = function em(e) {
          switch (e.tagName) {
            case "INPUT":
              if (e.type !== "image") break;
            case "VIDEO":
            case "AUDIO":
            case "EMBED":
            case "OBJECT":
            case "CANVAS":
            case "IFRAME":
            case "IMG":
              return !0;
          }
          return !1;
        },
        Si = typeof window != "undefined" ? window : {},
        so = new WeakMap(),
        ou = /auto|scroll/,
        tm = /^tb|vertical/,
        rm = /msie|trident/i.test(Si.navigator && Si.navigator.userAgent),
        Vr = function Vr(e) {
          return parseFloat(e || "0");
        },
        Ia = function Ia(e, t, r) {
          return e === void 0 && (e = 0), t === void 0 && (t = 0), r === void 0 && (r = !1), new Qp((r ? t : e) || 0, (r ? e : t) || 0);
        },
        su = ia({
          devicePixelContentBoxSize: Ia(),
          borderBoxSize: Ia(),
          contentBoxSize: Ia(),
          contentRect: new nu(0, 0, 0, 0)
        }),
        lu = function lu(e, t) {
          if (t === void 0 && (t = !1), so.has(e) && !t) return so.get(e);
          if (au(e)) return so.set(e, su), su;
          var r = getComputedStyle(e),
            n = _s(e) && e.ownerSVGElement && e.getBBox(),
            a = !rm && r.boxSizing === "border-box",
            i = tm.test(r.writingMode || ""),
            o = !n && ou.test(r.overflowY || ""),
            l = !n && ou.test(r.overflowX || ""),
            u = n ? 0 : Vr(r.paddingTop),
            h = n ? 0 : Vr(r.paddingRight),
            g = n ? 0 : Vr(r.paddingBottom),
            y = n ? 0 : Vr(r.paddingLeft),
            C = n ? 0 : Vr(r.borderTopWidth),
            H = n ? 0 : Vr(r.borderRightWidth),
            z = n ? 0 : Vr(r.borderBottomWidth),
            F = n ? 0 : Vr(r.borderLeftWidth),
            R = y + h,
            D = u + g,
            re = F + H,
            oe = C + z,
            we = l ? e.offsetHeight - oe - e.clientHeight : 0,
            ve = o ? e.offsetWidth - re - e.clientWidth : 0,
            Pe = a ? R + re : 0,
            U = a ? D + oe : 0,
            ie = n ? n.width : Vr(r.width) - Pe - ve,
            de = n ? n.height : Vr(r.height) - U - we,
            ye = ie + R + ve + re,
            ne = de + D + we + oe,
            Ne = ia({
              devicePixelContentBoxSize: Ia(Math.round(ie * devicePixelRatio), Math.round(de * devicePixelRatio), i),
              borderBoxSize: Ia(ye, ne, i),
              contentBoxSize: Ia(ie, de, i),
              contentRect: new nu(y, u, ie, de)
            });
          return so.set(e, Ne), Ne;
        },
        cu = function cu(e, t, r) {
          var n = lu(e, r),
            a = n.borderBoxSize,
            i = n.contentBoxSize,
            o = n.devicePixelContentBoxSize;
          switch (t) {
            case ki.DEVICE_PIXEL_CONTENT_BOX:
              return o;
            case ki.BORDER_BOX:
              return a;
            default:
              return i;
          }
        },
        nm = function () {
          function e(t) {
            var r = lu(t);
            this.target = t, this.contentRect = r.contentRect, this.borderBoxSize = ia([r.borderBoxSize]), this.contentBoxSize = ia([r.contentBoxSize]), this.devicePixelContentBoxSize = ia([r.devicePixelContentBoxSize]);
          }
          return e;
        }(),
        uu = function uu(e) {
          if (au(e)) return 1 / 0;
          for (var t = 0, r = e.parentNode; r;) {
            t += 1, r = r.parentNode;
          }
          return t;
        },
        am = function am() {
          var e = 1 / 0,
            t = [];
          aa.forEach(function (o) {
            if (o.activeTargets.length !== 0) {
              var l = [];
              o.activeTargets.forEach(function (h) {
                var g = new nm(h.target),
                  y = uu(h.target);
                l.push(g), h.lastReportedSize = cu(h.target, h.observedBox), y < e && (e = y);
              }), t.push(function () {
                o.callback.call(o.observer, l, o.observer);
              }), o.activeTargets.splice(0, o.activeTargets.length);
            }
          });
          for (var r = 0, n = t; r < n.length; r++) {
            var a = n[r];
            a();
          }
          return e;
        },
        fu = function fu(e) {
          aa.forEach(function (r) {
            r.activeTargets.splice(0, r.activeTargets.length), r.skippedTargets.splice(0, r.skippedTargets.length), r.observationTargets.forEach(function (a) {
              a.isActive() && (uu(a.target) > e ? r.activeTargets.push(a) : r.skippedTargets.push(a));
            });
          });
        },
        im = function im() {
          var e = 0;
          for (fu(e); qp();) {
            e = am(), fu(e);
          }
          return Kp() && Yp(), e > 0;
        },
        xs,
        du = [],
        om = function om() {
          return du.splice(0).forEach(function (e) {
            return e();
          });
        },
        sm = function sm(e) {
          if (!xs) {
            var t = 0,
              r = document.createTextNode(""),
              n = {
                characterData: !0
              };
            new MutationObserver(function () {
              return om();
            }).observe(r, n), xs = function xs() {
              r.textContent = "" + (t ? t-- : t++);
            };
          }
          du.push(e), xs();
        },
        lm = function lm(e) {
          sm(function () {
            requestAnimationFrame(e);
          });
        },
        lo = 0,
        cm = function cm() {
          return !!lo;
        },
        um = 250,
        fm = {
          attributes: !0,
          characterData: !0,
          childList: !0,
          subtree: !0
        },
        hu = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
        pu = function pu(e) {
          return e === void 0 && (e = 0), Date.now() + e;
        },
        Es = !1,
        dm = function () {
          function e() {
            var t = this;
            this.stopped = !0, this.listener = function () {
              return t.schedule();
            };
          }
          return e.prototype.run = function (t) {
            var r = this;
            if (t === void 0 && (t = um), !Es) {
              Es = !0;
              var n = pu(t);
              lm(function () {
                var a = !1;
                try {
                  a = im();
                } finally {
                  if (Es = !1, t = n - pu(), !cm()) return;
                  a ? r.run(1e3) : t > 0 ? r.run(t) : r.start();
                }
              });
            }
          }, e.prototype.schedule = function () {
            this.stop(), this.run();
          }, e.prototype.observe = function () {
            var t = this,
              r = function r() {
                return t.observer && t.observer.observe(document.body, fm);
              };
            document.body ? r() : Si.addEventListener("DOMContentLoaded", r);
          }, e.prototype.start = function () {
            var t = this;
            this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), hu.forEach(function (r) {
              return Si.addEventListener(r, t.listener, !0);
            }));
          }, e.prototype.stop = function () {
            var t = this;
            this.stopped || (this.observer && this.observer.disconnect(), hu.forEach(function (r) {
              return Si.removeEventListener(r, t.listener, !0);
            }), this.stopped = !0);
          }, e;
        }(),
        Os = new dm(),
        mu = function mu(e) {
          !lo && e > 0 && Os.start(), lo += e, !lo && Os.stop();
        },
        hm = function hm(e) {
          return !_s(e) && !em(e) && getComputedStyle(e).display === "inline";
        },
        pm = function () {
          function e(t, r) {
            this.target = t, this.observedBox = r || ki.CONTENT_BOX, this.lastReportedSize = {
              inlineSize: 0,
              blockSize: 0
            };
          }
          return e.prototype.isActive = function () {
            var t = cu(this.target, this.observedBox, !0);
            return hm(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
          }, e;
        }(),
        mm = function () {
          function e(t, r) {
            this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = r;
          }
          return e;
        }(),
        co = new WeakMap(),
        gu = function gu(e, t) {
          for (var r = 0; r < e.length; r += 1) {
            if (e[r].target === t) return r;
          }
          return -1;
        },
        uo = function () {
          function e() {}
          return e.connect = function (t, r) {
            var n = new mm(t, r);
            co.set(t, n);
          }, e.observe = function (t, r, n) {
            var a = co.get(t),
              i = a.observationTargets.length === 0;
            gu(a.observationTargets, r) < 0 && (i && aa.push(a), a.observationTargets.push(new pm(r, n && n.box)), mu(1), Os.schedule());
          }, e.unobserve = function (t, r) {
            var n = co.get(t),
              a = gu(n.observationTargets, r),
              i = n.observationTargets.length === 1;
            a >= 0 && (i && aa.splice(aa.indexOf(n), 1), n.observationTargets.splice(a, 1), mu(-1));
          }, e.disconnect = function (t) {
            var r = this,
              n = co.get(t);
            n.observationTargets.slice().forEach(function (a) {
              return r.unobserve(t, a.target);
            }), n.activeTargets.splice(0, n.activeTargets.length);
          }, e;
        }(),
        gm = function () {
          function e(t) {
            if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
            if (typeof t != "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
            uo.connect(this, t);
          }
          return e.prototype.observe = function (t, r) {
            if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
            if (!iu(t)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
            uo.observe(this, t, r);
          }, e.prototype.unobserve = function (t) {
            if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
            if (!iu(t)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
            uo.unobserve(this, t);
          }, e.prototype.disconnect = function () {
            uo.disconnect(this);
          }, e.toString = function () {
            return "function ResizeObserver () { [polyfill code] }";
          }, e;
        }();
      var vm = c()[typeof document != "undefined" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"],
        bm = function bm(e) {
          var t = _.useRef(e);
          return _.useEffect(function () {
            t.current = e;
          }), t;
        };
      var ym = function ym(t) {
        var r = [],
          n = null,
          a = function a() {
            for (var o = arguments.length, l = new Array(o), u = 0; u < o; u++) {
              l[u] = arguments[u];
            }
            r = l, !n && (n = requestAnimationFrame(function () {
              n = null, t.apply(void 0, r);
            }));
          };
        return a.cancel = function () {
          !n || (cancelAnimationFrame(n), n = null);
        }, a;
      };
      var wm = ym,
        _m = typeof window != "undefined" && "ResizeObserver" in window ? window.ResizeObserver : gm;
      function xm() {}
      function Em(e, t) {
        var r = Tm(),
          n = bm(t);
        return vm(function () {
          var a = !1;
          var i = e && "current" in e ? e.current : e;
          if (!i) return xm;
          function o(l, u) {
            a || n.current(l, u);
          }
          return r.subscribe(i, o), function () {
            a = !0, r.unsubscribe(i, o);
          };
        }, [e, r, n]), r.observer;
      }
      function Om() {
        var e = new Map(),
          t = new _m(wm(function (r, n) {
            var _loop4 = function _loop4(a) {
              var i = e.get(r[a].target);
              i == null || i.forEach(function (o) {
                return o(r[a], n);
              });
            };
            for (var a = 0; a < r.length; a++) {
              _loop4(a);
            }
          }));
        return {
          observer: t,
          subscribe: function subscribe(r, n) {
            var a;
            t.observe(r);
            var i = (a = e.get(r)) !== null && a !== void 0 ? a : [];
            i.push(n), e.set(r, i);
          },
          unsubscribe: function unsubscribe(r, n) {
            var a;
            var i = (a = e.get(r)) !== null && a !== void 0 ? a : [];
            if (i.length === 1) {
              t.unobserve(r), e.delete(r);
              return;
            }
            var o = i.indexOf(n);
            o !== -1 && i.splice(o, 1), e.set(r, i);
          }
        };
      }
      var Ts;
      var Tm = function Tm() {
          return Ts || (Ts = Om());
        },
        ks = Em;
      var km = pe(594),
        Sm = pe.n(km);
      var Cm = {
          canvas: "OblL49alHyHyc9eQg8j4nA=="
        },
        Mm = {
          highlight: "rnaOpSl6-Al2+GT07ZkG5Q=="
        };
      var Nm = Object.defineProperty,
        Pm = Object.defineProperties,
        Rm = Object.getOwnPropertyDescriptors,
        vu = Object.getOwnPropertySymbols,
        Im = Object.prototype.hasOwnProperty,
        Am = Object.prototype.propertyIsEnumerable,
        bu = function bu(e, t, r) {
          return t in e ? Nm(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        yu = function yu(e, t) {
          for (var r in t || (t = {})) {
            Im.call(t, r) && bu(e, r, t[r]);
          }
          if (vu) {
            var _iterator34 = _createForOfIteratorHelper(vu(t)),
              _step34;
            try {
              for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                var r = _step34.value;
                Am.call(t, r) && bu(e, r, t[r]);
              }
            } catch (err) {
              _iterator34.e(err);
            } finally {
              _iterator34.f();
            }
          }
          return e;
        },
        Dm = function Dm(e, t) {
          return Pm(e, Rm(t));
        };
      function Lm(e) {
        var t = e.canvasRef,
          r = e.barHeight,
          n = e.xyToHighlightData,
          a = e.zoom,
          _c$useState = c().useState({
            height: "0px",
            visibility: "hidden"
          }),
          _c$useState2 = _slicedToArray(_c$useState, 2),
          i = _c$useState2[0],
          o = _c$useState2[1];
        c().useEffect(function () {
          o({
            height: "0px",
            visibility: "hidden"
          });
        }, [a]);
        var l = function l(h) {
            var g = n(h.offsetX, h.offsetY);
            if (g.isJust) {
              var y = g.value;
              o(yu({
                visibility: "visible",
                height: "".concat(r, "px")
              }, y));
            } else u();
          },
          u = function u() {
            o(Dm(yu({}, i), {
              visibility: "hidden"
            }));
          };
        return c().useEffect(function () {
          var h = t.current;
          return h ? (h.addEventListener("mousemove", l), h.addEventListener("mouseout", u), function () {
            h.removeEventListener("mousemove", l), h.removeEventListener("mouseout", u);
          }) : function () {};
        }, [t.current, l, u]), c().createElement("div", {
          className: Mm.highlight,
          style: i,
          "data-testid": "flamegraph-highlight"
        });
      }
      var Fm = {
        highlightContextMenu: "_2aEs2ORKQVtdd+CAuIWrcA=="
      };
      var jm = Object.defineProperty,
        wu = Object.getOwnPropertySymbols,
        Bm = Object.prototype.hasOwnProperty,
        zm = Object.prototype.propertyIsEnumerable,
        _u = function _u(e, t, r) {
          return t in e ? jm(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        $m = function $m(e, t) {
          for (var r in t || (t = {})) {
            Bm.call(t, r) && _u(e, r, t[r]);
          }
          if (wu) {
            var _iterator35 = _createForOfIteratorHelper(wu(t)),
              _step35;
            try {
              for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
                var r = _step35.value;
                zm.call(t, r) && _u(e, r, t[r]);
              }
            } catch (err) {
              _iterator35.e(err);
            } finally {
              _iterator35.f();
            }
          }
          return e;
        };
      var xu = {
        height: "0px",
        visibility: "hidden"
      };
      function Hm(e) {
        var t = e.node,
          r = e.barHeight,
          _c$useState3 = c().useState(xu),
          _c$useState4 = _slicedToArray(_c$useState3, 2),
          n = _c$useState4[0],
          a = _c$useState4[1];
        return c().useEffect(function () {
          t.match({
            Nothing: function Nothing() {
              return a(xu);
            },
            Just: function Just(i) {
              return a($m({
                visibility: "visible",
                height: "".concat(r, "px")
              }, i));
            }
          });
        }, [t]), c().createElement("div", {
          className: Fm.highlightContextMenu,
          style: n,
          "data-testid": "flamegraph-highlight-contextmenu"
        });
      }
      var Um = Object.defineProperty,
        Zm = Object.defineProperties,
        Vm = Object.getOwnPropertyDescriptors,
        Eu = Object.getOwnPropertySymbols,
        Gm = Object.prototype.hasOwnProperty,
        Wm = Object.prototype.propertyIsEnumerable,
        Ou = function Ou(e, t, r) {
          return t in e ? Um(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        Jm = function Jm(e, t) {
          for (var r in t || (t = {})) {
            Gm.call(t, r) && Ou(e, r, t[r]);
          }
          if (Eu) {
            var _iterator36 = _createForOfIteratorHelper(Eu(t)),
              _step36;
            try {
              for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                var r = _step36.value;
                Wm.call(t, r) && Ou(e, r, t[r]);
              }
            } catch (err) {
              _iterator36.e(err);
            } finally {
              _iterator36.f();
            }
          }
          return e;
        },
        Xm = function Xm(e, t) {
          return Zm(e, Vm(t));
        };
      var Aa = {
          name: "Default",
          goodColor: Fe().rgb(0, 170, 0),
          neutralColor: Fe().rgb(148, 142, 142),
          badColor: Fe().rgb(200, 0, 0),
          colors: [Fe().hsl(24, 69, 60), Fe().hsl(34, 65, 65), Fe().hsl(194, 52, 61), Fe().hsl(163, 45, 55), Fe().hsl(211, 48, 60), Fe().hsl(246, 40, 65), Fe().hsl(305, 63, 79), Fe().hsl(47, 100, 73), Fe().rgb(183, 219, 171), Fe().rgb(244, 213, 152), Fe().rgb(78, 146, 249), Fe().rgb(249, 186, 143), Fe().rgb(242, 145, 145), Fe().rgb(130, 181, 216), Fe().rgb(229, 168, 226), Fe().rgb(174, 162, 224), Fe().rgb(154, 196, 138), Fe().rgb(242, 201, 109), Fe().rgb(101, 197, 219), Fe().rgb(249, 147, 78), Fe().rgb(234, 100, 96), Fe().rgb(81, 149, 206), Fe().rgb(214, 131, 206), Fe().rgb(128, 110, 183)]
        },
        qm = Xm(Jm({}, Aa), {
          name: "Color Blind",
          goodColor: Fe().rgb(26, 133, 255),
          neutralColor: Fe().rgb(148, 142, 142),
          badColor: Fe().rgb(220, 50, 32)
        });
      function Km() {
        return c().createElement("svg", {
          id: "Layer_1",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 30 30"
        }, c().createElement("defs", null), c().createElement("path", {
          style: {
            fill: "#7d7d7f"
          },
          d: "M5,19.56c0,5.22,3.54,9.44,7.92,9.44h3.17c4.37,0,7.92-4.23,7.92-9.44v-7.56H5v7.56Z"
        }), c().createElement("path", {
          style: {
            fill: "#7d7d7f"
          },
          d: "M14,1h-.82c-4.52,0-8.18,3.73-8.18,8.33v1.67H14V1Z"
        }), c().createElement("path", {
          d: "M15.82,1h-.82V11h9v-1.67c0-4.6-3.66-8.33-8.18-8.33Z"
        }));
      }
      function Ym() {
        return c().createElement("svg", {
          id: "Layer_1",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 30 30"
        }, c().createElement("defs", null), c().createElement("path", {
          style: {
            fill: "#7d7d7f"
          },
          d: "M24,19.56c0,5.22-3.54,9.44-7.92,9.44h-3.17c-4.37,0-7.92-4.23-7.92-9.44v-7.56H24v7.56Z"
        }), c().createElement("path", {
          style: {
            fill: "#7d7d7f"
          },
          d: "M15,1h.82c4.52,0,8.18,3.73,8.18,8.33v1.67H15V1Z"
        }), c().createElement("path", {
          d: "M13.18,1h.82V11H5v-1.67c0-4.6,3.66-8.33,8.18-8.33Z"
        }));
      }
      var oa = {
        tooltip: "EitWfLJlRhB605WKBhJqJA==",
        flamegraphDiffTooltip: "JDNfewH9FpPntx5Wu1nQjw==",
        tooltipName: "OYP-AU7HdIz-U3S15iaSMQ==",
        functionName: "wx9q4ZorgH1vtYtZv7yIAg==",
        tooltipTable: "+0L0FytvTTAXpH3pPg1wZw==",
        clickInfo: "_8y0K87bqdGd-mxDZz+YoPg=="
      };
      function Tu(_ref53) {
        var _ref53$shouldShowFoot = _ref53.shouldShowFooter,
          e = _ref53$shouldShowFoot === void 0 ? !0 : _ref53$shouldShowFoot,
          _ref53$shouldShowTitl = _ref53.shouldShowTitle,
          t = _ref53$shouldShowTitl === void 0 ? !0 : _ref53$shouldShowTitl,
          r = _ref53.dataSourceRef,
          n = _ref53.clickInfoSide,
          a = _ref53.setTooltipContent;
        var i = (0, _.useRef)(null),
          _c$useState5 = c().useState({
            title: {
              text: "",
              diff: {
                text: "",
                color: ""
              }
            },
            tooltipData: []
          }),
          _c$useState6 = _slicedToArray(_c$useState5, 2),
          o = _c$useState6[0],
          l = _c$useState6[1],
          _ref54 = (0, _.useState)(),
          _ref55 = _slicedToArray(_ref54, 2),
          u = _ref55[0],
          h = _ref55[1],
          g = function g() {
            h({
              visibility: "hidden"
            }), l({
              title: {
                text: "",
                diff: {
                  text: "",
                  color: ""
                }
              },
              tooltipData: []
            });
          },
          y = (0, _.useCallback)(function (C) {
            if (!i || !i.current) throw new Error("Missing tooltipElement");
            var H = Math.min(C.clientX + 12, window.innerWidth - i.current.clientWidth - 20),
              F = {
                top: C.clientY + 20,
                left: H,
                visibility: "visible"
              };
            a(l, g, C), h(F);
          }, [i, a]);
        return (0, _.useEffect)(function () {
          var C = r.current;
          return C ? (C.addEventListener("mousemove", y), C.addEventListener("mouseout", g), function () {
            C.removeEventListener("mousemove", y), C.removeEventListener("mouseout", g);
          }) : function () {};
        }, [r.current, y]), c().createElement("div", {
          "data-testid": "tooltip",
          className: sn(oa.tooltip, _defineProperty({}, oa.flamegraphDiffTooltip, o.tooltipData.length > 1)),
          style: u,
          ref: i
        }, o.tooltipData.length > 0 && c().createElement(c().Fragment, null, t && c().createElement("div", {
          className: oa.tooltipName,
          "data-testid": "tooltip-title"
        }, o.title.text), c().createElement("div", {
          className: oa.functionName,
          "data-testid": "tooltip-function-name"
        }, o.title.text), o.title.diff.text.length > 0 ? c().createElement(ku, {
          data: o.tooltipData,
          diff: o.title.diff
        }) : c().createElement(ku, {
          data: o.tooltipData
        }), e && c().createElement(Qm, {
          clickInfoSide: n
        })));
      }
      var Ci = {
        objects: {
          percent: "% of objects in RAM",
          formattedValue: "Objects in RAM",
          total: "% of total RAM"
        },
        goroutines: {
          percent: "% of goroutines",
          formattedValue: "Goroutines",
          total: "% of total goroutines"
        },
        bytes: {
          percent: "% of RAM",
          formattedValue: "RAM",
          total: "% of total bytes"
        },
        samples: {
          percent: "Share of CPU",
          formattedValue: "CPU Time",
          total: "% of total CPU"
        },
        lock_nanoseconds: {
          percent: "% of Time spent",
          formattedValue: "Time",
          total: "% of total seconds"
        },
        lock_samples: {
          percent: "% of contended locks",
          formattedValue: "Contended locks",
          total: "% of total locks"
        },
        trace_samples: {
          percent: "% of time",
          formattedValue: "Samples",
          total: "% of total samples"
        },
        "": {
          percent: "Percentage",
          formattedValue: "Units",
          total: "% of total units"
        }
      };
      function ku(_ref56) {
        var e = _ref56.data,
          t = _ref56.diff;
        var _e3 = _slicedToArray(e, 2),
          r = _e3[0],
          n = _e3[1];
        if (!r) return null;
        var a;
        switch (r.tooltipType) {
          case "flamegraph":
            a = function a() {
              return c().createElement(c().Fragment, null, n && c().createElement("thead", null, c().createElement("tr", null, c().createElement("th", null), c().createElement("th", null, "Baseline"), c().createElement("th", null, "Comparison"), c().createElement("th", null, "Diff"))), c().createElement("tbody", null, c().createElement("tr", null, c().createElement("td", null, Ci[r.units].percent, ":"), c().createElement("td", null, r.percent), n && c().createElement(c().Fragment, null, c().createElement("td", null, n.percent), c().createElement("td", null, t && c().createElement("span", {
                "data-testid": "tooltip-diff",
                style: {
                  color: t.color
                }
              }, t.text)))), c().createElement("tr", null, c().createElement("td", null, Ci[r.units].formattedValue, ":"), c().createElement("td", null, r.formattedValue), n && c().createElement(c().Fragment, null, c().createElement("td", null, n.formattedValue), c().createElement("td", null))), c().createElement("tr", null, c().createElement("td", null, "Samples:"), c().createElement("td", null, r.samples), n && c().createElement(c().Fragment, null, c().createElement("td", null, n.samples), c().createElement("td", null)))));
            };
            break;
          case "table":
            a = function a() {
              return c().createElement(c().Fragment, null, c().createElement("thead", null, c().createElement("tr", null, c().createElement("td", null), c().createElement("td", null, "Self (", Ci[r.units].total, ")"), c().createElement("td", null, "Total (", Ci[r.units].total, ")"))), c().createElement("tbody", null, c().createElement("tr", null, c().createElement("td", null, Ci[r.units].formattedValue, ":"), c().createElement("td", null, r.self), c().createElement("td", null, r.total))));
            };
            break;
          default:
            a = function a() {
              return null;
            };
        }
        return c().createElement("table", {
          "data-testid": "tooltip-table",
          className: sn(oa.tooltipTable, _defineProperty({}, oa["".concat(r.tooltipType).concat(n ? "Diff" : "")], r.tooltipType))
        }, a());
      }
      function Qm(_ref57) {
        var e = _ref57.clickInfoSide;
        var t;
        switch (e) {
          case "right":
            t = c().createElement(c().Fragment, null, c().createElement(Km, null), c().createElement("span", null, "Right click for more node viewing options"));
            break;
          case "left":
            t = c().createElement(c().Fragment, null, c().createElement(Ym, null), c().createElement("span", null, "Click to highlight node in flamegraph"));
            break;
          default:
            t = c().createElement(c().Fragment, null);
        }
        return c().createElement("div", {
          "data-testid": "tooltip-footer",
          className: oa.clickInfo
        }, t);
      }
      function e0(e) {
        var t = e.format,
          r = e.canvasRef,
          n = e.xyToData,
          a = e.numTicks,
          i = e.sampleRate,
          o = e.units,
          l = e.leftTicks,
          u = e.rightTicks,
          h = e.palette,
          g = (0, _.useCallback)(function (y, C, H) {
            var z = Li(a, i, o),
              F = n(H.offsetX, H.offsetY);
            var R;
            if (F.isJust) R = F.value;else {
              C();
              return;
            }
            switch (R.format) {
              case "single":
                {
                  var D = {
                    percent: zs(R.total / a),
                    samples: o === "trace_samples" ? "" : wo(R.total),
                    units: o,
                    formattedValue: z.format(R.total, i),
                    tooltipType: "flamegraph"
                  };
                  y({
                    title: {
                      text: R.name,
                      diff: {
                        text: "",
                        color: ""
                      }
                    },
                    tooltipData: [D]
                  });
                  break;
                }
              case "double":
                {
                  if (t === "single") throw new Error("props format is 'single' but it has been mapped to 'double'");
                  var _D = t0({
                    formatter: z,
                    sampleRate: i,
                    totalLeft: R.totalLeft,
                    leftTicks: l,
                    totalRight: R.totalRight,
                    rightTicks: u,
                    title: R.name,
                    units: o
                  }, h);
                  y({
                    title: _D.title,
                    tooltipData: _D.tooltipData
                  });
                  break;
                }
              default:
                throw new Error("Unsupported format:'");
            }
          }, [a, i, o, l, u, h]);
        return c().createElement(Tu, {
          dataSourceRef: r,
          clickInfoSide: "right",
          setTooltipContent: g
        });
      }
      function t0(_ref58) {
        var e = _ref58.formatter,
          t = _ref58.sampleRate,
          r = _ref58.totalLeft,
          n = _ref58.leftTicks,
          a = _ref58.totalRight,
          i = _ref58.rightTicks,
          o = _ref58.title,
          l = _ref58.units;
        var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Aa;
        var h = r / n,
          g = a / i,
          y = ui(h),
          C = ui(g),
          H = {
            percent: "".concat(y, "%"),
            samples: wo(r),
            units: l,
            formattedValue: e.format(r, t),
            tooltipType: "flamegraph"
          },
          z = {
            percent: "".concat(C, "%"),
            samples: wo(a),
            units: l,
            formattedValue: e.format(a, t),
            tooltipType: "flamegraph"
          },
          F = r0(y, C);
        var R = "";
        F > 0 ? R = u.badColor.rgb().string() : F < 0 && (R = u.goodColor.rgb().string());
        var D = "";
        return r ? a ? F > 0 ? D = "(+".concat(F.toFixed(2), "%)") : F < 0 && (D = "(".concat(F.toFixed(2), "%)")) : D = "(removed)" : D = "(new)", {
          title: {
            text: o,
            diff: {
              text: D,
              color: R
            }
          },
          tooltipData: [H, z]
        };
      }
      function r0(e, t) {
        return (t - e) / e * 100;
      }
      var n0 = {
        dummy: "_8jsg5CgIlsOOE89k5kk7iA=="
      };
      var Su = Object.getOwnPropertySymbols,
        a0 = Object.prototype.hasOwnProperty,
        i0 = Object.prototype.propertyIsEnumerable,
        o0 = function o0(e, t) {
          var r = {};
          for (var n in e) {
            a0.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          }
          if (e != null && Su) {
            var _iterator37 = _createForOfIteratorHelper(Su(e)),
              _step37;
            try {
              for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
                var n = _step37.value;
                t.indexOf(n) < 0 && i0.call(e, n) && (r[n] = e[n]);
              }
            } catch (err) {
              _iterator37.e(err);
            } finally {
              _iterator37.f();
            }
          }
          return r;
        };
      function s0(e) {
        var t = bs(!1),
          r = t.openMenu,
          n = t.closeMenu,
          a = o0(t, ["openMenu", "closeMenu"]),
          _c$useState7 = c().useState({
            x: 0,
            y: 0
          }),
          _c$useState8 = _slicedToArray(_c$useState7, 2),
          i = _c$useState8[0],
          o = _c$useState8[1],
          l = e.canvasRef,
          _c$useState9 = c().useState([]),
          _c$useState10 = _slicedToArray(_c$useState9, 2),
          u = _c$useState10[0],
          h = _c$useState10[1],
          g = e.xyToMenuItems,
          y = e.onClose,
          C = e.onOpen,
          H = function H() {
            n(), y();
          };
        return c().useEffect(function () {
          n();
          var z = l.current;
          if (!z) return function () {};
          var F = function F(R) {
            R.preventDefault();
            var D = g(R.offsetX, R.offsetY);
            h(D);
            var re = R.clientX,
              oe = R.clientY + 20;
            o({
              x: re,
              y: oe
            }), r(), C(R.offsetX, R.offsetY);
          };
          return z.addEventListener("contextmenu", F), function () {
            z.removeEventListener("contextmenu", F);
          };
        }, [g]), c().createElement(ws, {
          className: n0.dummy,
          menuItemFocus: a.menuItemFocus,
          isMounted: a.isMounted,
          isOpen: a.isOpen,
          anchorPoint: i,
          onClose: H
        }, u);
      }
      var l0 = {
        logoLink: "HqveVyKaVoFyC4vstbKG5g=="
      };
      function c0() {
        return c().createElement("svg", {
          width: "22px",
          height: "22px",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg"
        }, c().createElement("defs", null, c().createElement("radialGradient", {
          cx: "49.4236252%",
          cy: "92.6627823%",
          fx: "49.4236252%",
          fy: "92.6627823%",
          r: "195.066755%",
          gradientTransform: "translate(0.494236,0.926628),scale(1.000000,0.735610),rotate(-90.000000),translate(-0.494236,-0.926628)",
          id: "radialGradient-1"
        }, c().createElement("stop", {
          stopColor: "#FFB90C",
          offset: "0%"
        }), c().createElement("stop", {
          stopColor: "#F9243A",
          offset: "38.390924%"
        }), c().createElement("stop", {
          stopColor: "#F9243A",
          offset: "50.5405%"
        }), c().createElement("stop", {
          stopColor: "#B51424",
          offset: "73.98091%"
        }), c().createElement("stop", {
          stopColor: "#B51424",
          offset: "100%"
        }))), c().createElement("g", {
          id: "Artboard",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, c().createElement("g", {
          id: "fire-part",
          transform: "translate(148.516736, 0.000000)",
          fillRule: "nonzero"
        }, c().createElement("g", {
          id: "whole-thing",
          transform: "translate(363.983264, 495.000000) scale(-1, 1) rotate(-180.000000) translate(-363.983264, -495.000000) translate(0.483264, 0.000000)"
        }, c().createElement("g", {
          id: "g70",
          transform: "translate(-0.000091, 0.685815)",
          fill: "url(#radialGradient-1)"
        }, c().createElement("path", {
          d: "M65.3646667,571.739321 L65.4492471,571.698868 C19.5139147,505.999969 -5.32464048,424.477859 1.04305801,336.877516 L1.04305801,336.877516 C14.0321963,158.179446 159.192462,13.7596653 338.059844,1.5917266 L338.059844,1.5917266 C419.418369,-3.93888015 495.500283,17.3823334 558.456522,57.4611191 L558.456522,57.4611191 L481.301947,162.097965 C437.516468,136.521928 399.367671,129.590556 363.486536,130.155994 L363.486536,130.155994 C234.497143,130.155994 129.556988,235.032238 129.556988,363.946998 L129.556988,363.946998 C129.556988,492.865683 234.497143,597.738003 363.486536,597.738003 L363.486536,597.738003 C492.483783,597.738003 597.427864,492.865683 597.427864,363.946998 L597.427864,363.946998 C597.41276,304.634864 581.39383,255.677522 530.630465,199.668053 L607.770843,95.1329436 C680.936847,161.576603 726.932594,257.364176 726.932594,363.946998 L726.932594,363.946998 C726.932594,458.031616 691.13483,543.75602 632.416071,608.271816 L632.416071,608.271816 L632.416071,608.275741 L533.597728,748.122808 L428.601388,617.203806 L434.703262,646.563419 C459.453008,765.59222 433.664131,889.543925 363.49439,988.853335 L363.49439,988.853335 L65.3646667,571.723019 L65.3646667,571.739321 Z",
          id: "path84"
        })), c().createElement("g", {
          id: "blue",
          transform: "translate(191.447039, 191.331780)"
        }, c().createElement("g", {
          id: "g88",
          transform: "translate(-0.000063, 0.685930)"
        }, c().createElement("g", {
          id: "g94",
          transform: "translate(0.177296, 0.699054)",
          fill: "#3EC1D3"
        }, c().createElement("path", {
          d: "M171.862466,343.697728 C77.0961324,343.697728 -0.00497405932,266.647602 -0.00497405932,171.934957 C-0.00497405932,77.2182874 77.0961324,0.168162396 171.862466,0.168162396 C266.632828,0.168162396 343.741988,77.2182874 343.741988,171.934957 C343.741988,266.647602 266.632828,343.697728 171.862466,343.697728",
          id: "path96"
        })), c().createElement("g", {
          id: "g98",
          transform: "translate(29.362379, 172.629585)",
          fill: "#FFFFFF"
        }, c().createElement("path", {
          d: "M22.8397982,0 L0.671669409,0 C0.671669409,78.2496309 64.380874,141.920035 142.678189,141.920035 L142.678189,119.765407 C76.6007327,119.765407 22.8397982,66.0372141 22.8397982,0",
          id: "path100"
        }))))))));
      }
      function u0() {
        return c().createElement("a", {
          className: l0.logoLink,
          href: "https://github.com/pyroscope-io/pyroscope/",
          target: "_blank",
          rel: "noreferrer"
        }, [c0(), c().createElement("span", null, "Pyroscope")]);
      }
      var fo = {
        flamegraphHeader: "F5gLmM2HlBS6Lh2eA+TOLA==",
        row: "-11Zgjyiq3PJ2gS11OZevw==",
        flamegraphTitle: "Jw-yvX-dsWn+UNQdvsw+FQ==",
        buttons: "X-KASulGPmT7oMsRdlQqnA=="
      };
      var f0 = pe(779),
        Cu = pe.n(f0);
      var Ss = {
        "flamegraph-legend": "PETh3MyDcaGQCI1Nw0+g+g==",
        "flamegraph-legend-list": "A3ypFowL4h2Jv2vkSIjs6Q==",
        "flamegraph-legend-item": "h-tSfWrzSrCEL9uo2nsHtA=="
      };
      function Mu(e) {
        var t = e.palette,
          r = e.showMode,
          n = d0(r),
          a = yl(t);
        return c().createElement("div", {
          "data-testid": "flamegraph-legend",
          className: "".concat(Ss["flamegraph-legend"], " ").concat(Ss["flamegraph-legend-list"])
        }, n.map(function (i) {
          return c().createElement("div", {
            key: i,
            className: Ss["flamegraph-legend-item"],
            style: {
              backgroundColor: a(i).rgb().toString()
            }
          }, i > 0 ? "+" : "", i, "%");
        }));
      }
      function d0(e) {
        switch (e) {
          case "large":
            return [-100, -80, -60, -40, -20, -10, 0, 10, 20, 40, 60, 80, 100];
          case "small":
            return [-100, -40, -20, 0, 20, 40, 100];
          default:
            throw new Error("Unsupported ".concat(e));
        }
      }
      function Nu() {
        return c().createElement("svg", {
          version: "1.1",
          id: "Capa_1",
          xmlns: "http://www.w3.org/2000/svg",
          x: "0px",
          y: "0px",
          width: "12px",
          height: "12px",
          viewBox: "0 0 405.272 405.272"
        }, c().createElement("g", null, c().createElement("path", {
          d: "M393.401,124.425L179.603,338.208c-15.832,15.835-41.514,15.835-57.361,0L11.878,227.836\n\n\t\tc-15.838-15.835-15.838-41.52,0-57.358c15.841-15.841,41.521-15.841,57.355-0.006l81.698,81.699L336.037,67.064\n\n\t\tc15.841-15.841,41.523-15.829,57.358,0C409.23,82.902,409.23,108.578,393.401,124.425z"
        })));
      }
      var Cs = {
        dropdownMenu: "J678hvn1r+E07yCv8bQwPQ==",
        dropdownMenuButton: "tKAw4h6chUOdq3FlfFl3Iw=="
      };
      var Pu = Object.getOwnPropertySymbols,
        h0 = Object.prototype.hasOwnProperty,
        p0 = Object.prototype.propertyIsEnumerable,
        m0 = function m0(e, t) {
          var r = {};
          for (var n in e) {
            h0.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          }
          if (e != null && Pu) {
            var _iterator38 = _createForOfIteratorHelper(Pu(e)),
              _step38;
            try {
              for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                var n = _step38.value;
                t.indexOf(n) < 0 && p0.call(e, n) && (r[n] = e[n]);
              }
            } catch (err) {
              _iterator38.e(err);
            } finally {
              _iterator38.f();
            }
          }
          return r;
        };
      function Ru(e) {
        var t = e,
          r = t.id,
          n = t.children,
          a = t.className,
          i = t.disabled,
          o = t.value,
          l = t.label,
          u = t.onItemClick,
          h = t.overflow,
          g = t.position,
          y = t.direction,
          C = t.align,
          H = t.viewScroll,
          z = t.arrow,
          F = t.offsetX,
          R = t.offsetY,
          _t$menuButtonClassNam = t.menuButtonClassName,
          D = _t$menuButtonClassNam === void 0 ? "" : _t$menuButtonClassNam,
          re = t.ariaLabel,
          oe = m0(t, ["id", "children", "className", "disabled", "value", "label", "onItemClick", "overflow", "position", "direction", "align", "viewScroll", "arrow", "offsetX", "offsetY", "menuButtonClassName", "ariaLabel"]);
        var we = oe.menuButton || c().createElement(Au, {
          "aria-label": re,
          className: "".concat(Cs.dropdownMenuButton, " ").concat(D),
          disabled: i,
          type: "button"
        }, o || l);
        return c().createElement(ys, {
          id: r,
          "aria-label": re,
          className: Cu()(a, Cs.dropdownMenu),
          "data-testid": oe["data-testid"],
          onItemClick: u,
          overflow: h,
          position: g,
          direction: y,
          align: C,
          viewScroll: H,
          arrow: z,
          offsetX: F,
          offsetY: R,
          menuButton: we
        }, c().createElement(tu, null, l), n);
      }
      var Iv = null,
        Iu = Ra,
        Au = Kc,
        Av = null,
        Dv = null,
        ho = {
          diffPaletteDropdown: "_6c8KIUK3wkkAS+zkvzR6PQ==",
          dropdownWrapper: "-ufQfGGUIgxKWexx4vHnlw==",
          dropdownItem: "ZmNLcnPdS72h63urXHirRw==",
          "rc-menu-item": "Vh5XCujqCzvUq1Sd4g0JLg==",
          row: "v0fu72DcFs5hE2iPZcxYbA=="
        },
        g0 = [Aa, qm],
        v0 = function v0(e) {
          var _e$palette = e.palette,
            t = _e$palette === void 0 ? Aa : _e$palette,
            r = e.onChange,
            n = c().useRef(null),
            a = y0(n);
          return c().createElement(c().Fragment, null, c().createElement("div", {
            className: ho.row,
            role: "heading",
            "aria-level": 2
          }, c().createElement("p", {
            style: {
              color: t.goodColor.rgb().string()
            }
          }, "(-) Removed"), c().createElement("p", {
            style: {
              color: t.badColor.rgb().string()
            }
          }, "Added (+)")), c().createElement("div", {
            ref: n,
            className: ho.dropdownWrapper
          }, c().createElement(Ru, {
            label: "Select a palette",
            menuButton: c().createElement(Au, {
              className: Cu()(Cs.dropdownMenuButton, ho.diffPaletteDropdown)
            }, c().createElement(Mu, {
              palette: t,
              showMode: a
            })),
            onItemClick: function onItemClick(i) {
              return r(i.value);
            }
          }, g0.map(function (i) {
            return c().createElement(Iu, {
              key: i.name,
              value: i
            }, c().createElement("div", null, c().createElement("label", null, i.name), c().createElement("div", {
              className: ho.dropdownItem
            }, c().createElement(Mu, {
              palette: i,
              showMode: a
            }), i === t ? c().createElement(Nu, null) : null)));
          }))));
        },
        b0 = 13 * 37,
        y0 = function y0(e) {
          var _c$useState11 = c().useState("large"),
            _c$useState12 = _slicedToArray(_c$useState11, 2),
            t = _c$useState12[0],
            r = _c$useState12[1],
            n = function n(a) {
              return a < b0 ? "small" : "large";
            };
          return c().useLayoutEffect(function () {
            if (e.current) {
              var _e$current$getBoundin = e.current.getBoundingClientRect(),
                a = _e$current$getBoundin.width;
              r(n(a));
            }
          }, [e.current]), ks(e, function (a) {
            r(n(a.contentRect.width));
          }), t;
        },
        Lv = null;
      function w0(e) {
        var t = e.format,
          r = e.units,
          _e$ExportData = e.ExportData,
          n = _e$ExportData === void 0 ? c().createElement(c().Fragment, null) : _e$ExportData,
          a = e.palette,
          i = e.setPalette,
          o = e.toolbarVisible,
          l = {
            objects: "number of objects in RAM per function",
            goroutines: "number of goroutines",
            bytes: "amount of RAM per function",
            samples: "CPU time per function",
            lock_nanoseconds: "time spent waiting on locks per function",
            lock_samples: "number of contended locks per function",
            trace_samples: "aggregated span duration",
            "": ""
          },
          h = o ? function () {
            switch (t) {
              case "single":
                return c().createElement("div", null, c().createElement("div", {
                  className: "".concat(fo.row, " ").concat(fo.flamegraphTitle),
                  role: "heading",
                  "aria-level": 2
                }, l[r] && c().createElement(c().Fragment, null, "Frame width represents ", l[r])));
              case "double":
                return c().createElement(c().Fragment, null, c().createElement(v0, {
                  palette: a,
                  onChange: i
                }));
              default:
                throw new Error("unexpected format ".concat(t));
            }
          }() : null;
        return c().createElement("div", {
          className: fo.flamegraphHeader
        }, c().createElement("div", null, h), n ? c().createElement("div", {
          className: fo.buttons
        }, n) : c().createElement(c().Fragment, null));
      }
      var _0 = {
        flamegraphPane: "sQhkbo9-hkp-QcidoRJEzQ=="
      };
      function x0(e) {
        var t = c().useRef(null),
          r = (0, _.useRef)(),
          _c$useState13 = c().useState(ot.nothing()),
          _c$useState14 = _slicedToArray(_c$useState13, 2),
          n = _c$useState14[0],
          a = _c$useState14[1],
          i = e.flamebearer,
          o = e.focusedNode,
          l = e.fitMode,
          u = e.highlightQuery,
          h = e.zoom,
          g = e.toolbarVisible,
          y = e.showCredit,
          C = e.setActiveItem,
          H = e.selectedItem,
          z = e.onZoom,
          F = e.onReset,
          R = e.isDirty,
          D = e.onFocusOnNode,
          re = e.ExportData,
          oe = e["data-testid"],
          we = e.palette,
          ve = e.setPalette,
          Pe = (0, _.useCallback)(Sm()(function () {
            Je();
          }, 50), []);
        ks(t, function () {
          r && Pe();
        });
        var U = function U(Ie) {
            var Oe = rt().xyToBar(Ie.nativeEvent.offsetX, Ie.nativeEvent.offsetY);
            Oe.match({
              Nothing: function Nothing() {},
              Just: function Just(at) {
                h.match({
                  Nothing: function Nothing() {
                    z(Oe);
                  },
                  Just: function Just(xt) {
                    at.i === xt.i && at.j === xt.j ? z(ot.nothing()) : z(Oe);
                  }
                });
              }
            });
          },
          ie = function ie(Ie, Oe) {
            return rt().xyToBar(Ie, Oe).map(function (xt) {
              return {
                left: Ye().offsetLeft + xt.x,
                top: Ye().offsetTop + xt.y,
                width: xt.width
              };
            });
          },
          de = function de(Ie, Oe) {
            return rt().xyToBar(Ie, Oe);
          },
          ye = function ye() {
            a(ot.nothing());
          },
          ne = function ne(Ie, Oe) {
            a(ie(Ie, Oe));
          },
          Ne = (0, _.useCallback)(function (Ie, Oe) {
            var at = R(),
              xt = rt().xyToBar(Ie, Oe),
              ir = xt.isJust ? xt.value.name : "",
              St = function St() {
                var Nt = xt.mapOrElse(function () {
                    return !1;
                  }, function () {
                    return !0;
                  }),
                  Pr = xt.mapOrElse(function () {
                    return function () {};
                  }, function (Ot) {
                    return D.bind(null, Ot.i, Ot.j);
                  });
                return c().createElement(Ra, {
                  key: "focus",
                  disabled: !Nt,
                  onClick: Pr
                }, c().createElement(Hr, {
                  icon: Dc.V9
                }), "Collapse nodes above");
              },
              or = function or() {
                var Nt = function Nt() {
                  !navigator.clipboard || navigator.clipboard.writeText(ir);
                };
                return c().createElement(Ra, {
                  key: "copy",
                  onClick: Nt
                }, c().createElement(Hr, {
                  icon: Ip.kZ
                }), "Copy function name");
              },
              Et = function Et() {
                var Nt = function Nt() {
                    C({
                      name: ir
                    });
                  },
                  Pr = H.isJust && H.value === ir ? "Clear highlight" : "Highlight similar nodes";
                return c().createElement(Ra, {
                  key: "highlight-similar-nodes",
                  onClick: Nt
                }, c().createElement(Hr, {
                  icon: Ap.Y6
                }), Pr);
              };
            return [c().createElement(Ra, {
              key: "reset",
              disabled: !at,
              onClick: F
            }, c().createElement(Hr, {
              icon: Rp.XS
            }), "Reset View"), St(), or(), Et()];
          }, [r, H]),
          ge = function ge() {
            if (t.current) {
              var Ie = new Nl(i, t.current, o, l, u, h, we);
              r.current = Ie;
            }
          };
        c().useEffect(function () {
          ge(), Je();
        }, [we]), c().useEffect(function () {
          ge(), Je();
        }, [t.current, i, o, l, u, h]);
        var Je = function Je() {
            var Ie, Oe, at;
            (Ie = t == null ? void 0 : t.current) == null || Ie.setAttribute("data-state", "rendering"), (Oe = r == null ? void 0 : r.current) == null || Oe.render(), (at = t == null ? void 0 : t.current) == null || at.setAttribute("data-state", "rendered");
          },
          pt = !i || i && i.names.length <= 1,
          Ye = function Ye() {
            if (!t.current) throw new Error("Missing canvas");
            return t.current;
          },
          rt = function rt() {
            if (!r.current) throw new Error("Missing canvas");
            return r.current;
          };
        return c().createElement("div", {
          "data-testid": "flamegraph-view",
          className: sn(_0.flamegraphPane, {
            "vertical-orientation": i.format === "double"
          })
        }, c().createElement(w0, {
          format: i.format,
          units: i.units,
          ExportData: re,
          palette: we,
          setPalette: ve,
          toolbarVisible: g
        }), c().createElement("div", {
          "data-testid": oe,
          style: {
            opacity: pt ? 0 : 1
          }
        }, c().createElement("canvas", {
          height: "0",
          "data-testid": "flamegraph-canvas",
          "data-highlightquery": u,
          className: sn("flamegraph-canvas", Cm.canvas),
          ref: t,
          onClick: U
        })), y ? c().createElement(u0, null) : "", r && t && c().createElement(Lm, {
          barHeight: ta,
          canvasRef: t,
          zoom: h,
          xyToHighlightData: ie
        }), r && c().createElement(Hm, {
          barHeight: ta,
          node: n
        }), r && c().createElement(e0, {
          format: i.format,
          canvasRef: t,
          xyToData: de,
          numTicks: i.numTicks,
          sampleRate: i.sampleRate,
          leftTicks: i.format === "double" ? i.leftTicks : 0,
          rightTicks: i.format === "double" ? i.rightTicks : 0,
          units: i.units,
          palette: we
        }), r && t && c().createElement(s0, {
          canvasRef: t,
          xyToMenuItems: Ne,
          onClose: ye,
          onOpen: ne
        }));
      }
      var sa = {
        table: "lEpSh-rOmaE5zcLKRPK0zg==",
        sortable: "EgDtrXnincRVPXTb58YV7g==",
        sortArrow: "K8lX8n2m68NgdYq1vXrGQA==",
        asc: "kf05VUyDM4gEXaiYchZLDQ==",
        desc: "SwVSTFb7+JtI0Ter5socwQ==",
        isRowSelected: "+NsZxUzwZfmKMTT3UeTBug==",
        isRowDisabled: "Jhqi+nxb2FEJkOLMACjE0A==",
        loadingSpinner: "uqa4BHuGVRjAsdPIyEz8KQ=="
      };
      var E0 = pe(424),
        O0 = pe.n(E0);
      function T0(_ref59) {
        var e = _ref59.className;
        return c().createElement("span", {
          role: "progressbar",
          className: e
        }, c().createElement(O0(), {
          color: "rgba(255,255,255,0.6)",
          size: "20px"
        }));
      }
      var k0 = Object.defineProperty,
        S0 = Object.defineProperties,
        C0 = Object.getOwnPropertyDescriptors,
        po = Object.getOwnPropertySymbols,
        Du = Object.prototype.hasOwnProperty,
        Lu = Object.prototype.propertyIsEnumerable,
        Fu = function Fu(e, t, r) {
          return t in e ? k0(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        mo = function mo(e, t) {
          for (var r in t || (t = {})) {
            Du.call(t, r) && Fu(e, r, t[r]);
          }
          if (po) {
            var _iterator39 = _createForOfIteratorHelper(po(t)),
              _step39;
            try {
              for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                var r = _step39.value;
                Lu.call(t, r) && Fu(e, r, t[r]);
              }
            } catch (err) {
              _iterator39.e(err);
            } finally {
              _iterator39.f();
            }
          }
          return e;
        },
        ju = function ju(e, t) {
          return S0(e, C0(t));
        },
        Ms = function Ms(e, t) {
          var r = {};
          for (var n in e) {
            Du.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          }
          if (e != null && po) {
            var _iterator40 = _createForOfIteratorHelper(po(e)),
              _step40;
            try {
              for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                var n = _step40.value;
                t.indexOf(n) < 0 && Lu.call(e, n) && (r[n] = e[n]);
              }
            } catch (err) {
              _iterator40.e(err);
            } finally {
              _iterator40.f();
            }
          }
          return r;
        };
      var M0 = function M0(e) {
        var t = e.filter(function (l) {
            return l == null ? void 0 : l.default;
          })[0] || e[0],
          _ref60 = (0, _.useState)(t.name),
          _ref61 = _slicedToArray(_ref60, 2),
          r = _ref61[0],
          n = _ref61[1],
          _ref62 = (0, _.useState)("desc"),
          _ref63 = _slicedToArray(_ref62, 2),
          a = _ref63[0],
          i = _ref63[1];
        return {
          sortBy: r,
          sortByDirection: a,
          updateSortParams: function updateSortParams(l) {
            var u = a;
            r === l ? u = u === "asc" ? "desc" : "asc" : u = "desc", n(l), i(u);
          }
        };
      };
      function N0(_ref64) {
        var e = _ref64.sortByDirection,
          t = _ref64.sortBy,
          r = _ref64.updateSortParams,
          n = _ref64.table,
          a = _ref64.tableBodyRef,
          i = _ref64.className,
          o = _ref64.isLoading;
        var l;
        var u = e && t && r;
        return o ? c().createElement("div", {
          className: sa.loadingSpinner
        }, c().createElement(T0, null)) : c().createElement("table", {
          className: sn(sa.table, _defineProperty({}, i || "", i)),
          "data-testid": "table-ui"
        }, c().createElement("thead", null, c().createElement("tr", null, n.headRow.map(function (h, g) {
          var y = h,
            C = y.sortable,
            H = y.label,
            z = y.name,
            F = Ms(y, ["sortable", "label", "name"]);
          return !C || n.type === "not-filled" || !u ? c().createElement("th", mo({
            key: g
          }, F), H) : c().createElement("th", ju(mo({}, F), {
            key: g,
            className: sa.sortable,
            onClick: function onClick() {
              return r(z);
            }
          }), H, c().createElement("span", {
            className: sn(sa.sortArrow, _defineProperty({}, sa[e], t === z))
          }));
        }))), c().createElement("tbody", {
          ref: a
        }, n.type === "not-filled" ? c().createElement("tr", {
          className: n == null ? void 0 : n.bodyClassName
        }, c().createElement("td", {
          colSpan: n.headRow.length
        }, n.value)) : (l = n.bodyRows) == null ? void 0 : l.map(function (h) {
          var _sn5;
          var g = h,
            y = g.cells,
            C = g.isRowSelected,
            H = g.isRowDisabled,
            z = g.className,
            F = Ms(g, ["cells", "isRowSelected", "isRowDisabled", "className"]);
          var R = Math.random();
          return c().createElement("tr", ju(mo({
            key: R
          }, F), {
            className: sn(z, (_sn5 = {}, _defineProperty(_sn5, sa.isRowSelected, C), _defineProperty(_sn5, sa.isRowDisabled, H), _sn5))
          }), y && y.map(function (D, re) {
            var oe = D,
              we = oe.style,
              ve = oe.value,
              Pe = Ms(oe, ["style", "value"]);
            return c().createElement("td", mo({
              key: R + re,
              style: we
            }, Pe), ve);
          }));
        })));
      }
      var P0 = N0;
      function R0(_ref65) {
        var e = _ref65.numTicks,
          t = _ref65.sampleRate,
          r = _ref65.units,
          n = _ref65.tableBodyRef;
        var a = Li(e, t, r),
          i = a.format(e, t),
          o = (0, _.useCallback)(function (l, u, h) {
            var g;
            var y = (g = h.target.closest("tr")) == null ? void 0 : g.dataset.row;
            if (!y) {
              u();
              return;
            }
            var _y$split = y.split(";"),
              _y$split2 = _slicedToArray(_y$split, 3),
              C = _y$split2[0],
              H = _y$split2[1],
              z = _y$split2[2],
              F = a.format(parseInt(H, 10), t),
              R = a.format(parseInt(z, 10), t),
              D = i.split(" "),
              re = D[0] === "<" ? D[1] : D[0],
              oe = F.split(" "),
              we = oe[0] === "<" ? oe[1] : oe[0],
              ve = R.split(" "),
              Pe = ve[0] === "<" ? ve[1] : ve[0],
              U = {
                units: r,
                self: "".concat(F, "(").concat((parseFloat(we) / parseFloat(re) * 100).toFixed(2), "%)"),
                total: "".concat(R, "(").concat((parseFloat(Pe) / parseFloat(re) * 100).toFixed(2), "%)"),
                tooltipType: "table"
              };
            l({
              title: {
                text: C,
                diff: {
                  text: "",
                  color: ""
                }
              },
              tooltipData: [U]
            });
          }, [n, e, a, t]);
        return c().createElement(Tu, {
          dataSourceRef: n,
          shouldShowTitle: !1,
          clickInfoSide: "left",
          setTooltipContent: o
        });
      }
      var I0 = Object.defineProperty,
        A0 = Object.defineProperties,
        D0 = Object.getOwnPropertyDescriptors,
        Bu = Object.getOwnPropertySymbols,
        L0 = Object.prototype.hasOwnProperty,
        F0 = Object.prototype.propertyIsEnumerable,
        zu = function zu(e, t, r) {
          return t in e ? I0(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        $u = function $u(e, t) {
          for (var r in t || (t = {})) {
            L0.call(t, r) && zu(e, r, t[r]);
          }
          if (Bu) {
            var _iterator41 = _createForOfIteratorHelper(Bu(t)),
              _step41;
            try {
              for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                var r = _step41.value;
                F0.call(t, r) && zu(e, r, t[r]);
              }
            } catch (err) {
              _iterator41.e(err);
            } finally {
              _iterator41.f();
            }
          }
          return e;
        },
        j0 = function j0(e, t) {
          return A0(e, D0(t));
        };
      var Gr = function Gr(e) {
        return e || 0;
      };
      function B0(e, t, r, n) {
        var a = t;
        return a.type = "single", a.self = Gr(a.self) + e.getBarSelf(r, n), a.total = Gr(a.total) + e.getBarTotal(r, n), a;
      }
      function z0(e, t, r, n) {
        var a = t;
        return a.type = "double", a.self = Gr(a.self) + e.getBarSelf(r, n), a.total = Gr(a.total) + e.getBarTotal(r, n), a.selfLeft = Gr(a.selfLeft) + e.getBarSelfLeft(r, n), a.selfRght = Gr(a.selfRght) + e.getBarSelfRght(r, n), a.selfDiff = Gr(a.selfDiff) + e.getBarSelfDiff(r, n), a.totalLeft = Gr(a.totalLeft) + e.getBarTotalLeft(r, n), a.totalRght = Gr(a.totalRght) + e.getBarTotalRght(r, n), a.totalDiff = Gr(a.totalDiff) + e.getBarTotalDiff(r, n), a;
      }
      function $0(e) {
        var t = [];
        if (!e) return t;
        var r = e.names,
          n = e.levels,
          a = e.format,
          i = a !== "double" ? ct : ht,
          o = {};
        for (var l = 0; l < n.length; l++) {
          var u = n[l];
          for (var h = 0; h < u.length; h += i.jStep) {
            var g = i.getBarName(u, h),
              y = r[g];
            o[y] = o[y] || {
              name: y || "<empty>"
            }, a === "single" ? B0(ct, o[y], u, h) : z0(ht, o[y], u, h);
          }
        }
        return Object.values(o);
      }
      function go(e) {
        return Math.min(0, e);
      }
      function Hu(e, t, r) {
        var a = 148 - e / t * 148,
          i = r.alpha(1);
        return {
          backgroundImage: "linear-gradient(".concat(i, ", ").concat(i, ")"),
          backgroundPosition: "-".concat(a, "px 0px"),
          backgroundRepeat: "no-repeat"
        };
      }
      function Da(e, t, r, n, a, i) {
        var l = 148 - Math.min(t, r) / n * 148,
          u = 148 - Math.max(t, r) / n * 148,
          h = a.alpha(1),
          g = r < t ? e.goodColor.alpha(.8) : e.badColor.alpha(.8);
        return i === "L" && t < r ? {
          backgroundImage: "linear-gradient(".concat(h, ", ").concat(h, ")"),
          backgroundPosition: "".concat(go(-l), "px 0px"),
          backgroundRepeat: "no-repeat"
        } : i === "R" && r < t ? {
          backgroundImage: "linear-gradient(".concat(h, ", ").concat(h, ")"),
          backgroundPosition: "".concat(go(-l), "px 0px"),
          backgroundRepeat: "no-repeat"
        } : {
          backgroundImage: "linear-gradient(".concat(h, ", ").concat(h, "), linear-gradient(").concat(g, ", ").concat(g, ")"),
          backgroundPosition: "".concat(go(-l), "px 0px, ").concat(go(-u), "px 0px"),
          backgroundRepeat: "no-repeat"
        };
      }
      var H0 = [{
          sortable: 1,
          name: "name",
          label: "Location"
        }, {
          sortable: 1,
          name: "self",
          label: "Self",
          default: !0
        }, {
          sortable: 1,
          name: "total",
          label: "Total"
        }],
        U0 = function (e) {
          return {
            diff: [e.name, e.selfDiff, e.totalDiff],
            self: [e.name, e.selfLeft, e.selfRght],
            total: [e.name, e.totalLeft, e.totalRght]
          };
        }({
          name: {
            sortable: 1,
            name: "name",
            label: "Location"
          },
          selfLeft: {
            sortable: 1,
            name: "selfLeft",
            label: "Self (Left)",
            default: !0
          },
          selfRght: {
            sortable: 1,
            name: "selfRght",
            label: "Self (Right)"
          },
          selfDiff: {
            sortable: 1,
            name: "selfDiff",
            label: "Self (Diff)",
            default: !0
          },
          totalLeft: {
            sortable: 1,
            name: "totalLeft",
            label: "Total (Left)",
            default: !0
          },
          totalRght: {
            sortable: 1,
            name: "totalRght",
            label: "Total (Right)"
          },
          totalDiff: {
            sortable: 1,
            name: "totalDiff",
            label: "Total (Diff)"
          }
        });
      function Z0(_ref66) {
        var e = _ref66.tableBodyRef,
          t = _ref66.flamebearer,
          r = _ref66.viewDiff,
          n = _ref66.fitMode,
          a = _ref66.handleTableItemClick,
          i = _ref66.highlightQuery,
          o = _ref66.selectedItem,
          l = _ref66.palette;
        var u = r ? U0[r] : H0,
          h = M0(u),
          g = $u({
            headRow: u
          }, V0({
            flamebearer: t,
            sortBy: h.sortBy,
            sortByDirection: h.sortByDirection,
            viewDiff: r,
            fitMode: n,
            handleTableItemClick: a,
            highlightQuery: i,
            palette: l,
            selectedItem: o
          }));
        return c().createElement(P0, j0($u({}, h), {
          tableBodyRef: e,
          table: g,
          className: "flamegraph-table"
        }));
      }
      var V0 = function V0(_ref67) {
        var e = _ref67.flamebearer,
          t = _ref67.sortBy,
          r = _ref67.sortByDirection,
          n = _ref67.viewDiff,
          a = _ref67.fitMode,
          i = _ref67.handleTableItemClick,
          o = _ref67.highlightQuery,
          l = _ref67.palette,
          u = _ref67.selectedItem;
        var h = e.numTicks,
          g = e.maxSelf,
          y = e.sampleRate,
          C = e.spyName,
          H = e.units,
          z = $0(e).sort(function (U, ie) {
            return ie.total - U.total;
          }),
          F = r === "asc" ? 1 : -1;
        var R;
        if (t === "name") R = z.sort(function (U, ie) {
          return F * U[t].localeCompare(ie[t]);
        });else switch (t) {
          case "total":
          case "self":
            {
              R = z.sort(function (U, ie) {
                return F * (U[t] - ie[t]);
              });
              break;
            }
          default:
            R = z.sort(function (U, ie) {
              return F * (U[t] - ie[t]);
            });
        }
        var D = Li(h, y, H),
          re = function re(U) {
            return u.isJust ? U === u.value : !1;
          },
          oe = function oe(U, ie) {
            return c().createElement("button", {
              className: "table-item-button"
            }, c().createElement("span", {
              className: "color-reference",
              style: ie
            }), c().createElement("div", {
              className: "symbol-name",
              style: xf(a)
            }, U.name));
          },
          we = function we(U, ie, de) {
            return {
              "data-row": "".concat(U.name, ";").concat(U.self, ";").concat(U.total, ";").concat(U.type),
              isRowSelected: re(U.name),
              onClick: function onClick() {
                return i(U);
              },
              cells: [{
                value: oe(U, de)
              }, {
                value: D.format(U.self, y),
                style: Hu(U.self, g, ie)
              }, {
                value: D.format(U.total, y),
                style: Hu(U.total, h, ie)
              }]
            };
          },
          ve = function () {
            switch (n) {
              case "self":
                return function (U, ie, de) {
                  return {
                    type: "self",
                    isRowSelected: re(U.name),
                    onClick: function onClick() {
                      return i(U);
                    },
                    cells: [{
                      value: oe(U, de)
                    }, {
                      style: Da(l, U.selfLeft, U.selfRght, g, ie, "L"),
                      value: function () {
                        return c().createElement("span", {
                          title: D.format(U.selfLeft, y)
                        }, D.format(U.selfLeft, y));
                      }()
                    }, {
                      style: Da(l, U.selfLeft, U.selfRght, g, ie, "R"),
                      value: c().createElement("span", {
                        title: D.format(U.selfRght, y)
                      }, D.format(U.selfRght, y))
                    }]
                  };
                };
              case "total":
                return function (U, ie, de) {
                  return {
                    type: "total",
                    isRowSelected: re(U.name),
                    onClick: function onClick() {
                      return i(U);
                    },
                    cells: [{
                      value: oe(U, de)
                    }, {
                      style: Da(l, U.totalLeft, U.totalRght, h / 2, ie, "L"),
                      value: function () {
                        return c().createElement("span", {
                          title: D.format(U.totalLeft, y)
                        }, D.format(U.totalLeft, y));
                      }()
                    }, {
                      style: Da(l, U.totalLeft, U.totalRght, h / 2, ie, "R"),
                      value: function () {
                        return c().createElement("span", {
                          title: D.format(U.totalRght, y)
                        }, D.format(U.totalRght, y));
                      }()
                    }]
                  };
                };
              case "diff":
                return function (U, ie, de) {
                  return {
                    type: "diff",
                    isRowSelected: re(U.name),
                    onClick: function onClick() {
                      return i(U);
                    },
                    cells: [{
                      value: oe(U, de)
                    }, {
                      style: Da(l, U.selfLeft, U.selfRght, g, gl),
                      value: function () {
                        return c().createElement("span", {
                          title: D.format(U.selfDiff, y)
                        }, D.format(U.selfDiff, y));
                      }()
                    }, {
                      style: Da(l, U.totalLeft, U.totalRght, h / 2, ie),
                      value: function () {
                        return c().createElement("span", {
                          title: D.format(U.totalDiff, y)
                        }, D.format(U.totalDiff, y));
                      }()
                    }]
                  };
                };
              default:
                return function () {
                  return {
                    type: "unsupported"
                  };
                };
            }
          }(),
          Pe = R.filter(function (U) {
            return o ? wl(o, U.name) : !0;
          }).reduce(function (U, ie) {
            var de = vl(C, ie.name),
              ye = n ? gl : bl(l, de),
              ne = {
                backgroundColor: ye.rgb().toString()
              };
            if (ie.type === "double") {
              var Ne = ve(ie, ye, ne);
              return Ne.type === "unsupported" || U.push(Ne), U;
            }
            return U.push(we(ie, ye, ne)), U;
          }, []);
        return Pe.length > 0 ? {
          bodyRows: Pe,
          type: "filled"
        } : {
          value: c().createElement("div", {
            className: "unsupported-format"
          }, "Unsupported"),
          type: "not-filled"
        };
      };
      function G0(_ref68) {
        var e = _ref68.flamebearer,
          t = _ref68.viewDiff,
          r = _ref68.fitMode,
          n = _ref68.handleTableItemClick,
          a = _ref68.highlightQuery,
          i = _ref68.palette,
          o = _ref68.selectedItem;
        var l = (0, _.useRef)(null);
        return c().createElement(c().Fragment, null, c().createElement(Z0, {
          tableBodyRef: l,
          flamebearer: e,
          viewDiff: t,
          fitMode: r,
          highlightQuery: a,
          handleTableItemClick: n,
          palette: i,
          selectedItem: o
        }), c().createElement(R0, {
          tableBodyRef: l,
          numTicks: e.numTicks,
          sampleRate: e.sampleRate,
          units: e.units
        }));
      }
      var W0 = pe(899),
        J0 = pe(459),
        X0 = pe(971),
        q0 = pe(384),
        K0 = pe(646),
        Y0 = pe(769),
        Q0 = pe(692);
      var la = {
        button: "D8639n1+pFnktQbfHEdhiQ==",
        iconWithText: "iUJrf0Zra72Ylrkdwe4m3g==",
        default: "HsSMSsZ6IvGC0zvef-oyEg==",
        primary: "uRSawyfmnPCTMB2RaexM7Q==",
        secondary: "uLhy-1n6bQNSjQ8XlHT5hA==",
        danger: "Zcv+sg60tkrHTHSCxMwOCA==",
        grouped: "h-JyltywHaflsNfDj7ETjw=="
      };
      var Uu = Object.getOwnPropertySymbols,
        eg = Object.prototype.hasOwnProperty,
        tg = Object.prototype.propertyIsEnumerable,
        rg = function rg(e, t) {
          var r = {};
          for (var n in e) {
            eg.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
          }
          if (e != null && Uu) {
            var _iterator42 = _createForOfIteratorHelper(Uu(e)),
              _step42;
            try {
              for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                var n = _step42.value;
                t.indexOf(n) < 0 && tg.call(e, n) && (r[n] = e[n]);
              }
            } catch (err) {
              _iterator42.e(err);
            } finally {
              _iterator42.f();
            }
          }
          return r;
        };
      function zn(e) {
        var t = e,
          _t$disabled = t.disabled,
          r = _t$disabled === void 0 ? !1 : _t$disabled,
          _t$kind = t.kind,
          n = _t$kind === void 0 ? "default" : _t$kind,
          _t$type = t.type,
          a = _t$type === void 0 ? "button" : _t$type,
          i = t.icon,
          o = t.children,
          l = t.grouped,
          u = t.onClick,
          h = t.id,
          g = t.className,
          y = rg(t, ["disabled", "kind", "type", "icon", "children", "grouped", "onClick", "id", "className"]);
        return c().createElement("button", {
          id: h,
          type: a,
          "data-testid": y["data-testid"],
          disabled: r,
          onClick: u,
          "aria-label": y["aria-label"],
          className: "".concat(la.button, " ").concat(l ? la.grouped : "", " ").concat(ng(n), " ").concat(g)
        }, i ? c().createElement(Hr, {
          icon: i,
          className: o ? la.iconWithText : ""
        }) : null, o);
      }
      function ng(e) {
        switch (e) {
          case "default":
            return la.default;
          case "primary":
            return la.primary;
          case "secondary":
            return la.secondary;
          case "danger":
            return la.danger;
          default:
            throw Error("Unsupported kind ".concat(e));
        }
      }
      var ag = {
        select: "OqcAa70--BCY73rHYPrNmg=="
      };
      function Zu(_ref69) {
        var e = _ref69.ariaLabel,
          t = _ref69.className,
          r = _ref69.value,
          n = _ref69.onChange,
          a = _ref69.children,
          i = _ref69.name,
          o = _ref69.id,
          l = _ref69.disabled;
        return c().createElement("select", {
          id: o,
          disabled: l || !1,
          name: i,
          "aria-label": e,
          className: "".concat(ag.select, " ").concat(t || ""),
          value: r,
          onChange: n
        }, a);
      }
      var ig = pe(687),
        og = pe(912);
      var sg = {
          input: "m7PZEM-Vxkue2eKuRu3yZQ=="
        },
        lg = c().forwardRef(function (_ref70, g) {
          var e = _ref70.testId,
            t = _ref70.className,
            r = _ref70.type,
            n = _ref70.name,
            a = _ref70.placeholder,
            _ref70$minLength = _ref70.minLength,
            i = _ref70$minLength === void 0 ? 0 : _ref70$minLength,
            _ref70$debounceTimeou = _ref70.debounceTimeout,
            o = _ref70$debounceTimeou === void 0 ? 100 : _ref70$debounceTimeou,
            l = _ref70.onChange,
            u = _ref70.value,
            h = _ref70.htmlId;
          return c().createElement(og.DebounceInput, {
            inputRef: g,
            "data-testid": e,
            className: "".concat(sg.input, " ").concat(t || ""),
            type: r,
            name: n,
            placeholder: a,
            minLength: i,
            debounceTimeout: o,
            onChange: l,
            value: u,
            id: h
          });
        }),
        Ns = {
          tooltip: "izIbNRLbF9xJDKe-4AJ+JQ==",
          left: "zT3KmMrzKP41T7FMS0SJtw==",
          right: "Xl2deKCyOq2flu8vgSgbjA==",
          bottom: "uG9bli7m866SO8q5AjDy3A==",
          top: "-bV6ZtBg6DRt5-1XGDZXSw==",
          visible: "sxcNNSa167Ke4esKRMThTw=="
        },
        cg = function cg(_ref71) {
          var e = _ref71.title,
            t = _ref71.visible,
            r = _ref71.className,
            n = _ref71.placement;
          var a;
          return c().createElement("div", {
            onClick: function onClick(i) {
              return i.stopPropagation();
            },
            className: "".concat(Ns.tooltip, " ").concat(t ? Ns.visible : "", " ").concat((a = Ns) == null ? void 0 : a[n], " ").concat(r || "", " "),
            role: "tooltip"
          }, e);
        },
        dn = {
          wrapper: "_1tNAjeMOzQp8uOuaYq+Hlg==",
          search: "Oa7YSy+wTDaxwMXZB4v5Gw==",
          "search-synced": "jaKSuzEc2kMgsQY1Ei1zIQ==",
          searchWithSync: "bMvkv+pO8CFQYIzcx9hNPw==",
          "search-small": "tgQzYT5gJmC8BxJWeVbhNg==",
          icon: "EXyIVsmmjw+Gmj5qWe4lFA==",
          checked: "bzaIPy4-2topIZ9a1V0log==",
          sync: "ZX3TafJkUlq6K5k390H1nw==",
          syncSelected: "dSO0qFp27L959Gj33bDomw=="
        },
        ug = function ug(e) {
          var t = (0, _.useRef)();
          return (0, _.useEffect)(function () {
            t.current = e;
          }), t.current;
        },
        fg = function fg(_ref72) {
          var e = _ref72.onHighlightChange,
            t = _ref72.showMode,
            r = _ref72.highlightQuery,
            n = _ref72.sharedQuery;
          var a = ug(n == null ? void 0 : n.syncEnabled),
            _ref73 = (0, _.useState)(!1),
            _ref74 = _slicedToArray(_ref73, 2),
            i = _ref74[0],
            o = _ref74[1],
            l = function l(y) {
              e(y.target.value), n && n.syncEnabled && n.onQueryChange(y.target.value);
            };
          (0, _.useEffect)(function () {
            typeof (n == null ? void 0 : n.searchQuery) == "string" && (n.syncEnabled && e(n.searchQuery), !n.syncEnabled && a && a !== (n == null ? void 0 : n.id) && e(""));
          }, [n == null ? void 0 : n.searchQuery, n == null ? void 0 : n.syncEnabled]);
          var u = function u() {
              var y = (n == null ? void 0 : n.syncEnabled) ? !1 : n == null ? void 0 : n.id;
              n == null || n.toggleSync(y), y ? n == null || n.onQueryChange(r) : (e(r), n == null || n.onQueryChange(""));
            },
            h = (0, _.useMemo)(function () {
              return n && n.syncEnabled ? n.searchQuery || "" : r;
            }, [n, r]),
            g = (0, _.useMemo)(function () {
              return "".concat(n ? dn.searchWithSync : dn.search, " ").concat(t === "small" ? dn["search-small"] : "", " ").concat((n == null ? void 0 : n.syncEnabled) ? dn["search-synced"] : "");
            }, [n, t]);
          return c().createElement("div", {
            className: dn.wrapper
          }, c().createElement(lg, {
            testId: "flamegraph-search",
            className: g,
            type: "search",
            name: "flamegraph-search",
            placeholder: "Search\u2026",
            minLength: 2,
            debounceTimeout: 100,
            onChange: l,
            value: h
          }), n ? c().createElement("button", {
            className: n.syncEnabled ? dn.syncSelected : dn.sync,
            onClick: u,
            onMouseEnter: function onMouseEnter() {
              return o(!0);
            },
            onMouseLeave: function onMouseLeave() {
              return o(!1);
            }
          }, c().createElement(Hr, {
            className: "".concat(n.syncEnabled ? dn.checked : dn.icon),
            icon: ig.nN
          }), c().createElement(cg, {
            placement: "top",
            visible: i,
            title: n.syncEnabled ? "Unsync search bars" : "Sync search bars"
          })) : null);
        },
        Mi = {
          navbar: "YA6yFCiTuhT9605JIjPYsA==",
          "space-filler": "cgRZhc4M4hYARCOdbJigOA==",
          fitModeDropdownMenuItem: "X3FRWBEqbFJ2BneRkbVfsA==",
          fitModeDropdownSmall: "hLxcZfkuovRKDwfNBljW1A==",
          fitModeDropdownLarge: "_7IQU1MziDWeX+DyRDdXHYg=="
        },
        dg = 900,
        hg = function hg(e) {
          var _c$useState15 = c().useState("large"),
            _c$useState16 = _slicedToArray(_c$useState15, 2),
            t = _c$useState16[0],
            r = _c$useState16[1],
            n = function n(a) {
              return a < dg ? "small" : "large";
            };
          return c().useLayoutEffect(function () {
            if (e.current) {
              var _e$current$getBoundin2 = e.current.getBoundingClientRect(),
                a = _e$current$getBoundin2.width;
              r(n(a));
            }
          }, [e.current]), ks(e, function (a) {
            r(n(a.contentRect.width));
          }), t;
        },
        pg = c().memo(function (_ref75) {
          var e = _ref75.view,
            t = _ref75.viewDiff,
            r = _ref75.handleSearchChange,
            n = _ref75.highlightQuery,
            a = _ref75.isFlamegraphDirty,
            i = _ref75.reset,
            o = _ref75.updateFitMode,
            l = _ref75.fitMode,
            u = _ref75.updateView,
            h = _ref75.updateViewDiff,
            g = _ref75.selectedNode,
            y = _ref75.onFocusOnSubtree,
            C = _ref75.flamegraphType,
            _ref75$disableChangin = _ref75.disableChangingDisplay,
            H = _ref75$disableChangin === void 0 ? !1 : _ref75$disableChangin,
            z = _ref75.sharedQuery;
          var F = c().useRef(null),
            R = hg(F);
          return c().createElement("div", {
            role: "toolbar",
            ref: F,
            "data-mode": R
          }, c().createElement("div", {
            className: Mi.navbar
          }, c().createElement(fg, {
            showMode: R,
            onHighlightChange: r,
            highlightQuery: n,
            sharedQuery: z
          }), C === "double" && c().createElement(bg, {
            showMode: R,
            viewDiff: t,
            updateViewDiff: h
          }), c().createElement("div", {
            className: Mi["space-filler"]
          }), c().createElement(vg, {
            showMode: R,
            fitMode: l,
            updateFitMode: o
          }), c().createElement(gg, {
            showMode: R,
            isFlamegraphDirty: a,
            reset: i
          }), c().createElement(mg, {
            showMode: R,
            selectedNode: g,
            onFocusOnSubtree: y
          }), !H && c().createElement(yg, {
            showMode: R,
            view: e,
            updateView: u
          })));
        });
      function mg(_ref76) {
        var e = _ref76.onFocusOnSubtree,
          t = _ref76.selectedNode,
          r = _ref76.showMode;
        var n = "";
        switch (r) {
          case "small":
            {
              n = "Collapse";
              break;
            }
          case "large":
            {
              n = "Collapse nodes above";
              break;
            }
          default:
            throw new Error("Wrong mode");
        }
        var a = t.mapOr(function () {}, function (i) {
          return function () {
            return e(i.i, i.j);
          };
        });
        return c().createElement(zn, {
          disabled: !t.isJust,
          onClick: a,
          icon: Dc.V9
        }, n);
      }
      function gg(_ref77) {
        var e = _ref77.isFlamegraphDirty,
          t = _ref77.reset,
          r = _ref77.showMode;
        var n = "";
        switch (r) {
          case "small":
            {
              n = "Reset";
              break;
            }
          case "large":
            {
              n = "Reset View";
              break;
            }
          default:
            throw new Error("Wrong mode");
        }
        return c().createElement(c().Fragment, null, c().createElement(zn, {
          id: "reset",
          "data-testid": "reset-view",
          disabled: !e,
          onClick: t,
          icon: Q0.X7
        }, n));
      }
      function vg(_ref78) {
        var _n4, _n5, _n6;
        var e = _ref78.fitMode,
          t = _ref78.updateFitMode,
          r = _ref78.showMode;
        var n = (_n4 = {
            label: ""
          }, _defineProperty(_n4, _a, ""), _defineProperty(_n4, wa, ""), _n4),
          a = "";
        switch (r) {
          case "small":
            n = (_n5 = {
              label: "Fit"
            }, _defineProperty(_n5, _a, "Head"), _defineProperty(_n5, wa, "Tail"), _n5), a = Mi.fitModeDropdownSmall;
            break;
          case "large":
            n = (_n6 = {
              label: "Prefer to Fit"
            }, _defineProperty(_n6, _a, "Head first"), _defineProperty(_n6, wa, "Tail first"), _n6), a = Mi.fitModeDropdownLarge;
            break;
          default:
            throw new Error("Wrong mode");
        }
        var o = [_a, wa].map(function (l) {
          return c().createElement(Iu, {
            key: l,
            value: l
          }, c().createElement("div", {
            className: Mi.fitModeDropdownMenuItem,
            "data-testid": l
          }, n[l], e === l ? c().createElement(Nu, null) : null));
        });
        return c().createElement(Ru, {
          label: n.label,
          ariaLabel: "Fit Mode",
          value: n[e],
          onItemClick: function onItemClick(l) {
            return t(l.value);
          },
          menuButtonClassName: a
        }, o);
      }
      function bg(_ref79) {
        var e = _ref79.viewDiff,
          t = _ref79.updateViewDiff,
          r = _ref79.showMode;
        if (!e) return null;
        var n = c().createElement(Zu, {
            name: "viewDiff",
            ariaLabel: "view-diff",
            value: e,
            onChange: function onChange(l) {
              t(l.target.value);
            }
          }, c().createElement("option", {
            value: "self"
          }, "Self"), c().createElement("option", {
            value: "total"
          }, "Total"), c().createElement("option", {
            value: "diff"
          }, "Diff")),
          a = function a(l) {
            return e === l ? "primary" : "default";
          },
          i = c().createElement(c().Fragment, null, c().createElement(zn, {
            grouped: !0,
            icon: K0.gf,
            kind: a("self"),
            onClick: function onClick() {
              return t("self");
            }
          }, "Self"), c().createElement(zn, {
            grouped: !0,
            icon: J0.xi,
            kind: a("total"),
            onClick: function onClick() {
              return t("total");
            }
          }, "Total"), c().createElement(zn, {
            grouped: !0,
            icon: W0.el,
            kind: a("diff"),
            onClick: function onClick() {
              return t("diff");
            }
          }, "Diff")),
          o = function o() {
            switch (r) {
              case "small":
                return n;
              case "large":
                return i;
              default:
                throw new Error("Invalid option: '".concat(r, "'"));
            }
          };
        return c().createElement("div", {
          className: "btn-group viz-switch",
          "data-testid": "diff-view"
        }, o());
      }
      function yg(_ref80) {
        var e = _ref80.view,
          t = _ref80.updateView,
          r = _ref80.showMode;
        var n = c().createElement(Zu, {
            ariaLabel: "view",
            name: "view",
            value: e,
            onChange: function onChange(l) {
              t(l.target.value);
            }
          }, c().createElement("option", {
            value: "table"
          }, "Table"), c().createElement("option", {
            value: "both"
          }, "Both"), c().createElement("option", {
            value: "flamegraph"
          }, "Flame")),
          a = function a(l) {
            return e === l ? "primary" : "default";
          },
          i = c().createElement(c().Fragment, null, c().createElement(zn, {
            grouped: !0,
            kind: a("table"),
            icon: Y0.B3,
            onClick: function onClick() {
              return t("table");
            }
          }, "Table"), c().createElement(zn, {
            grouped: !0,
            kind: a("both"),
            icon: X0.rW,
            onClick: function onClick() {
              return t("both");
            }
          }, "Both"), c().createElement(zn, {
            grouped: !0,
            kind: a("flamegraph"),
            icon: q0.$P,
            onClick: function onClick() {
              return t("flamegraph");
            }
          }, "Flamegraph")),
          o = function o() {
            switch (r) {
              case "small":
                return n;
              case "large":
                return i;
              default:
                throw new Error("Invalid option: '".concat(r, "'"));
            }
          };
        return c().createElement("div", {
          className: "btn-group viz-switch"
        }, o());
      }
      var wg = pg,
        _g = {
          noProfilingData: "uf0fDCR2p7mFe03meuOCpw=="
        };
      function xg() {
        return c().createElement("div", {
          "data-testid": "no-profiling-data",
          className: _g.noProfilingData
        }, c().createElement("span", null, "No profiling data available for this application / time range."));
      }
      var hn = {
        flamegraphContainer: "dp4rYndtkn5OL137gNcXFw==",
        createdBy: "Sg8G+XWf37nf2z2mq0UlZA==",
        horizontal: "Fa+QibGLT2PTOlQu9kZ42w==",
        vertical: "_1fK+ZP5KAHBMI34rObiBpA==",
        panesWrapper: "UiDrEFZwwNI6mFmaWDftKw==",
        tablePane: "rcGeWTV5hY5txTEQvQenVg=="
      };
      var Eg = ["styles"];
      function Og(e, t) {
        if (e == null) return {};
        var r = Tg(e, t),
          n,
          a;
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          for (a = 0; a < i.length; a++) {
            n = i[a], !(t.indexOf(n) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, n) || (r[n] = e[n]));
          }
        }
        return r;
      }
      function Tg(e, t) {
        if (e == null) return {};
        var r = {},
          n = Object.keys(e),
          a,
          i;
        for (i = 0; i < n.length; i++) {
          a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
        }
        return r;
      }
      function Ps() {
        return Ps = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];
            for (var n in r) {
              Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
          }
          return e;
        }, Ps.apply(this, arguments);
      }
      var kg = function kg(e) {
        var t = e.styles,
          r = t === void 0 ? {} : t,
          n = Og(e, Eg);
        return c().createElement("svg", Ps({
          width: "1024",
          height: "1024",
          viewBox: "0 0 1024 1024",
          xmlns: "http://www.w3.org/2000/svg"
        }, n), c().createElement("defs", null, c().createElement("radialGradient", {
          cx: "49.424%",
          cy: "92.663%",
          fx: "49.424%",
          fy: "92.663%",
          r: "195.067%",
          gradientTransform: "matrix(0 -.73561 1 0 -.432 1.29)",
          id: "a"
        }, c().createElement("stop", {
          stopColor: "#FFB90C",
          offset: "0%"
        }), c().createElement("stop", {
          stopColor: "#F9243A",
          offset: "38.391%"
        }), c().createElement("stop", {
          stopColor: "#F9243A",
          offset: "50.541%"
        }), c().createElement("stop", {
          stopColor: "#B51424",
          offset: "73.981%"
        }), c().createElement("stop", {
          stopColor: "#B51424",
          offset: "100%"
        }))), c().createElement("g", {
          fillRule: "nonzero",
          fill: "none"
        }, c().createElement("path", {
          d: "M65.365 571.74l.084-.041C19.514 506-5.325 424.478 1.043 336.878 14.033 158.179 159.193 13.76 338.06 1.592c81.358-5.53 157.44 15.79 220.397 55.87l-77.155 104.636c-43.786-25.576-81.934-32.507-117.815-31.942-128.99 0-233.93 104.876-233.93 233.791 0 128.919 104.94 233.791 233.93 233.791 128.997 0 233.94-104.872 233.94-233.791-.014-59.312-16.033-108.27-66.797-164.279l77.14-104.535c73.167 66.444 119.163 162.231 119.163 268.814 0 94.085-35.798 179.809-94.517 244.325v.004l-98.818 139.847L428.6 617.203l6.102 29.36c24.75 119.03-1.039 242.98-71.209 342.29l-298.13-417.13v.016z",
          transform: "matrix(1 0 0 -1 149 989.314)",
          fill: "url(#a)"
        }), c().createElement("path", {
          d: "M512.487 453.586c-94.767 0-171.868 77.05-171.868 171.762 0 94.717 77.101 171.767 171.868 171.767 94.77 0 171.88-77.05 171.88-171.767 0-94.712-77.11-171.762-171.88-171.762",
          fill: "#3EC1D3"
        }), c().createElement("path", {
          d: "M392.65 625.353H370.48c0-78.25 63.71-141.92 142.007-141.92v22.154c-66.078 0-119.839 53.728-119.839 119.766",
          fill: "#FFF"
        })));
      };
      function Vu(e, t) {
        var r = _toConsumableArray(t);
        function n(a, i, o) {
          var _iterator43 = _createForOfIteratorHelper(a),
            _step43;
          try {
            for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
              var l = _step43.value;
              var u = 0;
              for (var h = i; h < l.length; h += o) {
                l[h] -= u, u += l[h] + l[h + 1];
              }
            }
          } catch (err) {
            _iterator43.e(err);
          } finally {
            _iterator43.f();
          }
        }
        return e === "double" ? (n(r, 0, 7), n(r, 3, 7)) : n(r, 0, 4), r;
      }
      function Rs(e, t) {
        var r = _toConsumableArray(t);
        function n(a, i, o) {
          var _iterator44 = _createForOfIteratorHelper(a),
            _step44;
          try {
            for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
              var l = _step44.value;
              var u = 0;
              for (var h = i; h < l.length; h += o) {
                l[h] += u, u = l[h] + l[h + 1];
              }
            }
          } catch (err) {
            _iterator44.e(err);
          } finally {
            _iterator44.f();
          }
        }
        return e === "double" ? (n(r, 0, 7), n(r, 3, 7)) : n(r, 0, 4), r;
      }
      function Sg(e) {
        var t = JSON.parse(JSON.stringify(e));
        return t.flamebearer.levels = Rs(t.metadata.format, t.flamebearer.levels), t;
      }
      var Cg = Object.defineProperty,
        Mg = Object.defineProperties,
        Ng = Object.getOwnPropertyDescriptors,
        Gu = Object.getOwnPropertySymbols,
        Pg = Object.prototype.hasOwnProperty,
        Rg = Object.prototype.propertyIsEnumerable,
        Wu = function Wu(e, t, r) {
          return t in e ? Cg(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        Yt = function Yt(e, t) {
          for (var r in t || (t = {})) {
            Pg.call(t, r) && Wu(e, r, t[r]);
          }
          if (Gu) {
            var _iterator45 = _createForOfIteratorHelper(Gu(t)),
              _step45;
            try {
              for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
                var r = _step45.value;
                Rg.call(t, r) && Wu(e, r, t[r]);
              }
            } catch (err) {
              _iterator45.e(err);
            } finally {
              _iterator45.f();
            }
          }
          return e;
        },
        La = function La(e, t) {
          return Mg(e, Ng(t));
        };
      function Is(e) {
        if (e.profile && e.flamebearer && console.warn("'profile' and 'flamebearer' properties are mutually exclusive. Please use profile if possible."), e.profile) {
          var r = JSON.parse(JSON.stringify(e.profile)),
            n = Sg(r);
          return Yt(Yt(Yt({}, n), n.flamebearer), n.metadata);
        }
        return e.flamebearer ? e.flamebearer : {
          format: "single",
          names: [],
          units: "",
          levels: [[]],
          spyName: "unknown",
          numTicks: 0,
          sampleRate: 0,
          maxSelf: 0
        };
      }
      var Ju = /*#__PURE__*/function (_c$Component) {
        _inherits(Ju, _c$Component);
        var _super33 = _createSuper(Ju);
        function Ju(t) {
          var _this24;
          _classCallCheck(this, Ju);
          _this24 = _super33.call(this, t);
          _this24.resetFlamegraphState = {
            focusedNode: ot.nothing(),
            zoom: ot.nothing()
          }, _this24.initialFlamegraphState = _this24.resetFlamegraphState, _this24.calcNewConfigs = function (r, n) {
            var a = _this24.state.flamegraphConfigs,
              i = function i(u, h, g) {
                var y = function y(C, H, z) {
                  return C.names[vt(C.format).getBarName(C.levels[H], z)];
                };
                if (g.isNothing) return !0;
                try {
                  var C = y(u, g.value.i, g.value.j),
                    H = y(h, g.value.i, g.value.j);
                  return C === H;
                } catch (C) {
                  return !1;
                }
              },
              o = _this24.state.flamegraphConfigs.zoom;
            i(r, n, o) || (a.zoom = _this24.resetFlamegraphState.zoom);
            var l = _this24.state.flamegraphConfigs.focusedNode;
            return i(r, n, l) || (a.focusedNode = _this24.resetFlamegraphState.focusedNode), a;
          }, _this24.onSearchChange = function (r) {
            _this24.setState({
              searchQuery: r
            });
          }, _this24.isSameFlamebearer = function (r, n) {
            return JSON.stringify(r) === JSON.stringify(n);
          }, _this24.onReset = function () {
            _this24.setState(La(Yt({}, _this24.state), {
              flamegraphConfigs: Yt(Yt({}, _this24.state.flamegraphConfigs), _this24.initialFlamegraphState)
            }));
          }, _this24.onFlamegraphZoom = function (r) {
            if (r.isJust && r.value.i === 0 && r.value.j === 0) {
              _this24.onReset();
              return;
            }
            _this24.setState(La(Yt({}, _this24.state), {
              flamegraphConfigs: La(Yt({}, _this24.state.flamegraphConfigs), {
                zoom: r
              })
            }));
          }, _this24.onFocusOnNode = function (r, n) {
            if (r === 0 && n === 0) {
              _this24.onReset();
              return;
            }
            var a = Yt({}, _this24.state.flamegraphConfigs);
            var i = _this24.state.flamegraphConfigs.zoom;
            i.isJust && i.value.i <= r && (a = La(Yt({}, a), {
              zoom: _this24.initialFlamegraphState.zoom
            })), _this24.setState(La(Yt({}, _this24.state), {
              flamegraphConfigs: La(Yt({}, a), {
                focusedNode: ot.just({
                  i: r,
                  j: n
                })
              })
            }));
          }, _this24.setActiveItem = function (r) {
            var n = r.name;
            if (_this24.state.selectedItem.isJust && n === _this24.state.selectedItem.value) {
              _this24.setState({
                selectedItem: ot.nothing()
              });
              return;
            }
            _this24.setState({
              selectedItem: ot.just(n)
            });
          }, _this24.getHighlightQuery = function () {
            return _this24.state.selectedItem.isJust ? _this24.state.selectedItem.value : _this24.state.searchQuery;
          }, _this24.updateViewDiff = function (r) {
            _this24.setState({
              viewDiff: r
            });
          }, _this24.updateView = function (r) {
            _this24.setState({
              view: r
            });
          }, _this24.updateFlamegraphDirtiness = function () {
            var r = _this24.isDirty();
            _this24.setState({
              isFlamegraphDirty: r
            });
          }, _this24.updateFitMode = function (r) {
            _this24.setState({
              fitMode: r
            });
          }, _this24.isDirty = function () {
            return JSON.stringify(_this24.initialFlamegraphState) !== JSON.stringify(_this24.state.flamegraphConfigs);
          }, _this24.render = function () {
            var r;
            var n = c().createElement("div", {
                key: "table-pane",
                className: sn(hn.tablePane, _this24.state.panesOrientation === "vertical" ? hn.vertical : hn.horizontal)
              }, c().createElement(G0, {
                "data-testid": "table-view",
                flamebearer: _this24.state.flamebearer,
                viewDiff: ((r = _this24.state.flamebearer) == null ? void 0 : r.format) === "double" && _this24.state.viewDiff,
                fitMode: _this24.state.fitMode,
                highlightQuery: _this24.state.searchQuery,
                selectedItem: _this24.state.selectedItem,
                handleTableItemClick: _this24.setActiveItem,
                palette: _this24.state.palette
              })),
              a = _this24.shouldShowToolbar(),
              i = c().createElement(x0, {
                key: "flamegraph-pane",
                showCredit: _this24.props.showCredit,
                flamebearer: _this24.state.flamebearer,
                ExportData: _this24.props.ExportData || c().createElement(c().Fragment, null),
                highlightQuery: _this24.getHighlightQuery(),
                setActiveItem: _this24.setActiveItem,
                selectedItem: _this24.state.selectedItem,
                fitMode: _this24.state.fitMode,
                zoom: _this24.state.flamegraphConfigs.zoom,
                focusedNode: _this24.state.flamegraphConfigs.focusedNode,
                onZoom: _this24.onFlamegraphZoom,
                onFocusOnNode: _this24.onFocusOnNode,
                onReset: _this24.onReset,
                isDirty: _this24.isDirty,
                palette: _this24.state.palette,
                toolbarVisible: a,
                setPalette: function setPalette(u) {
                  return _this24.setState({
                    palette: u
                  });
                }
              }),
              o = !_this24.state.flamebearer || _this24.state.flamebearer.names.length <= 1,
              l = Ig(_this24.state.view, i, n);
            return c().createElement("div", {
              "data-flamegraph-color-mode": _this24.props.colorMode || "dark"
            }, c().createElement("div", null, a && c().createElement(wg, {
              sharedQuery: _this24.props.sharedQuery,
              disableChangingDisplay: !!_this24.props.onlyDisplay,
              flamegraphType: _this24.state.flamebearer.format,
              view: _this24.state.view,
              viewDiff: _this24.state.viewDiff,
              handleSearchChange: _this24.onSearchChange,
              reset: _this24.onReset,
              updateView: _this24.updateView,
              updateViewDiff: _this24.updateViewDiff,
              updateFitMode: _this24.updateFitMode,
              fitMode: _this24.state.fitMode,
              isFlamegraphDirty: _this24.state.isFlamegraphDirty,
              selectedNode: _this24.state.flamegraphConfigs.zoom,
              highlightQuery: _this24.state.searchQuery,
              onFocusOnSubtree: _this24.onFocusOnNode
            }), _this24.props.children, c().createElement("div", {
              className: "".concat(hn.flamegraphContainer, " ").concat(sn(_this24.state.panesOrientation === "vertical" ? hn.vertical : hn.horizontal, hn[_this24.state.panesOrientation], hn.panesWrapper))
            }, o ? c().createElement(xg, null) : l.map(function (u) {
              return u;
            }))), _this24.props.showPyroscopeLogo && c().createElement("div", {
              className: hn.createdBy
            }, "Created by", c().createElement("a", {
              href: "https://twitter.com/PyroscopeIO",
              rel: "noreferrer",
              target: "_blank"
            }, c().createElement(kg, {
              width: "30",
              height: "30"
            }), "@PyroscopeIO")));
          }, _this24.state = {
            isFlamegraphDirty: !1,
            view: _this24.props.onlyDisplay ? _this24.props.onlyDisplay : "both",
            viewDiff: "diff",
            fitMode: "HEAD",
            flamebearer: Is(t),
            panesOrientation: t.panesOrientation ? t.panesOrientation : "horizontal",
            searchQuery: "",
            selectedItem: ot.nothing(),
            flamegraphConfigs: _this24.initialFlamegraphState,
            palette: Aa
          };
          return _this24;
        }
        _createClass(Ju, [{
          key: "componentDidUpdate",
          value: function componentDidUpdate(t, r) {
            var n = Is(t),
              a = Is(this.props);
            if (!this.isSameFlamebearer(n, a)) {
              var i = this.calcNewConfigs(n, a);
              this.setState({
                flamebearer: a,
                flamegraphConfigs: Yt(Yt({}, this.state.flamegraphConfigs), i),
                selectedItem: ot.nothing()
              });
              return;
            }
            r.flamegraphConfigs !== this.state.flamegraphConfigs && this.updateFlamegraphDirtiness();
          }
        }, {
          key: "shouldShowToolbar",
          value: function shouldShowToolbar() {
            return this.props.showToolbar !== void 0 ? this.props.showToolbar : !0;
          }
        }]);
        return Ju;
      }(c().Component);
      Ju.defaultProps = {
        showCredit: !0
      };
      function Ig(e, t, r) {
        switch (e) {
          case "table":
            return [r];
          case "flamegraph":
            return [t];
          case "both":
            return [r, t];
          default:
            throw new Error("Invalid view '".concat(e, "'"));
        }
      }
      var Ag = Ju;
      var Dg = Object.defineProperty,
        Xu = Object.getOwnPropertySymbols,
        Lg = Object.prototype.hasOwnProperty,
        Fg = Object.prototype.propertyIsEnumerable,
        qu = function qu(e, t, r) {
          return t in e ? Dg(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        Ku = function Ku(e, t) {
          for (var r in t || (t = {})) {
            Lg.call(t, r) && qu(e, r, t[r]);
          }
          if (Xu) {
            var _iterator46 = _createForOfIteratorHelper(Xu(t)),
              _step46;
            try {
              for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                var r = _step46.value;
                Fg.call(t, r) && qu(e, r, t[r]);
              }
            } catch (err) {
              _iterator46.e(err);
            } finally {
              _iterator46.f();
            }
          }
          return e;
        };
      var jg = {
          showPyroscopeLogo: !1
        },
        Bg = function Bg(e) {
          return c().createElement("pyro-flamegraph", {
            is: "span"
          }, c().createElement(Ag, Ku(Ku({}, e), jg)));
        };
      var zg = pe(572),
        $g = pe.n(zg),
        Hg = pe(343),
        Ug = pe.n(Hg);
      function Zg(e) {
        var t = {
            numTicks: 0,
            maxSelf: 0,
            names: [],
            levels: []
          },
          r = {},
          n = {
            children: []
          };
        e.spans.forEach(function (o) {
          o.children = [], r[o.spanID] = o;
        }), e.spans.forEach(function (o) {
          var l = n;
          o.references && o.references.length > 0 && (l = r[o.references[0].spanID] || n), l.children.push(o);
        });
        function a(o, l) {
          (o.children || []).forEach(function (g) {
            return a(g, l + 1);
          });
          var u = 0;
          var h = $g()(o.children || [], function (g) {
            return g.operationName;
          });
          o.children = Ug()(h, function (g) {
            var y = g[0];
            for (var C = 1; C < g.length; C += 1) {
              y.duration += g[C].duration;
            }
            return u += y.duration, y;
          }), o.total = o.duration || u, o.self = Math.max(0, o.total - u);
        }
        a(n, 0);
        function i(o, l, u) {
          var h;
          return t.numTicks || (t.numTicks = o.total), (h = t.levels)[l] || (h[l] = []), t.levels[l].push(u), t.levels[l].push(o.total), t.levels[l].push(o.self), t.names.push((o.processID ? "".concat(e.processes[o.processID].serviceName, ": ") : "") + (o.operationName || "total")), t.levels[l].push(t.names.length - 1), (o.children || []).forEach(function (g) {
            u += i(g, l + 1, u);
          }), o.total;
        }
        return i(n, 0, 0), t.levels = Vu("single", t.levels), {
          version: 1,
          flamebearer: t,
          metadata: {
            format: "single",
            units: "trace_samples",
            spyName: "tracing",
            sampleRate: 1e6
          }
        };
      }
      var Vg = Object.defineProperty,
        Yu = Object.getOwnPropertySymbols,
        Gg = Object.prototype.hasOwnProperty,
        Wg = Object.prototype.propertyIsEnumerable,
        Qu = function Qu(e, t, r) {
          return t in e ? Vg(e, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : e[t] = r;
        },
        Jg = function Jg(e, t) {
          for (var r in t || (t = {})) {
            Gg.call(t, r) && Qu(e, r, t[r]);
          }
          if (Yu) {
            var _iterator47 = _createForOfIteratorHelper(Yu(t)),
              _step47;
            try {
              for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
                var r = _step47.value;
                Wg.call(t, r) && Qu(e, r, t[r]);
              }
            } catch (err) {
              _iterator47.e(err);
            } finally {
              _iterator47.f();
            }
          }
          return e;
        };
      function Xg(e, t) {
        var r = {},
          n = {};
        var a;
        return [e, t].forEach(function (i, o) {
          var l, u;
          for (var h = 0; h < i.levels.length; h += 1) {
            for (var g = 0; g < i.levels[h].length; g += 4) {
              var y = [o, h, g].join("/"),
                C = i.names[i.levels[h][g + 3]],
                H = i.levels[h][g + 0];
              var z = void 0;
              if (h !== 0) {
                var D = h - 1;
                for (var re = 0; re < i.levels[D].length; re += 4) {
                  var oe = i.levels[D][re + 0],
                    we = i.levels[D][re + 1];
                  if (H >= oe && H < oe + we) {
                    var ve = [o, D, re].join("/");
                    z = n[ve].key;
                    break;
                  }
                }
              }
              var F = [z || "", C].join("/");
              r[F] || (r[F] = {
                name: C,
                children: [],
                self: [],
                total: [],
                key: F
              });
              var R = r[F];
              (l = R.total)[o] || (l[o] = 0), R.total[o] += i.levels[h][g + 1], (u = R.self)[o] || (u[o] = 0), R.self[o] += i.levels[h][g + 2], n[y] = R, z && r[z].children.push(R), h === 0 && (a = R);
            }
          }
        }), a;
      }
      function qg(e, t) {
        var r = {
            format: "double",
            numTicks: e.numTicks + t.numTicks,
            leftTicks: e.numTicks,
            rightTicks: t.numTicks,
            maxSelf: 100,
            sampleRate: e.sampleRate,
            names: [],
            levels: [],
            units: e.units,
            spyName: e.spyName
          },
          n = Xg(e, t),
          a = function a(i, o, l, u) {
            var h;
            var g = i.name,
              y = i.children,
              C = i.self,
              H = i.total;
            r.names.push(g), (h = r.levels)[o] || (h[o] = []), r.maxSelf = Math.max(r.maxSelf, C[0] || 0, C[1] || 0), r.levels[o] = r.levels[o].concat([l, H[0] || 0, C[0] || 0, u, H[1] || 0, C[1] || 0, r.names.length - 1]);
            for (var z = 0; z < y.length; z += 1) {
              var _a4 = a(y[z], o + 1, l, u),
                _a5 = _slicedToArray(_a4, 2),
                F = _a5[0],
                R = _a5[1];
              l += F, u += R;
            }
            return [H[0] || 0, H[1] || 0];
          };
        return a(n, 0, 0, 0), r;
      }
      function Kg(e, t) {
        e.flamebearer.levels = Rs("single", e.flamebearer.levels), t.flamebearer.levels = Rs("single", t.flamebearer.levels);
        var r = qg(e.flamebearer, t.flamebearer);
        r.levels = Vu("double", r.levels);
        var n = Jg({}, e.metadata);
        return n.format = "double", {
          version: 1,
          flamebearer: r,
          metadata: n,
          leftTicks: e.flamebearer.numTicks,
          rightTicks: t.flamebearer.numTicks
        };
      }
    }(), ja;
  }();
});